import { adminFaz8De } from './admin.faz8.de';
/** Panel arayüz metinleri (Almanca; F7-17). Kaynak: TR (asıl) ve EN; terimler docs/I18N_GLOSSARY.md. */
export const adminDe = {
  ...adminFaz8De,
  nav: {
    overview: 'Übersicht',
    business: 'Unternehmen',
    team: 'Team',
    connections: 'Verbindungen',
    records: 'Protokolle',
    dashboard: 'Dashboard',
    setup: 'Einrichtungsassistent',
    organization: 'Unternehmensdaten',
    brands: 'Marken',
    stores: 'Shops',
    users: 'Benutzer',
    roles: 'Rollen',
    apiKeys: 'API-Schlüssel',
    webhooks: 'Webhooks',
    integrations: 'Integrationen',
    audit: 'Prüfprotokoll',
    system: 'Systemstatus',
    migration: 'Migrationspaket',
    privacy: 'KVKK-Anfragen',
    retention: 'Aufbewahrung und Löschung',
    ledger: 'Händlerkonten',
    quotes: 'Angebote',
    salesRegions: 'Vertriebsgebiete',
    commissions: 'Außendienstprovisionen',
    dealerReports: 'Händlerberichte',
    internationalReport: 'Umsatz nach Land',
    subscriptions: 'Wiederkehrende Bestellungen',
    bizimhesap: 'BizimHesap',
    exports: 'Exporte',
    seo: 'SEO-Center',
    attribution: 'Kampagnen und Quellen',
    tracking: 'Messung',
    google: 'Google-Verbindungen',
    webVitals: 'Seitengeschwindigkeit',
    keywords: 'Keywords',
    siteSearch: 'Websitesuche',
    attributes: 'Produktattribute',
    collections: 'Kollektionen',
    searchConsole: 'Suchleistung',
    merchant: 'Google Shopping',
    helpEditor: 'Hilfetexte',
    uiTranslations: 'Übersetzungen',
    account: 'Mein Konto',
    menu: 'Menü',
    skipToContent: 'Zum Inhalt springen',
    stagingBanner: 'Staging-Server (Test): E-Mails werden nur an Adressen auf der Zulassungsliste gesendet.',
    stagingBannerLink: 'Zulassungsliste',
    organizationSwitch: 'Unternehmen',
    sales: 'Vertrieb',
    catalog: 'Katalog',
    orders: 'Bestellungen',
    customers: 'Kunden',
    dealers: 'Händler',
    applications: 'Händleranträge',
    products: 'Produkte',
    categories: 'Kategorien',
    stock: 'Bestand',
    pricing: 'Preise',
    fx: 'Wechselkurse',
    discounts: 'Gutscheincodes',
    promotions: 'Automatische Rabatte',
    giftCards: 'Geschenkkarten',
    loyalty: 'Treueprogramm',
    referrals: 'Empfehlungsprogramm',
    affiliates: 'Affiliate-Partner',
    imports: 'Import / Export',
    payments: 'Zahlungen',
    invoices: 'Rechnungen',
    paymentSettings: 'Zahlungseinstellungen',
    shipping: 'Versand',
    legal: 'Rechtstexte',
    redirects: 'Weiterleitungen',
    brokenLinks: 'Defekte Links',
    storefrontGroup: 'Storefront',
    marketing: 'Marketing',
    marketingAudience: 'Abonnenten und Einwilligungen',
    segments: 'Segmente',
    emailTemplates: 'E-Mail-Vorlagen',
    campaigns: 'E-Mail-Kampagnen',
    automations: 'Automatisierungen',
    productAlerts: 'Bestands- und Preisbenachrichtigungen',
    smsWhatsapp: 'SMS und WhatsApp',
    smsTemplates: 'SMS-Vorlagen',
    push: 'Push-Benachrichtigungen',
    design: 'Design',
    menus: 'Menüs',
    pageDesigns: 'Seitendesigns',
    salesPoints: 'Verkaufsstellen',
    googleAdsCampaigns: 'Google-Ads-Kampagnen',
    needsFinder: 'Bedarfsfinder',
    pages: 'Seiten',
    banners: 'Banner',
    blog: 'Blog',
    contentCalendar: 'Inhaltskalender',
    contentReport: 'Inhaltsbericht',
    forms: 'Formulare',
    contactMessages: 'Kontaktnachrichten',
    supportTickets: 'Support-Tickets',
    ads: 'Werbecenter',
    googleReports: 'Google-Berichte',
    liveChat: 'Live-Chat',
    questions: 'Produktfragen',
    reviews: 'Produktbewertungen',
  },
  help: {
    whatItDoes: 'Wozu dient es?',
    whenToUse: 'Wann verwenden?',
    dataChanged: 'Was wird geändert?',
    requiredPermission: 'Erforderliche Berechtigung',
    reversible: 'Kann es rückgängig gemacht werden?',
    commonErrors: 'Häufige Probleme und Lösungen',
    guide: 'Ausführliche Anleitung',
    open: 'Erklärung: {{title}}',
  },
  auth: {
    brand: 'Zootopia Panel',
    tagline: 'Verwalten Sie Ihren Shop, Ihr Team und Ihre Verbindungen an einem Ort.',
    signInTitle: 'Anmeldung zur Verwaltung',
    signIn: 'Anmelden',
    forgot: 'Passwort vergessen',
    mfaTitle: 'Bestätigungscode',
    mfaLead:
      'Geben Sie den 6-stelligen Code ein, der in der Authenticator-App auf Ihrem Telefon angezeigt wird.',
    code: '6-stelliger Code',
    verify: 'Bestätigen',
    useBackup: 'Backup-Code verwenden',
    backupCode: 'Backup-Code',
    useCode: 'Mit App-Code bestätigen',
    enrollTitle: 'Zwei-Faktor-Authentifizierung einrichten',
    enrollLead:
      'Jeder Benutzer sichert die Verwaltung mit einer Authenticator-App (Google Authenticator, Microsoft Authenticator usw.). Tippen Sie in der App auf „Konto hinzufügen“ und scannen Sie diesen QR-Code.',
    manualKey: 'Scannen nicht möglich? Geben Sie diesen Schlüssel manuell in der App ein:',
    confirmEnroll: 'Einrichtung abschließen',
    backupTitle: 'Speichern Sie Ihre Backup-Codes',
    backupLead:
      'Wenn Sie keinen Zugriff auf Ihr Telefon haben, melden Sie sich mit einem dieser Codes an. Jeder Code funktioniert nur einmal, und die Codes werden nicht erneut angezeigt.',
    backupDone: 'Codes gespeichert, weiter',
    copyCodes: 'Codes kopieren',
    printCodes: 'Drucken',
    forgotTitle: 'Passwort zurücksetzen',
    forgotLead:
      'Geben Sie die E-Mail-Adresse Ihres Kontos ein. Falls sie registriert ist, senden wir Ihnen einen Link, der 1 Stunde gültig ist.',
    sendLink: 'Link senden',
    forgotSent:
      'Falls die Adresse registriert ist, wurde eine E-Mail gesendet. Prüfen Sie Ihren Posteingang und Ihren Spam-Ordner.',
    forgotUnavailable:
      'E-Mails zum Zurücksetzen des Passworts können nicht gesendet werden, da der E-Mail-Dienst noch nicht eingerichtet ist. Wenden Sie sich an die Administration Ihres Unternehmens; der Serveradministrator kann einen Link zum Zurücksetzen für Sie erstellen.',
    backToSignIn: 'Zurück zur Anmeldung',
    resetTitle: 'Neues Passwort festlegen',
    newPassword: 'Neues Passwort',
    setPassword: 'Passwort speichern',
    resetDone: 'Ihr Passwort wurde geändert. Sie können sich jetzt mit dem neuen Passwort anmelden.',
    passwordHint:
      'Mindestens 12 Zeichen. Ein langer Satz, den Sie sich leicht merken können, ist eine gute Wahl.',
    inviteTitle: '{{organization}} hat Sie eingeladen',
    inviteLead:
      'Einladung für {{email}}. Legen Sie Ihren Namen und Ihr Passwort fest; anschließend richten Sie die Zwei-Faktor-Authentifizierung ein.',
    inviteExistingLead:
      'Sie haben bereits ein Konto für {{email}}. Geben Sie Ihr aktuelles Passwort ein, um die Einladung anzunehmen.',
    yourName: 'Vollständiger Name',
    acceptInvite: 'Einladung annehmen',
    stepUpTitle: 'Bestätigen Sie Ihre Identität',
    stepUpLead:
      'Diese Aktion ist sicherheitsrelevant. Geben Sie den Code aus Ihrer Authenticator-App erneut ein.',
    stepUpSubmit: 'Bestätigen und fortfahren',
  },
  dashboard: {
    greeting: 'Hallo {{name}}',
    setupHeading: 'Einrichtung',
    setupProgress: '{{done}} von {{total}} in dieser Phase verfügbaren Schritten sind abgeschlossen.',
    continueSetup: 'Einrichtung fortsetzen',
    healthHeading: 'System',
    attentionHeading: 'Handlungsbedarf',
    salesHeading: 'Umsatz und Bestellungen',
    nothingToDo: 'Derzeit erfordert nichts Ihre Aufmerksamkeit.',
    salesPending:
      'Umsatz- und Bestelldiagramme kommen mit dem Berichtsmodul (Phase 8). Nutzen Sie bis dahin die Bereiche Bestellungen, Zahlungen und Bestand; ohne echte Daten werden keine geschätzten Zahlen angezeigt.',
    alertReturns: '{{count}} Rücksende-/Widerrufsanfragen warten auf eine Antwort.',
    alertPrivacy: '{{count}} KVKK-Anfragen warten auf eine Antwort (gesetzliche Frist 30 Tage).',
    alertPrivacyOverdue: 'Bei {{count}} KVKK-Anfragen ist die 30-Tage-Frist überschritten.',
    alertLowStock: '{{count}} Produkte haben einen niedrigen Bestand (Bestand → Niedriger Bestand).',
    alertPaymentReview: '{{count}} Zahlungen müssen geprüft werden (die Bestellung gilt nicht als bezahlt).',
    alertBalanceReview:
      '{{count}} Kartenzahlungen von Händlern müssen geprüft werden (nicht im Händlerkonto gebucht; Händlerkonten → Händler → Saldozahlungen per Karte).',
    alertIntegration: 'Die Verbindung zu {{name}} schlägt fehl.',
    alertTls: 'Das SSL-Zertifikat von {{host}} läuft in {{days}} Tagen ab.',
    alertTlsError: 'Das SSL-Zertifikat für {{host}} konnte nicht gelesen werden.',
    alertMail:
      'Der E-Mail-Dienst ist nicht eingerichtet: Einladungen und E-Mails zum Zurücksetzen des Passworts können nicht gesendet werden.',
    alertBackup: 'Noch keine Sicherung erfasst. Nächtliche Sicherungen starten nach der Servereinrichtung.',
    alertBackupFailed: 'Die letzte Sicherung ist fehlgeschlagen. Details: Systemstatus.',
    alertBackupStale:
      'Die letzte erfolgreiche Sicherung ist älter als 26 Stunden. Der Sicherungsdienst läuft möglicherweise nicht.',
    alertRestoreFailed:
      'Der letzte Wiederherstellungstest ist fehlgeschlagen: Sicherungen lassen sich möglicherweise nicht wiederherstellen. Details: Systemstatus.',
    alertRedis: 'Warteschlangenserver nicht erreichbar; E-Mails können nicht gesendet werden.',
  },
  setup: {
    go: 'Öffnen',
    skip: 'Überspringen',
    unskip: 'Rückgängig',
  },
  organization: {
    systemName: 'Panelname (Systemname)',
    systemNameHint:
      'Der Name oben im Verwaltungsbereich und im Browser-Tab. Leer lassen für „Zootopia Panel“.',
    legalSection: 'Rechtliche Angaben',
    legalLead: 'Die Verkäuferangaben auf der Website, Rechnungen und der POS-Antrag verwenden diese Angaben.',
    contactSection: 'Kontakt',
    defaultsSection: 'Standardwerte',
    name: 'Anzeigename',
    legalName: 'Offizieller Firmenname',
    taxOffice: 'Finanzamt',
    taxNumber: 'Steuernr. / TCKN',
    mersis: 'MERSIS-Nr.',
    kep: 'KEP-Adresse',
    etbis: 'ETBİS-Verifizierungslink',
    etbisHint:
      'Die Adresse, die der QR-Code öffnet, den Sie nach der ETBİS-Registrierung erhalten. Wird zusammen mit dem QR-Code in der Fußzeile der Storefront angezeigt.',
    phone: 'Telefon',
    email: 'E-Mail',
    address: 'Adresse',
    defaultLocale: 'Standardsprache',
    defaultCurrency: 'Standardwährung',
  },
  brands: {
    add: 'Marke hinzufügen',
    createTitle: 'Neue Marke',
    editTitle: 'Marke bearbeiten',
    name: 'Markenname',
    slug: 'Kurzname',
    description: 'Beschreibung',
    color: 'Hauptfarbe',
    logo: 'Logo',
    uploadLogo: 'Logo hochladen',
    replaceLogo: 'Logo ersetzen',
    noLogo: 'Kein Logo',
    archive: 'Archivieren',
    activate: 'Aktivieren',
    active: 'Aktiv',
    archived: 'Archiviert',
    emptyTitle: 'Noch keine Marken',
    emptyLead: 'Fügen Sie die Marken hinzu, die Sie verkaufen, z. B. Zootopia Global und VITATOPIA.',
    logoUploaded: 'Logo hochgeladen',
  },
  stores: {
    customerAuth: {
      title: 'Kundenanmeldung',
      lead: '„Weiter mit Google“ bei Anmeldung, Registrierung und Kasse. Standardmäßig aus; erst aktivieren, wenn Datenschutzhinweis und Verzeichnis der Auslandsübermittlungen mit rechtlicher Freigabe aktualisiert sind.',
      clientReady: 'Client für Google-Anmeldung eingerichtet',
      clientMissing: 'Einrichtung erforderlich: kein Client für Google-Anmeldung',
      configure: 'In Integrationen einrichten',
      google: 'Mit Google anmelden',
      on: 'An',
      off: 'Aus',
      enable: 'Google-Anmeldung aktivieren',
      disable: 'Google-Anmeldung deaktivieren',
      enableConfirm:
        'Kunden können sich in diesem Shop mit ihrem Google-Konto anmelden und registrieren. Fahren Sie fort, wenn Datenschutzhinweis und Verzeichnis der Auslandsübermittlungen rechtlich freigegeben aktualisiert wurden.',
      disableConfirm:
        'Die Google-Anmeldung wird deaktiviert. Mit Google erstellte Konten können sich weiter mit E-Mail und Passwort anmelden (ohne Passwort über „Passwort vergessen“).',
      ownerOnly: 'Nur der Inhaber kann dies aktivieren.',
      redirects: 'Weiterleitungs-URIs für den OAuth-Client in Google Cloud',
      noDomains: 'Der Shop hat keine Shop-Domain.',
    },
    add: 'Shop hinzufügen',
    createTitle: 'Neuer Shop',
    name: 'Shopname',
    code: 'Code',
    channel: 'Kanaltyp',
    channelB2C: 'B2C — Endkunden',
    channelB2B: 'B2B — Händler',
    channelHYBRID: 'Hybrid — Endkunden und Händler',
    status_draft: 'Vorschau',
    status_live: 'Live',
    status_maintenance: 'Wartung',
    status_archived: 'Archiviert',
    deleteTitle: 'Shop löschen',
    deleteLead:
      'Für einen versehentlich angelegten oder nicht genutzten Shop. Nur ein Shop in Vorschau oder Archiv ohne Bestellungen kann gelöscht werden; archivieren Sie einen Shop mit Bestellungen.',
    delete: 'Shop löschen',
    deleted: 'Shop gelöscht',
    deleteBlocked_store_not_draft:
      'Ein Shop im Live- oder Wartungsstatus kann nicht gelöscht werden; setzen Sie ihn zuerst auf Vorschau zurück oder archivieren Sie ihn.',
    deleteBlocked_store_has_orders:
      'Dieser Shop hat Bestellungen und kann nicht gelöscht werden. Archivieren Sie ihn, wenn Sie ihn nicht mehr nutzen.',
    deleteDialogTitle: '„{{name}}“ löschen?',
    deleteDialogLead: 'Dies kann nicht rückgängig gemacht werden. Folgendes wird mit dem Shop gelöscht:',
    deleteCodeLabel: 'Geben Sie zur Bestätigung den Shopcode ein: {{code}}',
    deleteCount_domains: '{{count}} Domains',
    deleteCount_markets: '{{count}} Märkte',
    deleteCount_priceLists: '{{count}} Preislisten (mit Preisen)',
    deleteCount_listings: '{{count}} Produkteinträge (Produkte bleiben erhalten)',
    deleteCount_pages: '{{count}} Seiten',
    deleteCount_banners: '{{count}} Banner',
    deleteCount_menus: '{{count}} Menüs',
    deleteCount_redirects: '{{count}} Weiterleitungen',
    deleteCount_shippingMethods: '{{count}} Versandarten',
    brands: 'Verkaufte Marken',
    domains: 'Domains',
    addDomain: 'Domain hinzufügen',
    hostname: 'Domain',
    purpose: 'Verwendung',
    purpose_storefront: 'Storefront',
    purpose_admin: 'Verwaltung',
    purpose_api: 'API',
    primary: 'Primär',
    markets: 'Märkte',
    addMarket: 'Markt hinzufügen',
    makeDefault: 'Als Standard festlegen',
    makeDefaultConfirm:
      '„{{name}}“ als Standardmarkt festlegen? Die Storefront öffnet sich in dessen Sprache und Währung ({{currency}}); Produkte ohne Preis in dieser Währung können nicht verkauft werden.',
    defaultMarketSaved: 'Standardmarkt geändert.',
    taxMode: 'Steuermodus',
    taxModeOf: 'Steuermodus für {{name}}',
    taxModeSaved: 'Steuermodus gespeichert.',
    taxModes: {
      domestic: 'Inländische MwSt.',
      export_exempt: 'Export (MwSt.-befreit)',
      destination: 'MwSt. des Bestimmungslandes',
    },
    returnPolicy: {
      title: 'Rückgaberichtlinie (für Suchmaschinen)',
      lead: 'Rückgabeinformationen, die in Google-Produktergebnissen angezeigt werden. Sie müssen mit den Widerrufs- und Rückgabebedingungen in Ihren Rechtstexten übereinstimmen.',
      enabled: 'An Suchmaschinen melden',
      days: 'Rückgabefrist (Tage)',
      method: 'Rückgabemethode',
      methods: {
        by_mail: 'Per Versand',
        in_store: 'Im Geschäft',
        by_mail_or_in_store: 'Per Versand oder im Geschäft',
      },
      fees: 'Rücksendekosten',
      feeOptions: {
        customer_pays: 'Kunde zahlt',
        free: 'Kostenlos (wir zahlen)',
      },
      save: 'Rückgaberichtlinie speichern',
      saved: 'Rückgaberichtlinie gespeichert.',
    },
    marketName: 'Marktname',
    country: 'Land',
    language: 'Sprache',
    currency: 'Währung',
    default: 'Standard',
    emptyTitle: 'Noch keine Shops',
    emptyLead: 'Beginnen Sie, indem Sie einen Shop für zootopia.com.tr anlegen.',
    dnsNote:
      'Nach dem Hinzufügen der Domain muss deren A-Record im Kundenbereich Ihres Domain-Registrars auf die IP-Adresse Ihres Servers zeigen.',
    noDomains: 'Noch keine Domains.',
    noMarkets:
      'Noch keine Märkte. Preise und Steuern gelten je Markt, fügen Sie daher mindestens einen hinzu.',
    tls: 'SSL',
    remove: 'Entfernen',
    open: 'Details',
    back: 'Zurück zu den Shops',
  },
  users: {
    invite: 'Benutzer einladen',
    inviteTitle: 'Benutzer einladen',
    inviteSent: 'Einladungs-E-Mail gesendet',
    manualTitle: 'Einladungslink teilen',
    manualLead:
      'An {{email}} wurde keine E-Mail gesendet, da der E-Mail-Dienst nicht eingerichtet ist. Teilen Sie diesen Link über einen sicheren Kanal; er ist 7 Tage gültig und funktioniert nur einmal.',
    copyLink: 'Link kopieren',
    role: 'Rolle',
    storeScope: 'Shop-Einschränkung',
    dealerScope: 'Händlerbereich',
    dealerScopeOf: '{{name}} — Händlerbereich',
    dealerScopes: {
      all: 'Alle Händler',
      assigned: 'Nur zugewiesene Händler',
    },
    allStores: 'Alle Shops',
    active: 'Aktiv',
    suspended: 'Gesperrt',
    lastLogin: 'Letzte Anmeldung',
    members: 'Mitglieder',
    pending: 'Ausstehende Einladungen',
    expires: 'Gültig bis',
    revoke: 'Einladung widerrufen',
    suspend: 'Sperren',
    activate: 'Aktivieren',
    remove: 'Mitglied entfernen',
    changeRole: 'Rolle ändern',
    you: 'Sie',
    confirmRemove: '{{name}} entfernen? Frühere Aktionen bleiben im Prüfprotokoll erhalten.',
    noPending: 'Keine ausstehenden Einladungen.',
  },
  roles: {
    system: 'Vordefinierte Rollen',
    custom: 'Benutzerdefinierte Rollen',
    createCustom: 'Benutzerdefinierte Rolle erstellen',
    createTitle: 'Benutzerdefinierte Rolle',
    basedOn: 'Ausgangsrolle',
    basedOnNone: 'Leer beginnen',
    permissions: 'Berechtigungen',
    permissionCount: '{{count}} Berechtigungen',
    sensitive: 'Sensibel',
    phaseNote: 'Phase {{phase}}',
    emptyCustom:
      'Noch keine benutzerdefinierten Rollen. Erstellen Sie eine, wenn keine vordefinierte Rolle passt.',
    name: 'Rollenname',
    description: 'Beschreibung',
    delete: 'Rolle löschen',
    showPermissions: 'Berechtigungen anzeigen',
  },
  apiKeys: {
    create: 'API-Schlüssel erstellen',
    name: 'Schlüsselname',
    namePlaceholder: 'z. B. Buchhaltungssoftware',
    scopes: 'Bereiche',
    prefix: 'Präfix',
    expiresAt: 'Läuft ab',
    noExpiry: 'Unbefristet',
    revoked: 'Widerrufen',
    expired: 'Abgelaufen',
    revoke: 'Widerrufen',
    secretTitle: 'Ihr Schlüssel ist bereit',
    secretLead:
      'Kopieren Sie diesen Schlüssel jetzt in das externe Programm. Er wird nicht erneut angezeigt.',
    usage: 'Anwendungsbeispiel',
    emptyTitle: 'Noch keine API-Schlüssel',
    emptyLead: 'Erstellen Sie einen Schlüssel, um Buchhaltung, ERP oder n8n anzubinden.',
    confirmRevoke: 'Programme, die diesen Schlüssel verwenden, verlieren sofort den Zugriff. Widerrufen?',
    docs: 'API-Dokumentation',
  },
  webhooks: {
    add: 'Webhook hinzufügen',
    url: 'URL',
    description: 'Beschreibung',
    events: 'Ereignisse',
    allEvents: 'Alle Ereignisse',
    active: 'Aktiv',
    disabled: 'Deaktiviert',
    test: 'Testereignis senden',
    testSent: 'Testereignis in die Warteschlange gestellt. Das Ergebnis sehen Sie im Zustellverlauf.',
    deliveries: 'Zustellverlauf',
    rotate: 'Secret erneuern',
    secretTitle: 'Signatur-Secret',
    secretLead:
      'Speichern Sie dieses Secret, damit das empfangende Programm prüfen kann, dass Anfragen von uns stammen. Es wird nicht erneut angezeigt.',
    signatureHelp:
      'Jede Anfrage enthält einen Header X-Zootopia-Signature: t=<Zeit>,v1=<HMAC-SHA256(Secret, Zeit + "." + Body)>.',
    redeliver: 'Erneut zustellen',
    attempt: 'Versuch',
    response: 'Antwort',
    delivery_pending: 'Ausstehend',
    delivery_succeeded: 'Erfolgreich',
    delivery_failed: 'Fehlgeschlagen',
    delivery_dead: 'Aufgegeben',
    emptyTitle: 'Noch keine Webhooks',
    emptyLead:
      'Fügen Sie eine URL hinzu, wenn ein Programm sofort über Shop-Ereignisse informiert werden soll.',
    emptyDeliveries: 'Noch keine Zustellungen.',
    delete: 'Löschen',
    confirmDelete: 'Benachrichtigungen an diese URL beenden und sie löschen?',
    confirmRotate:
      'Ein neues Signatur-Secret wird erzeugt, und das alte funktioniert sofort nicht mehr. Aktualisieren Sie auch das empfangende Programm. Fortfahren?',
    disable: 'Deaktivieren',
    enable: 'Aktivieren',
  },
  integrations: {
    pendingMerged: 'Für Kartenzahlungen die iyzico-Verbindung verwenden',
    pendingDecision: 'Einrichtung erforderlich: Entscheidung und Konto liegen beim Inhaber',
    log_health_check: 'Verbindungsprüfung',
    health: {
      title: 'Verbindungsprüfung',
      lead: 'Gespeicherte Verbindungen werden alle 6 Stunden automatisch geprüft – nur mit Tests, die keine Nachrichten senden und keine Kosten verursachen. Zwei Fehler in Folge lösen einen Alarm im Systemstatus und eine E-Mail an die Alarmempfänger aus. Die Prüfung ändert den Verbindungsstatus nicht.',
      verify: 'Alle Verbindungen prüfen',
      summary: '{{time}}: {{ok}} funktionieren, {{failed}} funktionieren nicht, {{skipped}} einzeln testen.',
      tableCaption: 'Ergebnisse der Verbindungsprüfung',
      colService: 'Dienst',
      colResult: 'Ergebnis',
      colDetail: 'Details',
      outcome_ok: 'Funktioniert',
      outcome_failed: 'Funktioniert nicht',
      outcome_skipped: 'Einzeln testen',
      lastOk: 'Letzte Prüfung {{time}}: funktioniert',
      lastFailed: 'Letzte Prüfung {{time}}: funktioniert nicht – „Verbindung testen“ ausprobieren',
    },
    carrierViaGeliver:
      'Eine direkte Anbindung erfordert einen Firmen-Integrationsvertrag und eine IP-Freigabe beim Versanddienstleister; bis dahin können Sie über Geliver mit diesem Dienstleister versenden.',
    bizimhesapSettings: 'Konto- und Kasseneinstellungen',
    adapterPending:
      'Noch nicht verbunden (Einrichtung erforderlich): Integrationsdetails des Anbieters stehen noch aus',
    configure: 'Konfigurieren',
    manageOnGoogle: 'Im Bereich Google-Verbindungen',
    manageOnTracking: 'Im Bereich Messung',
    test: 'Verbindung testen',
    testOk: 'Verbindung erfolgreich',
    testFail: 'Verbindung fehlgeschlagen',
    disconnect: 'Verbindung trennen',
    save: 'Angaben speichern',
    saved: 'Angaben verschlüsselt gespeichert. Testen Sie jetzt die Verbindung.',
    environment: 'Umgebung',
    env_sandbox: 'Sandbox (Test)',
    env_live: 'Live',
    lastTested: 'Zuletzt getestet',
    notAvailable: 'Diese Integration kommt in Phase {{phase}}. Angaben können noch nicht eingegeben werden.',
    docs: 'Offizielle Dokumentation',
    logs: 'Verbindungsprotokoll',
    emptyLogs: 'Noch keine Einträge.',
    log_test_connection: 'Verbindungstest',
    log_mail_send: 'E-Mail',
    log_mail_feedback: 'Bounce-/Beschwerdebenachrichtigung',
    logOutcome_success: 'Erfolgreich',
    logOutcome_failure: 'Fehlgeschlagen',
    logOutcome_blocked: 'Auf Staging blockiert',
    reenterSecrets:
      'Gespeicherte Passwörter werden nie angezeigt. Geben Sie alle Felder erneut ein, um sie zu ändern.',
    confirmDisconnect:
      'Die gespeicherten Angaben werden gelöscht, und dieser Dienst funktioniert nicht mehr. Fortfahren?',
    paymentNote:
      '„Sandbox“ / „Live“ ist hier nur das Ergebnis des Verbindungstests der Schlüssel; ob die Kartenzahlung in der Storefront deaktiviert, im Test- oder im Live-Modus ist, sehen Sie in den Zahlungseinstellungen:',
  },
  audit: {
    when: 'Zeit',
    actor: 'Von',
    action: 'Aktion',
    entity: 'Datensatz',
    filterEntity: 'Datensatztyp',
    allEntities: 'Alle',
    apply: 'Filtern',
    clear: 'Zurücksetzen',
    loadMore: 'Mehr anzeigen',
    before: 'Vorher',
    after: 'Nachher',
    actor_system: 'System',
    actor_customer: 'Kunde',
    actor_api_key: 'API-Schlüssel',
    actor_user: 'Benutzer',
    empty: 'Keine Einträge entsprechen diesem Filter.',
    details: 'Details',
    code: 'Aktionscode',
    recordId: 'Datensatz-ID',
  },
  system: {
    refresh: 'Aktualisieren',
    checkedAt: 'Gemessen um {{time}}',
    database: 'Datenbank',
    services: 'Dienste',
    runStatus: {
      running: 'läuft',
      succeeded: 'erfolgreich',
      failed: 'fehlgeschlagen',
    },
    redis: 'Warteschlangenserver',
    queues: 'Warteschlangen',
    queueName_mail: 'E-Mail',
    waiting: 'Wartend',
    activeJobs: 'Laufend',
    failed: 'Fehlgeschlagen',
    delayed: 'Verzögert',
    mail: 'E-Mail-Versand',
    mail_organization_smtp: 'SMTP-Verbindung des Unternehmens',
    mail_platform_smtp: 'Plattform-SMTP',
    mail_not_configured: 'Nicht eingerichtet',
    backup: 'Letzte Sicherung',
    restoreTest: 'Letzter Wiederherstellungstest',
    offsite: 'Externe Sicherungskopie',
    offsiteSetup: 'Einrichtung erforderlich',
    offsitePending: 'Verbunden; erster Upload nach der nächsten nächtlichen Sicherung',
    offsiteKeep: 'Wird {{days}} Tage im Speicher aufbewahrt',
    none: 'Noch keine',
    domains: 'Domains und SSL',
    ok: 'Funktioniert',
    error: 'Fehler',
    daysLeft: 'Noch {{days}} Tage',
    noQueues: 'Warteschlangeninformationen nicht verfügbar.',
    media: 'Dateispeicher (Bilder und Dokumente)',
    media_ok: 'Beschreibbar',
    media_storage_permission_denied: 'Keine Schreibberechtigung',
    media_storage_disk_full: 'Festplatte voll',
    media_storage_read_only: 'Schreibgeschützt',
    media_storage_write_failed: 'Nicht beschreibbar',
    failedJobs: 'Fehlgeschlagene Hintergrundaufgaben',
    environment: 'Umgebung',
    env_staging: 'Staging (Testserver)',
    env_production: 'Produktion',
    env_development: 'Entwicklung',
    mailGuardTitle: 'E-Mail-Schutz auf Staging',
    mailGuardLead:
      'Damit echte Kunden und Händler keine E-Mails vom Testserver erhalten, werden E-Mails nur an Adressen auf der Zulassungsliste gesendet. Andere werden nicht gesendet und erscheinen unter Integrationen → SMTP-E-Mail → Verbindungsprotokoll als „Auf Staging blockiert“. In der Produktion gibt es keine solche Einschränkung.',
    mailGuardServer: 'Auf dem Server festgelegt (MAIL_ALLOWLIST): {{count}} Einträge',
    mailGuardList: 'In der Verwaltung zugelassene Adressen',
    mailGuardListHint: 'Eine Adresse (name@example.com) oder Domain (@example.com) pro Zeile; maximal 20.',
    mailGuardEmpty: 'Die Zulassungsliste ist leer: Der Staging-Server sendet keine E-Mails.',
    mailGuardPlaceholder: 'name@example.com\n@example.com',
    mailGuardSave: 'Zulassungsliste speichern',
    mailGuardSaved: 'Zulassungsliste gespeichert.',
    alertsTitle: 'Kritische Warnungen',
    alertsLead:
      'Sicherungen, Wiederherstellungstest, Festplatte, Job-Warteschlangen, SSL-Zertifikate, Zahlungsbenachrichtigungen und die Erreichbarkeit von Storefront und Verwaltung werden alle 5 Minuten geprüft. Eine E-Mail wird gesendet, wenn ein Problem beginnt, alle 24 Stunden, solange es andauert, und wenn es behoben ist (höchstens 10 pro Stunde).',
    alertsNone: 'Keine laufenden Probleme.',
    alertsResolved: '{{count}} Warnungen in den letzten 7 Tagen behoben',
    alertSince: 'seit {{time}}',
    alertLastMail: 'letzte E-Mail: {{time}}',
    alertNotMailed: 'E-Mail nicht gesendet (Stundenlimit oder kein Empfänger)',
    alertResolvedAt: 'behoben: {{time}}',
    severity_critical: 'Dringend',
    severity_warning: 'Warnung',
    cspTitle: 'Verstöße gegen die Inhaltssicherheit im Shop',
    cspLead:
      'Blockiert die Inhaltssicherheitsrichtlinie (CSP) des Shops ein nicht erlaubtes Skript, Bild, Frame oder eine Verbindung, meldet der Browser des Besuchers dies. Wird ein neu hinzugefügtes Tag, Video oder Zahlungsframe blockiert oder versucht jemand, Code in die Seite einzuschleusen, erscheint es hier. Personenbezogene Daten und Meldungen von Browsererweiterungen werden nicht gespeichert; Einträge, die {{days}} Tage nicht gesehen wurden, werden gelöscht.',
    cspNone: 'In den letzten {{days}} Tagen wurden keine Verstöße gemeldet.',
    cspSummary:
      '{{rows}} verschiedene Verstöße, insgesamt {{hits}} Meldungen · in den letzten 24 Stunden gesehen: {{lastDay}}',
    cspDirective: 'Regel',
    cspBlocked: 'Blockierte Ressource',
    cspPage: 'Seite',
    cspHits: 'Anzahl',
    cspLastSeen: 'Zuletzt gesehen',
    cspReportOnly: 'nur Meldung',
    cspSource: 'Quelle: {{file}} (Zeile {{line}})',
    cspKeyword_inline: 'Inline-Code (in die Seite eingebettetes Skript oder Ereignishandler)',
    cspKeyword_eval: 'Dynamischer Code (eval)',
    'cspKeyword_wasm-eval': 'WebAssembly-Kompilierung',
    cspKeyword_data: 'data:-Adresse',
    cspKeyword_blob: 'blob:-Adresse',
    cspKeyword_self: 'Eigene Adresse des Shops',
    alertKinds: {
      login_failures:
        'Ungewöhnlich viele fehlgeschlagene Anmeldungen ({{surface}}): {{count}} Versuche und {{locked}} gesperrte Konten in den letzten {{minutes}} Minuten',
      integration: 'Verbindungsprüfung wiederholt fehlgeschlagen: {{provider}} ({{result}})',
      backup_missing: 'Seit 26 Stunden keine Datenbanksicherung',
      backup_failed: 'Letzte Datenbanksicherung fehlgeschlagen',
      restore_failed: 'Wiederherstellungstest der Sicherung fehlgeschlagen',
      queue_backlog: 'Rückstau in der Job-Warteschlange ({{queue}}: {{waiting}} wartend)',
      queue_failed: 'Fehlgeschlagene Jobs ({{queue}}: {{failed}})',
      disk_space: 'Festplatte zu {{usedPct}} % belegt ({{freeGb}} GB frei)',
      tls: 'SSL-Zertifikat: {{host}} ({{days}} Tage)',
      payment_hooks: 'Zahlungsbenachrichtigungen abgelehnt ({{failures}} in der letzten Stunde)',
      uptime: '{{name}} nicht erreichbar ({{result}})',
      preauth_expiring:
        '{{count}} Bestellungen haben Vorautorisierungen, die älter als 20 Tage sind (älteste: {{oldest}})',
    },
    errorTracking: 'Externes Fehler-Tracking',
    errorTrackingLive: 'Verbunden',
    errorTrackingSetup: 'Einrichtung erforderlich',
    observability: 'Beobachtbarkeit (OpenTelemetry)',
    recipients: 'Empfänger von Warnungen',
    recipientsHint:
      'Eine E-Mail-Adresse pro Zeile (max. 10). Wenn leer, werden die Inhaber benachrichtigt. Ist ALERT_EMAILS auf dem Server gesetzt, gehen Plattformwarnungen dorthin.',
    recipientsSave: 'Empfänger speichern',
    recipientsSaved: 'Empfänger von Warnungen gespeichert.',
    mailDnsTitle: 'E-Mail-Domain (SPF, DKIM, DMARC)',
    mailDnsLead:
      'Diese Einträge befinden sich im DNS Ihrer Domain. Fehlen sie, können Bestell- und Passwort-E-Mails im Spam landen oder abgelehnt werden.',
    mailDnsNone:
      'Keine Domain zu prüfen: Sie erscheint, sobald eine SMTP-Verbindung oder eine Storefront-Domain eingerichtet ist.',
    mailDnsDomain: '{{domain}} ({{source}}) · geprüft: {{time}}',
    mailDnsSource_smtp: 'SMTP-Absenderadresse',
    mailDnsSource_provider: 'Absenderadresse beim E-Mail-Anbieter',
    mailDnsSource_storefront: 'Storefront-Domain',
    mailDnsSource_query: 'manuell eingegeben',
    dns: {
      spf: 'SPF',
      dkim: 'DKIM',
      dmarc: 'DMARC',
      spf_ok: 'Vorhanden',
      spf_missing: 'Fehlt — fügen Sie den SPF-Eintrag Ihres E-Mail-Anbieters hinzu',
      spf_multiple: 'Mehrere SPF-Einträge — zu einem zusammenführen (sonst ungültig)',
      spf_unknown: 'DNS konnte nicht gelesen werden; versuchen Sie es später erneut',
      dkim_ok: 'Vorhanden',
      dkim_not_found: 'Nicht gefunden — geben Sie unten den Selektor ein, falls Sie ihn kennen',
      dkim_unknown: 'DNS konnte nicht gelesen werden; versuchen Sie es später erneut',
      dmarc_ok: 'Vorhanden (Schutz aktiv)',
      dmarc_monitoring: 'Vorhanden, nur Überwachung (p=none)',
      dmarc_missing: 'Fehlt — fügen Sie mindestens „v=DMARC1; p=none“ hinzu',
      dmarc_unknown: 'DNS konnte nicht gelesen werden; versuchen Sie es später erneut',
    },
    dkimSelector: 'DKIM-Selektor',
    dkimSelectorHint:
      'Der Name im DKIM-Eintrag Ihres Anbieters (z. B. „default“); leer lassen, falls unbekannt.',
    dkimSelectorSave: 'Selektor speichern und prüfen',
    mailGuardTooMany: 'Maximal 20 Einträge.',
  },
  account: {
    profile: 'Profil',
    phone: 'Telefon',
    language: 'Sprache der Verwaltung',
    uiMode: 'Nutzungsmodus',
    beginner: 'Einsteiger — Erklärungen standardmäßig eingeblendet',
    advanced: 'Experte — aufgeräumte Ansicht',
    password: 'Passwort',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    changePassword: 'Passwort ändern',
    passwordChanged: 'Passwort geändert; Sitzungen auf anderen Geräten wurden abgemeldet.',
    sessions: 'Aktive Sitzungen',
    thisDevice: 'Dieses Gerät',
    revoke: 'Sitzung abmelden',
    organizations: 'Meine Unternehmen',
    switchTo: 'Zu diesem Unternehmen wechseln',
    current: 'Aktuell',
    mobile: 'Mobile App',
    browser: 'Browser',
  },
  privacy: {
    create: 'Anfrage erfassen',
    createLead:
      'Erfassen Sie eine Anfrage, die per E-Mail, KEP (registrierte E-Mail), Post oder persönlich eingegangen ist. Die Antwortfrist beträgt 30 Tage ab Eingang beim Unternehmen.',
    created: 'Anfrage erfasst',
    save: 'Speichern',
    state: 'Anzeigen',
    states: {
      open: 'Offene Anfragen',
      closed: 'Abgeschlossen',
    },
    emptyOpen: 'Keine offenen Anfragen',
    emptyClosed: 'Keine abgeschlossenen Anfragen',
    emptyLead:
      'Kunden können in der Storefront unter Mein Konto → Meine personenbezogenen Daten eine Anfrage stellen; erfassen Sie per E-Mail eingegangene Anfragen mit „Anfrage erfassen“.',
    overdue: 'Überfällig',
    daysLeft: 'Noch {{count}} Tage',
    requesterName: 'Name der antragstellenden Person',
    requesterEmail: 'E-Mail der antragstellenden Person',
    kind: 'Art der Anfrage',
    channel: 'Eingegangen über',
    receivedAt: 'Datum der Anfrage',
    dueAt: 'Antwortfrist',
    store: 'Shop (in E-Mails angezeigter Name)',
    details: 'Anfragetext / Zusammenfassung',
    statusLabel: 'Status',
    customer: 'Kundenkonto',
    noCustomer: 'Kein Konto mit dieser E-Mail (Gastbestellungen werden über die E-Mail zugeordnet)',
    resolution: 'Ergebnis',
    exportedAt: 'Daten zuletzt heruntergeladen',
    recordsTitle: 'Datensätze im System',
    records:
      '{{orders}} Bestellungen, {{addresses}} Adressen, {{favorites}} Favoriten, {{questions}} Produktfragen, {{companies}} Mitgliedschaften in Händlerfirmen, {{invoices}} Rechnungen, {{acceptances}} Vertrags-/Hinweisbestätigungen, {{messages}} Kontaktnachrichten, {{tickets}} Support-Tickets, {{chats}} Live-Chats, {{newsletter}} Newsletter-Abonnements, {{campaigns}} Kampagnen-E-Mails, {{automations}} Automatisierungs-E-Mails, {{stockAlerts}} Anfragen zur Wiederverfügbarkeit, {{smsMessages}} SMS-/WhatsApp-Kampagnennachrichten; {{loyaltyPoints}} Treuepunkte (verfallen bei Löschung).',
    export: 'Kopie der Daten herunterladen',
    exported: 'Daten heruntergeladen',
    erasureTitle: 'Vorschau der Anonymisierung',
    erasureDeletes:
      'Gelöscht / anonymisiert: Konto (Name, E-Mail, Telefon, Passwort; Anmeldung gesperrt), Adressbuch, Sitzungen, Warenkörbe, Favoriten, Mitgliedschaft in Händlerfirmen; bei Bestellungen E-Mail, Telefon, Lieferadresse (Stadt/Bezirk bleiben erhalten) und Kundennotiz; Autorenname bei Produktfragen. Erteilte Einwilligungen für Nachrichten werden als widerrufen erfasst.',
    erasureKeeps:
      'Aufbewahrt (gesetzliche Pflicht): Bestellsummen und -positionen, Rechnungsadresse und Rechnungen, Zahlungsdatensätze, Bestätigungen von Verträgen und Vorabinformationen, Einwilligungsverlauf, Prüfprotokoll und der Datensatz dieser Anfrage.',
    note: 'Antwort an die antragstellende Person',
    noteErasure:
      'Antwort an die antragstellende Person (optional; bei der Anonymisierung wird ein Standardtext gesendet)',
    noteHint:
      'Wird der antragstellenden Person beim Abschließen oder Ablehnen per E-Mail gesendet (sofern E-Mail eingerichtet ist). Zum Ablehnen ist eine Begründung erforderlich.',
    startReview: 'Prüfung starten',
    complete: 'Abschließen',
    reject: 'Ablehnen',
    anonymize: 'Anonymisieren',
    confirmEmail: 'Geben Sie zur Bestätigung die E-Mail der antragstellenden Person ein: {{email}}',
    anonymizeConfirm: 'Dauerhaft anonymisieren',
    anonymized: 'Personenbezogene Daten anonymisiert',
    kinds: {
      export: 'Datenkopie',
      erasure: 'Löschung (Anonymisierung)',
      info: 'Auskunftsersuchen',
      rectification: 'Berichtigung',
      objection: 'Widerspruch',
      other: 'Sonstiges',
    },
    channels: {
      storefront: 'Storefront (Mein Konto)',
      email: 'E-Mail',
      kep: 'KEP (registrierte E-Mail)',
      post: 'Post',
      in_person: 'Persönlich',
      other: 'Sonstiges',
    },
    statuses: {
      received: 'Eingegangen',
      in_progress: 'In Prüfung',
      completed: 'Abgeschlossen',
      rejected: 'Abgelehnt',
    },
  },
  exports: {
    settingsTitle: 'Zeitraum und Datei',
    settingsLead: 'Diese Auswahl gilt für alle Listen unten.',
    period: 'Zeitraum',
    periods: {
      this_month: 'Dieser Monat',
      last_month: 'Letzter Monat',
      last_30: 'Letzte 30 Tage',
      this_year: 'Dieses Jahr',
      last_year: 'Letztes Jahr',
      custom: 'Zeitraum wählen',
      all: 'Gesamter Zeitraum',
    },
    from: 'Von',
    to: 'Bis',
    range: '{{from}} – {{to}} (türkische Zeit, Endtag eingeschlossen)',
    rangeAll: 'Alle Datensätze',
    store: 'Shop',
    allStores: 'Alle Shops',
    format: 'Dateiformat',
    formats: {
      xlsx: 'Excel (XLSX)',
      csv: 'CSV (Semikolon)',
    },
    personalData: 'Personenbezogene Daten',
    personalDataHint:
      'Unmaskierte Dateien erfordern die Zwei-Faktor-Authentifizierung und werden im Prüfprotokoll gekennzeichnet.',
    personalDataModes: {
      masked: 'Maskiert (empfohlen)',
      full: 'Unmaskiert (vollständige Angaben)',
    },
    listsTitle: 'Listen',
    listsLead: 'Jeder Download wird im Prüfprotokoll erfasst. Eine Datei enthält höchstens 50.000 Zeilen.',
    noAccess:
      'Es gibt keine Liste, die Sie exportieren können. Bitten Sie Ihre Administration um die passende Anzeigeberechtigung.',
    downloaded: '{{name}} heruntergeladen.',
    stockNote: 'Aktueller Bestand; der Zeitraum gilt hier nicht.',
    customersNote: 'Der Zeitraum bezieht sich auf das Registrierungsdatum.',
    kinds: {
      orders: {
        title: 'Bestellungen',
        lead: 'Eine Zeile pro Bestellung mit Beträgen, MwSt. und Rechnungsangaben.',
        action: 'Bestellungen herunterladen',
      },
      order_lines: {
        title: 'Bestellpositionen',
        lead: 'Eine Zeile pro Artikel mit MwSt.-Satz und Chargen.',
        action: 'Bestellpositionen herunterladen',
      },
      customers: {
        title: 'Kunden',
        lead: 'Mit Typ, Einwilligungen und Anzahl der Bestellungen.',
        action: 'Kunden herunterladen',
      },
      stock: {
        title: 'Bestand',
        lead: 'Nach Lager und Charge, mit Mindesthaltbarkeitsdaten.',
        action: 'Bestand herunterladen',
      },
      invoices: {
        title: 'Rechnungen',
        lead: 'Rechnungsnr., Typ, Nettobetrag, MwSt. und Gesamtbetrag.',
        action: 'Rechnungen herunterladen',
      },
      payments: {
        title: 'Zahlungen und Erstattungen',
        lead: 'Zahlungseingänge und Erstattungen; Erstattungen als negative Beträge.',
        action: 'Zahlungen herunterladen',
      },
    },
  },
  seo: {
    indexingTitle: 'Indexierung',
    indexingLead: 'Ob Suchmaschinen den Shop sehen können.',
    indexOpen: 'Für Suchmaschinen geöffnet',
    indexClosed: 'Für Suchmaschinen gesperrt',
    closedStore: 'Der Shop ist nicht live (Vorschau). Er wird freigegeben, sobald der Shop live geht.',
    closedServer: 'Der Shop ist live, aber die Indexierung (SITE_INDEXING) ist auf dem Server deaktiviert.',
    checked:
      'Geprüft: {{products}} Produkte, {{categories}} Kategorien, {{pages}} Seiten, {{posts}} Beiträge.',
    issuesTitle: 'SEO-Probleme',
    issuesLead:
      'Lücken in veröffentlichten Storefront-Inhalten. Der Bearbeiten-Link öffnet den passenden Bereich.',
    filter: 'Problemtyp',
    filterAll: 'Alle ({{count}} Elemente)',
    noIssues: 'Keine Probleme für diesen Filter',
    noIssuesLead: 'In veröffentlichten Inhalten wurden keine Lücken dieses Typs gefunden.',
    colKind: 'Typ',
    colTitle: 'Titel',
    colIssues: 'Probleme',
    editItem: '{{title}} bearbeiten',
    more: 'Die ersten {{shown}} Elemente werden angezeigt (insgesamt {{total}}).',
    kinds: {
      product: 'Produkt',
      category: 'Kategorie',
      page: 'Seite',
      post: 'Blogbeitrag',
    },
    issueNames: {
      title_long: 'Titel zu lang',
      title_duplicate: 'Doppelter Titel',
      description_missing: 'Keine Beschreibung',
      description_long: 'Beschreibung zu lang',
      description_short: 'Beschreibung zu kurz',
      image_missing: 'Kein Bild',
      image_alt_missing: 'Alt-Text fehlt',
      image_too_small: 'Hauptbild zu klein',
      image_low_resolution: 'Hauptbild mit niedriger Auflösung',
      gtin_invalid: 'Ungültiger Barcode (GTIN)',
      content_thin: 'Dünner Inhalt',
    },
    crawl: {
      title: 'Website-Crawler',
      lead: 'Durchsucht Ihre Storefront wie ein Besucher und findet technische Probleme (nur Ihre eigene Domain).',
      start: 'Crawl starten',
      started: 'Crawl in die Warteschlange gestellt.',
      none: 'Noch kein Crawl.',
      clean: 'Beim letzten Crawl wurden keine Probleme gefunden.',
      result: '{{pages}} Seiten, {{issues}} Probleme',
      truncated: 'Seitenlimit erreicht',
      failed: 'Fehlgeschlagen: {{reason}}',
      failReasons: {
        no_domain: 'Der Shop hat keine Storefront-Domain',
        site_protected:
          'Die Storefront ist passwortgeschützt (Staging); der Crawler kann die Seiten nicht lesen',
        home_unreachable: 'Die Startseite war nicht erreichbar',
        https_required: 'Die Storefront-Adresse verwendet kein https',
        private_address: 'Die Domain verweist auf eine interne Netzwerkadresse',
        unknown: 'Unerwarteter Fehler',
      },
      showingPrevious: 'Die folgenden Ergebnisse stammen aus dem letzten abgeschlossenen Crawl ({{time}}).',
      filter: 'Problemtyp',
      filterAll: 'Alle ({{count}})',
      tableLabel: 'Crawl-Probleme',
      colSeverity: 'Schweregrad',
      colType: 'Problem',
      colPath: 'Adresse',
      colDetail: 'Details',
      status: {
        queued: 'In Warteschlange',
        running: 'Läuft',
        completed: 'Abgeschlossen',
        failed: 'Fehlgeschlagen',
      },
      trigger: {
        manual: 'manuell',
        scheduled: 'wöchentlich',
      },
      severity: {
        error: 'Fehler',
        warning: 'Warnung',
        info: 'Info',
      },
      detailStatus: 'Status {{status}}',
      detailFrom: 'verlinkt von: {{list}}',
      detailCanonical: 'canonical: {{url}}',
      detailCount: '{{count}} Elemente',
      detailAlso: 'identisch mit: {{list}}',
      types: {
        fetch_failed: 'Seite nicht erreichbar',
        server_error: 'Serverfehler',
        broken_link: 'Defekter Link',
        sitemap_url_not_ok: 'Sitemap-Adresse lässt sich nicht öffnen',
        redirect_chain: 'Weiterleitungskette',
        redirected_link: 'Weitergeleiteter Link',
        title_missing: 'Kein Titel',
        title_duplicate: 'Doppelter Titel',
        description_missing: 'Keine Beschreibung',
        description_duplicate: 'Doppelte Beschreibung',
        h1_missing: 'Keine H1',
        h1_multiple: 'Mehrere H1',
        img_alt_missing: 'Bild ohne Alt-Text',
        canonical_mismatch: 'Canonical stimmt nicht überein',
        noindex_in_sitemap: 'Noindex-Seite in der Sitemap',
        orphan_page: 'Verwaiste Seite (keine Links)',
      },
    },
    historyTitle: 'SEO-Änderungsverlauf',
    historyLead: 'Änderungen an SEO-Titeln, -Beschreibungen und Slugs (letzte 50).',
    historyEmpty: 'Noch keine Änderungen an SEO-Feldern.',
    fields: {
      seoTitle: 'SEO-Titel',
      seoDescription: 'SEO-Beschreibung',
      slug: 'Slug (Adresse)',
    },
  },
  merchant: {
    previewTitle: 'Prüfung vor dem Feed',
    previewLead:
      'Geprüft werden Produkte, die im Shop veröffentlicht und für Endkunden sichtbar sind; Produkte mit Problemen werden nie an Google gesendet.',
    counts: {
      items: 'Zu sendende Angebote',
      inStock: 'Auf Lager',
      excluded: 'Nicht gesendete Produkte',
    },
    excludedTitle: 'Nicht gesendete Produkte',
    warningsTitle: 'Warnungen (werden gesendet)',
    colProduct: 'Produkt',
    colReason: 'Grund',
    reasons: {
      excluded_by_user: 'Im Produktbereich deaktiviert',
      health_not_approved: 'Keine tierärztliche Freigabe oder Inhalt geändert',
      health_claim: 'Krankheits-/Behandlungsaussage im Text',
      image_missing: 'Kein Bild',
      image_too_small: 'Bilder zu klein für Google (mindestens {{min}}×{{min}} px erforderlich)',
      image_too_large: 'Bilder größer als 64 Megapixel',
      price_missing: 'Kein Preis',
      price_not_tax_inclusive: 'Preis ohne MwSt.',
      translation_missing: 'Keine Übersetzung in der Sprache des Marktes',
      tax_rate_missing: 'Kein MwSt.-Satz für das Land des Marktes',
      no_variants: 'Keine aktive Variante',
      country_blocked: 'Produkt ist im Land dieses Marktes nicht zum Verkauf freigegeben',
    },
    warnings: {
      gtin_missing: 'Kein Barcode (GTIN)',
      description_missing: 'Keine Beschreibung',
      google_category_missing: 'Keine Google-Produktkategorie',
      title_truncated: 'Titel nach 150 Zeichen gekürzt',
      image_main_replaced: 'Erstes Bild zu klein für Google; das nächste Bild wurde als Hauptbild gesendet',
      image_below_upcoming_minimum:
        'Wird nach dem 31. Januar 2027 nicht mehr gesendet: Google verlangt mindestens 500×500 px',
      image_below_recommended: 'Hauptbild unter den empfohlenen 1500×1500 px',
      image_size_unknown: 'Größe des Hauptbilds unbekannt',
    },
    imageSize: 'erstes Bild {{size}} px',
    feedTitle: 'Feed-Datei',
    feedLead:
      'Fügen Sie diese Adresse im Merchant Center unter „Produkte → Datenquellen → Datei → Geplanter Abruf“ hinzu; Google ruft sie täglich ab. Keine Google-Verbindung erforderlich.',
    feedEnabled: 'Feed-Datei aktiv',
    feedSaved: 'Gespeichert.',
    previewMarket: 'Markt',
    marketsTitle: 'Märkte (Land und Sprache)',
    marketsLead:
      'Jeder an Google gesendete Markt erhält einen eigenen Feed und eine eigene Merchant-API-Datenquelle: Preis in der Währung und Preisliste dieses Marktes, Name und Beschreibung in der Sprache des Marktes, Versandarten dieses Landes.',
    marketsSaved: 'Märkte gespeichert.',
    defaultMarket: 'Standard',
    marketFeedUrl: 'Feed-Adresse für {{market}}',
    marketsNote:
      'Fügen Sie jeden Markt im Merchant Center als separate Datenquelle hinzu (mit Auswahl von Land und Sprache); bei der Merchant-API-Synchronisierung werden die Quellen automatisch angelegt. Mindestens ein Markt bleibt ausgewählt.',
    feedUrl: 'Feed-Adresse',
    lastFetch: 'Letzter Abruf: {{time}} ({{count}} Angebote)',
    neverFetched: 'Noch nicht abgerufen.',
    rotate: 'Adresse erneuern',
    rotateConfirm:
      'Die alte Adresse funktioniert sofort nicht mehr; aktualisieren Sie sie im Merchant Center.',
    apiTitle: 'Merchant API',
    apiLead:
      'Produkte werden über die Google-Verbindung direkt gesendet; Freigabestatus und Ablehnungsgründe werden hier angezeigt.',
    notLinked: 'Kein Merchant-Center-Konto ausgewählt',
    notLinkedLead:
      'Verbinden Sie sich im Bereich Google-Verbindungen mit der Merchant-Center-Berechtigung und wählen Sie das Konto für diesen Shop aus.',
    lastSync: 'Letzte Synchronisierung: {{time}}',
    neverSynced: 'Noch nicht synchronisiert',
    status: {
      approved: 'Freigegeben',
      pending: 'In Prüfung',
      disapproved: 'Abgelehnt',
    },
    syncNow: 'Jetzt senden',
    synced: '{{inserted}} gesendet, {{deleted}} gelöscht, {{unchanged}} unverändert.',
    issuesTitle: 'Probleme bei Google',
    issuesLead:
      'Abgelehnte oder mit Warnung versehene Angebote mit der Erklärung von Google und einem Link zur Dokumentation.',
    perfTitle: 'Produktleistung',
    perfLead:
      'Impressionen und Klicks Ihrer Produkte bei Google in kostenlosen Einträgen und Shopping-Anzeigen. Werden auf Anfrage aus dem Merchant Center gelesen.',
    perfPeriod: 'Zeitraum',
    perfLastDays: 'Letzte {{n}} Tage',
    perfTotals: 'Summen des Zeitraums',
    perfProduct: 'Produkt',
    perfOrganicClicks: 'Kostenlose Klicks',
    perfOrganicImpressions: 'Kostenlose Impressionen',
    perfAdsClicks: 'Anzeigenklicks',
    perfAdsImpressions: 'Anzeigenimpressionen',
    perfConversions: 'Conversions (kostenlos)',
    perfEmpty: 'Keine Impressionen bei Google in diesem Zeitraum.',
    perfNote:
      'Bis einschließlich gestern. Google meldet Conversions nur für kostenlose Einträge; Werbeausgaben und tatsächliche Bestellumsätze finden Sie im Werbecenter.',
    colOffer: 'Angebot (SKU)',
    colStatus: 'Status',
    colIssue: 'Problem',
    docs: 'Google-Dokumentation',
  },
  attribution: {
    builderTitle: 'Kampagnenlink erstellen',
    builderLead:
      'Fügt dem Link, den Sie in Anzeigen, E-Mails, sozialen Medien und QR-Codes verwenden, Quellinformationen (UTM) hinzu. Bestellungen werden im Bericht unten danach gruppiert.',
    url: 'Seitenadresse',
    fields: {
      source: 'Quelle (utm_source)',
      medium: 'Medium (utm_medium)',
      campaign: 'Kampagne (utm_campaign)',
      term: 'Keyword (utm_term)',
      content: 'Inhalt (utm_content)',
    },
    result: 'Kampagnenlink',
    resultEmpty: 'Geben Sie Adresse, Quelle, Medium und Kampagne ein',
    copy: 'Kopieren',
    copied: 'Link kopiert.',
    builderNote:
      'Werte werden kleingeschrieben und türkische Zeichen umgewandelt (z. B. „Ekim Bülteni“ → ekim-bulteni), damit eine Kampagne im Bericht eine einzige Zeile bildet.',
    reportTitle: 'Bestellungen nach Quelle',
    reportLead:
      'Echte Bestellungen (ohne Entwürfe und Stornierungen) nach ihrer Herkunftsquelle. Umsatz nur aus bezahlten Bestellungen; Erstattungen werden separat angezeigt.',
    period: 'Zeitraum',
    lastDays: 'Letzte {{n}} Tage',
    model: 'Kontaktpunkt',
    models: {
      last: 'Letzter Kontakt',
      first: 'Erster Kontakt',
    },
    dimension: 'Aufschlüsselung',
    dimensions: {
      source_medium: 'Quelle / Medium',
      campaign: 'Kampagne',
    },
    colSource: 'Quelle',
    colMedium: 'Medium',
    colCampaign: 'Kampagne',
    colOrders: 'Bestellungen',
    colPaid: 'Bezahlt',
    colRevenue: 'Umsatz (bezahlt)',
    colRefunded: 'Erstattungen',
    colNet: 'Netto',
    noConsent: 'Unbekannt (keine Cookie-Einwilligung)',
    direct: 'Direkt / unbekannt',
    noCampaign: 'Keine Kampagne',
    empty: 'Keine Bestellungen in diesem Zeitraum.',
    reportNote:
      'Quellinformationen werden nur erfasst, wenn der Besucher Analyse- oder Marketing-Cookies zugelassen hat; andere Bestellungen werden als „Unbekannt“ gezählt.',
  },
  webVitals: {
    statusTitle: 'Messung',
    statusLead:
      'Startseite, eine Kategorie, ein Produkt und ein Blogbeitrag werden mit Google PageSpeed Insights auf Mobilgeräten und Desktop gemessen. Live-Shops werden jeden Montag gemessen.',
    notConfigured: 'Kein PageSpeed-Insights-Schlüssel',
    notConfiguredLead:
      'Erstellen Sie in Google Cloud einen kostenlosen API-Schlüssel, geben Sie ihn unter Integrationen → PageSpeed Insights ein und testen Sie ihn.',
    start: 'Jetzt messen',
    running: 'Wird gemessen…',
    started: 'Messung gestartet; dies kann einige Minuten dauern.',
    lastRun: 'Letzte Messung: {{time}}',
    neverRun: 'Noch nicht gemessen.',
    resultsTitle: 'Neueste Ergebnisse',
    resultsLead:
      'Punktzahl: Lighthouse-Labortest (0–100). LCP, INP und CLS: echte Besucher der letzten 28 Tage (Chrome UX Report), die Google für das Ranking verwendet.',
    colPage: 'Seite',
    colDevice: 'Gerät',
    colScore: 'Punktzahl',
    colLcp: 'LCP',
    colInp: 'INP',
    colCls: 'CLS',
    thresholds:
      'Gut: LCP ≤ 2,5 s, INP ≤ 200 ms, CLS ≤ 0,1. Schlecht: LCP > 4 s, INP > 500 ms, CLS > 0,25. Punktzahl: 90+ gut, 50–89 verbesserungswürdig.',
    templates: {
      home: 'Startseite',
      category: 'Kategorie',
      product: 'Produkt',
      post: 'Blogbeitrag',
    },
    strategies: {
      mobile: 'Mobil',
      desktop: 'Desktop',
    },
    ratings: {
      good: 'Gut',
      needs_improvement: 'Verbesserungswürdig',
      poor: 'Schlecht',
    },
    change: '{{n}} ggü. vorher',
    scopes: {
      url: 'Diese Seite',
      origin: 'Gesamte Website (nicht genug Daten für diese Seite)',
      none: 'Nicht genug Besucherdaten',
    },
    fieldLine: 'Felddaten: {{scope}}',
    labLine: 'Labor: LCP {{lcp}} s, TBT {{tbt}} ms, CLS {{cls}}',
    units: {
      s: '{{n}} s',
      ms: '{{n}} ms',
    },
    runsTitle: 'Letzte Messungen',
    runStatus: {
      queued: 'In Warteschlange',
      running: 'Wird gemessen',
      completed: 'Abgeschlossen',
      failed: 'Fehlgeschlagen',
    },
    triggers: {
      manual: 'Manuell',
      scheduled: 'Wöchentlich',
    },
    errors: {
      psi_page_failed:
        'Seite konnte nicht geöffnet werden (die Storefront ist möglicherweise passwortgeschützt)',
      psi_key_invalid: 'API-Schlüssel nicht akzeptiert',
      psi_quota: 'Tageskontingent aufgebraucht',
      psi_timeout: 'Zeitüberschreitung bei der Messung',
      psi_unreachable: 'PageSpeed Insights nicht erreichbar',
      pagespeed_not_configured: 'Kein Schlüssel',
      store_has_no_domain: 'Shop hat keine Domain',
      unknown: 'Messung fehlgeschlagen',
    },
  },
  attributes: {
    title: 'Produktattribute',
    lead: 'Technische Eigenschaften von Produkten (z. B. Nettogewicht, Lebensphase, Geschmacksrichtung). Die Werte werden im Produktbereich eingegeben; sichtbare Attribute erscheinen in der Tabelle „Technische Daten“ auf der Produktseite.',
    add: 'Attribut hinzufügen',
    edit: 'Attribut bearbeiten',
    editItem: 'Attribut {{name}} bearbeiten',
    saved: 'Attribut gespeichert',
    deleted: 'Attribut gelöscht',
    deleteConfirm: '„{{name}}“ löschen? Der Wert bei {{count}} Produkten wird ebenfalls gelöscht.',
    emptyTitle: 'Noch keine Attribute',
    emptyLead:
      'Fügen Sie z. B. „Nettogewicht“ (Zahl, kg) oder „Lebensphase“ (Optionen: Kitten, Adult, Senior) hinzu.',
    name: 'Name',
    code: 'Kurzcode',
    type: 'Typ',
    types: {
      text: 'Text',
      number: 'Zahl',
      select: 'Option (einzeln)',
      multiselect: 'Optionen (mehrere)',
      boolean: 'Ja / Nein',
    },
    unit: 'Einheit',
    options: 'Optionen',
    optionsPlaceholder: 'Eine Option pro Zeile',
    where: 'Angezeigt in',
    onProductPage: 'Produktseite',
    inFilters: 'Filter',
    internal: 'Nur Verwaltung',
    productCount: 'Produkte',
    visible: 'Auf der Produktseite anzeigen',
    filterable: 'In Storefront-Filtern anzeigen',
    position: 'Reihenfolge',
    tagsTitle: 'Verwendete Tags',
    tagsLead:
      'An Produkte vergebene Tags und deren Produktanzahl. Tags werden im Produktbereich eingegeben; sie werden in der Storefront nicht angezeigt.',
    noTags: 'Noch keine Tags.',
  },
  collections: {
    title: 'Kollektionen',
    lead: 'Gruppen handverlesener Produkte oder von Produkten, die einer Regel entsprechen (z. B. „Produkte für Kitten“). Eine regelbasierte Kollektion aktualisiert sich selbst, wenn sich Produkte ändern.',
    add: 'Neue Kollektion',
    emptyTitle: 'Noch keine Kollektionen',
    emptyLead:
      'Wählen Sie Produkte manuell aus oder legen Sie eine Regel nach Kategorie, Marke, Tag, Tierart und Attributen fest.',
    name: 'Name',
    kind: 'Typ',
    kinds: {
      manual: 'Manuell ausgewählt',
      rule: 'Regelbasiert',
    },
    kindChoice: {
      manual: 'Ich wähle die Produkte selbst aus',
      rule: 'Produkte, die einer Regel entsprechen',
    },
    status: 'Status',
    statuses: {
      active: 'Aktiv',
      hidden: 'Ausgeblendet',
    },
    productCount: 'Produkte',
    saved: 'Kollektion gespeichert',
    deleted: 'Kollektion gelöscht',
    deleteConfirm: 'Kollektion „{{title}}“ löschen? Die Produkte werden nicht gelöscht.',
    backToList: 'Zurück zu den Kollektionen',
    basics: 'Grunddaten',
    slug: 'Slug (Adresse)',
    description: 'Beschreibung',
    seoTitle: 'SEO-Titel',
    seoDescription: 'SEO-Beschreibung',
    productsTitle: 'Produkte',
    pickProducts: 'Produkt hinzufügen',
    matchesTitle: 'Passende Produkte: {{count}}',
    matchesLead:
      'Produkte in der gespeicherten Kollektion (jeder Status; die Storefront zeigt nur veröffentlichte an).',
    previewLead: 'Vorschau: Die Regel ist noch nicht gespeichert.',
    noMatches: 'Keine passenden Produkte.',
    match: 'Bedingungen',
    matchAll: 'Alle Bedingungen müssen erfüllt sein',
    matchAny: 'Eine Bedingung genügt',
    conditions: 'Bedingungsliste',
    field: 'Feld',
    fields: {
      category: 'Kategorie',
      brand: 'Marke',
      tag: 'Tag',
      species: 'Tierart',
      attribute: 'Attribut',
    },
    attribute: 'Attribut',
    op: 'Vergleich',
    ops: {
      is: 'ist',
      is_not: 'ist nicht',
      gte: 'mindestens',
      lte: 'höchstens',
    },
    value: 'Wert',
    choose: 'Auswählen',
    addCondition: 'Bedingung hinzufügen',
    removeCondition: 'Bedingung entfernen',
    preview: 'Treffer anzeigen',
  },
  siteSearch: {
    reportTitle: 'Suchbericht',
    reportLead:
      'In der Storefront durchgeführte Suchen (der erste Aufruf einer Suchseite zählt als eine Suche). Es werden keine personenbezogenen Daten gespeichert.',
    period: 'Zeitraum',
    lastDays: 'Letzte {{days}} Tage',
    emptyTitle: 'Keine Suchen in diesem Zeitraum',
    emptyLead: 'Suchen erscheinen hier, sobald Besucher die Suche in der Storefront nutzen.',
    totalSearches: 'Suchen gesamt',
    distinctQueries: 'Unterschiedliche Suchen',
    zeroResultSearches: 'Suchen ohne Ergebnisse',
    topTitle: 'Am häufigsten gesucht',
    zeroTitle: 'Suchen ohne Ergebnisse',
    noZero: 'Keine Suchen ohne Ergebnisse.',
    noResults: 'Keine Ergebnisse',
    colQuery: 'Suche',
    colSearches: 'Anzahl',
    colResults: 'Letzte Ergebnisse',
    synonymsTitle: 'Synonyme',
    synonymsLead:
      'Wörter einer Gruppe werden füreinander gesucht (z. B. Futter, Nahrung). Nützlich bei Suchen ohne Ergebnisse.',
    addSynonym: 'Synonyme hinzufügen',
    editSynonym: 'Synonyme bearbeiten',
    editSynonymItem: 'Gruppe {{terms}} bearbeiten',
    deleteSynonymConfirm: 'Gruppe {{terms}} löschen?',
    synonymSaved: 'Synonyme gespeichert',
    synonymDeleted: 'Synonymgruppe gelöscht',
    noSynonyms: 'Noch keine Synonymgruppen.',
    terms: 'Wörter',
    termsPlaceholder: 'Durch Kommas getrennt: Futter, Nahrung',
  },
  keywords: {
    alertsTitle: 'Warnungen',
    alertsLead:
      'Aus den Search-Console-Daten der letzten 28 Tage: Seiten, die um dieselbe Suche konkurrieren, und Keywords ohne Zielseite.',
    noAlerts: 'Keine Warnungen.',
    none: 'Keine.',
    cannibalTitle: 'Kannibalisierung',
    gapTitle: 'Inhaltslücke',
    gapReasons: {
      no_target: 'Keine Zielseite',
      target_not_found: 'Zielseite nicht live',
    },
    inPool: 'Im Pool',
    target: 'Ziel',
    pageStats: '{{impressions}} Impressionen, {{clicks}} Klicks, Position {{position}}',
    poolTitle: 'Keyword-Pool',
    poolLead: 'Suchanfragen, auf die der Shop abzielt, mit den Search-Console-Daten der letzten 28 Tage.',
    add: 'Keyword hinzufügen',
    edit: 'Keyword bearbeiten',
    editItem: '{{keyword}} bearbeiten',
    saved: 'Gespeichert.',
    deleted: 'Gelöscht.',
    deleteConfirm: '„{{keyword}}“ aus dem Pool entfernen?',
    cluster: 'Cluster',
    allClusters: 'Alle Cluster',
    language: 'Sprache',
    allLanguages: 'Alle Sprachen',
    search: 'Suchen',
    emptyTitle: 'Noch keine Keywords',
    emptyLead: 'Nutzen Sie „Keyword hinzufügen“ oder wählen Sie aus den Search-Console-Vorschlägen unten.',
    colKeyword: 'Keyword',
    colTarget: 'Zielseite',
    colClicks: 'Klicks',
    colImpressions: 'Impressionen',
    colPosition: 'Ø Position',
    colTopPage: 'Seite mit den meisten Impressionen',
    cannibalized: 'Kannibalisierung',
    targetStatus: {
      ok: 'Live',
      missing: 'Kein Ziel',
      not_found: 'Nicht live',
      unverified: 'Nicht geprüft',
    },
    intents: {
      informational: 'Informativ',
      commercial: 'Kommerziell',
      transactional: 'Transaktional',
      navigational: 'Navigation',
    },
    metricsNote:
      'Klicks, Impressionen und Position sind die Search-Console-Daten der letzten 28 Tage (etwa 2 Tage Verzögerung).',
    keyword: 'Keyword',
    intent: 'Suchintention',
    intentNone: 'Nicht festgelegt',
    targetPath: 'Zielseite',
    notes: 'Notiz',
    candidatesTitle: 'Search-Console-Vorschläge',
    candidatesLead:
      'Suchanfragen, die nicht im Pool sind, mit den meisten Impressionen in den letzten 28 Tagen. Auswählen und hinzufügen; die Zielseite wird anhand der Seite mit den meisten Impressionen vorgeschlagen.',
    notSynced:
      'Noch keine Search-Console-Daten. Wählen Sie im Bereich Suchleistung eine Property aus und synchronisieren Sie:',
    noCandidates: 'Keine neuen Vorschläge; alle Suchanfragen sind im Pool.',
    candidateStats: '{{impressions}} Impressionen, {{clicks}} Klicks, Position {{position}}',
    importCluster: 'Cluster',
    importSelected: 'Ausgewählte hinzufügen ({{n}})',
    imported: '{{created}} Keywords hinzugefügt, {{skipped}} waren bereits vorhanden.',
    rankTitle: 'Ranking-Tracking',
    rankLead:
      'Für das tägliche Tracking von Google-Rankings ist ein lizenzierter (kostenpflichtiger) Datenanbieter erforderlich; bis einer ausgewählt und sein Schlüssel eingegeben ist, wird „Einrichtung erforderlich“ angezeigt. Vorerst entspricht die Position dem Search-Console-Durchschnitt.',
  },
  scSetup: {
    title: 'Mit Google verbinden und einrichten',
    lead: 'Ein Knopf: Das System bestätigt und ergänzt die Search-Console-Properties der Shop-Domain und der alten Domains, reicht die Sitemap ein und ordnet die in Google sichtbaren Seiten der alten Website neuen Adressen zu. Jeden Morgen prüft es Produktseiten und Beispiele alter Adressen in Google.',
    connectedAs: 'Verbundenes Google-Konto: {{email}}',
    notConnected: 'Kein Google-Konto verbunden.',
    missingScope: 'Berechtigung zur Website-Bestätigung fehlt: mit „Mit Google verbinden“ erteilen.',
    connect: 'Mit Google verbinden',
    run: 'Einrichtung ausführen',
    rerun: 'Einrichtung erneut ausführen',
    done: 'Search-Console-Einrichtung abgeschlossen',
    siteOk: 'Bestätigt und zur Search Console hinzugefügt',
    siteVerifiedOnly: 'Bestätigt; konnte nicht zur Search Console hinzugefügt werden',
    siteFailed: 'Abgebrochen bei {{step}}: {{reason}}',
    enableApi:
      'Im Google-Cloud-Projekt muss „{{api}}“ aktiviert werden (kostenlos); danach die Einrichtung erneut ausführen.',
    enableApiLink: 'Aktivierungsseite öffnen',
    sitePending: 'Noch nicht eingerichtet',
    lastRun: 'Letzte Einrichtung: {{date}}',
    sitemapOk: 'Sitemap eingereicht: {{url}}',
    sitemapFailed: 'Sitemap konnte nicht eingereicht werden: {{reason}}',
    sitemapSkipped: 'Sitemap nicht eingereicht (Shop-Property konnte nicht hinzugefügt werden).',
    legacyPages:
      '{{found}} in Google sichtbare Seiten der alten Properties: {{matched}} neue Zuordnungen, {{table}} bereits weitergeleitet, {{fallback}} ohne Gegenstück (Defekte Links).',
    publishNote:
      'Für eine dauerhafte Verbindung muss die OAuth-App in Google Cloud „In Produktion“ sein; die Berechtigung einer App im Status „Test“ läuft nach 7 Tagen ab.',
    inspectionsTitle: 'Google-Indexstatus (tägliche URL-Prüfung)',
    inspectionsEmpty:
      'Noch keine Prüfungen. Die ersten Ergebnisse erscheinen am Morgen nach der Einrichtung.',
    colUrl: 'Adresse',
    colKind: 'Art',
    colState: 'Status in Google',
    colCrawl: 'Letztes Crawling',
    checkedAt: 'geprüft: {{date}}',
    roles: {
      store: 'Shop',
      legacy: 'Alte Domain',
    },
    kinds: {
      product: 'Produktseite',
      legacy: 'Alte Adresse',
    },
    steps: {
      token: 'Bestätigungsdatei',
      verify: 'Bestätigung',
      add: 'Hinzufügen zur Search Console',
      link: 'Verknüpfung',
      sitemap: 'Sitemap',
      pages: 'alte Seiten',
    },
  },
  indexNow: {
    title: 'IndexNow (Bing, Yandex)',
    lead: 'Geänderte Produkt-, Kategorie-, Seiten- und Artikeladressen werden alle zehn Minuten an Bing und Yandex gemeldet; beim ersten Lauf werden alle Adressen einmal gesendet.',
    notLive: 'Der Shop ist nicht live: es wird nichts gesendet.',
    indexingOff: 'Die Indexierung ist auf dem Server aus: es wird nichts gesendet.',
    key: 'Schlüssel: {{key}} (Datei ist auf der Website erreichbar)',
    noKey: 'Der Schlüssel wird bei der ersten Meldung erzeugt.',
    last: 'Letzte Meldung: {{date}} · {{count}} Adressen',
    never: 'Noch nichts gemeldet.',
    failed: 'Meldung fehlgeschlagen: {{reason}}',
    sent: '{{count}} Adressen an IndexNow gesendet',
    submit: 'Alle Adressen jetzt senden',
    skipped: {
      not_live: 'Der Shop ist nicht live.',
      indexing_off: 'Die Indexierung ist aus.',
      no_domain: 'Der Shop hat keine Domain.',
      nothing_changed: 'Keine Adressen zu senden.',
    },
  },
  sc: {
    notLinked: 'Keine Search-Console-Property ausgewählt',
    notLinkedLead:
      'Verbinden Sie Ihr Google-Konto und wählen Sie die Search-Console-Property dieses Shops; die Daten kommen am nächsten Morgen (oder sofort mit „Jetzt synchronisieren“).',
    statusTitle: 'Verknüpfte Property',
    lastSync: 'Letzte Synchronisierung: {{time}}',
    neverSynced: 'Noch nicht synchronisiert',
    dataRange: 'Daten: {{from}} – {{to}}',
    syncNow: 'Jetzt synchronisieren',
    synced: 'Synchronisierung abgeschlossen ({{rows}} Zeilen).',
    noData:
      'Noch keine Daten. Nutzen Sie „Jetzt synchronisieren“; bei neuen Properties liegen Google-Daten erst nach einigen Tagen vor.',
    summaryTitle: 'Zusammenfassung',
    period: 'Zeitraum',
    lastDays: 'Letzte {{count}} Tage',
    metrics: {
      clicks: 'Klicks',
      impressions: 'Impressionen',
      ctr: 'Klickrate',
      position: 'Durchschnittliche Position',
    },
    vsPrevious: '{{change}} ggü. Vorzeitraum',
    chartLabel: 'Diagramm der täglichen Klicks',
    chartCaption: 'Tägliche Klicks (Google-Daten hinken etwa 2 Tage hinterher).',
    tableTitle: 'Details',
    dimension: 'Anzeigen',
    dims: {
      query: 'Suchanfragen',
      page: 'Seiten',
      country: 'Länder',
      device: 'Geräte',
    },
    devices: {
      mobile: 'Mobil',
      desktop: 'Desktop',
      tablet: 'Tablet',
    },
    filter: 'Suchen',
    noRows: 'Keine Zeilen in diesem Zeitraum.',
    moversTitle: 'Steigende und fallende Seiten',
    moversLead: 'Klicks im letzten Zeitraum im Vergleich zum vorherigen, gleich langen Zeitraum.',
    rising: 'Steigend',
    falling: 'Fallend',
    noMovers: 'Keine nennenswerte Veränderung.',
    notComparable:
      'Für den vorherigen Zeitraum liegen noch keine Daten vor (Search-Console-Daten sammeln sich täglich an).',
    sitemapsTitle: 'Sitemaps',
    sitemapsLead: 'An die Search Console übermittelte Sitemaps und ihr Status.',
    sitemapsError: 'Sitemaps konnten nicht gelesen werden; testen Sie die Google-Verbindung.',
    noSitemaps: 'Noch keine Sitemap übermittelt.',
    colSitemap: 'Sitemap',
    colSubmitted: 'Übermittelt',
    colStatus: 'Status',
    colUrls: 'URLs',
    sitemapPending: 'Wird verarbeitet',
    sitemapOk: 'Verarbeitet',
    sitemapErrors: '{{count}} Fehler',
    ownSitemap: 'Sitemap des Shops:',
    notInProperty: 'Nicht von der Property abgedeckt',
    submitSitemap: 'Sitemap übermitteln',
    sitemapSubmitted: 'Sitemap an die Search Console übermittelt.',
    inspectTitle: 'URL-Prüfung',
    inspectLead: 'Der Status einer Seite im Google-Index (URL-Prüfung der Search Console).',
    inspectUrl: 'Seitenadresse',
    inspect: 'Prüfen',
    quota: 'Heute {{used}} / {{limit}} Prüfungen genutzt.',
    verdicts: {
      PASS: 'Indexiert',
      PARTIAL: 'Teilweise (mit Warnungen)',
      FAIL: 'Nicht indexiert (Fehler)',
      NEUTRAL: 'Nicht indexiert',
      VERDICT_UNSPECIFIED: 'Unbekannt',
    },
    inspectFields: {
      verdict: 'Ergebnis',
      coverageState: 'Abdeckung',
      indexingState: 'Indexierung erlaubt',
      robotsTxtState: 'robots.txt',
      pageFetchState: 'Seitenabruf',
      lastCrawlTime: 'Letzter Crawl',
      googleCanonical: 'Von Google gewählte Canonical-URL',
    },
    digestTitle: 'Wöchentliche E-Mail-Zusammenfassung',
    digestLead:
      'Jeden Montag um 09:00 Uhr erhalten die Empfänger von Warnungen eine Übersicht über die letzten 7 Tage, die wichtigsten Suchanfragen, steigende/fallende Seiten und den letzten Website-Crawl.',
    digestToggle: 'Wöchentliche E-Mail-Zusammenfassung',
    digestSaved: 'Gespeichert.',
  },
  google: {
    connected: 'Google-Konto verbunden.',
    clientTitle: 'OAuth-Client',
    clientLead:
      'Der OAuth-Client, den Sie in der Google Cloud Console erstellt haben. ID und Secret werden unter Integrationen verschlüsselt gespeichert.',
    clientOk: 'Verifiziert',
    clientMissing:
      'Geben Sie zuerst unter Integrationen → Google-Konto (OAuth-Client) die Client-ID und das Secret ein und testen Sie sie.',
    toIntegrations: 'Zu den Integrationen',
    redirectUri: 'Autorisierte Weiterleitungs-URI',
    copy: 'Kopieren',
    copied: 'Adresse kopiert.',
    accountTitle: 'Google-Konto',
    accountLead:
      'Sie genehmigen die ausgewählten Dienste auf dem Einwilligungsbildschirm von Google; Ihr Passwort erreicht uns nie.',
    account: 'Verbundenes Konto',
    connectedAt: 'Verbunden am',
    lastChecked: 'Zuletzt geprüft',
    notConnected: 'Noch kein Google-Konto verbunden.',
    chooseServices: 'Zu verbindende Dienste',
    permissionsTitle: 'Erteilte Berechtigungen',
    granted: 'Erteilt',
    notGranted: 'Nicht erteilt',
    connect: 'Mit Google verbinden',
    reconnect: 'Erneut verbinden',
    test: 'Verbindung testen',
    testOk: 'Die Verbindung funktioniert.',
    testFailed: 'Bei der Verbindung gibt es Probleme; siehe Protokoll.',
    disconnect: 'Verbindung entfernen',
    disconnectConfirm:
      'Der Google-Zugriff wird widerrufen, und die für Shops ausgewählten Properties/Konten werden entfernt.',
    disconnected: 'Verbindung entfernt und Zugriff bei Google widerrufen.',
    disconnectedLocal:
      'Verbindung entfernt; Google war nicht erreichbar. Entfernen Sie den Zugriff daher auch in Ihrem Google-Konto.',
    status: {
      active: 'Aktiv',
      error: 'Fehler',
    },
    errors: {
      token_revoked: 'Der Zugriff wurde bei Google entfernt; verbinden Sie sich erneut.',
      userinfo_failed: 'Kontoinformationen konnten nicht gelesen werden.',
      resource_not_accessible: 'Auf diese Ressource kann nicht mehr zugegriffen werden.',
      insufficient_scope: 'Berechtigung nicht erteilt.',
      permission_denied: 'Kein Zugriff auf diese Ressource.',
      api_not_enabled: 'API im Cloud-Projekt nicht aktiviert.',
      unauthorized: 'Autorisierung abgelehnt.',
      quota_exceeded: 'Google-Kontingent erschöpft; es wird später erneut versucht.',
      http_error: 'Google hat die Anfrage abgelehnt.',
      network: 'Google konnte nicht erreicht werden.',
      timeout: 'Google hat nicht rechtzeitig geantwortet.',
    },
    services: {
      search_console: 'Search Console',
      analytics: 'Google Analytics 4',
      merchant_center: 'Merchant Center',
      google_ads: 'Google Ads',
      business_profile: 'Google Business Profile',
    },
    serviceLeads: {
      search_console: 'Suchanfragen, Seitenleistung, Einreichen der Sitemap.',
      analytics: 'Property-Liste und Berichte (nur Lesezugriff).',
      merchant_center: 'Produktdaten und Produktstatus.',
      google_ads:
        'Werbeausgaben (ins Werbezentrum) und optionaler Conversion-Upload. Kein Entwickler-Token nötig; ein echtes Konto erfordert Explorer-Zugriff für das Cloud-Projekt.',
      business_profile: 'Standortdaten des Unternehmens und Google-Bewertungen (nur Lesezugriff).',
    },
    resourcesTitle: 'Shop-Ressourcen',
    resourcesLead:
      'Welche Search-Console-Property, GA4-Property, welches Merchant-Center-Konto, Google-Ads-Kundenkonto und welchen Business-Profile-Standort jeder Shop verwendet.',
    notLinked: 'Nicht ausgewählt.',
    serviceNotGranted:
      'Für diesen Dienst wurde keine Berechtigung erteilt; wählen Sie ihn aus und verbinden Sie sich erneut.',
    choose: 'Auswählen',
    change: 'Ändern',
    unlink: 'Entfernen',
    linked: 'Ressource gespeichert.',
    unlinked: 'Ressourcenverknüpfung entfernt.',
    resourceLabel: '{{service}}-Ressource',
    pick: 'Auswählen',
    noResources:
      'Dieses Google-Konto hat auf keine Ressource Zugriff. Erteilen Sie den Zugriff bei Google und laden Sie die Seite neu.',
    lastSync: 'Letzte Synchronisierung: {{time}}',
    noSyncYet: 'Noch nicht synchronisiert',
    logsTitle: 'Protokoll',
    logsLead: 'Die letzten 50 Vorgänge. Tokens und personenbezogene Daten werden niemals protokolliert.',
    noLogs: 'Noch keine Einträge.',
    colTime: 'Zeit',
    colOperation: 'Vorgang',
    colOutcome: 'Ergebnis',
    colDetail: 'Detail',
    logError: 'Fehler: {{code}}',
    operations: {
      oauth_start: 'Verbindung gestartet',
      oauth_callback: 'Google-Antwort',
      token_refresh: 'Token-Aktualisierung',
      list_resources: 'Ressourcenliste',
      verify_resource: 'Kontozugriffsprüfung',
      test: 'Verbindungstest',
      revoke: 'Zugriff widerrufen',
    },
    outcomes: {
      success: 'Erfolgreich',
      failure: 'Fehlgeschlagen',
      blocked: 'Blockiert',
    },
  },
  tracking: {
    crossDomain: {
      title: 'Domainübergreifendes Tracking',
      lead: 'Hat der Shop mehrere Storefront-Domains, werden Besucher beim Wechsel zwischen ihnen als derselbe Besucher mit derselben Quelle (Kampagne) gemessen.',
      active: 'Aktiv',
      inactive: 'Nicht nötig',
      activeLead: 'GA4-Linker und Quelldaten werden über {{count}} Domains übertragen.',
      reasons: {
        single_domain:
          'Der Shop hat nur eine Storefront-Domain; mit einer zweiten Domain schaltet sich dies selbst ein.',
        no_google_tag: 'Keine GA4-Mess-ID und kein GTM-Container eingetragen.',
      },
      toDomains: 'Zu den Domains',
      domains: 'Domains im domainübergreifenden Tracking',
      stepsTitle: 'Zu erledigen',
      stepAuto:
        'Die Storefront ergänzt Links zwischen diesen Domains selbst um den GA4-Linker-Parameter und die Quelldaten; Besuche von diesen Domains zählen nicht als Verweis.',
      stepGa4:
        'Fügen Sie diese Domains in Google Analytics unter Verwaltung → Datenstreams → Webstream → Tag-Einstellungen konfigurieren → Domains konfigurieren hinzu. Bei GTM erforderlich.',
      stepReferrals:
        'Damit diese Wechsel nicht als Verweise erscheinen, fügen Sie sie bei Bedarf an derselben Stelle unter „Unerwünschte Verweise auflisten“ hinzu.',
      stepConsent:
        'Die Cookie-Einwilligung gilt pro Domain: Besucher werden auf der anderen Domain erneut gefragt; Quelldaten werden dort nur mit Einwilligung gespeichert.',
    },
    server: {
      title: 'Serverseitige Ereignisse',
      lead: 'Abgeschlossene Verkäufe und Erstattungen werden zusätzlich vom Server gesendet, unabhängig vom Browser: So werden auch Bestellungen per Banküberweisung und Nachnahme sowie Verkäufe von Besuchern mit Werbeblockern erfasst. Die Cookie-Einwilligung des Besuchers zum Zeitpunkt der Bestellung wird berücksichtigt.',
      providers: {
        ga4: 'Google Analytics 4 (Measurement Protocol)',
        meta: 'Meta (Conversions API)',
        tiktok: 'TikTok (Events API)',
      },
      short: {
        ga4: 'GA4',
        meta: 'Meta',
        tiktok: 'TikTok',
      },
      status: {
        live: 'An',
        off: 'Aus',
        needs_secret: 'Einrichtung erforderlich',
        needs_id: 'Keine ID',
      },
      needsId: {
        ga4: 'Geben Sie zuerst oben unter „Storefront-Tags“ die GA4-Mess-ID ein.',
        meta: 'Geben Sie zuerst oben unter „Storefront-Tags“ die Meta-Pixel-ID ein.',
        tiktok: 'Geben Sie zuerst oben unter „Storefront-Tags“ die TikTok-Pixel-ID ein.',
      },
      secret: {
        ga4: 'API-Secret (Measurement Protocol)',
        meta: 'Zugriffstoken (Conversions API)',
        tiktok: 'Zugriffstoken (Events API)',
      },
      secretSaved: 'Gespeichert – geben Sie einen neuen Wert ein, um ihn zu ersetzen',
      testCode: 'Testereigniscode',
      enabled: 'Serverereignisse senden',
      save: 'Speichern',
      saved: 'Gespeichert.',
      test: 'Testereignis senden',
      testOk: 'Das Testereignis hat den Anbieter erreicht.',
      testFailed: 'Test fehlgeschlagen: {{reason}}',
      remove: 'Secret entfernen',
      removeConfirm: 'Das Secret wird gelöscht und Serverereignisse an diesen Anbieter werden eingestellt.',
      last24h:
        'Letzte 24 Stunden: {{sent}} gesendet, {{failed}} fehlgeschlagen, {{pending}} ausstehend, {{skipped}} nicht gesendet.',
      userData: 'Abgleich personenbezogener Daten (E-Mail- und Telefon-Hash)',
      userDataLead:
        'Wenn aktiviert, werden E-Mail-Adresse und Telefonnummer des Kunden als SHA-256-Hashes an Meta und TikTok gesendet. Dies ist eine Übermittlung personenbezogener Daten: Aktualisieren Sie zuerst gemeinsam mit Ihrem Rechtsbeistand die Datenschutzhinweise und die Cookie-Richtlinie. Standardmäßig deaktiviert.',
      logTitle: 'Serverereignisprotokoll',
      logLead:
        'Die letzten 100 Ereignisse: gesendete Daten, Versuche und die Fehlermeldung des Anbieters. Aufbewahrung für 90 Tage.',
      logEmpty:
        'Noch keine Serverereignisse. Sie erscheinen, sobald die Bestellung eines Besuchers mit Einwilligung bezahlt wird.',
      filter: 'Status',
      all: 'Alle',
      eventStatus: {
        pending: 'Ausstehend',
        sent: 'Gesendet',
        failed: 'Fehlgeschlagen',
        skipped: 'Nicht gesendet',
      },
      events: {
        purchase: 'Kauf',
        refund: 'Erstattung',
      },
      colTime: 'Zeit',
      colProvider: 'Anbieter',
      colEvent: 'Ereignis',
      colOrder: 'Bestellung',
      colStatus: 'Status',
      colDetail: 'Details',
      attempts: '{{n}} Versuche',
      payload: 'Gesendete Daten',
      retry: 'Erneut versuchen',
      retried: 'Erneut in die Warteschlange gestellt.',
      errors: {
        no_client_id: 'Kein GA-Cookie (Besucher hat bestellt, bevor GA geladen wurde)',
        no_match_keys: 'Keine passende ID (kein Pixel-Cookie)',
        disabled: 'Nicht gesendet, da das Senden deaktiviert war',
        timeout: 'Der Anbieter hat nicht rechtzeitig geantwortet',
        network: 'Der Anbieter konnte nicht erreicht werden',
        redirect:
          'Der Anbieter hat die Anfrage umgeleitet (die Dienstadresse hat sich möglicherweise geändert)',
      },
    },
    statusTitle: 'Storefront-Status',
    statusLead:
      'Tags werden in der Storefront nur geladen, solange die Cookie-Richtlinie veröffentlicht ist, und nur mit Einwilligung des Besuchers.',
    active: 'Aktiv',
    inactive: 'Nicht aktiv',
    activeLead: 'Tags, die bei Einwilligung des Besuchers geladen werden: {{list}}.',
    reasons: {
      no_tags:
        'Noch keine Tags. Die Storefront zeigt kein Cookie-Banner und verwendet nur notwendige Cookies.',
      cookie_policy_missing:
        'Tags werden der Storefront nicht hinzugefügt, da keine Cookie-Richtlinie veröffentlicht ist. Veröffentlichen Sie sie zuerst unter „Rechtstexte“.',
    },
    toLegal: 'Zu den Rechtstexten',
    tagsTitle: 'Tags',
    tagsLead:
      'Kopieren Sie die IDs aus den jeweiligen Konten. Ein leeres Feld bedeutet, dass dieses Tag nicht verwendet wird.',
    fields: {
      gtmContainerId: 'Google-Tag-Manager-ID',
      ga4MeasurementId: 'GA4-Mess-ID',
      googleAdsId: 'Google-Ads-ID',
      googleAdsPurchaseLabel: 'Conversion-Label für Käufe',
      metaPixelId: 'Meta-Pixel-ID',
      tiktokPixelId: 'TikTok-Pixel-ID',
    },
    consentNote:
      'GA4 wird nur mit Einwilligung in Analyse geladen, Google Ads, Meta und TikTok nur mit Einwilligung in Marketing, GTM mit einer der beiden. Bei Besuchern, die ablehnen, wird kein Tag ausgeführt.',
    save: 'Tags speichern',
    saved: 'Tags gespeichert. Sie werden innerhalb weniger Minuten in der Storefront wirksam.',
    providers: {
      site: 'Storefront (Einwilligungsauswahl)',
      gtm: 'Google Tag Manager',
      ga4: 'Google Analytics 4',
      googleAds: 'Google Ads',
      meta: 'Meta-Pixel',
      tiktok: 'TikTok-Pixel',
    },
    legal: {
      title: 'Auswirkungen auf Rechtstexte',
      lead: 'Cookies der konfigurierten Tags und Datenempfänger – und ob die veröffentlichten Texte sie erwähnen.',
      policyVersion: 'Veröffentlichte Cookie-Richtlinie: Version {{version}}.',
      policyMissing: 'Es ist keine Cookie-Richtlinie veröffentlicht.',
      actionNeeded:
        'Einige Cookies oder Übermittlungen werden nicht erwähnt: Lassen Sie die Texte von Ihrem Rechtsbeistand aktualisieren und veröffentlichen Sie eine neue Version.',
      cookiesTitle: 'Cookies',
      transfersTitle: 'Datenübermittlungen (ins Ausland)',
      colCookie: 'Cookie',
      colService: 'Dienst',
      colDuration: 'Dauer',
      colRecipient: 'Empfänger',
      colCountries: 'Länder',
      colInPolicy: 'In der Cookie-Richtlinie',
      colInNotice: 'In den Datenschutzhinweisen',
      found: 'Erwähnt',
      missing: 'Nicht erwähnt',
      days: '{{count}} Tage',
      note: 'Das System verfasst keine Rechtstexte; es prüft nur, ob die Cookie- und Anbieternamen darin vorkommen. Cookie-Namen und -Laufzeiten richten sich nach der Dokumentation der Anbieter und können sich ändern. Wenn eine neue Version der Cookie-Richtlinie veröffentlicht wird, werden die Besucher erneut gefragt.',
    },
    stats: {
      title: 'Statistik zur Cookie-Einwilligung',
      lead: 'Letzte 30 Tage; gezählt wird die jeweils letzte Auswahl pro Browser.',
      none: 'Keine Auswahl in den letzten 30 Tagen.',
      visitors: 'Browser mit Auswahl',
      acceptAll: 'Alle akzeptiert',
      rejectAll: 'Abgelehnt',
      custom: 'In den Einstellungen ausgewählt',
      analytics: 'Analyse erlaubt',
      marketing: 'Marketing erlaubt',
    },
  },
  migration: {
    exportTitle: 'Export (Staging)',
    exportLead:
      'Lädt die Konfiguration und die Inhalte des ausgewählten Shops als eine ZIP-Datei herunter. Laden Sie sie in der Live-Verwaltung über „Importieren“ hoch.',
    sourceStore: 'Shop',
    export: 'Migrationspaket herunterladen',
    exported: 'Migrationspaket heruntergeladen',
    included:
      'Enthalten: Produkte, Kategorien, Preislisten und Preise, Lagerbestände (mit Charge/MHD), Rechtstexte, Seiten, Blog, Menüs, Banner, Theme, Versandarten, Bankkonten, Shop- und Unternehmensdaten, Weiterleitungen und Bilder.',
    excluded:
      'Nicht enthalten: Kunden, Händler, Bestellungen, Zahlungen, Prüfprotokoll, Benutzer, Domains, die Steuernummer des Unternehmens sowie alle Schlüssel/Passwörter (SMTP, iyzico, PayTR, API).',
    importTitle: 'Import (Live)',
    importLead:
      'Zuerst wird eine Vorschau angezeigt: Es wird nichts geschrieben. Der Abgleich erfolgt über Slug, SKU, Code und IBAN; ein erneutes Hochladen desselben Pakets erzeugt keine Duplikate.',
    targetStore: 'Zielshop',
    targetFromPackage: 'Shop aus dem Paket (Abgleich über den Code; wird angelegt, falls nicht vorhanden)',
    includeStock: 'Lagerbestände als Anfangsbestand übernehmen',
    overwrite:
      'Abweichende vorhandene Datensätze überschreiben (aus: nur fehlende Datensätze werden hinzugefügt)',
    legalReviewed:
      'Ich bestätige, dass die Rechtstexte von einem Rechtsanwalt geprüft wurden (Veröffentlichung mit der Markierung „geprüft“)',
    carryApprovals: 'Ich übernehme die im Staging erteilten tierärztlichen (Fach-)Freigaben in meinem Namen',
    chooseFile: 'Paketdatei auswählen und Vorschau anzeigen',
    previewOf: 'Paket aus dem Shop „{{store}}“ von {{org}} ({{env}}), exportiert am {{date}}.',
    storeWillCreate:
      'Der Shop „{{store}}“ existiert hier nicht; er wird im Vorschaumodus angelegt (fügen Sie die Domain später hinzu).',
    sectionsCaption: 'Aktionen pro Bereich',
    section: 'Bereich',
    create: 'Hinzuzufügen',
    update: 'Zu aktualisieren',
    unchanged: 'Unverändert',
    skipped: 'Übersprungen',
    stockTitle: 'Anfangsbestand (pro Produkt)',
    stockSkipped: 'Bestand wird nicht übernommen (Option deaktiviert)',
    product: 'Produkt',
    stockStatus: 'Status',
    stockStatus_new: 'Zu schreiben',
    stockStatus_already: 'Bereits geschrieben',
    stockStatus_exists: 'Das Lager hat bereits Bestandsdatensätze; übersprungen',
    stockStatus_missing: 'Produkt oder Lager fehlt',
    approvalsPending:
      '{{products}} Produkte und {{content}} Inhalte warten auf die tierärztliche Freigabe (Freigaben nicht übernommen) und sind bis dahin in der Storefront ausgeblendet.',
    legalWithReview:
      'Rechtstexte werden mit der Markierung „von einem Rechtsanwalt geprüft“ veröffentlicht: {{list}}',
    legalWithoutReview:
      'Rechtstexte werden ohne die Markierung „von einem Rechtsanwalt geprüft“ veröffentlicht (eine Voraussetzung für den Livegang): {{list}}',
    warnings: {
      migration_no_secrets:
        'Schlüssel und Passwörter sind nicht im Paket enthalten: Geben Sie SMTP-, Zahlungs- und Versanddaten in der Live-Verwaltung erneut ein.',
      migration_card_off:
        'Die Kartenzahlung ist nach dem Import deaktiviert; aktivieren Sie sie in den Zahlungseinstellungen, nachdem die Schlüssel eingegeben und getestet wurden.',
      migration_domains_manual:
        'Domains werden nicht übernommen; fügen Sie die Live-Domain unter „Shops“ hinzu.',
    },
    refresh: 'Vorschau aktualisieren',
    stale: 'Optionen geändert; aktualisieren Sie die Vorschau',
    apply: 'Importieren',
    applyConfirm:
      'Das Paket wird auf dieses Unternehmen angewendet (in einer einzigen Transaktion). Vorhandene Datensätze ändern sich nur, wenn „Überschreiben“ aktiviert ist. Fortfahren?',
    applied: 'Migrationspaket angewendet',
    resultTitle: 'Auf den Shop „{{store}}“ angewendet. Ergebnis:',
    sections: {
      store: 'Shop',
      organization: 'Unternehmensdaten',
      files: 'Bilder',
      brands: 'Marken',
      taxClasses: 'Steuerklassen',
      categories: 'Kategorien',
      customerGroups: 'Kundengruppen',
      warehouses: 'Lager',
      products: 'Produkte',
      productOptions: 'Produktoptionen',
      productVariants: 'Varianten (SKU)',
      productCategories: 'Produkt-Kategorie-Zuordnungen',
      productMedia: 'Produktbilder',
      markets: 'Märkte',
      storeBrands: 'Shop-Marken',
      priceLists: 'Preislisten',
      prices: 'Preise',
      productStoreListings: 'Produkteinträge',
      shippingMethods: 'Versandarten',
      paymentSettings: 'Zahlungseinstellungen (Karte deaktiviert)',
      bankAccounts: 'Bankkonten',
      legalDocuments: 'Rechtstexte',
      legalDocumentVersions: 'Rechtstextversionen',
      postCategories: 'Blog-Kategorien',
      posts: 'Blogbeiträge',
      postVersions: 'Beitragsversionen',
      pages: 'Seiten',
      pageVersions: 'Seitenversionen',
      banners: 'Banner',
      menus: 'Menüs',
      themes: 'Theme',
      themeVersions: 'Theme-Versionen',
      redirects: 'Weiterleitungen',
    },
  },
  uiTranslations: {
    coverageTitle: 'Übersetzungsstand je Sprache',
    coverageLead:
      'Abdeckung der Oberflächentexte (Verwaltung, Storefront, Mobil) und der Hilfetexte je Sprache. Ausgangssprache ist Türkisch; fehlende Texte fallen auf Englisch, dann auf Türkisch zurück.',
    language: 'Sprache',
    ui: 'Oberflächentexte',
    help: 'Hilfetexte',
    direction: 'Schreibrichtung',
    ltr: 'Links nach rechts',
    rtl: 'Rechts nach links',
    complete: 'Vollständig ({{total}})',
    missing: '{{count}} von {{total}} fehlen',
    missingKeys: '{{language}}: fehlende Schlüssel ({{count}})',
    helpNote:
      'In anderen Sprachen stammen ausführliche Hilfefelder aus dem türkischen Eintrag; Bearbeitung je Sprache:',
  },
  helpEditor: {
    search: 'Schlüssel oder Titel suchen',
    edit: 'Bearbeiten',
    customized: 'Bearbeitet',
    saved: 'Erläuterung gespeichert',
    title: 'Titel',
    short: 'Kurzbeschreibung',
    history: 'Frühere Versionen',
    noHistory: 'Keine früheren Versionen.',
    locale: 'Sprache',
  },
  confirm: {
    title: 'Sind Sie sicher?',
    yes: 'Ja, fortfahren',
  },
  products: {
    customs: {
      title: 'Zoll und Export',
      lead: 'Wird auf der Proforma-Rechnung und der Zollanmeldung für Sendungen ins Ausland verwendet.',
      hsCode: 'HS-Code (GTİP)',
      hsCodeHint: '6–12 Ziffern; Punkte und Leerzeichen sind zulässig (z. B. 2309.10.13.00.00).',
      originCountry: 'Ursprungsland',
      description: 'Zollbeschreibung',
      descriptionHint: 'Kurze Warenbeschreibung für die Anmeldung (z. B. Katzentrockenfutter).',
    },
    extrasTitle: 'Videos, Dokumente und ergänzende Produkte',
    extrasLead:
      'Die Tabs „Videos“ und „Dokumente“ sowie der Bereich „Passt gut zu“ auf der Produktseite. Änderungen werden mit „Speichern“ übernommen.',
    videos: 'Videos',
    videoUrl: 'Adresse von Video {{n}}',
    videoTitle: 'Titel von Video {{n}}',
    addVideo: 'Video hinzufügen',
    removeVideo: 'Video {{n}} entfernen',
    documents: 'Dokumente',
    noDocuments: 'Keine Dokumente.',
    documentTitle: 'Titel von Dokument {{n}}',
    documentKind: 'Typ von Dokument {{n}}',
    documentFile: 'Datei: {{name}} ({{size}} KB)',
    documentKinds: {
      analysis_certificate: 'Analysezertifikat',
      leaflet: 'Gebrauchsanweisung',
      safety_data_sheet: 'Sicherheitsdatenblatt',
      registration: 'Registrierung / Zulassung',
      other: 'Sonstiges Dokument',
    },
    addDocument: 'PDF-Dokument hochladen',
    openDocument: 'Öffnen',
    removeDocument: 'Dokument {{n}} entfernen',
    documentUploaded:
      'Dokument hochgeladen. Es erscheint in der Storefront, nachdem Sie das Produkt gespeichert haben.',
    complementary: 'Ergänzende Produkte („Passt gut zu“)',
    create: 'Neues Produkt',
    createTitle: 'Neues Produkt',
    search: 'Suchen',
    searchPlaceholder: 'Produktname, SKU oder Barcode',
    status: 'Status',
    statuses: {
      draft: 'Entwurf',
      active: 'Aktiv',
      archived: 'Archiviert',
    },
    vetReview: 'Tierärztliche Prüfung',
    vetStatuses: {
      pending: 'Ausstehend',
      approved: 'Freigegeben',
      rejected: 'Abgelehnt',
      not_required: 'Nicht erforderlich',
    },
    brand: 'Marke',
    empty: 'Noch keine Produkte',
    emptyLead:
      'Fügen Sie Produkte einzeln hinzu oder laden Sie auf der Seite „Import / Export“ eine Excel- oder Shopify-Datei hoch.',
    product: 'Produkt',
    sku: 'SKU',
    stock: 'Bestand',
    variantCount: '{{count}} Varianten',
    backToList: 'Produktliste',
    basics: 'Grunddaten',
    title: 'Produktname',
    slug: 'Kurzname (URL)',
    species: 'Tierart',
    speciesNames: {
      cat: 'Katze',
      dog: 'Hund',
      bird: 'Vogel',
      rodent: 'Kleinnager (Hamster, Meerschweinchen usw.)',
      rabbit: 'Kaninchen',
      reptile: 'Reptilien und Schildkröten',
      exotic: 'Andere Exoten',
    },
    taxClass: 'Steuerklasse',
    defaultTax: 'Standard-Steuerklasse',
    b2cVisible: 'Für Endkunden sichtbar',
    b2bVisible: 'Für Händler sichtbar',
    dealerMinQuantity: 'Mindestmenge für Händler',
    dealerPackSize: 'Händler-Kartongröße (Menge muss ein Vielfaches sein)',
    healthContent: 'Enthält gesundheitsbezogene Inhalte (tierärztliche Freigabe erforderlich)',
    subscribable: 'Für regelmäßige Lieferung verfügbar (Kunden können „alle N Wochen“ bestellen)',
    content: 'Inhalt',
    contentLead:
      'Behaupten Sie nicht, dass das Produkt Krankheiten vorbeugt oder behandelt. Änderungen an diesen Feldern lösen eine neue tierärztliche Prüfung aus.',
    shortDescription: 'Kurzbeschreibung',
    description: 'Beschreibung',
    composition: 'Zusammensetzung',
    usage: 'Anwendung',
    warnings: 'Warnhinweise',
    feedRegistrationNo: 'Futtermittel-Registrierungsnr.',
    categories: 'Kategorien',
    noCategories: 'Noch keine Kategorien; fügen Sie sie auf der Seite „Kategorien“ hinzu.',
    tagsAttributes: 'Tags und Attribute',
    tagsAttributesLead:
      'Tags dienen für Kollektionsregeln und Filter in der Verwaltung; Attribute erscheinen in der Tabelle „Spezifikationen“ auf der Produktseite.',
    tags: 'Tags',
    tagsPlaceholder: 'Kommagetrennt: Kitten, getreidefrei',
    tagSuggestions: 'Häufig verwendet:',
    tag: 'Tag',
    noAttributes: 'Noch keine Produktattribute definiert.',
    attributeEmpty: 'Leer',
    variants: 'Optionen und Varianten',
    variantsLead: 'Trennen Sie Optionswerte durch Kommas. Jede Zeile ist eine Variante.',
    optionName: 'Optionsname',
    optionNamePlaceholder: 'z. B. Größe',
    optionValues: 'Optionswerte',
    optionValuesPlaceholder: 'z. B. 60 Tabletten, 120 Tabletten',
    removeOption: 'Option entfernen',
    addOption: 'Option hinzufügen',
    barcode: 'Barcode',
    weight: 'Gewicht (g)',
    cost: 'Kosten',
    reservedShort: '{{n}} reserviert',
    archiveVariant: 'Archivieren',
    restoreVariant: 'Wiederherstellen',
    addVariant: 'Variante hinzufügen',
    seo: 'Suchmaschinen (SEO)',
    seoTitle: 'SEO-Titel',
    seoTitleHint: 'Max. 70 Zeichen. Bleibt das Feld leer, wird der Produktname verwendet.',
    seoDescription: 'SEO-Beschreibung',
    seoDescriptionHint: 'Max. 170 Zeichen.',
    merchant: {
      title: 'Google Shopping',
      lead: 'An das Merchant Center gesendete Produktdaten. Preis, Bestand, Bilder und Barcodes stammen aus dem Produkt selbst.',
      include: 'An Google Shopping senden',
      googleCategory: 'Google-Produktkategorie',
      condition: 'Artikelzustand',
      conditions: {
        new: 'Neu',
        refurbished: 'Generalüberholt',
        used: 'Gebraucht',
      },
      identifierExists: 'Hersteller-Barcode',
      identifiers: {
        auto: 'Ja, wenn ein Barcode (GTIN) eingegeben ist',
        no: 'Dieses Produkt hat keinen Barcode',
      },
      skuIsMpn: 'Die SKU ist die Herstellerteilenummer (MPN)',
      customLabels: 'Benutzerdefinierte Labels (Kampagnengruppierung)',
      customLabel: 'Label {{n}}',
    },
    vetReviewTitle: 'Tierärztliche Prüfung',
    vetReviewLead:
      'Produkte mit gesundheitsbezogenen Inhalten können ohne Freigabe durch den tierärztlichen Prüfer nicht veröffentlicht werden.',
    claimsFound: 'Es wurden Formulierungen gefunden, die geprüft werden müssen:',
    noClaims:
      'Die automatische Prüfung hat keine riskanten Formulierungen gefunden (die Entscheidung trifft der Prüfer).',
    reviewNote: 'Prüfnotiz',
    reviewNoteHint: 'bei Ablehnung erforderlich',
    approveContent: 'Inhalt freigeben',
    rejectContent: 'Ablehnen',
    reviewSaved: 'Prüfung gespeichert',
    fields: {
      title: 'Produktname',
      shortDescription: 'Kurzbeschreibung',
      description: 'Beschreibung',
      composition: 'Zusammensetzung',
      usage: 'Anwendung',
      warnings: 'Warnhinweise',
    },
    media: 'Bilder',
    mediaLead: 'Das erste Bild ist das Titelbild.',
    mediaAlt: 'Alt-Text von Bild {{n}}',
    mediaMoveLeft: 'Bild {{n}} nach vorne verschieben',
    mediaMoveRight: 'Bild {{n}} nach hinten verschieben',
    mediaReordered: 'Bildreihenfolge gespeichert',
    mediaOrderLead: 'Die Galerie in der Storefront zeigt die Bilder in dieser Reihenfolge.',
    mediaStatus: {
      ready: 'Bereit',
      pending_download: 'Wartet auf Download',
      failed: 'Download fehlgeschlagen',
    },
    mediaFailure: {
      invalid_url: 'Ungültige Adresse',
      blocked_address: 'Interne Netzwerkadressen sind nicht zulässig',
      dns_failed: 'Domain nicht gefunden',
      connect_failed: 'Verbindung zum Server fehlgeschlagen',
      tls_failed: 'Sichere Verbindung fehlgeschlagen',
      timeout: 'Zeitüberschreitung (30 s)',
      not_found: 'Das Bild existiert an der Quelle nicht mehr',
      forbidden: 'Die Quelle hat den Zugriff verweigert',
      http_error: 'Fehler des Quellservers',
      too_many_redirects: 'Zu viele Weiterleitungen',
      too_large: 'Größer als 20 MB',
      not_image: 'Kein Bild oder beschädigt',
      storage_failed: 'Konnte nicht auf dem Server gespeichert werden',
      unknown: 'Unbekannter Fehler',
    },
    mediaRetry: 'Erneut versuchen',
    mediaSize: '{{width}}×{{height}} px',
    mediaSmall:
      'Zu klein für Google Shopping: mindestens 500×500 px empfohlen (ab dem 31. Januar 2027 erforderlich)',
    mediaRetryQueued: 'Das Bild wird erneut heruntergeladen (in etwa 30 s).',
    confirmRemoveMedia: 'Bild aus dem Produkt entfernen?',
    imageAdded: 'Bild hinzugefügt',
    addImage: 'Bild hinzufügen',
    prices: 'Preise',
    pricesLead: 'Preise werden gespeichert, wenn Sie das Feld verlassen. Ein leeres Feld entfernt den Preis.',
    noPriceLists: 'Legen Sie zuerst auf der Seite „Preisgestaltung“ eine Preisliste an.',
    noBaseList_none:
      'Der Shop „{{store}}“ hat keine Basispreisliste (Endkundenpreise): Das Produkt hat dort keinen Preis und wird nicht gelistet. Legen Sie auf der Seite „Preisgestaltung“ eine Liste mit ausgewähltem Shop und ohne Gruppe an.',
    noBaseList_inactive:
      'Die Basispreisliste des Shops „{{store}}“ ist inaktiv: Das Produkt hat dort keinen Preis. Aktivieren Sie sie auf der Seite „Preisgestaltung“.',
    noBaseList_currency:
      'Der Shop „{{store}}“ verkauft in {{currency}}, seine Basispreisliste verwendet jedoch eine andere Währung. Legen Sie eine Liste in {{currency}} an.',
    noBaseList_dates:
      'Die Basispreisliste des Shops „{{store}}“ ist heute nicht gültig (Start-/Enddatum). Prüfen Sie die Daten auf der Seite „Preisgestaltung“.',
    goPriceLists: 'Zur Preisgestaltung',
    listInactive: 'inaktiv',
    listings: 'Veröffentlichung im Shop',
    listingsLead:
      'Voraussetzungen für die Veröffentlichung: aktives Produkt, freigegebene gesundheitsbezogene Inhalte, ein Basispreis.',
    published: 'Veröffentlicht',
    notPublished: 'Nicht veröffentlicht',
    publish: 'Veröffentlichen',
    unpublish: 'Veröffentlichung zurückziehen',
  },
  categories: {
    name: 'Kategoriename',
    parent: 'Übergeordnete Kategorie',
    slug: 'Kurzname (Adresse)',
    slugLead:
      'Adresse: {{path}}. Bei einer Änderung wird die alte Adresse dauerhaft auf die neue weitergeleitet.',
    description: 'Beschreibung',
    seoTitle: 'Titel in Suchergebnissen',
    seoDescription: 'Beschreibung in Suchergebnissen',
    editTitle: 'Kategorie bearbeiten',
    editHint:
      'Mit „Bearbeiten“ ändern Sie Name, Adresse und Beschreibung einer Kategorie sowie ihre Darstellung in Suchergebnissen.',
    topLevel: 'Oberste Ebene',
    add: 'Kategorie hinzufügen',
    productCount: '{{count}} Produkte',
    statuses: {
      active: 'Sichtbar',
      hidden: 'Ausgeblendet',
    },
    hide: 'Ausblenden',
    show: 'Einblenden',
    confirmDelete: '„{{name}}“ löschen? Produkte werden nicht gelöscht.',
    empty: 'Noch keine Kategorien',
    emptyLead: 'Beginnen Sie mit Kategorien der obersten Ebene wie „Nahrungsergänzung für Katzen“.',
  },
  pricing: {
    referencePriceNote:
      'Der „frühere Preis“ in der Storefront ist der niedrigste tatsächlich angewendete Preis der letzten 30 Tage; keine manuellen Streichpreise.',
    groups: 'Kundengruppen',
    groupsLead: 'Händlerstufen. Freigegebene Händlerfirmen werden einer Gruppe zugeordnet.',
    addGroup: 'Gruppe hinzufügen',
    noGroups: 'Noch keine Kundengruppen',
    noGroupsLead: 'Legen Sie für Händlerpreise mindestens eine Händlergruppe an.',
    minOrderShort: 'Mindestbestellwert: {{amount}}',
    noMinOrder: 'Kein Mindestbestellwert',
    editMinOrder: 'Mindestbestellwert',
    minOrderTitle: '{{name}} – Mindestbestellwert',
    minOrderLead:
      'Händler dieser Gruppe können nicht bestellen, solange die Warenkorbsumme (inkl. Produkte, Rabatte und MwSt.; ohne Versand) unter diesem Betrag liegt. Ein firmenspezifischer Betrag wird auf der Händlerkarte festgelegt.',
    minOrder: 'Mindestbestellwert ({{currency}})',
    minOrderHint: 'Leer: keiner',
    groupName: 'Gruppenname',
    groupCode: 'Code',
    groupCodeHint: 'Kleinbuchstaben, Ziffern, - und _.',
    groupKind: 'Typ',
    kinds: {
      dealer: 'Händler',
      retail: 'Endkunden',
    },
    lists: 'Preislisten',
    listsLead: 'Eine Liste ohne Gruppe ist die Basisliste, die alle sehen.',
    addList: 'Preisliste hinzufügen',
    noLists: 'Noch keine Preislisten',
    noListsLead: 'Legen Sie zuerst die Basisliste an, dann die Händlerlisten.',
    taxIncl: 'Inkl. Steuer',
    taxExcl: 'Exkl. Steuer',
    forGroup: 'Gruppe: {{group}}',
    baseList: 'Basisliste',
    priceCount: '{{count}} Preise',
    listStatus: {
      active: 'Aktiv',
      inactive: 'Inaktiv',
    },
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren',
    listName: 'Listenname',
    store: 'Shop',
    listGroup: 'Kundengruppe',
    baseListOption: 'Keine – Basisliste (Endkunden)',
    market: 'Markt',
    allMarkets: 'Alle Märkte (in dieser Währung)',
    forMarket: 'Markt: {{market}}',
    currency: 'Währung',
    taxInclusive: 'Preise inkl. Steuer',
    priority: 'Priorität',
    taxes: 'Steuerklassen',
    taxesLead: 'Den Produkten zugewiesene Steuersätze.',
    defaultTax: 'Standard',
    noTaxes: 'Noch keine Steuerklassen',
    taxName: 'Name',
    taxNamePlaceholder: 'z. B. MwSt. 20 %',
    taxRate: 'Satz',
    addTax: 'Steuerklasse hinzufügen',
    countryRates: 'MwSt.-Sätze nach Land',
    countryRatesLead:
      'In Märkten mit dem Steuermodus „MwSt. des Bestimmungslandes“ gilt der Satz der Produktsteuerklasse für dieses Land. Produkte ohne Satz können in diesem Markt nicht verkauft werden.',
    noCountryRates: 'Noch keine Ländersätze',
    countryRateClass: 'Steuerklasse',
    countryRateCountry: 'Land',
    addCountryRate: 'Ländersatz hinzufügen',
    countryRateDelete:
      'Den Satz „{{name}}“ für {{country}} löschen? Produkte dieser Klasse können im Markt „MwSt. des Bestimmungslandes“ dieses Landes nicht mehr verkauft werden.',
    bulk: 'Massenpreisänderung',
    bulkLead: 'Zuerst Vorschau; angewendete Änderungen können rückgängig gemacht werden.',
    targetList: 'Zielliste',
    operation: 'Vorgang',
    ops: {
      percent: 'Um Prozentsatz erhöhen/senken',
      fixed: 'Betrag addieren/abziehen',
      from_list: 'Aus anderer Liste ableiten',
      from_cost: 'Aus Kosten (Aufschlag)',
      target_margin: 'Ziel-Bruttomarge',
      fx: 'Aus anderer Währung (Kurs)',
    },
    markup: 'Aufschlag (%)',
    markupHint:
      'Nettopreis = Kosten × (1 + Aufschlag). Bei Listen inkl. Steuer wird die MwSt. hinzugerechnet.',
    targetMargin: 'Bruttomarge (%)',
    targetMarginHint: 'Nettopreis = Kosten ÷ (1 − Marge). Z. B. 40 % Marge bei Kosten von 100 → 166,67.',
    fxRate: 'Kurs',
    fxRateHint: 'Wert von 1 Einheit der Quellwährung in dieser Liste (z. B. 1 TRY = 0.0291 EUR → 0.0291).',
    fxAdjust: 'Zusätzliche Anpassung (%)',
    minMargin: 'Mindestmarge (%)',
    minMarginHint:
      'Leer lassen, um die Prüfung zu überspringen. Die Marge basiert auf Nettopreis und Kosten; Produkte ohne Kosten werden nicht geprüft.',
    minMarginMode: 'Falls darunter',
    minMarginModes: {
      warn: 'Warnen (trotzdem anwenden)',
      block: 'Nicht anwenden',
    },
    margin: 'Marge',
    lowMargin: 'Niedrige Marge',
    noCost: '{{count}} Varianten ohne Kosten (oder mit Kosten in einer anderen Währung) wurden übersprungen.',
    blocked: '{{count}} Varianten liegen unter der Mindestmarge und werden nicht angewendet.',
    lowMarginCount: '{{count}} Varianten liegen unter der Mindestmarge.',
    campaign: 'Aktion',
    campaignStates: {
      upcoming: 'Nicht gestartet',
      live: 'Läuft',
      ended: 'Beendet',
    },
    validity: '{{from}} – {{to}}',
    startsAt: 'Gültig ab',
    endsAt: 'Gültig bis',
    datesHint:
      'Leer lassen, damit die Liste immer gültig ist. Legen Sie für eine Aktionsliste Daten und eine höhere Priorität als die der Basisliste fest.',
    editDates: 'Daten bearbeiten',
    noLimit: 'unbefristet',
    amount: 'Betrag',
    percent: 'Prozent',
    valueHint: 'Verwenden Sie zum Senken ein Minuszeichen (z. B. -10).',
    sourceList: 'Quellliste',
    filterBrand: 'Marke',
    filterCategory: 'Kategorie',
    ending: 'Preisendung',
    endings: {
      none: 'Beibehalten',
      whole: 'Ganzzahlig',
      end_90: '.90',
      end_99: '.99',
    },
    previewBulk: 'Vorschau',
    previewSummary: '{{affected}} Preise werden geändert, {{skipped}} übersprungen.',
    before: 'Vorher',
    after: 'Nachher',
    confirmApply: '{{count}} Preise werden geändert. Fortfahren?',
    applyBulk: 'Anwenden',
    bulkApplied: 'Massenpreise angewendet',
    bulkReverted: 'Massenpreise rückgängig gemacht',
    history: 'Verlauf',
    affectedCount: '{{count}} Preise',
    bulkStatus: {
      preview: 'Vorschau',
      applied: 'Angewendet',
      reverted: 'Rückgängig gemacht',
      expired: 'Abgelaufen',
    },
    confirmRevert: 'Diese Massenänderung rückgängig machen? Manuell geänderte Preise bleiben erhalten.',
    revert: 'Rückgängig machen',
  },
  discounts: {
    create: 'Gutscheincode erstellen',
    empty: 'Noch keine Gutscheincodes',
    emptyLead: 'Erstellen Sie für eine Aktion einen prozentualen oder festen Gutscheincode.',
    min: 'mind. {{amount}}',
    used: '{{used}}/{{limit}} verwendet',
    until: 'bis {{date}}',
    name: 'Name des Gutscheincodes (intern)',
    code: 'Code',
    type: 'Typ',
    types: {
      percentage: 'Prozentual',
      fixed_amount: 'Fester Betrag',
    },
    minSubtotal: 'Mindestwarenkorbsumme',
    usageLimit: 'Nutzungslimit',
    endsAt: 'Enddatum',
    groups: 'Gültige Kundengruppen',
    groupsHint: 'Wenn keine ausgewählt ist, kann ihn jeder verwenden.',
  },
  stock: {
    ledgerNote: 'Lagerbewegungen werden nie gelöscht; gleichen Sie Fehler mit einer Gegenbuchung aus.',
    warehouses: 'Lager',
    warehousesLead: 'Das erste Lager ist das Standardlager; Bestellungen reservieren zuerst daraus.',
    default: 'Standard',
    noWarehouses: 'Noch keine Lager',
    warehouseName: 'Lagername',
    warehouseCode: 'Code',
    addWarehouse: 'Lager hinzufügen',
    variantStock: 'Produktbestand',
    variantStockLead:
      'Suchen Sie ein Produkt und wählen Sie eine Variante, um Bestände und letzte Bewegungen zu sehen.',
    findProduct: 'Produkt suchen',
    newMovement: 'Lagerbewegung',
    transfer: 'Umlagerung',
    warehouse: 'Lager',
    lot: 'Charge',
    expiry: 'MHD',
    onHand: 'Vorhanden',
    reserved: 'Reserviert',
    movements: 'Letzte Bewegungen',
    types: {
      receipt: 'Wareneingang',
      sale: 'Verkauf',
      return: 'Rücksendung',
      adjustment: 'Korrektur',
      transfer_in: 'Umlagerung (Eingang)',
      transfer_out: 'Umlagerung (Ausgang)',
      damage: 'Beschädigung',
      count: 'Inventur',
      import: 'Import',
      opening: 'Anfangsbestand',
    },
    noResults: 'Keine Ergebnisse',
    movementType: 'Bewegungsart',
    lotPick: 'Charge',
    chooseLot: 'Charge auswählen',
    lotless: 'Bestand ohne Charge',
    lotOption: '{{lot}} · MHD {{expiry}} · {{onHand}} Einheiten',
    countedQuantity: 'Gezählte Menge (neuer Gesamtbestand)',
    quantity: 'Menge',
    lotNo: 'Chargennr.',
    reason: 'Grund',
    fromWarehouseId: 'Von Lager',
    toWarehouseId: 'An Lager',
    noLot: 'Keine Charge',
    expiryLabel: 'MHD {{date}}',
    availableCount: '{{count}} verfügbar',
    transferNoStock:
      'Dieses Produkt hat keinen umlagerbaren Bestand. Eine Umlagerung verschiebt vorhandenen Bestand zwischen Lagern; der erste Bestandseintrag ist ein „Wareneingang“.',
    goReceipt: 'Wareneingang erfassen',
    transferNeedsTwo:
      'Für eine Umlagerung ist ein weiteres aktives Lager erforderlich (fügen Sie eines unter „Lager“ hinzu).',
    transferMax: 'Es können bis zu {{count}} umgelagert werden.',
    transferTooMany: 'Diese Quelle hat nur {{count}}.',
    noStockYet:
      'Noch kein Bestand für dieses Produkt. Erfassen Sie den ersten Eintrag mit „Lagerbewegung“ → „Wareneingang“ (mit Charge und MHD).',
    expiring: 'Läuft bald ab',
    expiringLead: 'Chargen mit Bestand, deren MHD bald erreicht ist.',
    withinDays: 'Zeitraum',
    days: '{{n}} Tage',
    lotLabel: 'Charge {{lot}}',
    noExpiring: 'In diesem Zeitraum laufen keine Chargen ab.',
    critical: {
      title: 'Niedriger Bestand',
      lead: 'Produkte, deren verkaufbare Menge ihren Schwellenwert erreicht oder unterschritten hat. Die größte Unterschreitung zuerst.',
      none: 'Kein Produkt hat einen niedrigen Bestand.',
      product: 'Produkt',
      available: 'Verkaufbar',
      threshold: 'Schwellenwert',
      rule: 'Regel',
      allWarehouses: 'Alle Lager',
      sources: {
        warehouse: 'Lager-Schwellenwert',
        variant: 'Produkt-Schwellenwert',
        default: 'Standard-Schwellenwert',
      },
      more: 'Die ersten {{shown}} Zeilen werden angezeigt (insgesamt {{total}}).',
      defaultThreshold: 'Standard-Schwellenwert',
      defaultThresholdHint: 'Für Produkte ohne eigenen Schwellenwert; leer lassen, um ihn zu deaktivieren.',
      saveDefault: 'Standard-Schwellenwert speichern',
      defaultSaved: 'Standard-Schwellenwert gespeichert.',
      dailyDigest: 'Tägliche E-Mail-Zusammenfassung',
      digestOn: 'Die tägliche E-Mail-Zusammenfassung ist aktiviert (jeden Morgen um 08:00 Uhr).',
      digestOff: 'Die tägliche E-Mail-Zusammenfassung ist deaktiviert.',
      thresholds: 'Schwellenwerte für niedrigen Bestand',
      thresholdsLead:
        'Das Produkt erscheint in der Liste für niedrigen Bestand, wenn seine verkaufbare Menge auf diesen Wert oder darunter fällt.',
      saveThresholds: 'Schwellenwerte speichern',
      thresholdsSaved: 'Schwellenwerte gespeichert.',
    },
  },
  customers: {
    create: 'Kunde hinzufügen',
    search: 'Suchen',
    searchMaskedHint: 'Ohne die Berechtigung für personenbezogene Daten wird nur nach Namen gesucht.',
    kind: 'Typ',
    kinds: {
      dealer: 'Händler',
      retail: 'Endkunde',
    },
    maskedNote: 'Personenbezogene Daten sind maskiert.',
    empty: 'Noch keine Kunden',
    emptyLead: 'Kunden erscheinen, wenn sie sich registrieren oder eine Händlerliste importiert wird.',
    notActivated: 'Nicht aktiviert',
    disabled: 'Deaktiviert',
    createdAndEmailed: 'Gespeichert; der Zugangslink wurde per E-Mail gesendet.',
    name: 'Vollständiger Name',
    email: 'E-Mail',
    phone: 'Telefon',
    sendAccessLink: 'Link zum Festlegen des Passworts senden',
    manualLinkTitle: 'Link manuell senden',
    manualLinkLead:
      'E-Mail ist nicht eingerichtet, daher wurde nichts gesendet. Teilen Sie diesen Link über einen sicheren Kanal mit dem Kunden.',
    linkEmailed: 'Der Link wurde per E-Mail gesendet.',
    backToList: 'Kundenliste',
    profile: 'Profil',
    activated: 'Konto aktiv (Passwort festgelegt)',
    emailVerified: 'E-Mail bestätigt',
    created: 'Erstellt',
    companies: 'Händlerfirmen',
    sendReset: 'Link zum Zurücksetzen des Passworts',
    sendActivation: 'Aktivierungslink',
    unlock: 'Entsperren',
    confirmDisable: 'Kundenkonto deaktivieren? Offene Sitzungen werden beendet.',
    confirmEnable: 'Kundenkonto wieder aktivieren?',
    disable: 'Deaktivieren',
    enable: 'Aktivieren',
    consents: 'Marketing-Einwilligungen',
    channels: {
      email: 'E-Mail',
      sms: 'SMS',
      call: 'Anruf',
      whatsapp: 'WhatsApp',
    },
    consentStatus: {
      granted: 'Erteilt',
      revoked: 'Widerrufen',
      none: 'Kein Eintrag',
    },
    consentSource: {
      register: 'Bei der Registrierung',
      account: 'Kontoseite',
      checkout: 'An der Kasse',
      import: 'Import',
      admin: 'Aus der Verwaltung',
      unsubscribe: 'Abmeldelink',
    },
    confirmRevoke: 'Einwilligung widerrufen? Der Verlauf bleibt erhalten.',
    revoke: 'Widerrufen',
    addresses: 'Adressen',
    masked: 'maskiert',
    noAddresses: 'Keine gespeicherten Adressen.',
    orders: 'Letzte Bestellungen',
    noOrders: 'Noch keine Bestellungen.',
    tags: 'Tags',
    tagsLead:
      'Wird in der Storefront nicht angezeigt; dient als Listenfilter und in Segmentregeln. In KVKK-Datenkopien enthalten.',
    tagsLabel: 'Tags (kommagetrennt)',
    tagsPlaceholder: 'z. B. VIP, Messe 2026, Katzenhalter',
    tagSuggestions: 'Häufig verwendet:',
    saveTags: 'Tags speichern',
    tagsSaved: 'Tags gespeichert.',
    noTags: 'Keine Tags.',
    tagFilter: 'Tag',
    metricsTitle: 'Bestellübersicht und RFM',
    metricsLead:
      'Wird nachts aus gültigen Bestellungen berechnet (ohne stornierte, Entwurfs- und vollständig erstattete Bestellungen).',
    noMetrics: 'Noch keine gültigen Bestellungen, oder RFM wurde noch nicht berechnet.',
    orderCount: 'Bestellungen',
    totalSpent: 'Nettoausgaben',
    avgOrder: 'Durchschnittliche Bestellung',
    firstOrder: 'Erste Bestellung',
    lastOrder: 'Letzte Bestellung',
    rfmGroup: 'RFM-Gruppe',
    rfmScores: 'R{{r}} · F{{f}} · M{{m}}',
    otherCurrency: '{{count}} Bestellungen in einer anderen Währung (nicht in den Ausgaben enthalten)',
    metricsComputed: 'Berechnet: {{date}}',
    summaryTitle: 'Kundenübersicht',
    summaryLead:
      'Live aus den Bestellungen berechnet (ohne stornierte, Entwurfs-, unbezahlte und vollständig erstattete Bestellungen); die RFM-Gruppe wird nachts aktualisiert.',
    lifetimeSpent: 'Bisherige Nettoausgaben',
    last12Months: 'Letzte 12 Monate',
    daysAgo: 'vor {{count}} Tagen',
    cycle: 'Bestellintervall',
    cycleValue: 'Durchschnittlich alle {{days}} Tage',
    cycleNone: 'Erfordert mindestens zwei Bestellungen',
    nextExpected: 'Nächste Bestellung erwartet: {{date}} (Schätzung anhand früherer Bestellungen)',
    returnsCount: 'Rücksendeanfragen',
    newsletter: 'Newsletter',
    acquisition: 'Akquisitionsquelle',
    acquisitionNoAd: 'Keinem Werbekonto zugeordnet',
    cacValue: 'Akquisitionskosten {{amount}} ({{month}}, {{count}} Neukunden)',
    newsletterNone: 'Nicht abonniert',
    rfmNotYet: 'Noch nicht berechnet',
    notes: 'Interne Notizen',
    notesLead: 'Nur für Benutzer der Verwaltung sichtbar; in KVKK-Datenkopien enthalten.',
    notesLabel: 'Notiz',
    saveNotes: 'Notiz speichern',
    notesSaved: 'Notiz gespeichert.',
    noNotes: 'Keine Notizen.',
    timelineTitle: 'Aktivität',
    timelineLead: 'Die letzten 40 Ereignisse, neueste zuerst; nur Bereiche, die Sie sehen dürfen.',
    timeline: {
      account: 'Registriert',
      order: 'Bestellung {{number}} · {{status}} · {{total}}',
      return: 'Rücksendeanfrage (Bestellung {{order}}) · {{resolution}} · {{status}}',
      review: '{{rating}}/5-Bewertung für {{product}} · {{status}}',
      question: 'Frage zu {{product}} · {{status}}',
      consent: '{{channel}}-Einwilligung: {{status}} · {{source}}',
      contact: 'Nachricht über das Kontaktformular · {{status}}',
      ticket: 'Support-Ticket #{{number}}: {{subject}} · {{status}}',
      privacy: 'KVKK-Antrag: {{kind}} · {{status}}',
      newsletter: 'Newsletter: {{status}}',
      campaign: 'Kampagnen-E-Mail: {{name}}',
      campaignClicked: 'hat auf einen Link geklickt',
      campaignUnsubscribed: 'hat sich abgemeldet',
      automation: 'Automatisierungs-E-Mail: {{name}}',
      message: '{{channel}}-Kampagne: {{name}} ({{status}})',
    },
  },
  dealers: {
    ledgerTitle: 'Kundenkonto',
    ledgerOpen: 'Offenes Konto',
    ledgerSummary: 'Saldo {{balance}} · überfällig {{overdue}}',
    paymentTerm: 'Zahlungsziel (Tage)',
    paymentTermInvalid: 'Geben Sie eine ganze Zahl zwischen 0 und 365 ein.',
    paymentTermValue: 'Zahlungsziel: {{days}} Tage nach der Bestellung.',
    importList: 'Händlerliste importieren',
    create: 'Händler hinzufügen',
    search: 'Suchen',
    searchHint: 'Name, Händlercode, Stadt oder vollständige Steuernummer.',
    status: 'Status',
    statuses: {
      applied: 'Beantragt',
      approved: 'Freigegeben',
      suspended: 'Gesperrt',
      rejected: 'Abgelehnt',
    },
    empty: 'Noch keine Händler',
    emptyLead: 'Importieren Sie Ihre Händlerliste aus Excel/CSV oder fügen Sie die Händler einzeln hinzu.',
    memberCount: '{{count}} Benutzer',
    legalName: 'Offizieller Firmenname',
    tradeName: 'Handelsname',
    taxOffice: 'Finanzamt',
    taxNumber: 'Steuernr. / TCKN',
    externalCode: 'Händlercode',
    city: 'Stadt',
    district: 'Bezirk',
    email: 'Firmen-E-Mail',
    phone: 'Telefon',
    group: 'Händlergruppe',
    createApproved: 'Als freigegeben anlegen (Händlerpreise sofort sichtbar)',
    backToList: 'Händlerliste',
    info: 'Firmendaten',
    address: 'Adresse',
    source: 'Quelle',
    sources: {
      application: 'Antrag über die Storefront',
      import: 'Import',
      manual: 'Aus der Verwaltung',
    },
    approvedAt: 'Freigegeben am',
    statusActions: 'Statusaktionen',
    note: 'Notiz',
    noteHint: 'bei Ablehnung erforderlich',
    actions: {
      approved: 'Freigeben',
      rejected: 'Ablehnen',
      suspended: 'Sperren',
    },
    confirm: {
      approved: 'Händler freigeben? Seine Benutzer sehen dann Händlerpreise.',
      rejected: 'Händler ablehnen?',
      suspended: 'Händler sperren? Seine Benutzer sehen dann Endkundenpreise.',
    },
    members: 'Benutzer',
    membersLead: 'Personen, die sich für diese Firma in der Storefront anmelden.',
    roles: {
      owner: 'Verantwortliche Person',
      buyer: 'Einkäufer',
      viewer: 'Nur ansehen',
    },
    rolesLead: 'Die Rolle bestimmt, was der Benutzer in der Storefront für die Firma tun kann.',
    roleHelp: {
      owner:
        'Gibt Bestellungen auf; sieht Firmenbestellungen, den Kontoauszug und die Firmenbenutzer; verwaltet die Firmenstandorte. Kein Bestelllimit.',
      buyer:
        'Gibt Bestellungen auf und sieht nur die eigenen Bestellungen. Mit Limit benötigen Bestellungen darüber die Freigabe der verantwortlichen Person.',
      viewer:
        'Sieht Händlerpreise, Firmenbestellungen und den Kontoauszug; kann nicht bestellen (z. B. Buchhaltung).',
    },
    editMember: 'Rolle und Limit',
    orderRules: 'Bestellregeln',
    orderRulesLead:
      'Mindestbestellwert für diesen Händler (wenn leer, gilt der Wert der Händlergruppe) und ob Storefront-Bestellungen einen Bestellschein (PO) erfordern.',
    minOrder: 'Mindestbestellwert ({{currency}})',
    minOrderHint: 'Leer: Wert der Händlergruppe',
    poRequirement: 'Bestellschein (PO)',
    poRequirements: {
      none: 'Optional',
      number: 'PO-Nummer erforderlich',
      number_and_document: 'PO-Nummer und Dokument erforderlich',
    },
    editMemberTitle: '{{name}} – Rolle und Bestelllimit',
    orderLimit: 'Bestelllimit ({{currency}})',
    orderLimitHint: 'Leer: kein Limit',
    orderLimitShort: 'Limit: {{amount}}',
    confirmRemoveMember: '{{name}} aus der Firma entfernen? Das Konto wird nicht gelöscht.',
    noMembers: 'Noch keine Benutzer.',
    role: 'Rolle',
    addMember: 'Benutzer hinzufügen',
    applications: 'Anträge',
  },
  applications: {
    status: 'Status',
    statuses: {
      pending: 'Ausstehend',
      approved: 'Angenommen',
      rejected: 'Abgelehnt',
    },
    empty: 'Keine Anträge',
    emptyLead: 'Anträge aus dem Storefront-Formular erscheinen hier.',
    documentCount: '{{count}} Dokumente',
    businessType: 'Geschäftsart',
    applicant: 'Antragsteller',
    note: 'Antragsnotiz',
    documents: 'Dokumente',
    noDocuments: 'Keine Dokumente hochgeladen.',
    decisionNote: 'Notiz',
    decisionNoteHint: 'Bei Ablehnung erforderlich; wird dem Antragsteller per E-Mail gesendet.',
    approve: 'Annehmen',
    reject: 'Ablehnen',
  },
  imports: {
    products: 'Produkte',
    productsLead:
      'Unsere Vorlage (Excel/CSV), eine Shopify-Produkt-CSV oder ein Produktdokument im JSON-/XML-Format. Produkte werden als Entwürfe hinzugefügt; mehr als 50 Produkte werden im Hintergrund verarbeitet.',
    columnMapping: 'Spaltenzuordnung',
    columnMappingLead:
      'Welchem Feld jede Spalte der Datei zugeordnet wird. Ordnen Sie eine nicht erkannte Spalte einem Feld zu oder ignorieren Sie sie und zeigen Sie dann erneut die Vorschau an. Die Zuordnung wird beim Anwenden gespeichert und für spätere Dateien mit denselben Spaltenüberschriften automatisch verwendet.',
    unmatchedCount: '{{count}} Spalten nicht erkannt',
    fileColumn: 'Spalte in der Datei',
    targetField: 'Importiert in',
    columnSource: 'Art der Zuordnung',
    noField: '— nicht importiert —',
    ignoreColumn: 'Ignorieren',
    attributeColumn: 'Attributspalte',
    columnSources: {
      auto: 'Automatisch',
      saved: 'Gespeicherte Zuordnung',
      manual: 'Manuell ausgewählt',
      attribute: 'Attribut',
      ignored: 'Ignoriert',
      unmatched: 'Nicht erkannt',
    },
    remap: 'Erneut Vorschau mit Zuordnung',
    fields: {
      handle: 'Produktcode (Slug)',
      title: 'Produktname',
      brand: 'Marke',
      categories: 'Kategorie',
      species: 'Tierart',
      shortDescription: 'Kurzbeschreibung',
      description: 'Beschreibung',
      composition: 'Zusammensetzung',
      usage: 'Anwendung',
      warnings: 'Warnhinweise',
      feedRegistrationNo: 'Futtermittel-Registrierungsnr.',
      tax: 'MwSt.',
      visibility: 'Sichtbarkeit',
      option1Name: 'Name von Option 1',
      option1Value: 'Wert von Option 1',
      option2Name: 'Name von Option 2',
      option2Value: 'Wert von Option 2',
      option3Name: 'Name von Option 3',
      option3Value: 'Wert von Option 3',
      sku: 'SKU',
      barcode: 'Barcode',
      weight: 'Gewicht (g)',
      cost: 'Kosten',
      price: 'Preis',
      stock: 'Bestand',
      images: 'Bild-URLs',
      imageAlt: 'Bildbeschreibung',
      seoTitle: 'SEO-Titel',
      seoDescription: 'SEO-Beschreibung',
      tags: 'Tags',
    },
    importQueued: 'Wird im Hintergrund angewendet: {{processed}} / {{total}} Produkte',
    importQueuedLead:
      'Sie können diese Seite verlassen; der Import läuft weiter. Das Ergebnis erscheint hier.',
    importProgress: 'Importfortschritt',
    retryFailed: 'Fehlgeschlagene Produkte erneut versuchen',
    exportJson: 'JSON herunterladen',
    exportXml: 'XML herunterladen',
    template: 'Vorlage herunterladen',
    exportProducts: 'Produkte exportieren',
    priceList: 'Preisliste',
    skipPrices: 'Preise nicht importieren',
    warehouse: 'Lager',
    skipStock: 'Bestand nicht importieren',
    defaultBrand: 'Standardmarke',
    healthContent: 'Produkte enthalten gesundheitsbezogene Inhalte (tierärztliche Freigabe erforderlich)',
    chooseFile: 'Datei auswählen und Vorschau anzeigen',
    formats: {
      zootopia: 'Zootopia-Vorlage',
      shopify: 'Shopify-CSV',
    },
    toCreate: '{{count}} neu',
    toUpdate: '{{count}} Aktualisierungen',
    skipped: '{{count}} übersprungen',
    variants: '{{count}} Varianten',
    images: '{{count}} Bilder',
    unknownHeaders: 'Unbekannte Spalten (ignoriert): {{list}}',
    issues: '{{count}} Probleme gefunden; betroffene Zeilen werden nicht übernommen.',
    row: 'Zeile {{row}}',
    downloadIssues: 'Problemliste herunterladen',
    issueRow: 'Zeile',
    issueField: 'Feld',
    issueProblem: 'Problem',
    issueValue: 'Wert in der Datei',
    productsDraftNote:
      'Produkte werden nicht veröffentlicht; prüfen Sie sie und veröffentlichen Sie sie nach der tierärztlichen Freigabe.',
    apply: 'Anwenden',
    applied: 'Import angewendet',
    stockSkippedLot:
      'Der Bestand von {{count}} Varianten wird nach Charge/MHD geführt und wurde nicht aus der Datei übernommen; erfassen Sie ihn in der Bestandsansicht pro Charge.',
    productResult: '{{created}} hinzugefügt, {{updated}} aktualisiert, {{failed}} fehlgeschlagen.',
    categories: 'Kategorien',
    categoriesLead:
      'Kategoriebaum aus einer Datei hinzufügen oder aktualisieren. Laden Sie Kategorien vor den Produkten hoch; ein erneutes Hochladen derselben Datei erzeugt keine Duplikate.',
    exportCategories: 'Kategorien exportieren',
    categoriesPreview: 'Kategorievorschau',
    categoryResult: '{{created}} Kategorien hinzugefügt, {{updated}} aktualisiert.',
    createMissingCategories: 'Fehlende Kategorien anlegen',
    categoryMode: 'Kategorien vorhandener Produkte',
    categoryModes: {
      merge: 'Kategorien aus der Datei hinzufügen (vorhandene beibehalten)',
      replace: 'Durch die Kategorien aus der Datei ersetzen',
    },
    categoriesToCreate: '{{count}} Kategorien werden angelegt',
    skuMissing:
      '{{count}} Varianten haben eine leere SKU; ihre Produkte werden übersprungen. Vorgeschlagene SKUs werden in der Problemliste in Klammern angezeigt (Barcode, falls vorhanden, sonst Produktcode + Option).',
    skuGenerate: 'Erneut Vorschau mit vorgeschlagenen SKUs',
    skuGenerated:
      'SKUs für {{count}} Varianten vorgeschlagen (unten pro Produkt aufgeführt). Beim Anwenden werden sie gespeichert; ein erneutes Hochladen derselben Datei erzeugt dieselben SKUs, also keine Duplikate.',
    mediaStatusTitle: 'Importierte Bilder',
    mediaPending: '{{count}} Bilder warten auf den Download (im Hintergrund, alle 30 s).',
    mediaFailed: '{{count}} Bilder konnten nicht heruntergeladen werden.',
    mediaReasons: 'Gründe: {{list}}',
    mediaRetryAll: 'Fehlgeschlagene Downloads erneut versuchen',
    mediaRetryQueued: '{{count}} Bilder werden erneut heruntergeladen.',
    dealers: 'Händlerliste',
    dealersLead:
      'Erforderlich: Firmenname und Händlercode oder Steuernummer. Ein erneutes Hochladen erzeugt keine Duplikate.',
    exportDealers: 'Händler exportieren',
    noDealerGroups: 'Legen Sie zuerst auf der Seite „Preisgestaltung“ eine Kundengruppe für Händler an.',
    defaultGroup: 'Standard-Händlergruppe',
    defaultStatus: 'Standardstatus',
    useCompanyEmail: 'Firmen-E-Mail für die Anmeldung verwenden, wenn keine Kontakt-E-Mail vorhanden ist',
    sendLinks: 'Links zum Festlegen des Passworts per E-Mail an die Benutzer senden',
    unchanged: '{{count}} unverändert',
    errorRows: '{{count}} fehlerhafte Zeilen',
    members: '{{count}} Benutzer',
    action: 'Aktion',
    actions: {
      create: 'Neu',
      update: 'Aktualisieren',
      unchanged: 'Unverändert',
      error: 'Fehler',
    },
    dealerResult:
      '{{created}} Händler hinzugefügt, {{updated}} aktualisiert, {{members}} Benutzer verknüpft.',
    linksEmailed: 'E-Mails zum Festlegen des Passworts wurden an {{count}} Benutzer gesendet.',
    needActivation:
      '{{count}} Benutzer haben keinen Link erhalten (E-Mail nicht eingerichtet oder nicht ausgewählt). Erstellen Sie die Links auf der Händlerseite, oder die Händler nutzen „Passwort vergessen“, sobald E-Mail eingerichtet ist.',
  },
  orders: {
    geliver: {
      ship: 'Mit Geliver versenden',
      lead: 'Geben Sie Paketmaße und Gewicht ein, holen Sie die Angebote der Versanddienstleister, wählen Sie eines und kaufen Sie das Etikett.',
      testBadge: 'Testumgebung',
      weight: 'Gewicht (g)',
      weightMissing:
        'Für {{count}} Produkt(e) ist kein Gewicht hinterlegt; das Standardgewicht wurde addiert. Wiegen Sie das Paket und korrigieren Sie den Wert.',
      getOffers: 'Angebote holen',
      offersPending: 'Angebote treffen ein ({{percent}} %)',
      refresh: 'Aktualisieren',
      noOffers: 'Keine Angebote erhalten. Prüfen Sie Maße und Adresse und versuchen Sie es erneut.',
      offers: 'Versandangebote',
      cheapest: 'Günstigstes',
      fastest: 'Schnellstes',
      buy: 'Etikett kaufen ({{amount}})',
      confirm:
        'Die Etikettgebühr von {{amount}} wird von Ihrem Geliver-Guthaben abgebucht; die Sendung wird erfasst und die verpackten Produkte werden aus dem Bestand gebucht.',
      confirmTest:
        'Für eine Testsendung wird ein Etikett gekauft; die Sendung wird erfasst und die verpackten Produkte werden aus dem Bestand gebucht.',
      confirmYes: 'Bestätigen und kaufen',
      back: 'Zurück',
      bought: 'Etikett gekauft; Sendung erfasst.',
      codNote: 'Nachnahmebestellungen werden noch nicht mit Geliver versendet.',
      notReady: 'Wählen Sie auf der Seite Versand eine Absenderadresse, um mit Geliver zu versenden.',
      badge: 'Geliver',
      label: 'Etikett öffnen',
      sync: 'Status aktualisieren',
      synced: 'Status aktualisiert',
      cancel: 'In Geliver stornieren',
      cancelConfirm:
        'Die Sendung wird in Geliver storniert; die verpackten Produkte gehen zurück in den Bestand und die Bestellung kann erneut versendet werden. Die Etikettgebühr wird nach den Regeln von Geliver erstattet.',
      cancelled: 'Sendung storniert',
      price: 'Etikett {{amount}}',
      awaitingTracking:
        'Die Sendungsnummer kommt, sobald der Versanddienstleister das Paket abholt; dann erhält der Kunde die E-Mail.',
    },
    createManual: 'Bestellung anlegen',
    paymentNote:
      'Kartenbestellungen werden nach der Prüfung durch den Anbieter automatisch auf „Bezahlt“ gesetzt. Verwenden Sie bei Banküberweisungen in der Bestellung „Zahlung eingegangen“, sobald das Geld eingegangen ist; Bestellungen per Nachnahme und auf offenes Händlerkonto gehen mit dem Status „In Bearbeitung“ ein.',
    search: 'Suchen (Bestellnr., Kunde, Firma, PO-Nr.)',
    po: {
      title: 'Bestellschein und Firmenfreigabe',
      lead: 'Die Bestellschein-Nummer (PO) und das Dokument des Händlers; die Freigabe der verantwortlichen Person der Firma, wenn die Bestellung eines Einkäufers dessen Limit überschreitet.',
      number: 'PO-Nummer',
      save: 'PO-Nummer speichern',
      document: 'PO-Dokument:',
      download: '{{name}} herunterladen ({{kb}} KB)',
      noDocument: 'nicht angehängt',
      attach: 'Dokument anhängen',
      replace: 'Dokument ersetzen',
      attached: 'PO-Dokument angehängt.',
      approval: 'Firmenfreigabe',
      requestedBy: 'Angefordert von',
      approvedBy: 'Freigegeben von (verantwortliche Person der Firma)',
      approvedAmount: 'Freigegebene Warensumme',
      approvalNote: 'Freigabenotiz',
      listLabel: 'PO: {{number}}',
    },
    status: 'Status',
    statuses: {
      draft: 'Entwurf',
      awaiting_payment: 'Zahlung ausstehend',
      paid: 'Bezahlt',
      processing: 'In Bearbeitung',
      shipped: 'Versandt',
      delivered: 'Zugestellt',
      completed: 'Abgeschlossen',
      cancelled: 'Storniert',
    },
    empty: 'Noch keine Bestellungen',
    emptyLead: 'Bestellungen aus der Storefront, von Händlern und aus der Verwaltung erscheinen hier.',
    number: 'Bestellnr.',
    customer: 'Kunde',
    channel: 'Kanal',
    channels: {
      web: 'Storefront',
      b2b: 'Händler',
      manual: 'Verwaltung',
      api: 'API',
    },
    total: 'Gesamt',
    detailTitle: 'Bestellung {{number}}',
    backToList: 'Bestellliste',
    payment: {
      unpaid: 'Unbezahlt',
      pending: 'Zahlung ausstehend',
      paid: 'Bezahlt',
      authorized: 'Vorautorisiert',
      partially_refunded: 'Teilweise erstattet',
      refunded: 'Erstattet',
    },
    lines: 'Positionen',
    qty: 'Menge',
    unitPrice: 'Stückpreis',
    lineTotal: 'Betrag',
    lotAllocated: 'Nach Charge / MHD zugeordnet',
    subtotal: 'Zwischensumme',
    discount: 'Rabatt {{code}}',
    promotion: 'Aktion: {{label}}',
    loyaltyTier: 'Stufenrabatt: {{tier}} ({{percent}})',
    loyaltyPoints: '{{points}} Punkte',
    shippingPromotion: 'Kostenlos ({{label}})',
    tax: 'Steuer',
    shipping: 'Versand',
    customerInfo: 'Kunde und Adresse',
    shippingAddress: 'Lieferadresse',
    billingAddress: 'Rechnungsadresse',
    customerNote: 'Bestellnotiz',
    changeStatus: 'Statusaktionen',
    actions: {
      awaiting_payment: 'Bestellung bestätigen (Bestand reservieren)',
      processing: 'Als „In Bearbeitung“ markieren',
      shipped: 'Als versandt markieren',
      delivered: 'Als zugestellt markieren',
      completed: 'Abschließen',
      cancelled: 'Stornieren',
    },
    actionHints: {
      awaiting_payment:
        'Der Entwurf wird bestätigt; der Bestand wird reserviert und der Gutscheincode wird angerechnet.',
      processing:
        'Die Vorbereitung beginnt. Wenn alles bereit ist, geben Sie über „Versenden“ die Sendungsnummer ein.',
      shipped:
        'Der reservierte Bestand wird als Verkauf abgebucht. Die Bestellung kann nicht mehr storniert werden.',
      delivered: 'Die Bestellung wird als zugestellt markiert.',
      completed: 'Die Bestellung wird abgeschlossen.',
      cancelled: 'Reservierter Bestand und die Gutscheinnutzung werden freigegeben.',
    },
    statusNote: 'Notiz',
    timeline: 'Verlauf',
    noteEvent: 'Interne Notiz',
    internalNote: 'Interne Notiz hinzufügen',
    addNote: 'Notiz hinzufügen',
    manualLead: 'Die Preise richten sich nach der Gruppe des Kunden (Händlerpreis für Händler).',
    createButton: 'Bestellung anlegen',
    created: 'Bestellung angelegt',
    changeCustomer: 'Ändern',
    customerHint: 'Suche nach Name (oder mit der Berechtigung für personenbezogene Daten nach E-Mail).',
    addProduct: 'Produkt hinzufügen',
    manualPrice: 'Manueller Stückpreis',
    manualPricePlaceholder: 'Listenpreis',
    fullName: 'Name des Empfängers',
    addressLine: 'Adresse',
    discountCode: 'Gutscheincode',
    initialStatus: 'Anfangsstatus',
    codFee: 'Nachnahmegebühr',
    paymentMethod: 'Zahlungsart',
    paymentMethods: {
      card: 'Karte',
      paypal: 'PayPal',
      bank_transfer: 'Banküberweisung',
      cash_on_delivery: 'Nachnahme',
      open_account: 'Offenes Konto',
      manual: 'Manuell (Überweisung/Bar usw.)',
      gift_card: 'Geschenkkarte',
      store_credit: 'Shop-Guthaben',
      loyalty_points: 'Treuepunkte',
    },
    shippingMethod: 'Versandart',
    initialStatuses: {
      confirmed: 'Bestätigen (Bestand reservieren)',
      draft: 'Entwurf (keine Reservierung)',
    },
    paymentsTitle: 'Zahlung',
    capture: 'Zahlung eingegangen',
    refund: 'Erstatten',
    noPayments: 'Keine Zahlungsdatensätze.',
    installments: '{{count}} Raten',
    refundedAmount: 'Erstattet: {{amount}}',
    refunds: 'Erstattungen',
    refundReasons: {
      customer_request: 'Kundenwunsch',
      withdrawal: 'Widerrufsrecht',
      damaged: 'Beschädigt/defekt',
      out_of_stock: 'Nicht vorrätig',
      duplicate: 'Doppelte Zahlung',
      other: 'Sonstiges',
    },
    restocked: 'wieder eingelagert',
    testPaymentWarning:
      'Diese Bestellung wurde in der Testumgebung bezahlt; es wurde kein echtes Geld eingezogen. Versenden Sie sie nicht und stornieren Sie die Bestellung nach Abschluss der Tests.',
    resolveRefund: 'Ergebnis festlegen',
    resolveRefundTitle: 'Erstattungsergebnis festlegen',
    resolveRefundLead:
      'Diese Erstattung wurde unterbrochen und ihr Ergebnis ist unbekannt. Prüfen Sie in der Verwaltung des Zahlungsanbieters, ob die Erstattung erfolgt ist, und wählen Sie dann das Ergebnis. Es wird keine neue Erstattungsanfrage an den Anbieter gesendet.',
    resolveRefundOutcome: 'Status dieser Erstattung in der Verwaltung des Anbieters',
    resolveRefundSucceeded: 'Durchgeführt (Betrag erstattet)',
    resolveRefundFailed: 'Nicht durchgeführt',
    resolveRefundNote: 'Notiz',
    resolveRefundSave: 'Ergebnis speichern',
    resolveRefundDone: 'Erstattungsergebnis gespeichert',
    eventTypes: {
      preauth_captured: 'Vorautorisierung eingezogen',
      preauth_released: 'Vorautorisierung freigegeben; Bestellung storniert',
      preauth_capture_failed: 'Einzug der Vorautorisierung fehlgeschlagen',
      edited: 'Bestellung bearbeitet',
      return_requested: 'Rücksende-/Widerrufsanfrage eröffnet',
      return_approved: 'Rücksendeanfrage genehmigt',
      return_rejected: 'Rücksendeanfrage abgelehnt',
      return_completed: 'Rücksendeanfrage abgeschlossen',
      return_cancelled: 'Rücksendeanfrage storniert',
      created: 'Bestellung angelegt',
      status_changed: 'Status geändert',
      payment_failed: 'Zahlung fehlgeschlagen',
      payment_review: 'Zahlung muss geprüft werden',
      payment_after_cancel: 'Zahlung für eine stornierte Bestellung eingegangen (Erstattung erforderlich)',
      payment_captured: 'Zahlung eingegangen',
      payment_amount_mismatch: 'Zahlungsbetrag stimmt nicht überein',
      refund: 'Erstattet',
      refund_failed: 'Erstattung fehlgeschlagen',
      partially_shipped: 'Paket versandt (Teillieferung)',
      exchange_shipped: 'Umtauschartikel versandt',
      items_cancelled: 'Positionen storniert (Teilstornierung)',
      shipment_cancelled: 'Sendung storniert; Artikel wurden wieder eingelagert',
    },
    eventMessages: {
      draft_updated: 'Entwurf aktualisiert (Positionen, Kunde, Versand oder Rabatt).',
      lines_changed: 'Positionen/Mengen geändert; Beträge und Bestandsreservierung neu berechnet.',
      address_changed: 'Lieferadresse geändert.',
      billing_changed: 'Rechnungsadresse geändert.',
      note_changed: 'Bestellnotiz geändert.',
      po_number_changed: 'Bestellschein-Nummer (PO) geändert.',
      po_document_attached: 'Bestellschein-Dokument (PO) angehängt.',
      payment_timeout: 'Die Zahlungsfrist ist abgelaufen; die Bestellung wurde automatisch storniert.',
      bank_transfer_timeout:
        'Die Banküberweisung ist nicht rechtzeitig eingegangen; die Bestellung wurde automatisch storniert.',
    },
    refundStatuses: {
      pending: 'In Bearbeitung',
      succeeded: 'Erfolgreich',
      failed: 'Fehlgeschlagen',
    },
    captured: 'Zahlung erfasst',
    captureTitle: 'Zahlung eingegangen · {{amount}}',
    captureLead:
      'Erfassen Sie die Zahlung, nachdem Sie den Geldeingang geprüft haben. Der Kunde erhält eine E-Mail „Zahlung eingegangen“.',
    captureNote: 'Zahlungsnotiz',
    refundDone: 'Erstattung abgeschlossen',
    refundFailed: 'Erstattung fehlgeschlagen; Details im Abschnitt Zahlung',
    refundTitle: 'Erstattung',
    refundCardLead:
      'Die Erstattung erfolgt über den Anbieter, bei dem die Zahlung eingegangen ist (iyzico, PayTR, Sipay, Stripe oder PayPal); bis der Betrag auf der Karte oder dem PayPal-Konto erscheint, kann es einige Werktage dauern.',
    refundManualLead:
      'Erstattungen bei Banküberweisung oder Nachnahme führen Sie selbst über Ihre Bank durch; hier erfassen Sie sie.',
    refundConfirm: 'Erstatten',
    refundable: 'Erstattungsfähig: {{amount}}',
    refundAmount: 'Erstattungsbetrag (₺)',
    refundReason: 'Grund',
    refundNote: 'Anmerkung',
    refundNoteHint: 'z. B. IBAN der Erstattung und Datum.',
    refundPayment: 'Zu erstattende Zahlung',
    refundPaymentOption: '{{provider}} · erstattungsfähig {{amount}}',
    refundAsCredit: 'Als Shop-Guthaben statt Geld erstatten',
    refundCreditConsent: 'Der Kunde hat der Erstattung als Shop-Guthaben ausdrücklich zugestimmt',
    refundCreditLead:
      'Der Betrag wird dem Shop-Guthaben des Kunden gutgeschrieben; es erfolgt keine Erstattung auf Karte oder Bankkonto. Nur mit ausdrücklicher Zustimmung des Kunden verwenden und nie bei Erstattungen nach Widerruf.',
    refundTenderLead:
      'Der Betrag wird der Geschenkkarte oder dem Shop-Guthaben wieder gutgeschrieben; beim Anbieter erfolgt keine Erstattung.',
    refundToStoreCredit: 'Als Shop-Guthaben',
    restock: 'Zurückgesendete Artikel wieder einlagern',
    restockQty: '{{title}} – zurückgenommene Menge',
    shipmentsTitle: 'Versand',
    ship: 'Versenden',
    shipAfterPayment: 'Versand erst nach Zahlungseingang möglich.',
    noShipments: 'Noch keine Sendungen.',
    trackingLink: 'Verfolgen',
    shipmentStatuses: {
      created: 'Erstellt',
      in_transit: 'Unterwegs',
      out_for_delivery: 'In Zustellung',
      delivered: 'Zugestellt',
      returned: 'Zurückgesendet',
      exception: 'Problem',
      cancelled: 'Storniert',
    },
    updateShipment: 'Status aktualisieren',
    shipped: 'Bestellung versendet',
    shipTitle: 'Bestellung versenden',
    shipLead:
      'Wählen Sie die Artikel und Mengen für dieses Paket. Die verpackten Mengen werden vom Bestand abgebucht und der Kunde erhält eine E-Mail mit der Sendungsnummer. Ist nichts mehr zu versenden, wird die Bestellung „Versendet“; andernfalls bleibt sie in Bearbeitung.',
    shipItems: 'Artikel in diesem Paket',
    shipQty: '{{title}} – zu versendende Menge',
    shipProgress: '{{shipped}}/{{ordered}} versendet',
    shipCodNote:
      'Eine Nachnahmebestellung kann nicht aufgeteilt werden; alle verbleibenden Artikel werden in diesem Paket versendet.',
    shipPartialNote: 'Dieses Paket ist ein Teil der Bestellung; die übrigen Artikel werden später versendet.',
    shipNothing: 'Fügen Sie dem Paket mindestens einen Artikel hinzu.',
    shippedPartial: 'Paket versendet; die übrigen Artikel warten auf den Versand',
    partiallyShipped: 'Teilweise versendet',
    ledgerSettled: 'Über Kundenkonto ausgeglichen',
    exportExempt: 'Export — MwSt.-befreit',
    waitingToShip: 'Warten auf Versand: {{items}}',
    shipmentItem: '{{quantity}} × {{title}}',
    chooseProvince: 'Provinz wählen',
    chooseDistrict: 'Bezirk wählen',
    chooseProvinceFirst: 'Zuerst Provinz wählen',
    legacyPlace: '{{value}} (nicht in der Liste)',
    cancelledQty: '{{count}} storniert',
    cancelledItems: 'Stornierte Artikel',
    refundDue:
      'Der Betrag von {{amount}} für Artikel, die nicht versendet werden konnten und storniert wurden, ist noch nicht erstattet. Erstatten Sie ihn über „Erstatten“ (der Betrag wird vorgeschlagen).',
    cancelItems: 'Verbleibende Artikel stornieren',
    cancelItemsLead:
      'Artikel, die nicht versendet werden können, werden aus der Bestellung storniert: Der reservierte Bestand wird freigegeben und der Kunde erhält eine E-Mail. Die Bestellsumme ändert sich nicht; wurde bereits bezahlt, erstatten Sie die stornierten Artikel über „Erstatten“. Ist nichts mehr zu versenden, wird die Bestellung „Versendet“.',
    cancelQty: '{{title}} – zu stornierende Menge',
    cancelItemsNote: 'Hinweis an den Kunden',
    cancelItemsNoteHint:
      'Wird dem Kunden in der E-Mail angezeigt (z. B. „Beim Lieferanten nicht mehr verfügbar“).',
    itemsCancelled: 'Artikel storniert; Betrag {{amount}}',
    trackingNumber: 'Sendungsnummer',
    trackingUrl: 'Tracking-URL',
    trackingUrlHint:
      'Wenn leer, wird die Tracking-Seite des Versanddienstleisters verwendet (Format nicht geprüft).',
    packageCount: 'Anzahl Pakete',
    updateShipmentLead:
      'Bei Auswahl von „Zugestellt“ wird auch die Bestellung als zugestellt markiert, sobald alle ihre Pakete zugestellt sind.',
    shipmentCancelNote:
      'Artikel eines stornierten Pakets kommen zurück in den Bestand und werden erneut für die Bestellung reserviert; die Bestellung kehrt zu „In Bearbeitung“ zurück und die Artikel können erneut versendet werden. Stornieren Sie nur, wenn das Paket nie verschickt wurde.',
    shipmentStatus: 'Status',
    shipmentNote: 'Anmerkung',
    invoicesTitle: 'Rechnung',
    createInvoice: 'Rechnung erstellen',
    noInvoices: 'Keine Rechnung.',
    contractsTitle: 'Akzeptierte Texte',
    contractsLead:
      'Texte, die der Kunde beim Bestellabschluss gesehen und akzeptiert hat, mit Version und Zeitpunkt.',
    contractHash: 'Text-Prüfsumme: {{hash}}…',
  },
  orderTools: {
    manualPriceHint:
      'Manueller Stückpreis ({{currency}}, Steuerbehandlung wie in der Preisliste); leer lassen, um den Listenpreis des Kunden zu verwenden.',
    editDraftTitle: 'Bestellentwurf {{number}}',
    saveDraft: 'Entwurf speichern',
    customerKind: 'Kundentyp',
    customerKinds: {
      customer: 'Registrierter Kunde',
      guest: 'Gast',
    },
    guestEmail: 'E-Mail',
    guestEmailHint: 'Bestell- und Zahlungsdetails werden an diese Adresse gesendet.',
    maskedKeep: 'Der gespeicherte Wert ist verborgen; leer lassen, um ihn beizubehalten.',
    guestPhone: 'Telefon des Kunden',
    noShippingMethod: 'Keine Versandart (kostenlos oder später festgelegt)',
    audience: {
      retail: 'nur Endkunden',
      dealers: 'nur Händler',
    },
    shippingFee: 'Versandkosten ({{currency}}, inkl. MwSt.)',
    shippingFeeHint:
      'Leer lassen, um sie aus der gewählten Versandart zu berechnen (Gewichtsstaffeln, Grenze für kostenlosen Versand).',
    discountKind: 'Rabatt',
    discountKinds: {
      none: 'Kein Rabatt',
      code: 'Gutscheincode',
      manual: 'Manueller Betrag',
    },
    manualDiscount: 'Rabattbetrag ({{currency}}, inkl. MwSt.)',
    manualDiscountHint:
      'Wird anteilig nach Betrag auf die Artikel verteilt; darf die Zwischensumme nicht übersteigen.',
    addressMasked:
      'Die Adresse ist verborgen (Sie dürfen keine personenbezogenen Daten einsehen). Geben Sie zum Ändern die vollständige Adresse ein; leer lassen, um die gespeicherte beizubehalten.',
    editLinesTitle: 'Artikel bearbeiten',
    editLinesLead:
      'Vorhandene Artikel behalten ihren Stückpreis; neue Artikel werden zum aktuellen Preis hinzugefügt. Die Versandkosten bleiben unverändert; der Bestand wird neu reserviert.',
    editAddressTitle: 'Adresse und Anmerkung bearbeiten',
    editAddressLead:
      'Lieferadresse und Bestellanmerkung können geändert werden, bis eine Sendung erstellt ist. Nach Rechnungsstellung kann die Rechnungsadresse nicht mehr geändert werden.',
    editDraft: 'Entwurf bearbeiten',
    editLines: 'Artikel bearbeiten',
    editAddress: 'Adresse und Anmerkung bearbeiten',
    bulkRegion: 'Ausgewählte Bestellungen',
    selected: '{{count}} Bestellungen ausgewählt',
    printOrders: 'Bestellübersicht drucken',
    printPacking: 'Packliste drucken',
    exportSelected: 'Als Excel herunterladen',
    bulkStatus: 'Status ändern',
    bulkDone: 'Status für {{count}} Bestellungen geändert.',
    bulkStatusTitle: 'Status von {{count}} Bestellungen ändern',
    bulkStatusLead:
      'Jede Bestellung wird nach ihren eigenen Regeln geändert (Bestand, Gutschein, Kundenbenachrichtigung); Bestellungen, bei denen das nicht möglich ist, werden mit Begründung aufgelistet.',
    bulkApply: 'Anwenden',
    bulkSummary: '{{ok}} Bestellungen geändert, {{failed}} nicht geändert.',
    bulkTarget: 'Neuer Status',
    bulkCancelWarning:
      'Kunden stornierter Bestellungen erhalten eine Storno-E-Mail; reservierter Bestand und Gutscheinnutzung werden freigegeben. Bezahlte Bestellungen werden nicht ohne Erstattung storniert.',
    selectAllPage: 'Alle Bestellungen auf dieser Seite auswählen',
    selectRow: 'Bestellung {{number}} auswählen',
  },
  preauth: {
    held: '{{amount}} ist auf der Karte reserviert (Vorautorisierung); noch nicht belastet.',
    deadline: 'Einzug bis: {{date}} (noch {{days}} Tage).',
    expiringSoon: 'Läuft bald ab: Bestellung versenden oder jetzt einziehen.',
    partial:
      'Die Bestellsumme beträgt {{amount}}: Dieser Betrag wird beim Einzug belastet, die Bank gibt die restlichen {{rest}} frei.',
    capture: 'Einziehen',
    captureTitle: 'Vorautorisierung einziehen',
    captureLead:
      '{{amount}} wird aus der Reservierung von {{held}} eingezogen. Dies geschieht beim Versand auch automatisch.',
    captured: 'Betrag eingezogen',
    release: 'Vorautorisierung freigeben',
    releaseTitle: 'Vorautorisierung freigeben',
    releaseLead:
      'Die Reservierung auf der Karte wird aufgehoben und die Bestellung storniert; Bestand und Gutscheinnutzung werden zurückgegeben und der Kunde erhält eine Storno-E-Mail. Dies kann nicht rückgängig gemacht werden.',
    releaseNote: 'Grund',
    released: 'Vorautorisierung freigegeben; Bestellung storniert',
  },
  paymentLinks: {
    title: 'Zahlungslink',
    create: 'Zahlungslink erstellen',
    renew: 'Neuen Link erstellen',
    empty: 'Kein Zahlungslink für diese Bestellung.',
    createdAt: 'Erstellt: {{date}}',
    expiresAt: 'Gültig bis: {{date}}',
    paidAt: 'Bezahlt: {{date}}',
    openedAt: 'Vom Kunden geöffnet: {{date}}',
    notOpened: 'Noch nicht geöffnet',
    states: {
      active: 'Gültig',
      paid: 'Bezahlt',
      expired: 'Abgelaufen',
      cancelled: 'Storniert',
      closed: 'Geschlossen',
      amount_changed: 'Betrag geändert',
    },
    cancel: 'Stornieren',
    cancelConfirm: 'Diesen Link stornieren? Der Kunde kann damit nicht mehr bezahlen.',
    cancelledToast: 'Link storniert',
    createTitle: 'Zahlungslink erstellen',
    createLead:
      'Der Kunde sieht die Bestellung und die Vertragstexte, akzeptiert sie und bezahlt {{amount}} per Karte.',
    draftNote:
      'Die Bestellung ist ein Entwurf: Mit dem Erstellen des Links wird sie bestätigt, der Bestand reserviert und die Gutscheinnutzung gezählt.',
    renewNote: 'Der aktuelle Link wird storniert; senden Sie dem Kunden den neuen Link.',
    hours: 'Gültig für',
    hourOptions: {
      h24: '24 Stunden',
      h72: '3 Tage',
      h168: '7 Tage',
      h720: '30 Tage',
    },
    sendEmail: 'Link an die E-Mail-Adresse des Kunden senden ({{email}})',
    noEmail: 'Die Bestellung hat keine E-Mail-Adresse; kopieren Sie den Link und senden Sie ihn selbst.',
    createButton: 'Erstellen',
    createdTitle: 'Zahlungslink bereit',
    createdLead:
      'Der Link wird nur jetzt angezeigt; kopieren Sie ihn und senden Sie ihn dem Kunden (WhatsApp, SMS, E-Mail). Falls er verloren geht, erstellen Sie einen neuen.',
    url: 'Link',
    copy: 'Kopieren',
    copied: 'Link kopiert',
    copyFailed: 'Kopieren nicht möglich; markieren Sie den Link und kopieren Sie ihn manuell.',
    emailed: 'Der Link wurde per E-Mail an den Kunden gesendet.',
    notEmailed: 'Es wurde keine E-Mail gesendet.',
  },
  proforma: {
    title: 'Proforma-Rechnung',
    open: 'Proforma-Rechnung',
    back: 'Zurück zur Bestellung',
    documentLabel: 'Proforma-Rechnung {{number}}',
    notInvoice:
      'Dies ist eine Proforma-Rechnung; sie ersetzt nicht die Handelsrechnung (e-Fatura / e-Arşiv).',
    currency: 'Währung: {{currency}}',
    sellerTax: 'Finanzamt / Steuernr.: {{office}} / {{number}}',
    mersis: 'MERSIS: {{no}}',
    buyer: 'Käufer',
    consignee: 'Empfänger',
    totalWeight: 'Gesamtgewicht der Produkte',
    kg: '{{value}} kg',
    description: 'Warenbeschreibung',
    hsCode: 'HS-Code',
    origin: 'Ursprung',
    weight: 'Gewicht',
    discount: 'Rabatt',
    exportExemption:
      'Ausfuhrlieferung: keine MwSt. berechnet (türkisches Umsatzsteuergesetz Nr. 3065, Art. 11/1-a).',
    exemptionVerify:
      'Lassen Sie die Rechtsgrundlage der Befreiung und den Wortlaut auf diesem Dokument von Ihrem Steuerberater bestätigen.',
    fxLine: 'Kurs: {{pair}} (TCMB-Devisenankaufskurs, {{date}})',
    pricesInclusive: 'Preise inkl. MwSt.',
    pricesExclusive: 'Preise zzgl. MwSt.',
    missingCustoms:
      'Produkte ohne HS-Code oder Ursprungsland: {{skus}}. Ergänzen Sie diese im Abschnitt „Zoll und Export“ des Produkteditors.',
  },
  catalogTranslations: {
    title: 'Übersetzungen',
    productLead:
      'Die Basissprache des Produkts ist {{base}}. Name, Beschreibungen und SEO-Felder in weiteren Sprachen; eine übersetzte Sprache wird unter ihrer Adresse mit Sprachpräfix (z. B. /en/…) für Suchmaschinen freigegeben.',
    missing: 'Keine Übersetzung',
    findings: '{{count}} mögliche gesundheitsbezogene Aussagen; vor der Freigabe prüfen',
    vet: {
      approved: 'Freigegeben',
      pending: 'Wartet auf tierärztliche Freigabe',
    },
    approve: 'Freigeben',
    approveConfirm:
      'Übersetzung ({{language}}) freigeben? Der freigegebene Text wird in der Storefront veröffentlicht.',
    approved: 'Übersetzung freigegeben.',
    add: 'Übersetzung hinzufügen',
    deleteConfirm: 'Übersetzung ({{language}}) löschen?',
    dialogTitle: 'Übersetzung: {{language}}',
    dialogLead:
      'Leere Beschreibungsfelder werden nicht angezeigt. Zusammensetzung, Anwendung und Warnhinweise bleiben in der Basissprache.',
    productTitle: 'Produktname',
    shortDescription: 'Kurzbeschreibung',
    description: 'Beschreibung',
    seoTitle: 'SEO-Titel',
    seoDescription: 'SEO-Beschreibung',
    categoryTitle: '{{name}} — Übersetzungen',
    categoryLead:
      'Kategoriename, Beschreibung und SEO-Felder; eine übersetzte Kategorie wird in dieser Sprache für Suchmaschinen freigegeben.',
    noLanguages:
      'Ihre Shops haben keine Sprache außer der Basissprache. Fügen Sie einen Markt in einer anderen Sprache hinzu, um zu übersetzen.',
    language: 'Sprache',
    done: 'übersetzt',
    categoryName: 'Kategoriename',
    saveLanguage: '{{language}} speichern',
  },
  orderPrint: {
    orderTitle: 'Bestellübersicht',
    packingTitle: 'Packliste',
    print: 'Drucken / als PDF speichern',
    nothing: 'Keine Bestellungen zum Drucken.',
    lead: '{{count}} Bestellungen. Jede Bestellung wird auf einer eigenen Seite gedruckt; für ein PDF wählen Sie im Druckdialog „Als PDF speichern“.',
    maskedNote:
      'Adressen und Kontaktdaten sind verborgen, da Sie keine personenbezogenen Daten einsehen dürfen.',
    documentLabel: '{{title}} {{number}}',
    packingNote: 'Kommissionier- und Packliste für das Lager; kein elektronischer Lieferschein.',
    lots: 'Charge / MHD',
    check: 'Kontrolle',
    lotLine: '{{lot}} (MHD {{expiry}}) × {{qty}}',
    preparedBy: 'Erstellt von',
    checkedBy: 'Geprüft von',
  },
  payments: {
    store: 'Shop',
    noStore: 'Erstellen Sie zuerst einen Shop',
    noStoreLead:
      'Zahlungs- und Versandeinstellungen gelten pro Shop. Fügen Sie unter „Shops“ einen Shop hinzu.',
    cardTitle: 'Kartenzahlung (virtuelles POS-Terminal)',
    cardLead:
      'iyzico oder PayTR. Kartendaten gelangen nie in den Shop; sie werden auf der sicheren Seite des Anbieters eingegeben.',
    envSandbox: 'Test',
    envLive: 'Live',
    keysHint:
      'Die Schlüssel werden verschlüsselt im Bereich Integrationen gespeichert, wo Sie auch den Verbindungstest durchführen:',
    cardProvider: 'Anbieter für Kartenzahlung',
    cardOff: 'Aus',
    cardStatus: 'Kartenzahlung in der Storefront:',
    cardState_off: 'Aus',
    cardState_test: 'Test (kein echtes Geld)',
    cardState_live: 'Live',
    cardNext_off_none:
      'Nächster Schritt: Geben Sie unter Integrationen die Sandbox-Schlüssel von iyzico oder PayTR ein und testen Sie die Verbindung; wählen Sie dann unten den Anbieter und speichern Sie.',
    cardNext_off_live_only:
      'Live-Schlüssel sind verbunden, aber die Kartenzahlung ist ausgeschaltet. Inhaber: Wählen Sie den Anbieter oder klicken Sie auf „Live schalten“; ohne Testzahlung können Sie die Warnung bestätigen und mit Zwei-Faktor-Authentifizierung direkt live gehen und anschließend eine kleine erste Live-Bestellung aufgeben und erstatten. Andere Rollen benötigen zuerst eine erfolgreiche Sandbox-Zahlung.',
    cardNext_off_ready:
      'Nächster Schritt: Wählen Sie unten den Anbieter und speichern Sie; die Kartenzahlung startet im Testmodus.',
    cardNext_test:
      'Kunden können mit Testkarten bezahlen; es wird kein echtes Geld belastet. Bezahlen Sie eine Testbestellung und prüfen Sie sie unter Zahlungen; bei Erfolg wechseln Sie mit „Live schalten“ zu echten Zahlungen (am Starttag).',
    cardNext_live: 'Echte Kartenzahlungen werden angenommen.',
    environment: 'Umgebung',
    goLive: 'Live schalten',
    backToSandbox: 'Zurück zu Test',
    backToSandboxConfirm:
      'Die Kartenzahlung wird ausgeschaltet und die Umgebung zurück auf Test gestellt. Fortfahren?',
    sandboxNote:
      'Im Test wird kein echtes Geld belastet; geben Sie eine Probebestellung mit den Testkarten des Anbieters auf.',
    maxInstallments: 'Ratenzahlung',
    singlePayment: 'Einmalzahlung',
    upTo: 'Bis zu {{count}} Raten',
    cardTimeout: 'Zeitlimit für Kartenzahlung (Minuten)',
    cardCapture: 'Zeitpunkt der Belastung',
    cardCaptures: {
      immediate: 'Bei Zahlung belasten',
      preauth: 'Vorautorisieren, bei Versand belasten',
    },
    cardCapturePreauthHint:
      'Der Betrag wird beim Bezahlvorgang auf der Karte reserviert und beim Versand der Bestellung belastet (oder über „Einziehen“ in der Bestellung). Reservierungen, die nicht innerhalb von 25 Tagen eingezogen werden, gibt die Bank frei. Nur Einmalzahlung; Debitkarten können nicht vorautorisiert werden.',
    preauthPaytr:
      'Vorautorisierung ist für PayTR nicht verfügbar: Die technische Dokumentation dazu ist nicht öffentlich; die Funktion kann ergänzt werden, sobald PayTR sie bereitstellt.',
    preauthSipay: 'Bei Sipay wird keine Vorautorisierung verwendet: die Zahlung wird sofort eingezogen.',
    cardCurrencies: 'Kartenzahlung in Fremdwährung',
    cardCurrenciesHint: {
      iyzico:
        'In einem Shop mit Preisen in einer anderen Währung als TRY werden Karten nur in den hier markierten Währungen angeboten. Markieren Sie diese, wenn Sie mit iyzico eine Vereinbarung über Fremdwährungszahlungen haben.',
      paytr:
        'In einem Shop mit Preisen in einer anderen Währung als TRY werden Karten nur in den hier markierten Währungen angeboten. PayTR erfordert für EUR/USD/GBP eine Vereinbarung mit seinem Firmenkundenteam.',
      sipay:
        'In einem Shop mit anderer Währung als TRY wird die Kartenzahlung nur in den hier markierten Währungen angeboten. Sipay akzeptiert EUR und USD; für Fremdwährung ist eine Vereinbarung mit Sipay nötig.',
      stripe:
        'Fremdwährungskarten über Stripe: In Märkten mit Preisen in einer markierten Währung werden Kartenzahlungen auf der Zahlungsseite von Stripe abgewickelt.',
    },
    cardCurrencyLabel: 'Kartenzahlung in {{currency}}',
    notifyUrls: 'Benachrichtigungs-URLs',
    iyzicoNotify: 'iyzico-Benachrichtigungs-URL (Webhook)',
    paytrNotify: 'PayTR-Benachrichtigungs-URL',
    sipayNotify: 'Sipay-Webhook-URL',
    intlTitle: 'Auslandszahlungen (Stripe, PayPal)',
    intlLead:
      'Nehmen Sie in Fremdwährungsmärkten Kartenzahlungen auf der Seite von Stripe und PayPal-Zahlungen auf der Seite von PayPal entgegen. TRY-Zahlungen laufen weiterhin über den obigen Kartenanbieter.',
    intlEntityTitle: 'Ein Unternehmen außerhalb der Türkei ist erforderlich',
    intlEntityLead:
      'Stripe und PayPal eröffnen keine Konten für in der Türkei ansässige Unternehmen. Das Konto wird für Ihr Unternehmen in einem unterstützten Land eröffnet, und die Gelder gehen an dieses Unternehmen. Klären Sie Rechnungsstellung und Buchhaltung mit Ihrem Steuerberater, bevor Sie live gehen.',
    intlCardProvider: 'Kartenzahlung in Fremdwährung',
    intlCardHint:
      'Ist Stripe ausgewählt, laufen Kartenzahlungen in anderen Währungen als TRY über Stripe; keine Ratenzahlung oder Vorautorisierung.',
    intlCardOff: 'Inländischer Kartenanbieter (falls Fremdwährungsvereinbarung vorhanden)',
    intlCardEnvironment: 'Umgebung für Fremdwährungskarten',
    paypal: 'Mit PayPal bezahlen',
    paypalHint:
      'PayPal-Option an der Kasse; nur in EUR-, USD- und GBP-Märkten sichtbar. Verbinden Sie zuerst Integrationen → PayPal.',
    paypalEnvironment: 'PayPal-Umgebung',
    stripeNotify: 'Stripe-Webhook-URL',
    paypalNotify: 'PayPal-Webhook-URL',
    otherTitle: 'Weitere Zahlungsarten',
    otherLead:
      'Bei Zahlungsarten ohne Karte markieren Sie die Bestellung mit „Zahlung erhalten“, sobald das Geld eingegangen ist.',
    bankTransfer: 'Banküberweisung',
    bankTransferHold: 'Zahlungsfrist für Banküberweisung (Stunden)',
    bankTransferHint:
      'Der Kunde sieht die Bankverbindung nach der Bestellung; Sie bestätigen den Zahlungseingang. Nicht fristgerecht bezahlte Bestellungen werden automatisch storniert.',
    cod: 'Nachnahme',
    codHint: 'Nur bei Versandarten angeboten, die Nachnahme unterstützen.',
    codFee: 'Nachnahmegebühr (₺)',
    codMax: 'Nachnahme-Höchstbetrag (₺)',
    dealerOpenAccount: 'Offenes Konto für Händler',
    dealerOpenAccountHint:
      'Freigegebene Händler bestellen ohne Zahlung; der Betrag wird ihrem Kundenkonto belastet.',
    guestCheckout: 'Bestellung als Gast',
    guestCheckoutHint: 'Wenn ausgeschaltet, müssen Kunden für eine Bestellung ein Konto anlegen.',
    summaryTitle: 'In der Storefront angebotene Zahlungsarten',
    summaryCard: 'Karte: {{provider}} ({{env}})',
    summaryNoCard: 'Kartenzahlung aus',
    summaryIntl: 'Fremdwährungskarten: {{provider}} ({{env}})',
    summaryPaypal: 'PayPal ({{env}})',
    goLiveTitle: 'Mit {{provider}} live gehen',
    goLiveLead:
      'Ab jetzt wird echtes Geld von den Karten der Kunden belastet. Die folgenden Punkte müssen erfüllt sein.',
    goLiveConfirm: 'Live schalten',
    checkLiveConnection: 'Verbindungstest mit Live-Schlüsseln erfolgreich',
    checkSandboxPayment: 'Mindestens eine erfolgreiche Zahlung im Test',
    noSandboxTitle: 'Keine Testzahlung durchgeführt',
    noSandboxLead:
      'Es gibt keine erfolgreiche Sandbox-Zahlung. Wenn Sie live gehen, geben Sie die erste Live-Bestellung selbst mit einem kleinen Betrag auf und erstatten Sie sie, um zu bestätigen, dass Zahlung und Erstattung funktionieren.',
    noSandboxAck:
      'Ich gehe ohne Testzahlung live; ich gebe die erste Live-Bestellung selbst mit einem kleinen Betrag auf und erstatte sie (Freigabe durch den Inhaber).',
    noSandboxOwnerOnly: 'Nur der Geschäftsinhaber kann das Live-Schalten ohne Testzahlung freigeben.',
    firstLiveOrderTitle: 'Erste Live-Bestellung selbst aufgeben und erstatten',
    firstLiveOrderLead:
      'Die Kartenzahlung wurde ohne Testzahlung live geschaltet. Geben Sie mit Ihrer eigenen Karte eine kleine Bestellung auf, prüfen Sie, dass sie bezahlt ist, und erstatten Sie sie in den Bestelldetails. Dieser Hinweis verschwindet, sobald die Erstattung abgeschlossen ist.',
    goLiveAck:
      'Mir ist bewusst, dass echte Karten belastet werden und der Vertrag mit dem Zahlungsanbieter genehmigt ist.',
    bankAccounts: 'Bankkonten',
    bankAccountsLead: 'Wird Kunden angezeigt, die Banküberweisung wählen.',
    addBankAccount: 'Bankkonto hinzufügen',
    editBankAccount: 'Bankkonto bearbeiten',
    noBankAccounts: 'Keine Bankkonten',
    noBankAccountsLead:
      'Fügen Sie mindestens ein Konto hinzu, wenn Banküberweisung aktiviert ist; andernfalls wird die Zahlungsart ausgeblendet.',
    accountStatus: {
      active: 'Aktiv',
      inactive: 'Inaktiv',
    },
    deleteBankAccountConfirm: 'Dieses Bankkonto löschen? Frühere Bestellungen sind nicht betroffen.',
    bankAccountDialogLead:
      'Die IBAN wird geprüft. Änderungen erfordern eine Zwei-Faktor-Authentifizierung und werden im Prüfprotokoll erfasst.',
    bankName: 'Bank',
    accountHolder: 'Kontoinhaber',
    iban: 'IBAN',
    accountStatusLabel: 'Status',
    accountCurrency: 'Währung',
    status: 'Status',
    provider: 'Zahlungsart',
    statuses: {
      pending: 'Ausstehend',
      requires_action: 'Prüfung erforderlich',
      authorized: 'Autorisiert (Reservierung)',
      captured: 'Eingezogen',
      failed: 'Fehlgeschlagen',
      cancelled: 'Storniert',
      expired: 'Abgelaufen',
    },
    providers: {
      iyzico: 'iyzico',
      paytr: 'PayTR',
      stripe: 'Stripe',
      paypal: 'PayPal',
      sipay: 'Sipay',
      bank_transfer: 'Banküberweisung',
      cash_on_delivery: 'Nachnahme',
      open_account: 'Offenes Konto',
      manual: 'Manuell',
      gift_card: 'Geschenkkarte',
      store_credit: 'Shop-Guthaben',
      loyalty_points: 'Treuepunkte',
    },
    empty: 'Noch keine Zahlungen',
    emptyLead: 'Zahlungen aus der Storefront oder der Verwaltung erscheinen hier.',
    amount: 'Betrag',
    refunded: 'Erstattet',
    events: 'Benachrichtigungen',
    eventsTitle: 'Zahlungsprotokoll · {{number}}',
    eventsLead:
      'Benachrichtigungen und Abfragen des Anbieters. Benachrichtigungen mit ungültiger Signatur werden nicht verarbeitet.',
    noEvents: 'Keine Einträge.',
    eventKinds: {
      webhook: 'Benachrichtigung',
      callback: 'Benachrichtigung (PayTR)',
      return: 'Browser-Rückleitung',
      status_query: 'Statusabfrage',
      reconcile: 'Abgleich',
      manual: 'Manuell',
    },
    outcomes: {
      applied: 'Verarbeitet',
      duplicate: 'Duplikat (ignoriert)',
      ignored: 'Ignoriert',
      rejected: 'Abgelehnt',
      error: 'Fehler',
    },
    signatureOk: 'Signatur gültig',
    signatureBad: 'Signatur ungültig',
  },
  returns: {
    title: 'Rücksende- und Widerrufsanfragen',
    customerNote: 'Anmerkung des Kunden',
    decisionNote: 'Anmerkung des Shops',
    kinds: {
      withdrawal: 'Widerrufsrecht',
      defective: 'Beschädigter / defekter Artikel',
      wrong_item: 'Falscher Artikel',
      other: 'Sonstiges',
    },
    statuses: {
      requested: 'Wartet auf Antwort',
      approved: 'Genehmigt',
      rejected: 'Abgelehnt',
      completed: 'Abgeschlossen',
      cancelled: 'Storniert',
    },
    actions: {
      approved: 'Genehmigen',
      rejected: 'Ablehnen',
      completed: 'Abschließen',
      cancelled: 'Stornieren',
    },
    leads: {
      approved:
        'Der Kunde erhält eine Genehmigungs-E-Mail. Geben Sie an, wie der Artikel zurückgesendet werden soll (Versanddienstleister, Vertragscode, Adresse). Die Erstattung erfolgt im Abschnitt Zahlung, sobald der Artikel eingetroffen ist.',
      rejected: 'Der Kunde erhält eine E-Mail mit der Begründung. Die Begründung ist erforderlich.',
      completed:
        'Schließen Sie die Anfrage, sobald der Artikel eingetroffen ist und die Erstattung im Abschnitt Zahlung erfolgt ist. Dabei wird KEINE Erstattung ausgeführt.',
      cancelled:
        'Schließen Sie die Anfrage, wenn der Kunde sie zurückgezogen hat. Eine Anmerkung ist erforderlich.',
    },
    noteLabels: {
      approved: 'Versandanweisungen',
      rejected: 'Begründung',
      completed: 'Anmerkung',
      cancelled: 'Anmerkung',
    },
    done: {
      approved: 'Anfrage genehmigt',
      rejected: 'Anfrage abgelehnt',
      completed: 'Anfrage abgeschlossen',
      cancelled: 'Anfrage storniert',
    },
    resolutions: {
      refund: 'Erstattung',
      exchange: 'Umtausch',
    },
    exchangeTo: 'Stattdessen senden: {{items}}',
    exchangeShipped: 'Umtauschartikel versendet: {{carrier}} · {{tracking}}',
    restockedYes: 'Der zurückgesendete Artikel wurde wieder eingelagert.',
    restockedNo: 'Der zurückgesendete Artikel wurde nicht wieder eingelagert.',
    shipExchange: 'Umtausch versenden',
    shipExchangeLead:
      'Sobald der zurückgesendete Artikel eingetroffen ist, versenden Sie den neuen Artikel. Der reservierte Artikel wird vom Bestand abgebucht, die Anfrage wird abgeschlossen und der Kunde erhält eine E-Mail mit der Sendungsnummer. Es fließt kein Geld.',
    restock: 'Zurückgesendeten Artikel wieder in den verkaufsfähigen Bestand aufnehmen',
    restockHint: 'Defekte oder geöffnete Artikel nicht wieder einlagern.',
    exchangeShippedDone: 'Umtauschartikel versendet',
    exchangeLeads: {
      approved:
        'Mit der Genehmigung wird der gewünschte Artikel für den Kunden reserviert und eine Genehmigungs-E-Mail gesendet. Geben Sie an, wie der Artikel zurückgesendet werden soll. Wenn der zurückgesendete Artikel eintrifft, versenden Sie den neuen über „Umtausch versenden“.',
      rejected: 'Der Kunde erhält eine E-Mail mit der Begründung. Eine Begründung ist erforderlich.',
      cancelled:
        'Schließen Sie die Anfrage, wenn der Kunde es sich anders überlegt hat; der reservierte Artikel wird wieder zum Verkauf freigegeben. Eine Anmerkung ist erforderlich.',
    },
  },
  launch: {
    title: 'Veröffentlichungsstatus',
    lead_draft:
      'Der Shop ist in der Vorschau: Die Storefront ist mit dem Hinweis „Vorschau“ geöffnet und für Suchmaschinen verborgen. Er kann live gehen, sobald die unten aufgeführten Pflichtpunkte erfüllt sind.',
    lead_live: 'Der Shop ist live: Die Storefront ist für echte Kunden geöffnet.',
    lead_maintenance:
      'Der Shop ist im Wartungsmodus: Besucher sehen eine Wartungsseite. Verwaltung und Bestellungen funktionieren weiter.',
    lead_archived:
      'Der Shop ist archiviert: Die Storefront ist geschlossen und der Shop wird zuletzt aufgeführt. Wird die Archivierung aufgehoben, kehrt er in die Vorschau zurück.',
    toArchive: 'Archivieren',
    unarchive: 'Archivierung aufheben',
    dialogTitle_archived: 'Shop archivieren',
    dialogLead_archived:
      'Die Storefront wird geschlossen; Bestellungen, Produkte und Einstellungen bleiben erhalten. Sie können die Archivierung jederzeit aufheben.',
    confirm_archived: 'Archivieren',
    done_archived: 'Shop archiviert',
    goLive: 'Shop live schalten',
    toMaintenance: 'Wartung',
    toDraft: 'Zurück zur Vorschau',
    blocked: 'Vor dem Live-Schalten fehlen {{count}} Pflichtpunkte.',
    noPermission: 'Nur der Inhaber und Administratoren können den Veröffentlichungsstatus ändern.',
    dialogTitle_live: 'Shop live schalten',
    dialogLead_live: 'Dies erfordert eine Zwei-Faktor-Authentifizierung und wird im Prüfprotokoll erfasst.',
    dialogTitle_maintenance: 'Shop in den Wartungsmodus versetzen',
    dialogLead_maintenance:
      'Besucher sehen eine Wartungsseite (innerhalb einer Minute). Suchmaschinen erhalten die Antwort „vorübergehend nicht verfügbar“.',
    dialogTitle_draft: 'Zurück zur Vorschau',
    dialogLead_draft:
      'Der Shop geht offline: Die Storefront wird mit dem Hinweis „Vorschau“ geöffnet und ist für Suchmaschinen verborgen.',
    liveEffect1: 'Der Hinweis „Vorschau“ verschwindet; aufgegebene Bestellungen sind echte Bestellungen.',
    liveEffect2:
      'Kartenzahlungen in der Testumgebung werden nicht angeboten; Kartenzahlungen erfordern die Live-Umgebung.',
    liveEffect3:
      'Die Freigabe für Suchmaschinen ist eine separate Servereinstellung (SITE_INDEXING=on); siehe Migrationsleitfaden.',
    confirmText:
      'Ich habe Preise, Zahlungsarten und Rechtstexte geprüft; der Shop wird für echte Kunden geöffnet.',
    note: 'Anmerkung',
    confirm_live: 'Live schalten',
    confirm_maintenance: 'Wartung starten',
    confirm_draft: 'Zurück zur Vorschau',
    done_live: 'Der Shop ist live',
    done_maintenance: 'Der Shop ist im Wartungsmodus',
    done_draft: 'Der Shop ist wieder in der Vorschau',
  },
  readiness: {
    title: 'Checkliste für den Livegang',
    lead: 'Was der Shop vor dem Verkaufsstart benötigt. Jeder Punkt wird anhand echter Daten geprüft.',
    progress: '{{done}} von {{total}} erledigt',
    ok: 'Erledigt',
    missing: 'Fehlt',
    fix: 'Beheben',
    goLiveLocked:
      'Sobald die Pflichtpunkte erfüllt sind, wird der Shop unter Shops → Shop → Veröffentlichungsstatus mit ausdrücklicher Bestätigung und Zwei-Faktor-Authentifizierung live geschaltet.',
    items: {
      seller_info: 'Verkäuferangaben (Firmenname, Adresse, Telefon, E-Mail)',
      domain: 'Shop-Domain',
      products: 'Mindestens ein veröffentlichtes Produkt',
      shipping: 'Mindestens eine Versandart',
      payment_methods: 'Mindestens eine Zahlungsart',
      card_live: 'Kartenzahlung live',
      etbis: 'ETBİS-Registrierung (empfohlen)',
      legal_published: 'Erforderliche Rechtstexte veröffentlicht',
      legal_reviewed: 'Rechtstexte von einem Anwalt geprüft',
      legal_languages: 'Rechtstexte in den Marktsprachen',
    },
    hints: {
      seller_info: 'Füllen Sie die fehlenden Felder unter Unternehmensangaben aus.',
      domain: 'Fügen Sie unter Shops eine Storefront-Domain hinzu.',
      products: 'Veröffentlichen Sie mindestens ein Produkt.',
      shipping: 'Fügen Sie eine Versandart hinzu.',
      payment_methods: 'Aktivieren Sie Kartenzahlung, Banküberweisung oder Nachnahme.',
      card_live: 'Nach einer erfolgreichen Testzahlung live schalten.',
      etbis:
        'Registrieren Sie sich bei ETBİS des Handelsministeriums und tragen Sie den Verifizierungslink unter Unternehmensangaben ein.',
      legal_published: 'Veröffentlichen Sie die fehlenden Rechtstexte.',
      legal_reviewed:
        'Lassen Sie die Texte von einem Anwalt prüfen und veröffentlichen Sie sie erneut mit der Markierung „geprüft“.',
      legal_languages:
        'Einige Texte sind in den Sprachen Ihrer Märkte nicht veröffentlicht; Besucher in dieser Sprache sehen den türkischen Text. Fügen Sie sie im Sprachreiter der Rechtstexte hinzu (optional).',
    },
    sellerFields: {
      legalName: 'Firmenname',
      address: 'Adresse',
      phone: 'Telefon',
      email: 'E-Mail',
    },
  },
  reconcile: {
    title: 'Abgleich',
    lead: 'Der Transaktionsbericht des Anbieters wird mit Ihren Zahlungen abgeglichen. Bei einer Live-Verbindung wird der Vortag täglich automatisch geprüft.',
    done: 'Abgleich abgeschlossen',
    date: 'Tag',
    run: 'Abgleichen',
    empty: 'Noch kein Abgleich.',
    issues: '{{count}} Abweichungen',
    statuses: {
      running: 'Läuft',
      ok: 'Keine Abweichungen',
      mismatch: 'Abweichungen',
      error: 'Fehler',
    },
    view: 'Details',
    detailTitle: 'Abgleichsdetails',
    summary: '{{local}} Zahlungen hier, {{remote}} beim Anbieter; {{issues}} Abweichungen.',
    kinds: {
      missing_local: 'Beim Anbieter vorhanden, hier fehlend',
      missing_provider: 'Hier vorhanden, beim Anbieter fehlend',
      amount_mismatch: 'Betragsabweichung',
      status_mismatch: 'Statusabweichung',
    },
    amounts: 'Hier: {{ours}} · Anbieter: {{theirs}}',
    resolvedNote: 'Geschlossen',
    resolveNote: 'Anmerkung',
    resolve: 'Abweichung schließen',
  },
  shipping: {
    currency: 'Währung der Gebühr',
    currencyMismatch:
      'Die Shop-Währung ist {{currency}}; die Versandart wird nur bei Bestellungen in ihrer eigenen Währung angeboten und daher nicht angezeigt.',
    otherCurrency: '{{currency}} (im Shop nicht sichtbar)',
    countries: 'Zielländer',
    countriesHint:
      'Ist keines ausgewählt, wird die Versandart in allen Märkten angeboten; andernfalls nur in den Märkten dieser Länder.',
    countriesShort: 'Länder: {{list}}',
    add: 'Versandart hinzufügen',
    edit: 'Versandart bearbeiten',
    empty: 'Keine Versandarten',
    emptyLead: 'Fügen Sie mindestens eine Versandart für die Kasse hinzu.',
    carriers: {
      yurtici: 'Yurtiçi Kargo',
      aras: 'Aras Kargo',
      mng: 'MNG Kargo (DHL eCommerce)',
      ptt: 'PTT Kargo',
      surat: 'Sürat Kargo',
      hepsijet: 'HepsiJET',
      kolaygelsin: 'Kolay Gelsin',
      ups: 'UPS',
      other: 'Sonstige',
    },
    freeAlways: 'Kostenlos',
    byWeight: 'Nach Gewicht ({{count}} Staffeln)',
    freeOverShort: 'Kostenlos ab {{amount}}',
    codShort: 'Nachnahme',
    audiences: {
      all: 'Alle',
      retail: 'Endkunden',
      dealers: 'Händler',
    },
    daysShort: '{{days}} Werktage',
    statuses: {
      active: 'Aktiv',
      inactive: 'Inaktiv',
    },
    deleteConfirm: 'Diese Versandart löschen? Bestehende Bestellungen sind nicht betroffen.',
    trackingTitle: 'Sendungsverfolgung',
    trackingLead:
      'Geben Sie beim Versand die Sendungsnummer ein; der Kunde sieht sie in der E-Mail und auf der Bestellseite.',
    carrierApiNote:
      'Ist Geliver verbunden, holt „Mit Geliver versenden“ auf der Bestellseite Angebote, kauft das Etikett und übernimmt die Sendungsnummer automatisch. Direkte Anbindungen an Yurtiçi, Aras und MNG erfordern die Firmen-Integrationsdaten und eine IP-Freigabe der Dienstleister (Einrichtung erforderlich); bis dahin über Geliver versenden oder die Sendungsnummer manuell eingeben.',
    geliver: {
      title: 'Versand mit Geliver',
      lead: 'Mit Ihrem Geliver-Konto werden Sendungen aus Bestellungen angelegt, Preise der Versanddienstleister verglichen und das Etikett im Panel gekauft; Status und Sendungsnummer kommen automatisch von Geliver.',
      notConnected: 'Geliver ist nicht verbunden (Einrichtung erforderlich).',
      connect: 'In Integrationen verbinden',
      test: 'Testumgebung',
      live: 'Live',
      testNote: 'In der Testumgebung werden Sendungen in Geliver als Testsendungen angelegt.',
      liveNote: 'In der Live-Umgebung wird die Etikettgebühr von Ihrem Geliver-Guthaben abgebucht.',
      sender: 'Absenderadresse',
      senderHint: 'Wählen Sie eine der in Geliver angelegten Adressen.',
      senderNone: 'Nicht gewählt',
      sendersEmpty:
        'Das Geliver-Konto hat keine Absenderadresse. Legen Sie eine im Geliver-Panel an und laden Sie die Seite neu.',
      senderDefault: '{{name}} (Geliver-Standard)',
      length: 'Länge (cm)',
      width: 'Breite (cm)',
      height: 'Höhe (cm)',
      parcel: 'Standard-Paketmaße',
      defaultWeight: 'Standardgewicht (g)',
      defaultWeightHint: 'Für Positionen, deren Produkt kein Gewicht hat.',
    },
    name: 'Name',
    nameHint: 'Wird Kunden angezeigt (z. B. Standardversand).',
    carrier: 'Versanddienstleister',
    audience: 'Zielgruppe',
    rateType: 'Tarifart',
    rateTypes: {
      flat: 'Pauschalpreis',
      weight: 'Nach Gewicht',
    },
    price: 'Preis (₺, inkl. MwSt.)',
    priceHint: 'Geben Sie 0 für kostenlosen Versand ein.',
    tiers: 'Gewichtsstaffeln',
    tiersHint: 'Jede Zeile: der Preis für Warenkörbe bis zu diesem Gewicht (Gramm). Aufsteigend sortieren.',
    upToGrams: 'Bis (Gramm)',
    addTier: 'Staffel hinzufügen',
    freeOver: 'Kostenloser Versand ab (₺)',
    estimatedDays: 'Voraussichtliche Lieferzeit (Werktage)',
    estimatedDaysHint: 'z. B. 1-3',
    handlingDays: 'Bearbeitungszeit (Werktage)',
    transitDays: 'Laufzeit (Werktage)',
    daysMin: 'Min.',
    daysMax: 'Max.',
    status: 'Status',
    codAvailable: 'Nachnahme verfügbar',
    codAvailableHint: 'Wird mit dieser Versandart angeboten (wenn Nachnahme aktiviert ist).',
  },
  brokenLinks: {
    collect: 'Alte Adressen aus dem Archiv sammeln',
    collected:
      '{{found}} Adressen im Archiv gefunden: {{matched}} neue Zuordnungen, {{table}} bereits in der Liste, {{fallback}} ohne Gegenstück (auf eine sichere Seite geleitet).',
    collectFailed: 'Das Archiv war nicht erreichbar: {{hosts}}. Bitte später erneut versuchen.',
    storeHost: 'Shop-Domain',
    foundVia: 'Herkunft',
    emptyLead: 'Adressen mit 404 oder alte Adressen ohne Gegenstück erscheinen hier.',
    fallback: 'Kein Gegenstück gefunden; Besucher werden per 301 weitergeleitet zu: {{to}}',
    shown404: 'Der Shop zeigt „Seite nicht gefunden“ (404)',
    notVisited: 'Noch keine Besuche · hinzugefügt: {{date}}',
    via: {
      request: 'Besuch',
      archive: 'Archiv',
      search_console: 'Search Console',
    },
    kinds: {
      product: 'Produkt',
      category: 'Kategorie',
      shop: 'Shop',
      blog: 'Artikel',
      post: 'Artikel',
      page: 'Seite',
      asset: 'Datei',
      home: 'Startseite',
    },
  },
  redirects: {
    goneTarget: 'Dauerhaft entfernt (keine Weiterleitung)',
    gone: 'Dauerhaft entfernt (410)',
    goneLead:
      'Es erfolgt keine Weiterleitung; Besucher sehen die Seite „Seite entfernt“ und Suchmaschinen erhalten 410, wodurch die Adresse aus dem Index entfernt wird. Verwenden Sie besser 301, wenn eine ähnliche Seite existiert.',
    goneSaved: 'Adresse als dauerhaft entfernt markiert',
    goneConfirm:
      'Für „{{path}}“ 410 (dauerhaft entfernt) zurückgeben? Suchmaschinen entfernen diese Adresse.',
    notFoundTitle: 'Nicht gefundene Adressen',
    notFoundLead:
      'Storefront-Adressen, die 404 liefern, und alte Adressen, die mangels Gegenstück auf eine sichere Seite geleitet wurden, die häufigsten zuerst. Fügen Sie die richtige Weiterleitung hinzu, geben Sie 410 zurück oder ignorieren Sie sie. Es werden nur Domain und Pfad gespeichert (keine IP und kein Query-String).',
    notFoundFilter: 'Anzeigen',
    notFoundOpen: 'Offen',
    notFoundIgnored: 'Ignoriert',
    notFoundEmpty: 'Keine nicht gefundenen Adressen.',
    notFoundIgnoredEmpty: 'Keine ignorierten Adressen.',
    notFoundHits: '{{count}}-mal aufgerufen · zuletzt: {{date}}',
    notFoundRedirect: 'Weiterleiten',
    notFoundGone: '410 zurückgeben',
    notFoundIgnore: 'Ignorieren',
    notFoundReopen: 'Wiederherstellen',
    notFoundMore: 'Die {{shown}} am häufigsten aufgerufenen Adressen werden angezeigt (insgesamt {{total}}).',
    add: 'Weiterleitung hinzufügen',
    edit: 'Weiterleitung bearbeiten',
    import: 'Aus Datei importieren',
    search: 'Adressen durchsuchen',
    empty: 'Noch keine Weiterleitungen',
    emptyLead:
      'Leiten Sie die Adressen der alten Website auf die neuen weiter, damit Google-Rankings und gespeicherte Links erhalten bleiben. Ändert sich die Adresse eines Produkts oder einer Kategorie, wird automatisch eine Weiterleitung hinzugefügt.',
    noMatch: 'Keine Weiterleitung entspricht der Suche',
    from: 'Alte Adresse',
    to: 'Neue Adresse',
    code: 'Weiterleitungstyp',
    permanent: '301 — dauerhaft (empfohlen)',
    temporary: '302 — vorübergehend',
    note: 'Anmerkung',
    saved: 'Weiterleitung gespeichert',
    dialogLead:
      'Die alte Adresse muss ein Pfad sein, der mit „/“ beginnt (eine vollständige URL wird auf ihren Pfad gekürzt). Die neue Adresse kann ein Pfad auf dieser Website oder eine vollständige https://-Adresse sein.',
    deleteConfirm:
      'Weiterleitung für {{path}} löschen? Besucher dieser Adresse sehen dann „Seite nicht gefunden“.',
    hits: '{{count}}-mal verwendet · zuletzt {{date}}',
    noHits: 'Noch nicht verwendet',
    range: '{{from}}–{{to}} von {{total}}',
    sources: {
      manual: 'Manuell',
      import: 'Import',
      auto: 'Automatisch',
      match: 'Zuordnung',
    },
    importTitle: 'Weiterleitungsliste importieren',
    importLead:
      'CSV- oder Excel-Datei: Spalten für alte Adresse, neue Adresse, optional Code (301/302) und Anmerkung. Zuerst wird eine Vorschau angezeigt; enthält eine Zeile einen Fehler, wird nichts gespeichert. Vorhandene alte Adressen werden aktualisiert. Eine optionale Spalte „Domain“ beschränkt eine Regel auf eine alte Domain.',
    chooseFile: 'Datei wählen und Vorschau anzeigen',
    apply: 'Importieren',
    previewSummary:
      '{{total}} Zeilen: {{create}} neu, {{update}} zu aktualisieren, {{unchanged}} unverändert, {{errors}} fehlerhaft.',
    errorLine: 'Zeile {{line}}',
    imported: '{{created}} Weiterleitungen hinzugefügt, {{updated}} aktualisiert',
    howTitle: 'So funktioniert es',
    howLead:
      'Die Storefront prüft diese Liste bei jedem Seitenaufruf (Änderungen greifen innerhalb einer Minute).',
    how1: 'Beim Abgleich werden Groß-/Kleinschreibung und ein abschließender „/“ ignoriert; „/uyeol/“ und „/uyeol“ sind identisch. Query-Strings (?...) werden ignoriert.',
    how2: 'Ketten werden zusammengefasst (A→B und B→C leiten A direkt zu C); ein Eintrag, der eine Schleife erzeugt, wird nicht angewendet.',
    how3: 'Die Nutzungszahl zeigt, ob eine alte Adresse noch Zugriffe erhält; monatelang ungenutzte Einträge können gelöscht werden.',
    allHosts: 'Alle Domains',
    host: 'Quelldomain',
    filterSource: 'Quelle',
    filterHost: 'Domain',
    anySource: 'Alle',
    anyHost: 'Alle',
    matchScore: 'Ähnlichkeit {{score}} %',
    shadowTitle: '{{count}} Regeln verdecken eigene Shopseiten',
    shadowLead:
      'Diese Adressen sind echte Shopseiten (z. B. Verkaufsstellen, Artikel, Bedarfsfinder, ein aktives Produkt oder eine Kategorie). Wegen der Regel werden Besucher umgeleitet, statt die Seite zu sehen. Löschen Sie die Regel, damit die Seite erscheint.',
    shadowDelete: 'Regel löschen',
    how4: 'Jede Anfrage an eine alte Domain (z. B. zootopiaglobal.com) – http oder https, mit oder ohne www – gelangt anhand dieser Liste in einem 301-Schritt zur endgültigen Adresse.',
    how5: 'Für eine alte Adresse, die nicht in der Liste steht, sucht das System das Gegenstück: Eine sichere Zuordnung wird als „Zuordnung“ hinzugefügt; andernfalls wird der Besucher zur Tierart-Kategorie, zu allen Produkten oder zur Startseite geleitet und die Adresse wird hier aufgeführt:',
    matchKinds: {
      product: 'Produkt',
      category: 'Kategorie',
      category_species: 'Tierart-Kategorie',
      shop: 'alle Produkte',
      blog: 'Artikel',
      post: 'Artikel',
      page: 'Seite',
    },
  },
  legal: {
    lawyerNote:
      'Diese Texte werden von Ihnen oder Ihrem Anwalt verfasst; das System erzeugt keine rechtlichen Inhalte. Lassen Sie sie vor der Veröffentlichung prüfen.',
    kinds: {
      kvkk_notice: 'Datenschutzhinweis (KVKK)',
      membership_terms: 'Mitgliedschaftsbedingungen',
      pre_information: 'Formular zur Vorabinformation',
      distance_sales: 'Fernabsatzvertrag',
      return_policy: 'Rückgabe und Widerruf',
      privacy_policy: 'Datenschutzerklärung',
      cookie_policy: 'Cookie-Richtlinie',
    },
    required: '(Pflicht für den Livegang)',
    publishedVersion: 'Version {{version}} · veröffentlicht am {{date}}',
    notPublished: 'Nicht veröffentlicht',
    templated: 'Wird bei der Bestellung ausgefüllt',
    reviewed: 'Rechtlich geprüft',
    notReviewed: 'Prüfung nicht bestätigt',
    hasDraft: 'Entwurf',
    write: 'Verfassen',
    draftSaved: 'Entwurf gespeichert',
    published: 'Neue Version veröffentlicht',
    templatedLead:
      'Dieser Text wird bei der Bestellung mit Angaben zu Verkäufer, Käufer, Produkten und Gesamtbetrag ausgefüllt. Pflichtvariablen: Name des Verkäufers, Name des Käufers, Produkte, Gesamtbetrag.',
    plainLead:
      'Dieser Text wird auf einer eigenen Storefront-Seite veröffentlicht; Verkäufervariablen werden ausgefüllt.',
    discardConfirm: 'Entwurf löschen? Die veröffentlichte Version ist nicht betroffen.',
    discard: 'Entwurf löschen',
    saveDraft: 'Entwurf speichern',
    publish: 'Veröffentlichen',
    title: 'Titel',
    variables: 'Variablen',
    insertVariable: 'An Cursorposition einfügen',
    body: 'Text',
    bodyHint: 'Reiner Text; trennen Sie Absätze durch eine Leerzeile.',
    reviewedAck: 'Dieser Text wurde von meinem Anwalt/Rechtsberater geprüft.',
    saveBeforePublish: 'Speichern Sie den Entwurf vor der Veröffentlichung.',
    history: 'Versionsverlauf',
    versionLabel: 'Version {{version}}',
    statuses: {
      published: 'Veröffentlicht',
      retired: 'Archiviert',
      draft: 'Entwurf',
    },
    view: 'Ansehen',
    languages: 'Sprachfassungen',
    languageGaps:
      'Einige Pflichttexte sind in den Sprachen Ihrer offenen Märkte nicht veröffentlicht (Besucher in dieser Sprache sehen den türkischen Text; der Livegang wird nicht blockiert):',
    langPublished: 'veröffentlicht, Version {{version}}',
    language: 'Sprache',
    primaryLanguage: 'Hauptfassung',
    marketLanguage: 'Marktsprache',
    copyTurkish: 'Mit dem türkischen Text beginnen',
    translationNote:
      'Die Fassung {{language}} ist eine Übersetzung des türkischen Textes. Lassen Sie auch die Übersetzung anwaltlich prüfen; die Prüfungserklärung wird für diese Sprache gesondert abgegeben. Solange in dieser Sprache keine Fassung veröffentlicht ist, sehen Besucher den türkischen Text.',
    switchLanguageConfirm: 'Nicht gespeicherte Änderungen gehen verloren. Sprache wechseln?',
  },
  invoices: {
    providerCancelStates: {
      required: 'In BizimHesap zu stornieren',
      failed: 'Stornierung in BizimHesap fehlgeschlagen',
      uncertain: 'Stornierung in BizimHesap ungewiss',
      return_required: 'E-Beleg ausgestellt: Retourenrechnung erforderlich',
      done: 'In BizimHesap storniert',
    },
    providerCancelResult: {
      done: 'Rechnung in BizimHesap storniert.',
      failed: 'BizimHesap hat die Stornierung abgelehnt; der Fehler ist an der Rechnung vermerkt.',
      uncertain:
        'BizimHesap hat nicht geantwortet: Die Stornierung ist möglicherweise erfolgt. Prüfen Sie dies in der BizimHesap-Verwaltung und markieren Sie das Ergebnis.',
    },
    cancelAtProvider: 'In BizimHesap stornieren',
    resolveProviderCancel: 'Stornierung markieren',
    returnDone: 'Retourenrechnung ausgestellt',
    returnLead:
      'Die Rechnung hat eine offizielle E-Beleg-Nummer: Sie wird in BizimHesap nicht storniert, stattdessen wird eine Retourenrechnung ausgestellt (Bestätigung durch den Steuerberater ausstehend). Markieren Sie dies hier, nachdem Sie die Retourenrechnung ausgestellt haben.',
    providerResolveLead: 'Prüfen Sie in der BizimHesap-Verwaltung, ob die Rechnung storniert wurde.',
    providerOutcomes: {
      done: 'Storniert',
      not_done: 'Nicht storniert (erneuter Versuch möglich)',
    },
    sendResult: {
      sent: 'Rechnung an BizimHesap gesendet',
      failed: 'Rechnung konnte nicht gesendet werden',
      uncertain: 'Verbindung unterbrochen: Rechnungsstatus ungewiss',
      draft: 'Gespeichert',
      sending: 'Wird gesendet',
      cancelled: 'Storniert',
    },
    bhTarget: 'BizimHesap-Kundenkonto {{code}} · Kasse {{cash}}',
    bhNoCash: 'keine (Forderung)',
    resend: 'Erneut senden',
    send: 'Senden',
    resolve: 'Geprüft',
    markCancelled: 'Als storniert markieren',
    resolveTitle: 'Ungewisse Rechnung erfassen',
    cancelTitle: 'Rechnung als storniert markieren',
    resolveLead: 'Prüfen Sie in BizimHesap, ob die Rechnung für diese Bestellung erstellt wurde.',
    cancelLead:
      'Damit wird nur der Eintrag hier storniert. Stornieren Sie die Rechnung bzw. das e-Arşiv-Dokument in BizimHesap.',
    outcome: 'Ergebnis',
    outcomes: {
      sent: 'Rechnung wurde erstellt',
      not_sent: 'Rechnung wurde nicht erstellt',
    },
    number: 'Rechnungsnummer',
    note: 'Anmerkung',
    status: 'Status',
    statuses: {
      draft: 'Entwurf',
      sending: 'Wird gesendet',
      sent: 'Gesendet',
      failed: 'Fehlgeschlagen',
      uncertain: 'Ungewiss',
      cancelled: 'Storniert',
    },
    empty: 'Noch keine Rechnungen',
    emptyLead: 'Rechnungen werden in den Bestelldetails erstellt.',
    providers: {
      bizimhesap: 'BizimHesap',
      manual: 'Manuell (anderweitig ausgestellt)',
    },
    kinds: {
      e_arsiv: 'e-Arşiv',
      e_fatura: 'e-Fatura',
      unknown: 'Nicht angegeben',
    },
    open: 'Rechnung öffnen',
    bizimhesapNote:
      'Die BizimHesap-API erstellt die Rechnung als Datensatz; die Umwandlung in e-Arşiv/e-Fatura erfolgt in BizimHesap.',
    bizimhesapLead:
      'Positionen und Summen entsprechen exakt der Bestellung; das Senden ist ein separater Schritt. Verbinden Sie BizimHesap im Bereich Integrationen.',
    manualLead:
      'Wenn Sie die Rechnung in einem anderen Programm ausgestellt haben, erfassen Sie ihre Nummer.',
    provider: 'Quelle',
    kind: 'Typ',
  },
  pageDesigns: {
    published: '{{experience}}: Design {{variant}} ist live.',
    option: '{{letter}} — {{name}}',
    live: 'Live',
    preview: 'Vorschau',
    previewOf: 'Vorschau von {{name}}',
    publish: 'Veröffentlichen',
    publishOf: '{{name}} veröffentlichen',
    shotDesktop: '{{name}}: Desktop-Ansicht',
    shotMobile: '{{name}}: Mobilansicht',
    history: 'Änderungsverlauf',
    historyLead: 'Wer wann von welcher Option zu welcher gewechselt hat (aus dem Prüfprotokoll).',
    noHistory: 'Noch keine Änderungen; alle Bereiche nutzen Option A.',
    colWhen: 'Datum',
    colWho: 'Person',
    colWhat: 'Bereich',
    colChange: 'Änderung',
    change: '{{from}} → {{to}}',
    experiences: {
      header: {
        title: 'Hauptmenü',
        lead: 'Der Kopfbereich jeder Shopseite: Logo, Menüpunkte (Menüs), Suche, Anmelden und Warenkorb; mobil ein Seitenmenü.',
      },
      articles: {
        title: 'Artikel',
        lead: 'Blogliste, Kategorie- und Archivseiten: empfohlener Beitrag, Kategorien, Lesezeit und Suche. Die Artikelseite ist in jeder Option gleich.',
      },
      store_locator: {
        title: 'Verkaufsstellen',
        lead: 'Die Storefront-Seite mit freigegebenen Händlern: Filter nach Provinz, Bezirk und Viertel, „Meinen Standort verwenden“, Karte und Provinz-/Bezirksseiten.',
      },
      needs_finder: {
        title: 'Was mein Tier braucht',
        lead: 'Fragenablauf und vorgeschlagene Pflegeroutine für das Tier des Besuchers (/ihtiyac-bulucu). Fragen, Regeln und Ergebnis sind in allen drei Varianten gleich.',
      },
    },
    variants: {
      header: {
        a: {
          name: 'Klassisch horizontal',
          character:
            'Logo, Suche und Warenkorb oben, Menüpunkte waagerecht; vertraut, am schnellsten zu überblicken.',
        },
        b: {
          name: 'Zentriertes Logo',
          character: 'Großer Markenname in der Mitte, Menü darunter zentriert; ruhiger Boutique-Eindruck.',
        },
        c: {
          name: 'Kompakt und bildhaft',
          character:
            'Schmale einzelne Zeile; Produkte öffnet illustrierte Tierart-Kacheln, mehr Platz für Inhalte.',
        },
      },
      articles: {
        a: {
          name: 'Magazin',
          character: 'Großer empfohlener Beitrag und Kategoriestreifen; Inhalte wie im Schaufenster.',
        },
        b: {
          name: 'Kartenraster',
          character: 'Gleich große Karten und Filterchips; schnelle Auswahl unter vielen Beiträgen.',
        },
        c: {
          name: 'Leseliste',
          character: 'Typografische, schlichte Liste mit kleinen Bildern; aufs Lesen konzentriert.',
        },
      },
      store_locator: {
        a: {
          name: 'Karte zuerst',
          character:
            'Filter und Liste auf einer Seite, Provinzkarte auf der anderen; beides gemeinsam durchsuchen.',
        },
        b: {
          name: 'Liste zuerst',
          character: 'Eine Filterzeile über einem Kartenraster; die Karte ist optional.',
        },
        c: {
          name: 'Regionsführer',
          character:
            'Provinz- und Bezirksverzeichnis mit einer Seite je Region; passend für Besucher aus Suchmaschinen.',
        },
      },
      needs_finder: {
        a: {
          name: 'Karten',
          character:
            'Jeder Schritt auf eigenem Bildschirm mit großen Karten; oben Fortschritt, unten Zurück / Weiter. Am bequemsten auf dem Telefon.',
        },
        b: {
          name: 'Chat',
          character:
            'Fragen erscheinen nacheinander in Sprechblasen, Antworten per Chip; jede Antwort lässt sich ändern. Die Fragen sind fest, keine KI.',
        },
        c: {
          name: 'Eine Seite + Live-Übersicht',
          character:
            'Alle Fragen auf einer Seite; daneben aktualisiert sich die Routine beim Antworten. Gut zum Vergleichen auf breiten Bildschirmen.',
        },
      },
    },
  },
  needsFinder: {
    editor: 'Editor des Bedarfsfinders',
    startTitle: '„Was mein Tier braucht“ ist noch nicht eingerichtet',
    startLead:
      'Besucher wählen Tierart, Grunddaten und Bereiche; feste Regeln schlagen eine Pflegeroutine aus passenden Produkten vor. Den ersten Entwurf können Sie aus Ihren Produktdaten erstellen oder leer beginnen. Ohne tierärztliche Freigabe geht der Entwurf nicht online.',
    generate: 'Ersten Entwurf aus Produktdaten erstellen',
    startEmpty: 'Mit leerem Entwurf beginnen',
    generated: 'Entwurf aus Produktdaten erstellt. Prüfen Sie Texte und Regeln.',
    noDraft: 'Noch kein Entwurf. Jemand mit Berechtigung zur Inhaltsbearbeitung kann ihn erstellen.',
    save: 'Entwurf speichern',
    saved: 'Entwurf gespeichert.',
    unsaved: 'Es gibt ungespeicherte Änderungen.',
    discard: 'Änderungen verwerfen',
    saveErrors: 'Der Entwurf konnte nicht gespeichert werden; beheben Sie Folgendes:',
    saveFirst: 'Speichern Sie zuerst den Entwurf.',
    statusTitle: 'Status und Veröffentlichung',
    statusLead:
      'Entwurf → zur Prüfung einreichen → tierärztliche Freigabe → veröffentlichen. Ändert sich der Entwurf nach der Freigabe, verfällt sie; der Shop zeigt weiter die freigegebene Version.',
    review: {
      not_submitted: 'Nicht eingereicht',
      pending: 'In fachlicher Prüfung',
      approved: 'Fachlich freigegeben',
      rejected: 'Fachlich abgelehnt',
    },
    live: 'Im Shop veröffentlicht',
    notLive: 'Nicht im Shop veröffentlicht',
    liveDiffers: 'Entwurf weicht von der veröffentlichten Version ab',
    publishedAt: 'Zuletzt veröffentlicht: {{date}}',
    generatedNote:
      'Dieser Entwurf wurde aus Produktdaten erzeugt: Bereiche aus Kategorien, Regeln aus Produkten. Prüfen Sie Begründungen, Notfallfrage und Ausschlüsse mit der Fachperson.',
    reviewNote: 'Notiz der Fachperson: {{note}}',
    problemsTitle: 'Prüfliste',
    problems: {
      no_areas: 'Keine Bereiche (verhindert die Veröffentlichung).',
      no_rules: 'Keine Empfehlungsregeln (verhindert die Veröffentlichung).',
      no_emergency_option: 'Keine Frage hat eine Notfalloption (verhindert die Veröffentlichung).',
      area_without_rules: 'Bereich „{{ref}}“ hat keine Regeln; wer ihn wählt, erhält keine Produkte.',
      product_hidden:
        '{{product}} ist im Shop nicht sichtbar (Entwurf, ausgeblendet, nicht gelistet oder ohne tierärztliche Freigabe); wird nicht vorgeschlagen.',
      product_species_mismatch: '{{product}} passt nicht zu den Tierarten der Regel; wird nie vorgeschlagen.',
      product_no_species: 'Für {{product}} ist keine Tierart angegeben; wird nie vorgeschlagen.',
      bundle_promotion_not_running: 'Die verknüpfte Paketaktion läuft nicht; sie wird im Shop nicht gezeigt.',
    },
    submit: 'Zur Prüfung einreichen',
    submitted: 'Entwurf zur fachlichen Prüfung eingereicht.',
    publish: 'Veröffentlichen',
    publishedToast: '„Was mein Tier braucht“ ist im Shop online.',
    unpublish: 'Veröffentlichung zurückziehen',
    unpublishedToast: 'Aus dem Shop entfernt.',
    unpublishTitle: 'Veröffentlichung zurückziehen?',
    unpublishLead:
      'Die Shopseite wird geschlossen und der Standardlink im Kopfmenü entfernt. Entwurf und Freigabe bleiben erhalten; Sie können erneut veröffentlichen.',
    regenerate: 'Entwurf neu erzeugen',
    regenerateTitle: 'Entwurf neu erzeugen?',
    regenerateLead:
      'Ein neuer Entwurf aus Produktdaten ersetzt den aktuellen; Ihre Änderungen und die Freigabe gehen verloren. Die veröffentlichte Version bleibt unverändert.',
    petProfiles: 'Mein Tier speichern (Mitglieder)',
    petProfilesLead:
      'Wenn aktiv, können Mitglieder die Grunddaten ihres Tieres mit ausdrücklicher Einwilligung im Konto speichern. Erst nach rechtlicher Prüfung des Einwilligungstextes einschalten. Antworten auf Gesundheitsfragen werden nicht gespeichert.',
    reviewTitle: 'Tierärztliche Prüfung',
    reviewLead:
      'Die Fachperson prüft Fragen, Begründungen und die vollständige Liste der Produkte, die vorgeschlagen werden können. Die Entscheidung gilt für den angezeigten Inhalt.',
    findings: 'Die Prüfung auf Gesundheitsversprechen fand {{count}} Ausdrücke',
    productsTitle: 'Mögliche Produktvorschläge',
    colProduct: 'Produkt',
    colSpecies: 'Tierart',
    colReasons: 'Begründung',
    colState: 'Status',
    visible: 'Im Shop sichtbar',
    hidden: 'Im Shop nicht sichtbar',
    noUsage: 'Kein Anwendungstext',
    reviewNoteLabel: 'Notiz der Fachperson',
    approve: 'Freigeben',
    reject: 'Ablehnen',
    decided: 'Entscheidung gespeichert.',
    waitingExpert: 'Die Entscheidung der tierärztlichen Prüfung steht aus.',
    otherLanguages: 'Weitere Sprachen',
    lang: {
      en: 'Englisch',
      de: 'Deutsch',
      ar: 'Arabisch',
    },
    condition: 'Bedingung',
    conditionLead:
      'Jeder ausgefüllte Abschnitt muss zutreffen; innerhalb eines Abschnitts genügt einer der markierten Werte. Ohne Auswahl gilt sie immer.',
    cond: {
      species: 'Tierart',
      ages: 'Alter',
      weights: 'Gewicht',
      neutered: 'Kastriert',
      any: 'Egal',
      reproductive: 'Trächtig / säugend',
      areas: 'Bereich',
      answer: 'Antwort auf eine Frage',
      noAnswer: 'Keine Antwort prüfen',
      answerOptions: 'Eine dieser Antworten',
    },
    always: 'Immer',
    moveUp: '{{name}}: nach oben',
    moveDown: '{{name}}: nach unten',
    edit: '{{name}}: bearbeiten',
    delete: '{{name}}: löschen',
    deleteTitle: 'Löschen?',
    deleteLead:
      'Das Element wird aus dem Entwurf entfernt; bis zum Speichern können Sie es mit „Änderungen verwerfen“ rückgängig machen.',
    apply: 'Übernehmen',
    tabs: {
      areas: 'Bereiche',
      questions: 'Fragen',
      rules: 'Empfehlungsregeln',
      exclusions: 'Ausschlüsse',
      texts: 'Texte',
      preview: 'Vorschau',
      report: 'Bericht',
    },
    areasLead:
      'Themen, die Besucher wählen (z. B. Gelenke, Haut und Fell). Nur für die markierten Tierarten sichtbar.',
    rulesCount: '{{count}} Regeln',
    addArea: 'Bereich hinzufügen',
    noAreas: 'Noch keine Bereiche.',
    areaDialog: 'Bereich',
    areaLabel: 'Name des Bereichs',
    areaDescription: 'Kurzbeschreibung',
    areaSpecies: 'Sichtbar für Tierarten',
    areaCategories: 'Zugehörige Kategorien',
    id: 'ID',
    idLead: 'Kurzname für Regeln (Kleinbuchstaben, Ziffern, Bindestriche). Nach dem Speichern nicht ändern.',
    questionsLead:
      'Fragen werden in dieser Reihenfolge gestellt. Eine bereichsbezogene Frage nur, wenn der Bereich gewählt ist; eine bedingte Frage nur, wenn die Bedingung zutrifft (Verzweigung).',
    general: 'Allgemein (alle Besucher)',
    optionsCount: '{{count}} Optionen',
    hasEmergency: 'Hat eine Notfalloption',
    askedWhen: 'Gefragt, wenn: {{condition}}',
    defaultYes: 'Ja',
    defaultNo: 'Nein',
    addQuestion: 'Frage hinzufügen',
    noQuestions: 'Noch keine Fragen. Mindestens eine Frage braucht eine Notfalloption.',
    questionDialog: 'Frage',
    questionText: 'Fragetext',
    questionHelp: 'Hilfetext',
    questionArea: 'Zugehöriger Bereich',
    questionMultiple: 'Mehrfachauswahl möglich',
    askWhen: 'Wann soll gefragt werden? (Verzweigung)',
    options: 'Optionen',
    optionLabel: 'Option {{n}}',
    optionEmergency: 'Notfall (keine Produkte, an Tierarzt verweisen)',
    optionExclusive: 'Nur allein wählbar („Nichts davon“)',
    addOption: 'Option hinzufügen',
    rulesLead:
      'Trifft die Bedingung zu, wird das Produkt mit freigegebener Begründung vorgeschlagen. Ein Produkt, das nicht zur gewählten Tierart passt, wird nie vorgeschlagen. Ist es nicht vorrätig, folgt die nächste Alternative.',
    unsavedProduct: 'Produkt (Name nach dem Speichern)',
    priorityValue: 'Priorität {{n}}',
    alternativesCount: '{{count}} Alternativen',
    addRule: 'Regel hinzufügen',
    noRules: 'Noch keine Regeln.',
    ruleDialog: 'Empfehlungsregel',
    ruleProduct: 'Vorgeschlagenes Produkt',
    ruleReason: 'Warum vorgeschlagen (im Shop sichtbar)',
    rulePriority: 'Priorität (0–100)',
    rulePriorityLead: 'Vorschläge mit höherer Priorität stehen weiter oben.',
    ruleAlternatives: 'Alternativen bei fehlendem Bestand (der Reihe nach, höchstens 5)',
    exclusionsLead:
      'Trifft die Bedingung zu, werden die aufgeführten Produkte von keiner Regel vorgeschlagen (z. B. in der Trächtigkeit ungeeignete). Ausschlüsse haben immer Vorrang.',
    addExclusion: 'Ausschluss hinzufügen',
    noExclusions: 'Noch keine Ausschlüsse.',
    exclusionDialog: 'Ausschluss',
    exclusionProducts: 'Nicht vorzuschlagende Produkte',
    exclusionNote: 'Notiz (im Panel)',
    textsLead: 'Einleitung, Notfalltext und optionale Paketaktion.',
    intro: 'Einleitungstext',
    emergencyText: 'Notfalltext',
    bundle: 'Bedarfspaket-Aktion',
    bundleLead:
      'Optional; standardmäßig aus. Läuft die verknüpfte automatische Aktion, werden Name und Bedingung im Ergebnis gezeigt; den Rabatt berechnet der Warenkorb.',
    bundleOff: 'Keine Aktion',
    bundleLinked: 'Eine Aktion ist verknüpft',
    previewLead:
      'Gleiche Berechnung wie die Regel-Engine im Shop. Wählen Sie Antworten eines Besuchers und sehen Sie, welche Produkte mit welcher Begründung erscheinen und welche warum entfernt werden.',
    previewResult: 'Ergebnis',
    removedTitle: 'Entfernte Produkte',
    removed: {
      excluded: 'Ausschlussregel',
      species: 'passt nicht zur Tierart',
      unavailable: 'im Shop nicht sichtbar',
    },
    previewNote:
      'Die Vorschau nutzt gespeicherte Produktdaten und ignoriert den Bestand; neue Produkte erscheinen nach dem Speichern.',
    emergencyShort: 'Notfall',
    reportLead:
      'Nur Summen: wie viele Besucher begonnen, abgeschlossen, einen Notfall gewählt und alles in den Warenkorb gelegt haben. Keine Besucheridentität oder Antworten gespeichert.',
    reportDays: 'Zeitraum',
    lastDays: 'Letzte {{n}} Tage',
    reportEmpty: 'Keine Einträge in diesem Zeitraum.',
    metrics: {
      starts: 'Begonnen',
      completes: 'Abgeschlossen',
      emergencies: 'Notfall',
      addAll: 'Alles in den Warenkorb',
      rate: 'Abschlussquote',
    },
    bySpecies: 'Nach Tierart',
    reportPrivacy:
      'Die Zähler enthalten keine personenbezogenen Daten; Mess-Tags (GA4/GTM) erhalten Ereignisse nur mit Cookie-Einwilligung.',
  },
  salesPoints: {
    sectionTitle: 'Verkaufsstelle',
    sectionLead:
      'Geschäftsangaben auf der Storefront-Seite „Verkaufsstellen“. Name und Mobilnummer des Ansprechpartners werden nie automatisch angezeigt.',
    add: 'Verkaufsstelle hinzufügen',
    edit: 'Verkaufsstelle bearbeiten',
    saved: 'Verkaufsstelle gespeichert.',
    deleted: 'Verkaufsstelle gelöscht.',
    confirmDelete: 'Verkaufsstelle „{{name}}“ löschen? Der Händlerdatensatz bleibt unverändert.',
    empty: 'Dieser Händler hat keine Verkaufsstelle',
    emptyLead:
      'Nach dem Hinzufügen erscheint sie auf der Seite „Verkaufsstellen“ (wenn der Händler freigegeben ist).',
    fromLocation: 'Aus Standort hinzufügen:',
    addFromLocation: '{{label}}',
    personNameNote:
      'Die Firmierung dieses Händlers könnte ein Personenname sein. Tragen Sie den Geschäfts- oder Ladennamen als Anzeigenamen ein oder blenden Sie die Verkaufsstelle aus (Datenschutz).',
    notApprovedNote:
      'Der Händler ist nicht freigegeben; seine Verkaufsstellen werden nicht angezeigt und erscheinen nach der Freigabe automatisch.',
    shown: 'Sichtbar',
    hidden: 'Ausgeblendet',
    visible: 'In der Storefront anzeigen',
    name: 'Anzeigename',
    nameLead: 'Laden- oder Geschäftsname. Keinen Personennamen eintragen.',
    neighbourhood: 'Viertel',
    chooseNeighbourhood: 'Viertel wählen',
    addressLine: 'Straße und Hausnummer',
    pin: 'Standort (Kartenpin)',
    pinLead:
      'Ort in Google Maps suchen, per Rechtsklick die Koordinaten kopieren und hier einfügen (ein Link geht auch). Ohne Pin wird nicht nach Entfernung sortiert.',
    pinRead: 'Gelesener Standort: {{lat}}, {{lng}}',
    pinInvalid:
      'Standort nicht lesbar. Koordinaten wie „41.0082, 28.9784“ oder einen Google-Maps-Link einfügen.',
    findOnMaps: 'Adresse in Google Maps öffnen',
    phone: 'Storefront-Telefon',
    phoneLead:
      'Die Geschäftsnummer für Besucher. Die Mobilnummer des Ansprechpartners nur mit dessen Einwilligung eintragen.',
    hours: 'Öffnungszeiten',
    days: {
      mon: 'Montag',
      tue: 'Dienstag',
      wed: 'Mittwoch',
      thu: 'Donnerstag',
      fri: 'Freitag',
      sat: 'Samstag',
      sun: 'Sonntag',
    },
    dayMode: '{{day}}: Status',
    dayUnknown: 'Nicht angegeben',
    dayOpen: 'Geöffnet',
    dayClosed: 'Geschlossen',
    opens: '{{day}}: öffnet',
    closes: '{{day}}: schließt',
    note: 'Hinweis (in der Storefront sichtbar)',
    warnings: {
      no_pin: 'Kein Pin',
      no_phone: 'Kein Telefon',
      person_name: 'Evtl. Personenname',
      company_not_approved: 'Händler nicht freigegeben',
      address_missing: 'Adresse fehlt',
      geocode_not_found: 'Adresse nicht auf der Karte gefunden',
      geocode_mismatch: 'Adresse zeigt woandershin',
      geocode_approximate: 'Ungefährer Standort',
    },
    settings: 'Automatisch aufnehmen',
    autoAdd: 'Neu freigegebene Händler als Verkaufsstelle aufnehmen',
    autoAddLead:
      'Bei der Freigabe werden aus den Standorten Verkaufsstellen erstellt (ohne Name und Telefon des Ansprechpartners). Händler, deren Firmierung ein Personenname sein könnte, werden ebenfalls sichtbar aufgenommen und mit einem Hinweis markiert; prüfen Sie den Anzeigenamen. Verkaufsstellen gesperrter Händler werden automatisch ausgeblendet.',
    autoAddOn: 'Neu freigegebene Händler werden als Verkaufsstelle aufgenommen.',
    autoAddOff: 'Neu freigegebene Händler werden nicht als Verkaufsstelle aufgenommen.',
    geocode: 'Standort aus Adresse ermitteln (OpenStreetMap)',
    geocodeLead:
      'Verkaufsstellen ohne manuelle Markierung werden anhand ihrer Adresse verortet; im Shop sortiert „Meinen Standort verwenden“ die nächstgelegenen danach. Zeigt die Adresse woandershin oder wird sie nicht gefunden, erscheint ein Hinweis in der Händlerkarte. Übermittelt wird nur die Geschäftsadresse.',
    geocodeOn: 'Standorte werden aus Adressen ermittelt.',
    geocodeOff: 'Standorte werden nicht aus Adressen ermittelt; nur manuelle Markierungen werden verwendet.',
    backfill: 'Aus freigegebenen Händlern erstellen',
    backfillDone:
      '{{created}} Verkaufsstellen hinzugefügt ({{companies}} Händler). Händler mit unbekannter Adresse: {{skipped}}.',
    backfillSkipped:
      'Für diese Händler konnte keine Verkaufsstelle angelegt werden, weil Provinz/Bezirk nicht erkannt wurde:',
    geocodeNow: 'Standorte jetzt ermitteln',
    geocodeNowRunning: 'Adressen werden gesucht…',
    geocodeNowDone: '{{checked}} Adressen gesucht: {{found}} gefunden, {{problems}} mit Problemen.',
    geocodeNowNone: 'Keine Verkaufsstelle wartet auf einen Standort.',
    geocodeOne: 'Standort aus Adresse ermitteln',
    geocodeResult: {
      ok: 'Standort gefunden und Markierung gespeichert.',
      approximate: 'Ungefährer Standort gefunden (Viertelebene); Markierung gespeichert.',
      not_found:
        'Adresse nicht auf der Karte gefunden; prüfen Sie die Adresse oder setzen Sie die Markierung manuell.',
      mismatch: 'Die Adresse zeigt woandershin ({{place}}); keine Markierung gespeichert.',
      error: 'Der Standortdienst war nicht erreichbar; es wird bald erneut versucht.',
    },
    pinSource: {
      manual: 'Standort: manuell gesetzt',
      geocoded: 'Standort: aus Adresse ermittelt (OpenStreetMap)',
      none: 'Standort: keiner',
    },
    mismatchFound: 'gefunden: {{place}}',
    missing: {
      no_address:
        'Dieser Händler hat keine Adresse; es konnte keine Verkaufsstelle angelegt werden. Fügen Sie einen Standort oder eine Firmenadresse hinzu.',
      address_unknown:
        'Provinz/Bezirk dieses Händlers steht nicht in der amtlichen Liste; es konnte keine Verkaufsstelle angelegt werden. Korrigieren Sie die Adresse oder legen Sie die Verkaufsstelle manuell an.',
    },
    listTitle: 'Verkaufsstellen',
    listLead:
      'Angaben werden auf der Händlerseite bearbeitet. In der Storefront erscheinen nur als „Sichtbar“ markierte Verkaufsstellen freigegebener Händler.',
    allCities: 'Alle Provinzen',
    visibility: 'Storefront-Status',
    bulkShow: 'Auswahl anzeigen ({{count}})',
    bulkHide: 'Auswahl ausblenden ({{count}})',
    bulkDone: '{{count}} Verkaufsstellen aktualisiert.',
    selectAll: 'Alle auswählen',
    selectOne: 'Verkaufsstelle {{name}} auswählen',
    none: 'Keine Verkaufsstellen',
    noneLead:
      'Auf der Händlerseite hinzufügen; mit automatischer Aufnahme werden neu freigegebene Händler automatisch aufgenommen.',
    colName: 'Anzeigename',
    colPlace: 'Bezirk/Provinz',
    colDealer: 'Händler',
    colStatus: 'Status',
  },
  design: {
    saved: 'Theme-Entwurf gespeichert.',
    published: 'Theme veröffentlicht. Es erscheint innerhalb einer Minute in der Storefront.',
    discarded: 'Nicht veröffentlichte Änderungen verworfen.',
    rolledBack: 'Die ausgewählte Version wurde erneut veröffentlicht.',
    preview: 'Vorschau in der Storefront',
    previewBlocked: 'Der Browser hat den neuen Tab blockiert. Kopieren und öffnen Sie den Link:',
    save: 'Entwurf speichern',
    publish: 'Veröffentlichen',
    unsaved: 'Sie haben nicht gespeicherte Änderungen.',
    revertLocal: 'Meine Änderungen verwerfen',
    discard: 'Zum veröffentlichten Theme zurückkehren',
    discardConfirm:
      'Nicht veröffentlichte Änderungen im Entwurf werden gelöscht und der Entwurf kehrt zur veröffentlichten Version ({{version}}) zurück. Fortfahren?',
    editor: 'Theme-Einstellungen',
    liveVersion: 'Live: Version {{version}} · {{date}}',
    noLiveTheme: 'Kein veröffentlichtes Theme (Standarddarstellung)',
    unpublished: 'Nicht veröffentlichte Änderungen',
    issuesCount: '{{count}} Lesbarkeitsprobleme',
    templates: 'Vorlagen',
    templatesLead:
      'Ändert Farben, Schriften und Layout zusammen. Die gewählte Vorlage ist bis zum Speichern nur in der Vorschau sichtbar.',
    templatePick: 'Vorlage wählen',
    templateNames: {
      clinic: 'Klinik',
      natural: 'Natürlich',
      modern: 'Modern',
      classic: 'Klassisch',
    },
    colors: 'Farben',
    colorsLead:
      'Beginnen Sie mit einer fertigen Palette und passen Sie die Farben einzeln an. Schlecht lesbare Farbpaare werden unter der Vorschau aufgeführt.',
    palettes: 'Fertige Paletten',
    paletteNames: {
      pine: 'Kiefer',
      ocean: 'Ozean',
      forest: 'Wald',
      amber: 'Bernstein',
      plum: 'Pflaume',
      ink: 'Tinte',
    },
    lightColors: 'Helle Farben',
    darkColors: 'Dunkle Farben',
    darkMode: 'Dunkle Farben verwenden, wenn das Gerät im Dunkelmodus ist',
    colorNames: {
      background: 'Hintergrund',
      surface: 'Hintergrund von Karten und Feldern',
      text: 'Text',
      mutedText: 'Sekundärer Text',
      border: 'Linien und Rahmen',
      primary: 'Primärfarbe (Links)',
      secondary: 'Sekundärfarbe',
      accent: 'Akzentfarbe',
      button: 'Schaltfläche',
      buttonText: 'Schaltflächentext',
      buttonHover: 'Schaltfläche (Hover)',
    },
    typography: 'Schrift',
    typographyLead:
      'Schriften werden mit der Storefront ausgeliefert; Besucher müssen sie nicht installiert haben.',
    bodyFont: 'Schrift für Fließtext',
    headingFont: 'Schrift für Überschriften',
    fontKinds: {
      sans: 'serifenlos',
      serif: 'mit Serifen',
    },
    baseSize: 'Schriftgröße Fließtext',
    px: '{{value}} px',
    headingScale: 'Überschriftengrößen',
    headingScales: {
      compact: 'Klein',
      normal: 'Mittel',
      large: 'Groß',
    },
    headingWeight: 'Schriftstärke der Überschriften',
    weights: {
      w500: 'Mittel',
      w600: 'Halbfett',
      w700: 'Fett',
    },
    shape: 'Form',
    shapeLead: 'Eckenradius und Schatten gelten für Karten, Felder und Schaltflächen.',
    radius: 'Eckenradius',
    buttonShape: 'Form der Schaltflächen',
    buttonShapes: {
      square: 'Eckig',
      rounded: 'Abgerundet',
      pill: 'Pille',
    },
    shadow: 'Schatten',
    shadows: {
      none: 'Keiner',
      soft: 'Weich',
      strong: 'Kräftig',
    },
    layout: 'Layout',
    layoutLead: 'Produktkarten, Kopf- und Fußzeile, Produktseite und Formularfelder.',
    cardStyle: 'Produktkarte',
    cardStyles: {
      bordered: 'Mit Rahmen',
      flat: 'Flach',
      raised: 'Erhöht',
    },
    imageRatio: 'Seitenverhältnis der Produktbilder',
    imageRatios: {
      square: 'Quadratisch (1:1)',
      portrait: 'Hochformat (4:5)',
      landscape: 'Querformat (4:3)',
    },
    gridDesktop: 'Spalten auf dem Desktop',
    gridMobile: 'Spalten auf Smartphones',
    columns: '{{count}} Spalten',
    headerLayout: 'Logoposition',
    headerLayoutMoved: 'Das Layout von Hauptmenü und Logo wird jetzt hier gewählt:',
    headerLayouts: {
      start: 'Links',
      center: 'Mitte',
    },
    headerStyle: 'Hintergrund der Kopfzeile',
    headerStyles: {
      surface: 'Hell',
      brand: 'Primärfarbe',
    },
    headerSticky: 'Kopfzeile beim Scrollen oben fixieren',
    footerStyle: 'Hintergrund der Fußzeile',
    footerStyles: {
      surface: 'Hell',
      dark: 'Dunkel',
      brand: 'Primärfarbe',
    },
    gallery: 'Bild auf der Produktseite',
    galleryPositions: {
      start: 'Links',
      end: 'Rechts',
    },
    blogLayout: 'Blogseite',
    blogLayouts: {
      grid: 'Raster',
      list: 'Liste',
    },
    inputStyle: 'Formularfelder',
    inputStyles: {
      outline: 'Umrandet',
      filled: 'Gefüllt',
    },
    livePreview: 'Live-Vorschau',
    device: 'Gerät',
    devices: {
      phone: 'Smartphone',
      tablet: 'Tablet',
      desktop: 'Desktop',
    },
    scheme: 'Darstellung',
    schemes: {
      light: 'Hell',
      dark: 'Dunkel',
    },
    mock: {
      store: 'Shopname',
      search: 'Produkte suchen',
      account: 'Mein Konto',
      cart: 'Warenkorb',
      heading: 'Beispielüberschrift',
      lead: 'Der Einleitungsabsatz verwendet die sekundäre Textfarbe.',
      body: 'Fließtext verwendet die gewählte Schrift und Größe;',
      link: 'Links verwenden die Primärfarbe.',
      primaryButton: 'Primäre Schaltfläche',
      secondaryButton: 'Sekundäre Schaltfläche',
      secondaryTag: 'Sekundär',
      accentTag: 'Akzent',
      products: 'Produkte',
      product: 'Produktname',
      price: 'Preis',
      field: 'Formularfeld',
      placeholder: 'Beispieleingabe',
      fieldHelp: 'Feldhilfen verwenden die sekundäre Textfarbe.',
      footer: 'Fußzeile',
    },
    contrastOk: 'Alle Farbpaare sind gut lesbar (WCAG AA).',
    contrastTitle:
      'Diese Farbpaare sind nicht ausreichend lesbar; das Theme kann erst nach der Korrektur veröffentlicht werden:',
    contrastIssue: 'Darstellung {{palette}}: {{fg}} / {{bg}} — {{ratio}}:1 (mindestens {{min}}:1)',
    versions: 'Versionsverlauf',
    versionsLead:
      'Jede Veröffentlichung wird als unveränderliche Version gespeichert. Auch das Zurückkehren veröffentlicht eine neue Version; der Verlauf wird nie gelöscht.',
    noVersions: 'Noch keine veröffentlichten Versionen.',
    versionNo: 'Version {{version}}',
    restoredFrom: 'Version {{version}} wiederhergestellt',
    current: 'Live',
    rollback: 'Zu dieser Version zurückkehren',
    rollbackConfirm:
      'Version {{version}} wird erneut veröffentlicht und der Entwurf auf diese Version gesetzt. Nicht gespeicherte Änderungen am Entwurf werden gelöscht. Fortfahren?',
    publishTitle: 'Theme veröffentlichen',
    publishLead:
      'Besucher sehen das neue Erscheinungsbild innerhalb einer Minute. Sie können jederzeit zu einer früheren Version zurückkehren.',
    publishConfirm: 'Veröffentlichen',
    publishSavesFirst: 'Nicht gespeicherte Änderungen werden zuerst gespeichert.',
    note: 'Versionshinweis',
  },
  menus: {
    save: 'Menü speichern',
    startFrom: 'Mit einer anderen Sprache beginnen',
    loadDraft: 'Entwurf laden',
    draftLoaded: 'Menüentwurf geladen; übersetzen Sie die Bezeichnungen und speichern Sie.',
    draftDropped: 'Links ohne Entsprechung in dieser Sprache wurden entfernt: {{labels}}',
    draftEmpty: 'Das Menü ({{lang}}) ist leer; es gibt nichts zu laden.',
    saved: 'Menü gespeichert. Es erscheint innerhalb einer Minute in der Storefront.',
    unsaved: 'Nicht gespeicherte Änderungen',
    location: 'Menüposition',
    locations: {
      header: 'Kopfzeilenmenü',
      footer: 'Fußzeilenmenü',
    },
    locationLead: {
      header:
        'Das Kopfzeilenmenü erscheint unter der Kopfzeile der Storefront. Ein Eintrag mit Untereinträgen öffnet ein Mega-Menü: Ebene zwei sind Spaltenüberschriften, Ebene drei sind Links.',
      footer:
        'Im Fußzeilenmenü ist Ebene eins eine Spaltenüberschrift und Ebene zwei deren Links. Links ohne Untereinträge werden unter „Links“ gruppiert.',
    },
    empty: 'Dieses Menü hat noch keine Einträge',
    emptyLead: {
      header:
        'Solange es leer ist, zeigt die Kopfzeile der Storefront die Links „Produkte“, „Verkaufsstellen“ und „Artikel“.',
      footer: 'Solange es leer ist, zeigt die Fußzeile Verkäuferangaben, Kundenservice und Rechtstexte.',
    },
    add: 'Eintrag hinzufügen',
    addChild: 'Untereintrag hinzufügen',
    newItem: 'Neuer Eintrag',
    label: 'Im Menü angezeigter Name',
    link: 'Link',
    linkTypes: {
      none: 'Überschrift ohne Link',
      category: 'Kategorie',
      product: 'Produkt',
      products: 'Alle Produkte',
      page: 'Seite',
      blog: 'Artikel (Blog)',
      post: 'Blogbeitrag',
      url: 'Adresse',
    },
    category: 'Kategorie',
    chooseCategory: 'Kategorie wählen',
    page: 'Seite',
    choosePage: 'Seite wählen',
    post: 'Beitrag',
    choosePost: 'Beitrag wählen',
    blogLead: 'Führt zur Artikelseite der Storefront (/blog).',
    notLivePage: '{{name}} (nicht live)',
    hiddenCategory: '{{name}} (verborgen)',
    product: 'Produkt',
    productSearch: 'Produktname, SKU oder Barcode',
    productPicked: 'Ausgewähltes Produkt: {{title}}',
    productNone: 'Noch kein Produkt ausgewählt.',
    url: 'Adresse',
    newTab: 'In neuem Tab öffnen',
    noneLead: 'Eine Überschrift ohne Link gruppiert nur ihre Untereinträge.',
    productsLead: 'Führt zur Seite mit allen Produkten.',
    unavailable: 'Ziel in der Storefront nicht sichtbar',
    moveUp: '{{label}} nach oben verschieben',
    moveDown: '{{label}} nach unten verschieben',
  },
  editor: {
    toolbar: 'Textformatierung',
    paragraph: 'Absatz',
    heading2: 'Überschrift',
    heading3: 'Zwischenüberschrift',
    bold: 'Fett',
    italic: 'Kursiv',
    bulletList: 'Aufzählung',
    orderedList: 'Nummerierte Liste',
    blockquote: 'Zitat',
    rule: 'Trennlinie',
    link: 'Link hinzufügen',
    unlink: 'Link entfernen',
    image: 'Bild hinzufügen',
    undo: 'Rückgängig',
    redo: 'Wiederholen',
    moveUp: 'Ausgewählten Block nach oben verschieben',
    moveDown: 'Ausgewählten Block nach unten verschieben',
    linkTitle: 'Link',
    linkApply: 'Link übernehmen',
    linkUrl: 'Adresse',
    linkUrlLead: 'Ein Pfad auf der Website (z. B. /urunler), eine https://-Adresse, mailto: oder tel:.',
    linkNewTab: 'In neuem Tab öffnen',
    imageTitle: 'Bild hinzufügen',
    imageInsert: 'Bild einfügen',
    imageAlt: 'Alternativtext',
    imageAltLead: 'Beschreiben Sie kurz, was das Bild zeigt; Screenreader lesen diesen Text vor.',
    imageCaption: 'Bildunterschrift',
    table: 'Tabelle einfügen',
    tableToolbar: 'Tabellenaktionen',
    addRow: 'Zeile hinzufügen',
    addColumn: 'Spalte hinzufügen',
    deleteRow: 'Zeile löschen',
    deleteColumn: 'Spalte löschen',
    deleteTable: 'Tabelle löschen',
    video: 'Video einfügen',
    videoTitle: 'Video einfügen',
    videoLead:
      'Fügen Sie eine YouTube- oder Vimeo-Adresse ein. In der Storefront wird erst dann eine Anfrage an den Videodienst gesendet, wenn der Besucher auf Wiedergabe drückt.',
    videoUrl: 'Videoadresse',
    videoName: 'Videotitel',
    videoInsert: 'Video einfügen',
    import: 'Markdown oder HTML importieren',
    importTitle: 'Markdown oder HTML importieren',
    importLead:
      'Fügen Sie anderswo verfassten Text ein; er wird an der Cursorposition eingefügt. Überschriften, Listen, Tabellen, Zitate, Fett/Kursiv und Links bleiben erhalten; Skripte, Stile und externe Bilder werden nicht übernommen.',
    importFormat: 'Format',
    importText: 'Text',
    importRun: 'Umwandeln und einfügen',
    importEmpty: 'Nichts zum Umwandeln.',
    imported: 'Inhalt eingefügt.',
    importSkippedImages:
      '{{count}} externe(s) Bild(er) übersprungen (laden Sie Bilder über „Bild einfügen“ hoch).',
    importSkippedScripts: '{{count}} Skript-/Stilblock/-blöcke entfernt.',
    importSkippedEmbeds:
      '{{count}} eingebettete(s) Element(e) entfernt (nur YouTube-/Vimeo-Videos bleiben erhalten).',
  },
  pages: {
    create: 'Neue Seite',
    createConfirm: 'Erstellen und bearbeiten',
    empty: 'Noch keine Seiten',
    emptyLead:
      'Solange kein Startseiten-Layout veröffentlicht ist, zeigt die Storefront die Standard-Startseite. Erstellen Sie mit „Neue Seite“ ein Startseiten-Layout, eine Unternehmensseite oder eine Aktionsseite.',
    updated: 'Zuletzt geändert {{date}}',
    kind: 'Seitentyp',
    kinds: {
      home: 'Startseiten-Layout',
      page: 'Unternehmensseite',
      landing: 'Aktionsseite',
    },
    states: {
      draft: 'Entwurf',
      scheduled: 'Geplant',
      live: 'Veröffentlicht',
      expired: 'Abgelaufen',
      unpublished: 'Nicht mehr veröffentlicht',
    },
    reviews: {
      not_required: 'Keine Freigabe erforderlich',
      pending: 'Wartet auf Expertenfreigabe',
      approved: 'Von Experten freigegeben',
      rejected: 'Von Experten abgelehnt',
    },
    title: 'Seitentitel',
    newHeading: 'Neue Überschrift',
    back: 'Alle Seiten',
    saved: 'Entwurf gespeichert',
    publishedToast: 'Seite veröffentlicht',
    unpublishedToast: 'Veröffentlichung der Seite aufgehoben',
    reviewedToast: 'Prüfentscheidung gespeichert',
    preview: 'Vorschau',
    save: 'Entwurf speichern',
    publish: 'Veröffentlichen',
    liveVersion: 'Veröffentlichte Version: {{version}}',
    unpublished: 'Unveröffentlichte Änderungen',
    publishAtInfo: 'Beginn: {{date}}',
    unpublishAtInfo: 'Ende: {{date}}',
    basics: 'Seitendetails',
    slug: 'Kurzname',
    slugLead: 'Adresse: {{path}}',
    seoTitle: 'SEO-Titel',
    seoDescription: 'SEO-Beschreibung',
    chars: '{{count}}/{{max}} Zeichen',
    healthContent: 'Gesundheitsbezogene Inhalte (Expertenfreigabe erforderlich)',
    sections: 'Abschnitte',
    sectionsLead:
      'Werden in der Storefront in dieser Reihenfolge von oben nach unten angezeigt. Ausgeblendete Abschnitte bleiben im Entwurf.',
    noSections: 'Noch keine Abschnitte. Wählen Sie unten einen Abschnittstyp aus und fügen Sie ihn hinzu.',
    sectionType: 'Abschnittstyp',
    sectionTypes: {
      hero: 'Hero-Bereich',
      richText: 'Text',
      imageText: 'Bild und Text',
      productGrid: 'Produktraster',
      categoryTiles: 'Kategoriekacheln',
      faq: 'FAQ',
      banners: 'Banner',
      postList: 'Blogbeiträge',
    },
    addSection: 'Abschnitt hinzufügen',
    hidden: 'Ausgeblendet',
    hide: 'Ausblenden',
    moveUp: 'Abschnitt {{n}} nach oben verschieben',
    moveDown: 'Abschnitt {{n}} nach unten verschieben',
    sectionUnavailable: 'Dieser Abschnittstyp wird noch nicht unterstützt.',
    heading: 'Überschrift',
    heroText: 'Kurztext',
    ctaLabel: 'Schaltflächentext',
    ctaHref: 'Link der Schaltfläche',
    body: 'Text',
    imagePosition: 'Bildposition',
    gridSource: 'Produktquelle',
    gridSources: {
      newest: 'Neueste Produkte',
      category: 'Produkte einer Kategorie',
      products: 'Von mir ausgewählte Produkte',
      bestsellers: 'Bestseller (letzte 30 Tage)',
      discounted: 'Reduzierte Produkte',
      collection: 'Produkte einer Kollektion',
      brand: 'Produkte einer Marke',
    },
    gridCollection: 'Kollektion',
    gridBrand: 'Marke',
    chooseRef: 'Auswählen',
    refInactive: '{{name}} (in der Storefront nicht sichtbar)',
    gridLimit: 'Anzahl der Produkte',
    products: 'Produkte hinzufügen',
    unknownProduct: 'Produkt nicht gefunden (möglicherweise gelöscht)',
    tileCategories: 'Anzuzeigende Kategorien',
    question: 'Frage {{n}}',
    answer: 'Antwort {{n}}',
    addQuestion: 'Frage hinzufügen',
    removeQuestion: 'Diese Frage entfernen',
    noImage: 'Kein Bild',
    uploadImage: 'Bild hochladen',
    replaceImage: 'Bild ersetzen',
    imageAlt: 'Alternativtext',
    review: 'Expertenprüfung',
    reviewLead:
      'Seiten mit gesundheitsbezogenen Inhalten oder Gesundheitsaussagen werden nach Freigabe durch die tierärztliche Fachprüfung veröffentlicht. Wird der Inhalt geändert, erlischt die Freigabe.',
    reviewNote: 'Hinweis des Prüfers: {{note}}',
    reviewNoteLabel: 'Prüfnotiz',
    reviewSaveFirst: 'Speichern Sie zuerst den Entwurf; die Entscheidung gilt für den gespeicherten Inhalt.',
    findings: 'Mögliche Gesundheitsaussagen: {{count}}',
    approve: 'Freigeben',
    reject: 'Ablehnen',
    versions: 'Veröffentlichte Versionen',
    versionsLead: 'Jede Veröffentlichung wird als unveränderliche Version gespeichert.',
    noVersions: 'Diese Seite wurde noch nicht veröffentlicht.',
    unpublish: 'Veröffentlichung aufheben',
    unpublishConfirm:
      'Die Seite wird sofort aus der Storefront entfernt. Entwürfe und Versionen bleiben erhalten. Fortfahren?',
    deleteConfirm: 'Diese Entwurfsseite wird endgültig gelöscht. Fortfahren?',
    publishTitle: 'Seite veröffentlichen',
    publishLead: 'Der Entwurf geht als neue Version live. Ohne Datumsangaben wird er sofort veröffentlicht.',
    publishConfirm: 'Veröffentlichen',
    publishAt: 'Startdatum',
    bannerPlacement: 'Bannerbereich',
    bannersLead: 'Dieser Abschnitt zeigt die aktiven Banner, die dem gewählten Bereich hinzugefügt wurden.',
    manageBanners: 'Banner verwalten',
    allPostCategories: 'Alle Kategorien',
    postLimit: 'Anzahl der Beiträge',
    unpublishAt: 'Enddatum',
  },
  banners: {
    create: 'Neues Banner',
    createConfirm: 'Als Entwurf speichern',
    save: 'Speichern',
    saved: 'Banner gespeichert',
    activate: 'Aktivieren',
    activated: 'Banner aktiviert',
    deactivate: 'Stoppen',
    deactivated: 'Banner gestoppt',
    reordered: 'Reihenfolge gespeichert',
    back: 'Alle Banner',
    unsaved: 'Ungespeicherte Änderungen',
    saveBeforeActivate: 'Speichern Sie vor dem Aktivieren.',
    activeLocked:
      'Dieses Banner ist aktiv; für Änderungen ist die Berechtigung „Inhalte veröffentlichen“ erforderlich.',
    emptyPlacement: 'Keine Banner in diesem Bereich.',
    noText: 'Kein Text',
    startsInfo: 'Beginn: {{date}}',
    endsInfo: 'Ende: {{date}}',
    updated: 'Zuletzt geändert {{date}}',
    moveUp: '{{name}} nach oben verschieben',
    moveDown: '{{name}} nach unten verschieben',
    placements: {
      home_hero: 'Startseiten-Slider',
      home_secondary: 'Sekundärbereich der Startseite',
      category_top: 'Oberhalb der Kategorie',
      announcement: 'Ankündigungsleiste',
      popup: 'Pop-up',
    },
    placementLead: {
      home_hero: 'Rotiert oben auf der Startseite (max. 8). Besucher können die Rotation anhalten.',
      home_secondary: 'Kacheln auf der Startseite (max. 6).',
      category_top: 'Über der Produktliste der gewählten Kategorien (erstes in der Reihenfolge).',
      announcement: 'Eine einzelne Zeile ganz oben auf der Website (erstes in der Reihenfolge).',
      popup:
        'Öffnet sich einmal beim Laden einer Seite; nie im Warenkorb oder an der Kasse (erstes in der Reihenfolge).',
    },
    states: {
      draft: 'Entwurf',
      scheduled: 'Geplant',
      live: 'Veröffentlicht',
      expired: 'Abgelaufen',
      inactive: 'Gestoppt',
    },
    audiences: {
      all: 'Alle',
      retail: 'Keine Händler',
      dealer: 'Nur Händler',
    },
    basics: 'Bannerdetails',
    placement: 'Platzierung',
    name: 'Interner Name',
    nameLead: 'Wird nur in der Verwaltung angezeigt.',
    title: 'Titel',
    text: 'Text',
    announcementText: 'Ankündigungstext',
    ctaLabel: 'Schaltflächentext',
    href: 'Linkadresse',
    images: 'Bilder',
    imagesLead: 'Text wird nie über das Bild gelegt; das Bild wird nur als Bild verwendet.',
    desktopImage: 'Desktop-Bild',
    uploadDesktop: 'Desktop-Bild hochladen',
    replaceDesktop: 'Desktop-Bild ersetzen',
    mobileImage: 'Mobiles Bild',
    uploadMobile: 'Mobiles Bild hochladen',
    replaceMobile: 'Mobiles Bild ersetzen',
    targeting: 'Zielgruppe und Zeitraum',
    targetingLead: 'Wer es sieht und wann.',
    audience: 'Zielgruppe',
    startsAt: 'Beginn',
    endsAt: 'Ende',
    dismissDays: 'Tage ausgeblendet nach dem Schließen',
    categories: 'Kategorien',
    categoriesLead: 'Wenn keine ausgewählt ist, erscheint es auf allen Kategorieseiten.',
    dangerZone: 'Löschen',
    deleteConfirm: 'Dieses Banner wird endgültig gelöscht. Fortfahren?',
  },
  blog: {
    create: 'Neuer Beitrag',
    posts: 'Beiträge',
    filter: 'Anzeigen',
    filters: {
      all: 'Alle Beiträge',
      review: 'Wartet auf Expertenfreigabe',
      live: 'Veröffentlicht',
      draft: 'Entwürfe',
    },
    pendingCount: '{{count}} Beiträge warten auf Expertenfreigabe',
    empty: 'Keine Beiträge',
    emptyLead:
      'Schreiben Sie mit „Neuer Beitrag“ Ihren ersten Beitrag; er wird erst nach der Veröffentlichung angezeigt.',
    publishedInfo: 'Veröffentlicht {{date}}',
    states: {
      draft: 'Entwurf',
      scheduled: 'Geplant',
      live: 'Veröffentlicht',
      unpublished: 'Nicht mehr veröffentlicht',
    },
    title: 'Beitragstitel',
    back: 'Alle Beiträge',
    feature: 'Hervorheben',
    unfeature: 'Hervorhebung entfernen',
    featuredBadge: 'Empfohlen',
    featuredToast: 'Der Beitrag wird auf der Artikelseite hervorgehoben.',
    unfeaturedToast: 'Der Beitrag wird nicht mehr hervorgehoben.',
    readingTime: '{{n}} Min. Lesezeit',
    article: 'Beitrag',
    excerpt: 'Auszug',
    category: 'Kategorie',
    noCategory: 'Keine Kategorie',
    tags: 'Schlagwörter',
    tagsLead: 'Durch Kommas trennen.',
    authorName: 'Name des Autors',
    authorTitle: 'Titel des Autors',
    authorTitlePlaceholder: 'Tierarzt',
    cover: 'Titelbild',
    uploadCover: 'Titelbild hochladen',
    replaceCover: 'Titelbild ersetzen',
    body: 'Beitragstext',
    references: 'Quellen',
    referencesLead: 'Wissenschaftliche Quellen und Links, auf denen der Beitrag basiert.',
    referenceTitle: 'Quelle {{n}}',
    referenceUrl: 'Link von Quelle {{n}}',
    referenceRemove: 'Quelle {{n}} entfernen',
    referenceAdd: 'Quelle hinzufügen',
    related: 'Passende Produkte',
    relatedLead: 'Wird am Ende des Beitrags angezeigt.',
    relatedSearch: 'Produkt hinzufügen',
    seo: 'Suchmaschinen',
    noVersions: 'Dieser Beitrag wurde noch nicht veröffentlicht.',
    publishedToast: 'Beitrag veröffentlicht',
    unpublishedToast: 'Veröffentlichung des Beitrags aufgehoben',
    unpublishConfirm:
      'Der Beitrag wird sofort aus der Storefront entfernt. Entwürfe und Versionen bleiben erhalten. Fortfahren?',
    deleteConfirm: 'Dieser Beitragsentwurf wird endgültig gelöscht. Fortfahren?',
    publishTitle: 'Beitrag veröffentlichen',
    publishLead: 'Der Entwurf geht als neue Version live. Ohne Datum wird er sofort veröffentlicht.',
    categories: 'Blog-Kategorien',
    categoriesLead:
      'Eine Kategorie wird in der Storefront aufgeführt, sobald sie einen veröffentlichten Beitrag enthält.',
    categoryName: 'Kategoriename',
    categoryAdd: 'Kategorie hinzufügen',
    categoryEdit: 'Kategorie bearbeiten',
    categorySlugLead: 'Bei einer Änderung wird die alte Adresse auf die neue weitergeleitet.',
    categoryDescription: 'Beschreibung',
    categorySaved: 'Kategorie gespeichert',
    categoryDelete: 'Kategorie {{name}} löschen',
    categoryDeleteConfirm:
      '„{{name}}“ wird gelöscht; die zugehörigen Beiträge sind dann keiner Kategorie mehr zugeordnet. Fortfahren?',
    postCount: '{{count}} Beiträge',
  },
  contentPlan: {
    kind: 'Typ',
    allKinds: 'Alle Inhalte',
    kinds: {
      post: 'Blogbeitrag',
      page: 'Seite',
      banner: 'Banner',
    },
    monthNav: 'Monatsauswahl',
    prevMonth: 'Vorheriger Monat',
    nextMonth: 'Nächster Monat',
    thisMonth: 'Dieser Monat',
    summary: '{{planned}} geplant, {{done}} erledigt',
    agenda: 'Inhaltskalender für {{month}}',
    today: 'Heute',
    planned: 'Geplant',
    empty: 'Keine Veröffentlichungsereignisse in diesem Monat',
    emptyLead:
      'Hier erscheinen Beiträge und Seiten, die für ein späteres Datum geplant sind, sowie Banner mit Start- oder Enddatum.',
    truncated: 'In diesem Monat gibt es zu viele Ereignisse; die ersten 1000 werden angezeigt.',
    events: {
      publish_planned: 'Geht live',
      publish_done: 'Live gegangen',
      update: 'Aktualisiert (Version {{version}})',
      start_planned: 'Anzeige beginnt',
      start_done: 'Anzeige begonnen',
      end_planned: 'Geht offline',
      end_done: 'Offline gegangen',
    },
    statesTitle: 'Statusübersicht',
    postsTitle: 'Blogbeiträge',
    pagesTitle: 'Seiten',
    bannersTitle: 'Banner',
    pendingReview: 'Wartet auf Expertenprüfung',
    categoriesTitle: 'Veröffentlichte Beiträge nach Kategorie',
    categoriesLead: 'Gezählt nach der Kategorie in der veröffentlichten Version.',
    noCategories: 'Noch keine Blog-Kategorien oder veröffentlichten Beiträge.',
    livePosts: 'Veröffentlichte Beiträge',
    monthlyTitle: 'In den letzten 12 Monaten veröffentlichte Beiträge',
    monthlyLead:
      'Nach dem in der Storefront angezeigten Datum (türkische Zeit); gezählt werden derzeit veröffentlichte Beiträge.',
    month: 'Monat',
    published: 'Beiträge',
    bar: 'Visueller Vergleich',
    staleTitle: 'Nicht aktualisierte Beiträge',
    staleLead:
      'Veröffentlichte Beiträge, deren zuletzt veröffentlichte Version älter als {{days}} Tage ist. Prüfen Sie die Informationen und veröffentlichen Sie sie erneut.',
    staleNone: 'Kein Beitrag ist seit über einem Jahr ohne Aktualisierung.',
    staleMore: 'und {{count}} weitere',
    lastPublished: 'Zuletzt veröffentlicht: {{date}}',
    scTitle: 'Search Console: Beiträge, letzte 28 Tage',
    scUnavailable: 'Search-Console-Daten können für diese Sprache nicht angezeigt werden.',
    scOtherLocale:
      'Search-Console-Klicks werden nur für Beiträge in der Sprache der Storefront (Standardsprache) angezeigt.',
    setupRequired: 'Einrichtung erforderlich',
    scNotLinked:
      'Mit diesem Shop ist keine Search-Console-Property verknüpft. Verknüpfen Sie eine auf der Seite „Google-Verbindungen“.',
    scNoData: 'Noch keine Search-Console-Daten; sie erscheinen hier nach der ersten Synchronisierung.',
    scRange: 'Datenzeitraum: {{from}} – {{to}}',
    scNoClicks: 'In diesem Zeitraum keine Suchklicks oder Impressionen bei Blogbeiträgen.',
    scWithoutClicks: 'Veröffentlichte Beiträge ohne Klicks in diesem Zeitraum: {{count}}',
    post: 'Beitrag',
  },
  forms: {
    form: 'Formular',
    kinds: {
      contact: 'Kontaktformular',
      dealer_application: 'Händlerbewerbung (zusätzliche Felder)',
    },
    settingsTitle: 'Veröffentlichung und Benachrichtigungen',
    noticeMissing: 'Datenschutzhinweis (KVKK) nicht veröffentlicht',
    noticeMissingLead:
      'Veröffentlichen Sie zuerst den Datenschutzhinweis, um das Formular in der Storefront anzuzeigen.',
    enabled: 'Formular auf der Kontaktseite anzeigen',
    notifyStaff: 'E-Mail-Benachrichtigung bei neuen Nachrichten',
    newMessages: 'Neue Nachrichten: {{count}}',
    dealerLead:
      'Firmenname, Steuerdaten, Telefon, Adresse, Provinz/Bezirk, Geschäftsart, Notiz und Dokumentfelder sind fest vorgegeben. Hier hinzugefügte Felder erscheinen am Ende des Bewerbungsformulars und werden mit der Bewerbung gespeichert.',
    fieldsTitle: 'Formularfelder',
    extraFieldsTitle: 'Zusätzliche Felder',
    fieldsLead:
      'Die Felder erscheinen in der Storefront in dieser Reihenfolge. Änderungen gehen mit „Formular speichern“ sofort live.',
    noFields: 'Noch keine zusätzlichen Felder.',
    addField: 'Feld hinzufügen',
    save: 'Formular speichern',
    saved: 'Formular gespeichert',
    untitled: 'Unbenanntes Feld',
    fieldN: 'Feld {{n}}: {{name}}',
    requiredBadge: 'Pflichtfeld',
    label: 'Bezeichnung',
    type: 'Feldtyp',
    help: 'Hilfetext',
    options: 'Optionen (eine pro Zeile)',
    required: 'Pflichtfeld',
    moveUp: '{{name}} nach oben verschieben',
    moveDown: '{{name}} nach unten verschieben',
    remove: '{{name}} entfernen',
    types: {
      text: 'Kurzer Text',
      textarea: 'Langer Text',
      email: 'E-Mail',
      tel: 'Telefon',
      number: 'Zahl',
      select: 'Auswahlliste',
      checkbox: 'Kontrollkästchen',
      date: 'Datum',
    },
    presets: {
      name: 'Vollständiger Name',
      email: 'E-Mail',
      phone: 'Telefon',
      message: 'Nachricht',
    },
  },
  messages: {
    filter: 'Anzeigen',
    convert: 'In Anfrage umwandeln',
    filters: {
      new: 'Neue Nachrichten',
      handled: 'Bearbeitet',
      all: 'Alle Nachrichten',
    },
    newCount: 'Neue Nachrichten: {{count}}',
    listTitle: 'Nachrichten',
    empty: 'Keine Nachrichten',
    emptyLead:
      'Hier erscheinen Nachrichten, die über die Storefront gesendet werden, während das Kontaktformular aktiv ist (Storefront → Formulare).',
    statuses: {
      new: 'Neu',
      handled: 'Bearbeitet',
    },
    reply: 'Per E-Mail antworten',
    markHandled: 'Als bearbeitet markieren',
    markNew: 'Als neu markieren',
    deleteConfirm: 'Diese Nachricht endgültig löschen? Dies kann nicht rückgängig gemacht werden.',
    deleted: 'Nachricht gelöscht',
    pageOf: 'Seite {{page}} von {{pages}}',
  },
  topbar: {
    store: 'Aktueller Shop',
    jobsRunning: 'Laufende Aufgaben: {{count}}',
    jobsDone: 'Aufgaben abgeschlossen ({{count}})',
    jobsTitle: 'Hintergrundaufgaben',
    jobsLead: 'Laufende Aufgaben und die in den letzten 10 Minuten abgeschlossenen.',
    progress: '{{processed}} / {{total}}',
    statuses: {
      queued: 'In Warteschlange',
      running: 'Läuft',
      done: 'Abgeschlossen',
      failed: 'Fehlgeschlagen',
    },
    kinds: {
      import: 'Import',
      product_bulk: 'Produkt-Massenaktion',
      seo_crawl: 'Website-Crawl',
      web_vitals: 'Messung der Seitengeschwindigkeit',
    },
    imports: {
      products: 'Produktimport',
      shopify_products: 'Shopify-Produktimport',
      categories: 'Kategorieimport',
      dealers: 'Import der Händlerliste',
      migration: 'Migrationspaket',
    },
  },
  audience: {
    subscribersTitle: 'Newsletter-Abonnenten',
    subscribersLead:
      'Personen, die sich über das Newsletter-Formular der Storefront angemeldet haben. Ein Abonnement beginnt mit dem Bestätigungslink in der E-Mail (Double-Opt-in); die Einwilligungen von Mitgliedern finden Sie in der Kundenkarte.',
    status: 'Status',
    statuses: {
      subscribed: 'Abonniert',
      pending: 'Wartet auf Bestätigung',
      unsubscribed: 'Abgemeldet',
      all: 'Alle',
    },
    sources: {
      storefront_form: 'Storefront-Formular',
      admin_import: 'Import',
    },
    search: 'E-Mail suchen',
    member: 'Mitglied',
    colEmail: 'E-Mail',
    colStatus: 'Status',
    colConsent: 'Datum und Text der Einwilligung',
    noSubscribers: 'Keine Abonnenten mit diesem Status',
    noSubscribersLead:
      'Das Newsletter-Formular erscheint in der Fußzeile der Storefront, wenn der E-Mail-Versand eingerichtet und der Datenschutzhinweis (KVKK) veröffentlicht ist.',
    unsubscribe: 'Abonnement beenden',
    unsubscribeConfirm:
      'An diese Adresse werden keine Marketing-E-Mails mehr gesendet (sie wird in die Sperrliste aufgenommen) und eine Ablehnung wird an İYS gemeldet. Fortfahren?',
    unsubscribedDone: 'Abonnement beendet.',
    deleteConfirm:
      'Der Abonnentendatensatz wird gelöscht (Datenschutz, KVKK). Abmelde- und İYS-Datensätze bleiben als Nachweis erhalten. Dies kann nicht rückgängig gemacht werden. Fortfahren?',
    deletedDone: 'Abonnent gelöscht.',
    suppressionsTitle: 'Sperrliste',
    suppressionsLead:
      'An diese Adressen wird auch bei vorliegender Einwilligung keine Marketingnachricht gesendet: Abmeldungen, unzustellbare Adressen, Beschwerden und manuelle Einträge. Bestell- und Versandbenachrichtigungen sind nicht betroffen.',
    channel: 'Kanal',
    channels: {
      email: 'E-Mail',
      sms: 'SMS',
      whatsapp: 'WhatsApp',
    },
    channelFilter: 'Liste nach Kanal filtern',
    allChannels: 'Alle Kanäle',
    address: 'Adresse',
    note: 'Notiz (optional)',
    suppress: 'Sperren',
    suppressedDone: 'Adresse zur Sperrliste hinzugefügt.',
    colReason: 'Grund',
    colDate: 'Datum',
    reasons: {
      unsubscribe: 'Abgemeldet',
      bounce: 'Unzustellbar',
      complaint: 'Beschwerde',
      manual: 'Manuell hinzugefügt',
      iys_ret: 'In İYS abgelehnt',
    },
    noSuppressions: 'Die Sperrliste ist leer',
    noSuppressionsLead:
      'Hier erscheinen Personen, die den Abmeldelink nutzen, sowie Adressen, die Sie sperren.',
    unsuppress: 'Entfernen',
    unsuppressConfirm:
      'Die Sperre wird aufgehoben; die Einwilligung wird dadurch nicht wiederhergestellt, die Person muss erneut einwilligen. Fortfahren?',
    unsuppressedDone: 'Sperre aufgehoben.',
    iysTitle: 'İYS-Datensätze',
    iysLead:
      'Einwilligungen und Ablehnungen müssen innerhalb von drei Werktagen an das türkische İleti Yönetim Sistemi gemeldet werden; auf Grundlage einer nicht gemeldeten Einwilligung wird keine Marketingnachricht gesendet.',
    iysConnected: 'İYS verbunden',
    iysSetup: 'Einrichtung erforderlich',
    iysSetupLink: 'Integrationen → İYS',
    iysPending: 'Ausstehend: {{count}}',
    iysOverdue: 'Überfällig: {{count}}',
    iysFailed: 'Abgelehnt: {{count}}',
    iysFilter: 'Anzeigen',
    iysFilters: {
      open: 'Zu melden',
      sent: 'An İYS gesendet',
      reported: 'Manuell gemeldet',
      failed: 'Abgelehnt',
      all: 'Alle',
    },
    iysDownload: 'Datei herunterladen (CSV)',
    iysMark: 'Auswahl als gemeldet markieren ({{count}})',
    iysMarked: 'Datensätze als gemeldet markiert.',
    iysEmpty: 'Nichts zu melden',
    iysEmptyLead: 'Neue Einwilligungen und Ablehnungen erscheinen hier.',
    select: 'Auswählen',
    selectRecord: 'Datensatz {{address}} auswählen',
    colIys: 'Einwilligung',
    colDue: 'Melden bis',
    colState: 'Status',
    overdue: 'Überfällig',
    recipientTypes: {
      BIREYSEL: 'Privatperson',
      TACIR: 'Gewerbetreibender (Händler)',
    },
    iysTypes: {
      EPOSTA: 'E-Mail',
      MESAJ: 'Nachricht',
      ARAMA: 'Anruf',
    },
    iysStatuses: {
      ONAY: 'Einwilligung',
      RET: 'Ablehnung',
    },
    eligibility: {
      invalid_address: 'Ungültige Adresse',
      suppressed: 'Auf der Sperrliste',
      no_consent: 'Keine Marketing-Einwilligung',
      iys_not_registered: 'Einwilligung noch nicht in İYS registriert',
      iys_refused: 'In İYS liegt eine Ablehnung vor',
    },
    iysStates: {
      pending: 'Ausstehend',
      sent: 'An İYS gesendet',
      reported: 'Manuell gemeldet',
      failed: 'Abgelehnt',
    },
  },
  segments: {
    rfmTitle: 'RFM-Gruppen',
    rfmLead:
      'Kunden werden mit 1–5 bewertet: wie kürzlich sie gekauft haben (R), wie oft (F) und nach ihren Nettoausgaben (M); anschließend werden sie gruppiert. Die Berechnung erfolgt jede Nacht automatisch.',
    computedAt: 'Zuletzt berechnet: {{date}}',
    neverComputed:
      'Noch nicht berechnet. Verwenden Sie „Jetzt neu berechnen“; die Berechnung läuft außerdem jede Nacht.',
    recompute: 'Jetzt neu berechnen',
    recomputed: 'RFM-Gruppen und Segmentzahlen aktualisiert.',
    thresholds:
      'R: Kauf innerhalb von {{r5}} Tagen 5, {{r4}} Tagen 4, {{r3}} Tagen 3, {{r2}} Tagen 2, älter 1. F: mindestens {{f5}} Bestellungen 5, {{f4}} → 4, {{f3}} → 3, {{f2}} → 2, eine Bestellung 1. M: Quintile unter den Kunden (die 20 % mit den höchsten Ausgaben → 5).',
    groupCount: '{{count}} Kunden',
    groupShare: '{{pct}} % der Kunden',
    groupSpent: 'Nettoausgaben {{amount}}',
    noOrdersCount: '{{count}} Mitglieder',
    saveAsSegment: 'Als Segment speichern',
    saveAsSegmentLabel: 'Gruppe {{group}} als Segment speichern',
    savedAsSegment: 'Segment erstellt.',
    groups: {
      champions: 'Champions',
      loyal: 'Treue Kunden',
      new: 'Neue Kunden',
      potential: 'Potenzielle Stammkunden',
      need_attention: 'Brauchen Aufmerksamkeit',
      cant_lose: 'Dürfen nicht verloren gehen',
      at_risk: 'Gefährdet',
      hibernating: 'Schlafend',
      lost: 'Verloren',
      none: 'Mitglieder ohne Bestellungen',
    },
    groupHints: {
      champions:
        'Kauf innerhalb von {{r4}} Tagen, mindestens {{f4}} Bestellungen und unter den 40 % mit den höchsten Ausgaben.',
      loyal: 'Kauf innerhalb von {{r3}} Tagen mit mindestens {{f3}} Bestellungen.',
      new: 'Einzige Bestellung innerhalb von {{r4}} Tagen aufgegeben.',
      potential: 'Zweite Bestellung innerhalb von {{r4}} Tagen aufgegeben.',
      need_attention: 'Letzter Kauf vor {{r4}}–{{r3}} Tagen, höchstens zwei Bestellungen.',
      cant_lose: 'Mindestens {{f4}} Bestellungen, aber seit über {{r3}} Tagen kein Kauf.',
      at_risk: '2–3 Bestellungen, seit über {{r3}} Tagen kein Kauf.',
      hibernating: 'Einzige Bestellung vor {{r3}}–{{r2}} Tagen.',
      lost: 'Einzige Bestellung vor mehr als {{r2}} Tagen.',
      none: 'Registriert, aber keine gültige Bestellung.',
    },
    listTitle: 'Segmente',
    listLead:
      'Regelbasierte Kundengruppen, die in Kampagnen und Automatisierungen als Zielgruppen verwendet werden. Die Mitglieder werden jedes Mal anhand der Regeln neu berechnet.',
    add: 'Neues Segment',
    emptyTitle: 'Noch keine Segmente',
    emptyLead: 'Speichern Sie oben eine RFM-Gruppe oder erstellen Sie ein Segment mit eigenen Regeln.',
    colName: 'Segment',
    colMembers: 'Kunden',
    colCounted: 'Zuletzt gezählt',
    backToList: 'Alle Segmente',
    basics: 'Segmentdetails',
    name: 'Name',
    description: 'Beschreibung',
    rulesTitle: 'Regeln',
    rulesLead:
      'Kunden, die die Regeln erfüllen, gehören zum Segment. Bestellbedingungen werden live ausgewertet, die RFM-Gruppe anhand der letzten Berechnung; gemäß KVKK gelöschte Kunden werden nie einbezogen.',
    match: 'Übereinstimmung',
    matchAll: 'Alle Bedingungen',
    matchAny: 'Eine beliebige Bedingung',
    conditions: 'Bedingungen',
    field: 'Feld',
    op: 'Vergleich',
    value: 'Wert',
    choose: 'Auswählen',
    addCondition: 'Bedingung hinzufügen',
    removeCondition: 'Bedingung entfernen',
    fields: {
      order_count: 'Anzahl der Bestellungen',
      total_spent: 'Nettoausgaben',
      last_order_days: 'Tage seit der letzten Bestellung',
      registered_days: 'Tage seit der Registrierung',
      species: 'Tierart des gekauften Produkts',
      tag: 'Schlagwort',
      city: 'Stadt',
      kind: 'Kundentyp',
      consent: 'Kanal mit Marketing-Einwilligung',
      consent_source: 'Ort der E-Mail-Einwilligung',
      rfm: 'RFM-Gruppe',
    },
    ops: {
      is: 'ist',
      is_not: 'ist nicht',
      gte: 'mindestens',
      lte: 'höchstens',
    },
    kinds: {
      dealer: 'Händler (freigegebenes Firmenmitglied)',
      retail: 'Endkunde',
    },
    amountIn: 'Betrag ({{currency}})',
    days: 'Tage',
    preview: 'Vorschau',
    previewTitle: 'Passende Kunden: {{count}}',
    previewLead: 'Vorschau vor dem Speichern; die ersten 10 Kunden werden angezeigt.',
    noMatches: 'Keine Kunden erfüllen die Regeln.',
    saved: 'Segment gespeichert.',
    deleted: 'Segment gelöscht.',
    deleteConfirm: 'Segment „{{name}}“ löschen? Kunden sind davon nicht betroffen.',
    membersTitle: 'Kunden in diesem Segment: {{count}}',
    membersEmpty: 'Derzeit keine Kunden in diesem Segment.',
    colCustomer: 'Kunde',
    colRfm: 'RFM-Gruppe',
    colOrders: 'Bestellungen',
    colSpent: 'Nettoausgaben',
    colLastOrder: 'Letzte Bestellung',
  },
  emailRouting: {
    title: 'E-Mail-Versand',
    lead: 'Bestell-, Passwort- und Einladungs-E-Mails (transaktional) sowie Newsletter- und Kampagnen-E-Mails (Marketing) können über unterschiedliche Anbieter versendet werden. Es werden nur Anbieter mit erfolgreichem Verbindungstest aufgeführt.',
    transactional: 'Transaktionale E-Mails',
    marketing: 'Marketing-E-Mails',
    smtpDefault: 'SMTP (Unternehmen oder Plattform)',
    sameAsTransactional: 'Wie transaktionale E-Mails',
    noProviders:
      'Noch kein E-Mail-Anbieter (Amazon SES, SendGrid, Postmark) verbunden; E-Mails werden über SMTP versendet.',
    save: 'Versandauswahl speichern',
    saved: 'Versandauswahl gespeichert.',
    webhooksLead:
      'Tragen Sie diese Adressen im Dashboard des Anbieters für Bounce-, Beschwerde- und Abmeldebenachrichtigungen ein; sie aktualisieren die Sperrliste. Sie enthalten einen geheimen Schlüssel; geben Sie sie nicht weiter.',
    webhookFor: 'Benachrichtigungs-URL für {{provider}}',
    rotate: 'URLs neu generieren',
    rotateConfirm:
      'Ein neuer geheimer Schlüssel wird erzeugt und die alten URLs funktionieren sofort nicht mehr. Aktualisieren Sie sie in den Dashboards der Anbieter. Fortfahren?',
    rotated: 'Benachrichtigungs-URLs neu generiert.',
  },
  emailTemplates: {
    create: 'Neue Vorlage',
    lead: 'Vorlagen für Newsletter- und Kampagnen-E-Mails. Erstellen Sie Inhalte aus Blöcken; Farben und Logo stammen aus dem veröffentlichten Theme des Shops, die rechtlichen Angaben in der Fußzeile aus den Unternehmenseinstellungen. Der Versand erfolgt über Kampagnen.',
    emptyTitle: 'Noch keine Vorlagen',
    emptyLead:
      'Beginnen Sie mit „Neue Vorlage“: Fügen Sie Überschrift-, Text-, Bild-, Schaltflächen- und Produktblöcke hinzu und ordnen Sie sie an.',
    listLabel: 'E-Mail-Vorlagen',
    colName: 'Vorlage',
    colReview: 'Expertenprüfung',
    colUpdated: 'Letzte Änderung',
    noReview: 'Nicht erforderlich',
    saved: 'Vorlage gespeichert.',
    deleted: 'Vorlage gelöscht.',
    save: 'Speichern',
    createConfirm: 'Vorlage erstellen',
    back: 'Alle Vorlagen',
    unsaved: 'Ungespeicherte Änderungen',
    completeFirst: 'Füllen Sie zum Speichern Name, Betreff und die als unvollständig markierten Blöcke aus.',
    editor: 'Vorlagen-Editor',
    basics: 'Vorlagendetails',
    name: 'Vorlagenname',
    nameLead: 'Wird nur in der Verwaltung angezeigt (z. B. „Oktober-Newsletter“).',
    subject: 'Betreff',
    preheader: 'Preheader',
    preheaderLead:
      'Kurzer Text, der im Posteingang neben dem Betreff angezeigt wird; nicht in der E-Mail selbst sichtbar.',
    mergeTitle: 'Personalisierungsfelder',
    mergeFields: {
      firstName: 'Vorname des Empfängers',
      name: 'vollständiger Name des Empfängers',
      email: 'E-Mail-Adresse des Empfängers',
      storeName: 'Shopname',
    },
    mergeFallback:
      'Für einen Ersatzwert, falls kein Wert vorhanden ist, schreiben Sie ihn nach einem senkrechten Strich:',
    blocks: 'Inhaltsblöcke',
    blocksLead:
      'Die Blöcke erscheinen in dieser Reihenfolge von oben nach unten. Ziehen Sie sie am Griff oder verwenden Sie die Pfeiltasten, um sie neu anzuordnen. Rechtliche Angaben und der Abmeldelink werden unten in jede E-Mail eingefügt.',
    noBlocks: 'Noch keine Blöcke. Fügen Sie unten einen hinzu.',
    moved: 'Block an Position {{position}} verschoben.',
    removed: 'Block {{n}} entfernt.',
    added: 'Block „{{type}}“ an Position {{n}} hinzugefügt.',
    dragHint: 'Zum Neuanordnen ziehen',
    blockTitle: '{{n}}. {{type}}',
    blockTypes: {
      heading: 'Überschrift',
      text: 'Text',
      image: 'Bild',
      button: 'Schaltfläche',
      products: 'Produktkarten',
      divider: 'Trennlinie',
      spacer: 'Abstand',
      cart: 'Warenkorb',
      order: 'Bestellung',
      quote: 'Angebot',
    },
    missing: {
      text: 'Text eingeben',
      image: 'Bild hochladen',
      label: 'Schaltflächentext eingeben',
      link: 'Link eingeben',
      products: 'Mindestens ein Produkt auswählen',
      collection: 'Kollektion auswählen',
      category: 'Kategorie auswählen',
    },
    moveUp: 'Block {{n}} nach oben verschieben',
    moveDown: 'Block {{n}} nach unten verschieben',
    removeBlock: 'Block {{n}} entfernen',
    addBlock: 'Block hinzufügen',
    blockLimit: 'Eine Vorlage kann höchstens {{max}} Blöcke enthalten.',
    dangerZone: 'Vorlage löschen',
    deleteConfirm:
      'Die Vorlage „{{name}}“ wird gelöscht. Versionen in anderen Sprachen bleiben erhalten. Fortfahren?',
    updated: 'Letzte Änderung: {{date}}',
    align: 'Ausrichtung',
    aligns: {
      left: 'Links',
      center: 'Zentriert',
    },
    headingText: 'Überschrift',
    level: 'Größe',
    levels: {
      '1': 'Große Überschrift',
      '2': 'Zwischenüberschrift',
    },
    text: 'Text',
    textLead:
      'Eine Leerzeile beginnt einen neuen Absatz. Text zwischen **zwei Sternchen** wird fett dargestellt.',
    replaceImage: 'Bild ersetzen',
    uploadImage: 'Bild hochladen',
    imageAlt: 'Bildbeschreibung',
    imageAltLead:
      'Wird angezeigt, wenn das Bild nicht lädt, und von Screenreadern vorgelesen. Für verlinkte Bilder erforderlich.',
    imageLink: 'Bildlink',
    width: 'Breite',
    widths: {
      full: 'Volle Breite',
      half: 'Halbe Breite (zentriert)',
    },
    buttonLabel: 'Schaltflächentext',
    buttonLink: 'Schaltflächenlink',
    source: 'Produktquelle',
    sources: {
      newest: 'Neueste Produkte',
      collection: 'Kollektion',
      category: 'Kategorie',
      manual: 'Handverlesene Produkte',
    },
    columns: 'Spalten',
    columnCount: '{{count}} Spalten',
    limit: 'Anzahl der Produkte',
    collection: 'Kollektion',
    category: 'Kategorie',
    choose: 'Auswählen',
    pickProducts: 'Produkte',
    showPrice: 'Preis anzeigen',
    productsLead:
      'Es werden nur Produkte angezeigt, die in diesem Shop veröffentlicht, aktiv und inhaltlich freigegeben sind; Produkte mit Gesundheitsaussagen, die auf Freigabe warten, werden ausgelassen. Der Preis ist der niedrigste Variantenpreis inkl. Steuern im Standardmarkt und wird beim Versand neu berechnet.',
    spacerSize: 'Abstandshöhe',
    sizes: {
      sm: 'Klein',
      md: 'Mittel',
      lg: 'Groß',
    },
    cartLead:
      'In der Automatisierung für abgebrochene Warenkörbe werden hier die Artikel und die Gesamtsumme des Warenkorbs aufgeführt. In Kampagnen-E-Mails wird stattdessen eine Beschreibung angezeigt.',
    orderLead:
      'In Automatisierungen nach dem Kauf werden hier die Bestellpositionen und die Gesamtsumme aufgeführt. In Kampagnen-E-Mails wird stattdessen eine Beschreibung angezeigt.',
    quoteLead:
      'In der Automation zum Nachfassen bei Händlerangeboten werden hier Artikel, Summe und Gültigkeitsdatum des Angebots aufgeführt. In einer Kampagnen-E-Mail erscheint stattdessen eine Erläuterung.',
    dividerLead: 'Eine dünne Linie zwischen Blöcken.',
    preview: 'Vorschau',
    previewUpdating: 'Wird aktualisiert…',
    device: 'Bildschirm',
    devices: {
      desktop: 'Desktop',
      phone: 'Smartphone',
    },
    format: 'Format',
    formats: {
      html: 'E-Mail',
      text: 'Nur Text',
    },
    previewFieldErrors: 'Die Vorschau konnte nicht erstellt werden; korrigieren Sie die markierten Felder.',
    previewWaiting: 'Die Vorschau erscheint hier, sobald Sie einen Betreff eingeben.',
    previewFrame: 'E-Mail-Vorschau',
    findingsTitle:
      '{{count}} Formulierung(en) könnten Gesundheitsaussagen sein. Nach dem Speichern ist die Freigabe durch die tierärztliche Fachprüfung erforderlich; ohne sie kann die Vorlage nicht in Kampagnen verwendet werden.',
    emptyProducts:
      'Ein Produktblock hat nichts anzuzeigen (Block: {{blocks}}). Die Quelle enthält keine veröffentlichten, freigegebenen Produkte; der Block wird in der E-Mail ausgelassen.',
    test: 'Test senden',
    testLead:
      'Die gespeicherte Version wird mit „[Test]“ vor dem Betreff gesendet. Sie geht nur an Verwaltungsbenutzer Ihres Unternehmens, nie an Kunden.',
    testSend: 'Senden',
    testQueued: 'Test-E-Mail zum Versand eingereiht ({{count}} Empfänger).',
    testSaveFirst:
      'Es gibt ungespeicherte Änderungen. Der Test sendet die gespeicherte Version; speichern Sie zuerst.',
    testTo: 'Empfänger',
    testToLead:
      'E-Mail-Adressen von Verwaltungsbenutzern, durch Kommas getrennt, höchstens 5. Leer lassen, um nur an sich selbst zu senden.',
  },
  campaigns: {
    create: 'Neue Kampagne',
    lead: 'Eine Kampagne sendet eine E-Mail-Vorlage an die gewählte Zielgruppe. Jeder Empfänger wird beim Versand erneut geprüft: Personen auf der Sperrliste, ohne Einwilligung oder deren Einwilligung nicht an İYS gemeldet wurde, erhalten sie nicht. Der Versand läuft im Hintergrund mit einem Limit pro Minute.',
    emptyTitle: 'Noch keine Kampagnen',
    emptyLead:
      'Erstellen Sie zuerst eine E-Mail-Vorlage und wählen Sie dann mit „Neue Kampagne“ die Zielgruppe.',
    listLabel: 'E-Mail-Kampagnen',
    colName: 'Kampagne',
    colStatus: 'Status',
    colSent: 'Gesendet / Empfänger',
    colClicked: 'Geklickt',
    colWhen: 'Datum',
    statuses: {
      draft: 'Entwurf',
      scheduled: 'Geplant',
      sending: 'Wird gesendet',
      testing: 'A/B-Test läuft',
      sent: 'Gesendet',
      paused: 'Pausiert',
      cancelled: 'Gestoppt',
    },
    saved: 'Kampagne gespeichert.',
    deleted: 'Kampagne gelöscht.',
    cancelled: 'Versand gestoppt.',
    resumed: 'Versand fortgesetzt.',
    save: 'Speichern',
    createConfirm: 'Entwurf erstellen',
    back: 'Alle Kampagnen',
    unsaved: 'Ungespeicherte Änderungen',
    editor: 'Kampagneneinstellungen',
    content: 'Inhalt',
    name: 'Kampagnenname',
    nameLead:
      'Wird in der Verwaltung und in Berichten angezeigt; daraus wird der Kampagnencode erzeugt, der an Links angehängt wird.',
    template: 'E-Mail-Vorlage',
    chooseTemplate: 'Vorlage auswählen',
    openTemplate: 'Vorlage öffnen',
    noTemplates: 'Dieser Shop hat noch keine E-Mail-Vorlagen.',
    subject: 'Betreff',
    subjectLead:
      'Wenn leer, wird der Betreff der Vorlage verwendet: „{{subject}}“. Empfänger in anderen Sprachen erhalten den Vorlagenbetreff in ihrer Sprache.',
    preheader: 'Preheader',
    preheaderLead: 'Wenn leer, wird der Preheader der Vorlage verwendet.',
    audience: 'Zielgruppe',
    audienceLead:
      'Kunden in den Segmenten und optional die Newsletter-Abonnenten des Shops. Jede Adresse wird nur einmal gezählt.',
    segments: 'Segmente',
    noSegments: 'Keine gespeicherten Segmente (Marketing → Segmente).',
    segmentCount: '(zuletzt gezählt: {{count}} Kunden)',
    subscribers: 'Newsletter-Abonnenten des Shops',
    estimate: 'Empfänger zählen',
    estimateResult: 'Kann an {{eligible}} Personen (von {{total}}) gesendet werden.',
    estimateNote:
      'Die Zahlen spiegeln den aktuellen Stand wider; jeder Empfänger wird beim Versand erneut geprüft.',
    skipReasons: {
      suppressed: 'Auf der Sperrliste: {{count}}',
      no_consent: 'Keine Marketing-Einwilligung: {{count}}',
      iys_not_registered: 'Einwilligung nicht an İYS gemeldet: {{count}}',
      iys_refused: 'In İYS abgelehnt: {{count}}',
      invalid_address: 'Ungültige Adresse: {{count}}',
      staging_allowlist: 'Nicht auf der Staging-Zulassungsliste (nicht gesendet): {{count}}',
    },
    abTitle: 'A/B-Test (Betreff)',
    abLead:
      'Ein Teil der Empfänger erhält zwei unterschiedliche Betreffzeilen. Nach der Wartezeit geht der Betreff mit der höheren Klickrate an die übrigen Empfänger.',
    abEnable: 'A/B-Test für den Betreff durchführen',
    subjectB: 'Betreff B',
    abPercent: 'Testgruppe',
    percentOption: '{{pct}} % der Empfänger',
    abWait: 'Wartezeit vor der Auswahl des Gewinners',
    hoursOption: '{{count}} Stunden',
    delivery: 'Versandgeschwindigkeit',
    deliveryLead:
      'Richten Sie diese nach dem Limit Ihres Anbieters und der Reputation Ihrer Domain. Beginnen Sie bei einer neuen Domain langsam.',
    rate: 'E-Mails pro Minute (max.)',
    dangerZone: 'Kampagne löschen',
    deleteConfirm: 'Die Kampagne „{{name}}“ wird gelöscht. Fortfahren?',
    updated: 'Letzte Änderung: {{date}}',
    send: 'Senden…',
    templateNotApproved:
      'Die Vorlage wartet auf Expertenfreigabe; sie kann erst nach der Freigabe gesendet werden.',
    sendTitle: 'Kampagne senden',
    sendLead:
      'E-Mails gehen an echte Personen und können nicht zurückgerufen werden. Sie können den Versand nach dem Start stoppen; bereits gesendete E-Mails bleiben gesendet.',
    scheduleConfirm: 'Planen',
    sendConfirm: 'An {{count}} Personen senden',
    when: 'Wann',
    now: 'Jetzt',
    later: 'Zu einem späteren Zeitpunkt',
    scheduledAt: 'Versandzeitpunkt',
    scheduledToast: 'Kampagne geplant.',
    queuedToast: 'Der Versand beginnt; verfolgen Sie den Fortschritt auf diesem Bildschirm.',
    statusTitle: 'Versandstatus',
    statusLabel: 'Status',
    startedAt: 'Gestartet',
    abDecideAt: 'Gewinnerauswahl am',
    winner: 'Gewinnender Betreff',
    variantLabel: 'Betreff {{v}}',
    finishedAt: 'Abgeschlossen',
    progressLabel: 'Versandfortschritt',
    progress: '{{done}} / {{total}} Empfänger verarbeitet: {{sent}} gesendet, {{skipped}} übersprungen.',
    abSkipped:
      'Kein A/B-Test: Es gab nicht genügend Empfänger (mindestens 100). Alle haben Betreff A erhalten.',
    pauseReasons: {
      email_not_configured:
        'Der E-Mail-Versand ist nicht eingerichtet (Einrichtung erforderlich). Verbinden Sie unter „Verbindungen“ SMTP oder einen Anbieter und klicken Sie dann auf „Fortsetzen“.',
      provider_auth_failed:
        'Der E-Mail-Anbieter hat den Schlüssel abgelehnt. Korrigieren Sie die Verbindung und klicken Sie auf „Fortsetzen“; nicht belieferte Empfänger warten.',
      template_review_required:
        'Die Vorlage wartet auf Expertenfreigabe. Klicken Sie nach der Freigabe auf „Fortsetzen“.',
      campaign_template_invalid:
        'Die Vorlage wurde nicht gefunden (möglicherweise gelöscht). Stoppen Sie diese Kampagne und erstellen Sie eine neue.',
    },
    resume: 'Fortsetzen',
    cancel: 'Versand stoppen',
    cancelConfirm:
      'Noch nicht belieferte Empfänger erhalten die E-Mail nicht; gesendete E-Mails können nicht zurückgerufen werden. Fortfahren?',
    reportTitle: 'Bericht',
    reportLead:
      'Öffnungen werden nicht gemessen (Datenschutz und Zuverlässigkeit). „Zugestellt“ wird nur bei SES, SendGrid oder Postmark mit hinterlegter Benachrichtigungsadresse befüllt.',
    purged:
      'Empfängerdatensätze wurden nach Ablauf der Aufbewahrungsfrist (180 Tage) gelöscht; die Summen bleiben erhalten.',
    stats: {
      recipients: 'Empfänger',
      sent: 'Gesendet',
      skipped: 'Übersprungen',
      delivered: 'Zugestellt',
      bounced: 'Unzustellbar',
      clicked: 'Geklickt',
      clicks: 'Klicks',
      unsubscribed: 'Abgemeldet',
      complained: 'Beschwerden',
      failed: 'Fehlgeschlagen',
    },
    skippedTitle: 'Übersprungen',
    colVariant: 'Betreff',
    winnerBadge: 'Gewinner',
    linksTitle: 'Link',
    ordersTitle: 'Bestellungen aus der Kampagne',
    noOrders: 'Noch keine Bestellungen über Kampagnenlinks.',
    ordersLine: '{{orders}} Bestellungen, {{paid}} bezahlt · Umsatz {{revenue}}',
    ordersNote:
      'Eine Bestellung wird gezählt, wenn der Besucher als letzten Kontaktpunkt über den E-Mail-Link kam und Cookies erlaubt hat (gleiche Regel wie im Bericht „Kampagnen und Quellen“).',
  },
  automations: {
    lead: 'Eine Automatisierung sendet einer Person automatisch eine E-Mail, wenn etwas passiert (Registrierung, abgebrochener Warenkorb, zugestellte Bestellung…). Abläufe sind standardmäßig deaktiviert; nur Ereignisse nach der Aktivierung eines Ablaufs werden aufgenommen. Vor jeder E-Mail werden Sperrliste, Marketing-Einwilligung, İYS, Frequenzbegrenzung und Ruhezeiten geprüft.',
    listLabel: 'Marketing-Automatisierungen',
    colFlow: 'Ablauf',
    colStatus: 'Status',
    colEnrolled: 'Aufgenommen',
    colSent: 'Gesendet',
    on: 'Ein',
    off: 'Aus',
    activeCount: '{{count}} laufend',
    last30Note: 'Die Zahlen beziehen sich auf die letzten 30 Tage.',
    kinds: {
      welcome: 'Willkommen',
      cart_abandon: 'Abgebrochener Warenkorb',
      checkout_abandon: 'Nicht abgeschlossene Zahlung',
      post_purchase: 'Nach dem Kauf',
      repurchase: 'Nachkauf-Erinnerung',
      winback: 'Rückgewinnung',
      vip: 'VIP-Kunden',
      birthday: 'Geburtstag',
      dealer_welcome: 'Händler-Willkommen',
      quote_followup: 'Nachfassen bei Händlerangeboten',
    },
    summaries: {
      welcome: 'Erste E-Mail an ein neues Mitglied oder einen Newsletter-Abonnenten.',
      cart_abandon:
        'Erinnerung an ein Mitglied, das Artikel im Warenkorb gelassen hat, mit optionaler zweiter E-Mail.',
      checkout_abandon: 'Erinnerung für eine Bestellung, deren Zahlung nicht abgeschlossen wurde.',
      post_purchase: 'Einladung zur Bewertung nach der Zustellung.',
      repurchase: 'Erinnerung einige Tage nach der letzten Bestellung.',
      winback: 'Kunden zurückgewinnen, die lange nicht bestellt haben.',
      vip: 'Ein jährliches Dankeschön an die Gruppe „Champions“.',
      birthday: 'Glückwunsch für Kunden, die ihren Geburtstag angegeben haben.',
      dealer_welcome: 'Willkommen für Benutzer einer freigegebenen Händlerfirma.',
      quote_followup:
        'Erinnerung an den Händler zu einem gesendeten Angebot, aus dem noch keine Bestellung wurde.',
    },
    settingsTitle: 'Versandregeln',
    settingsLead: 'Gelten für alle Abläufe. Kampagnen-E-Mails werden auf die Frequenzbegrenzung angerechnet.',
    frequencyCap: 'Frequenzbegrenzung',
    frequencyCapLead:
      'Wer innerhalb dieses Zeitraums eine Kampagnen- oder andere Ablauf-E-Mail erhalten hat, wird übersprungen. Den Abstand innerhalb eines Ablaufs legt der Warteschritt fest.',
    capNone: 'Keine Begrenzung',
    capHours: 'Höchstens eine E-Mail pro {{count}} Stunden',
    quietHours: 'Ruhezeiten',
    quietStart: 'Beginn',
    quietEnd: 'Ende',
    quietLead:
      'Zwischen {{start}} und {{end}} (türkische Zeit) werden keine E-Mails gesendet; solche E-Mails werden um {{end}} versendet.',
    quietOff: 'Keine Ruhezeiten: E-Mails können jederzeit gesendet werden.',
    saveSettings: 'Regeln speichern',
    settingsSaved: 'Versandregeln gespeichert.',
    unknownTitle: 'Ablauf nicht gefunden',
    unknownLead:
      'Die Adresse ist möglicherweise falsch. Wählen Sie einen Ablauf aus der Liste der Automatisierungen.',
    back: 'Alle Automatisierungen',
    unsaved: 'Ungespeicherte Änderungen',
    editor: 'Ablaufeinstellungen',
    save: 'Speichern',
    saveAndEnable: 'Speichern und aktivieren',
    enableConfirm:
      'Nach der Aktivierung gehen E-Mails automatisch an Personen, die die Bedingungen erfüllen (und die Prüfungen von Einwilligung, Sperrliste und İYS bestehen). Gesendete E-Mails können nicht zurückgerufen werden. Aktivieren?',
    saved: 'Ablauf gespeichert.',
    enabledToast: 'Ablauf aktiviert; neue Ereignisse werden aufgenommen.',
    disabledToast: 'Ablauf deaktiviert; laufende Personen wurden entfernt.',
    statusTitle: 'Status',
    enabledLabel: 'Ablauf aktiv',
    enabledSince: 'Aktiviert: {{date}}. Ereignisse nach diesem Datum werden in den Ablauf aufgenommen.',
    enableLead:
      'Wählen Sie für jeden E-Mail-Schritt eine Vorlage, um den Ablauf zu aktivieren. Der E-Mail-Versand muss eingerichtet sein; Vorlagen mit Gesundheitsaussagen benötigen eine Expertenfreigabe.',
    disableWarning:
      'Beim Speichern wird der Ablauf deaktiviert und die aktuell darin befindlichen Personen werden entfernt.',
    stepsChangedWarning:
      'Sie haben die Schritte geändert: Beim Speichern werden die aktuell im Ablauf befindlichen Personen entfernt.',
    triggerTitle: 'Auslöser',
    triggers: {
      welcome: 'Wenn ein Konto erstellt oder ein Newsletter-Abonnement bestätigt wird. Einmal pro Adresse.',
      cart_abandon: '{{hours}} Stunden nach der letzten Änderung am Warenkorb eines Mitglieds.',
      checkout_abandon: '{{hours}} Stunden nach Erstellung einer Bestellung, wenn die Zahlung noch aussteht.',
      post_purchase: '{{days}} Tage nach Zustellung der Bestellung.',
      repurchase:
        '{{days}} Tage nach der letzten Bestellung in diesem Shop (falls keine neuere Bestellung vorliegt).',
      winback:
        '{{days}} Tage nach der letzten Bestellung in diesem Shop (falls keine neuere Bestellung vorliegt).',
      vip: 'Wenn ein Kunde in der RFM-Gruppe „Champions“ ist; tägliche Prüfung, höchstens einmal pro Jahr und Kunde.',
      birthday: 'Am vom Kunden angegebenen Geburtstag (zu Tagesbeginn; bei Ruhezeiten morgens).',
      dealer_welcome: 'Direkt nach der Freigabe einer Händlerfirma.',
      quote_followup:
        '{{days}} Tage nachdem ein Angebot (seine letzte Version) an den Händler gesendet wurde, wenn das Angebot noch offen ist. Geht an die Inhaber der Firma und an den Nutzer, der das Angebot angefragt hat; beginnt neu, wenn eine neue Version gesendet wird.',
    },
    afterHours: 'Wie lange danach',
    hoursOption: '{{count}} Stunden',
    daysLabel: {
      post_purchase: 'Tage nach der Zustellung',
      repurchase: 'Tage nach der letzten Bestellung',
      winback: 'Tage nach der letzten Bestellung',
      quote_followup: 'Tage nach dem Senden des Angebots',
    },
    storeScoped:
      'Dieser Ablauf wird nur durch Warenkörbe, Bestellungen und Angebote des gewählten Shops ausgelöst.',
    stepsTitle: 'Schritte',
    stepsLead:
      'Die Schritte laufen nacheinander ab. Eine Wartezeit verzögert den nächsten Schritt; ist eine Bedingung nicht erfüllt, verlässt die Person den Ablauf; ein E-Mail-Schritt sendet die Vorlage.',
    stepTitle: 'Schritt {{n}}: {{type}}',
    stepNumber: 'Schritt {{n}}',
    stepTypes: {
      wait: 'Warten',
      condition: 'Bedingung',
      email: 'E-Mail',
    },
    waitHours: 'Wartezeit in Stunden',
    condition: 'Fortfahren, wenn',
    conditionLead: 'Ist die Bedingung nicht erfüllt, verlässt die Person den Ablauf.',
    conditions: {
      cart_not_converted: 'Warenkorb enthält noch Artikel und es wurde keine Bestellung aufgegeben',
      order_not_paid: 'Zahlung der Bestellung steht noch aus',
      not_reviewed: 'Produkte der Bestellung wurden noch nicht bewertet',
      no_order_since_enrollment: 'Keine Bestellung seit Aufnahme in den Ablauf',
      quote_open: 'Angebot noch offen (gleiche Version, nicht abgelaufen, nicht bestellt)',
    },
    template: 'E-Mail-Vorlage',
    chooseTemplate: 'Vorlage auswählen',
    openTemplate: 'Vorlage öffnen',
    noTemplates: 'Dieser Shop hat noch keine E-Mail-Vorlagen.',
    templateHints: {
      welcome: 'Verwenden Sie {{firstName}} für den Namen der Person.',
      cart_abandon:
        'Fügen Sie einen Block „Warenkorb“ hinzu, um die Artikel und aktuellen Preise anzuzeigen.',
      checkout_abandon:
        'Fügen Sie einen Block „Bestellung“ hinzu, um die ausstehende Bestellung und ihren Link anzuzeigen.',
      post_purchase: 'Fügen Sie einen Block „Bestellung“ hinzu, um die zugestellte Bestellung anzuzeigen.',
      repurchase: 'Fügen Sie einen Block „Bestellung“ hinzu, um die letzte Bestellung anzuzeigen.',
      winback: 'Fügen Sie einen Block „Bestellung“ hinzu, um die letzte Bestellung anzuzeigen.',
      vip: 'Verwenden Sie {{firstName}} für den Namen der Person.',
      birthday: 'Verwenden Sie {{firstName}} für den Namen der Person.',
      dealer_welcome: 'Händlerpreise werden nach der Anmeldung angezeigt; fügen Sie einen Anmeldelink ein.',
      quote_followup:
        'Fügen Sie der Vorlage einen Block „Angebot“ hinzu, um Artikel, Summe, Gültigkeitsdatum und eine Schaltfläche zum Angebot anzuzeigen.',
    },
    moveUp: 'Schritt {{n}} nach oben verschieben',
    moveDown: 'Schritt {{n}} nach unten verschieben',
    removeStep: 'Schritt {{n}} löschen',
    moved: 'Schritt an Position {{n}} verschoben.',
    added: 'Schritt {{n}} hinzugefügt.',
    removed: 'Schritt {{n}} gelöscht.',
    addStep: 'Schritt hinzufügen',
    resetDefaults: 'Auf Standardschritte zurücksetzen',
    reportTitle: 'Bericht',
    reportLead:
      'Aufnahmen, Austrittsgründe und Sendungen. Datensätze werden 180 Tage nach Ende des Ablaufs gelöscht. Öffnungen werden nicht gemessen.',
    stats: {
      enrolled: 'Aufgenommen',
      active: 'Laufend',
      completed: 'Abgeschlossen',
      exited: 'Ausgetreten',
      sent: 'Gesendet',
      skipped: 'Übersprungen',
      failed: 'Fehlgeschlagen',
    },
    exitsTitle: 'Austrittsgründe',
    exitReasons: {
      cart_not_converted: 'Warenkorb bestellt oder geleert: {{count}}',
      order_not_paid: 'Bezahlt oder storniert: {{count}}',
      not_reviewed: 'Bewertung geschrieben: {{count}}',
      no_order_since_enrollment: 'Bestellung aufgegeben: {{count}}',
      superseded: 'Warenkorb geändert, neue Aufnahme: {{count}}',
      expired: 'E-Mail konnte nicht innerhalb von 72 Stunden gesendet werden: {{count}}',
      flow_changed: 'Ablaufschritte geändert: {{count}}',
      disabled: 'Ablauf deaktiviert: {{count}}',
      quote_open: 'Angebot bestellt, abgelehnt, storniert, abgelaufen oder neue Version gesendet: {{count}}',
    },
    skipsTitle: 'Nicht gesendete E-Mails',
    skipReasons: {
      suppressed: 'Gesperrt: {{count}}',
      no_consent: 'Keine Marketing-Einwilligung: {{count}}',
      iys_not_registered: 'Einwilligung nicht an İYS gemeldet: {{count}}',
      iys_refused: 'In İYS abgelehnt: {{count}}',
      invalid_address: 'Ungültige Adresse: {{count}}',
      frequency_cap: 'Frequenzbegrenzung: {{count}}',
      template_unavailable: 'Vorlage nicht verfügbar: {{count}}',
      staging_allowlist: 'Nicht auf der Staging-Zulassungsliste: {{count}}',
      rejected: 'Vom Anbieter abgelehnt: {{count}}',
      error: 'Versandfehler: {{count}}',
    },
    skipOther: 'Sonstige: {{count}}',
    byStepTitle: 'Sendungen pro Schritt',
    colStep: 'Schritt',
    ordersTitle: 'Bestellungen aus diesem Ablauf',
    noOrders: 'Noch keine Bestellungen über die E-Mail-Links dieses Ablaufs.',
    ordersNote:
      'Shop-Links erhalten einen Kampagnencode des Ablaufs; eine Bestellung zählt, wenn dieser Link der letzte Kontaktpunkt war (mit Cookie-Einwilligung).',
    updated: 'Letzte Änderung: {{date}}',
  },
  productAlerts: {
    lead: 'Kunden können bei nicht vorrätigen Artikeln über „Benachrichtigen“ eine E-Mail-Adresse hinterlassen und erhalten eine einmalige Benachrichtigung, sobald der Artikel wieder verfügbar ist. Sinkt der Preis eines Favoriten ausreichend, können Kunden mit Marketing-Einwilligung eine E-Mail erhalten. Beides ist standardmäßig deaktiviert.',
    settingsTitle: 'Einstellungen',
    settingsLead:
      'Der E-Mail-Versand muss eingerichtet sein. Das Storefront-Formular wird nur angezeigt, wenn der Datenschutzhinweis veröffentlicht ist.',
    stockToggle: '„Benachrichtigen“ in der Storefront',
    stockToggleLead:
      'Wartende werden in der Reihenfolge ihrer Anfrage benachrichtigt, sobald wieder Bestand vorhanden ist (das 3-Fache des Bestands, mindestens 5 pro Runde, alle 5 Minuten). Eine einmalige, angeforderte Benachrichtigung; keine Marketing-Einwilligung erforderlich.',
    priceDropToggle: 'Preissenkungs-Benachrichtigungen für Favoriten',
    priceDropLead:
      'Tägliche Prüfung um 10:05 Uhr. Wird gesendet, wenn der Preis um den gewählten Anteil unter dem niedrigsten Preis seit dem Hinzufügen zu den Favoriten liegt. Eine Marketingnachricht: Einwilligung, Sperrliste, İYS und Frequenzbegrenzung gelten.',
    store: 'Shop',
    chooseStore: 'Shop auswählen',
    minPercent: 'Mindestsenkung',
    percentOption: '{{pct}} %',
    save: 'Speichern',
    saved: 'Einstellungen gespeichert.',
    enableConfirm:
      'Nach der Aktivierung gehen E-Mails automatisch an Personen, die die Bedingungen erfüllen; gesendete E-Mails können nicht zurückgerufen werden. Aktivieren?',
    requestsTitle: 'Benachrichtigungsanfragen',
    requestsLead:
      'Wartende und benachrichtigte Anfragen pro Variante. Anfragen gelten 6 Monate; geschlossene Datensätze werden nach 180 Tagen gelöscht.',
    emptyTitle: 'Noch keine Anfragen',
    emptyLead:
      'Bei nicht vorrätigen Artikeln hinterlassene E-Mail-Adressen erscheinen hier, solange „Benachrichtigen“ aktiv ist.',
    colProduct: 'Produkt',
    colWaiting: 'Wartend',
    colNotified: 'Benachrichtigt',
    colStock: 'Bestand',
    colOldest: 'Älteste Anfrage',
    colActions: 'Aktionen',
    inStock: 'Vorrätig ({{count}})',
    outOfStock: 'Nicht vorrätig',
    view: 'Anfragen',
    viewFor: 'Anfragen für {{product}}',
    priceDropLast30:
      'Preissenkungs-E-Mails in den letzten 30 Tagen: {{sent}} gesendet, {{skipped}} nicht gesendet.',
    statusFilter: 'Status',
    statuses: {
      waiting: 'Wartend',
      notified: 'Benachrichtigt',
      cancelled: 'Geschlossen',
    },
    noRequests: 'Keine Anfragen mit diesem Status.',
    member: 'Mitglied',
    requestedAt: 'Angefragt: {{date}}',
    notifiedAt: 'Benachrichtigt: {{date}}',
    reasons: {
      panel: 'In der Verwaltung storniert',
      expired: 'Abgelaufen (6 Monate)',
      suppressed: 'Adresse gesperrt',
      staging_allowlist: 'Nicht auf der Staging-Zulassungsliste',
      rejected: 'Vom Anbieter abgelehnt',
    },
    cancel: 'Stornieren',
    cancelConfirm: 'Die Anfrage wird geschlossen und es wird keine Benachrichtigung gesendet. Fortfahren?',
    cancelled: 'Anfrage storniert.',
  },
  messaging: {
    create: 'Neue SMS-/WhatsApp-Kampagne',
    lead: 'Senden Sie eine SMS oder eine von Meta genehmigte WhatsApp-Vorlage an Kunden in Segmenten. Jeder Empfänger wird beim Versand erneut auf Einwilligung, Sperrliste und İYS geprüft; Frequenzbegrenzung und Ruhezeiten gelten. Der Versand ist real und kostenpflichtig: Prüfen Sie zuerst die Zielgruppe und die geschätzten Kosten.',
    emptyTitle: 'Keine SMS-/WhatsApp-Kampagnen für diesen Shop',
    emptyLead:
      'Erstellen Sie zuerst eine SMS-Vorlage und dann mit „Neue SMS-/WhatsApp-Kampagne“ einen Entwurf.',
    listLabel: 'SMS- und WhatsApp-Kampagnen',
    colName: 'Kampagne',
    colChannel: 'Kanal',
    colStatus: 'Status',
    colSent: 'Gesendet',
    colDelivered: 'Zugestellt',
    colWhen: 'Datum',
    channels: {
      sms: 'SMS',
      whatsapp: 'WhatsApp',
    },
    statuses: {
      draft: 'Entwurf',
      scheduled: 'Geplant',
      sending: 'Wird gesendet',
      sent: 'Gesendet',
      paused: 'Pausiert',
      cancelled: 'Gestoppt',
    },
    recipientStatuses: {
      pending: 'in Warteschlange',
      sending: 'wird gesendet',
      sent: 'gesendet',
      delivered: 'zugestellt',
      failed: 'fehlgeschlagen',
      skipped: 'übersprungen',
      cancelled: 'storniert',
    },
    setupTitle: 'Einrichtungsstatus',
    setupLead:
      'Gewerbliche SMS erfordern einen verbundenen SMS-Anbieter, eine MERSİS-Nummer und einen Abmeldetext; WhatsApp erfordert eine WhatsApp-Business-Verbindung. Ein Kanal, bei dem etwas fehlt, zeigt „Einrichtung erforderlich“ und kann nicht senden.',
    connectedVia: '{{provider}} verbunden',
    connected: 'Verbunden',
    webhookUrl: 'Meta-Webhook-Adresse:',
    smsSetupLink:
      'Verbinden Sie Netgsm, İleti Merkezi oder Verimor unter Integrationen und wählen Sie den Anbieter dann unten aus',
    whatsappSetupLink: 'Verbinden Sie WhatsApp Business unter Integrationen',
    mersis: 'MERSİS-Nummer',
    missing: 'Fehlt',
    mersisLink: 'In den Unternehmensdaten eingeben',
    optOut: 'Abmeldetext',
    settingsTitle: 'Einstellungen',
    settingsLead:
      'SMS-Anbieter, Abmeldetext für gewerbliche SMS, geschätzte Stückkosten, Frequenzbegrenzung und Staging-Testnummern. Die Ruhezeiten werden mit den Automatisierungen geteilt.',
    smsProvider: 'SMS-Anbieter',
    smsProviderLead: 'Nur unter Integrationen verbundene und getestete Anbieter können ausgewählt werden.',
    noProvider: 'Nicht ausgewählt',
    providerNotConnected: '{{provider}} (Einrichtung erforderlich)',
    optOutLead:
      'Wird zusammen mit der MERSİS-Nummer am Ende gewerblicher SMS angefügt (max. 80 Zeichen). Der Verzicht auf türkische Sonderzeichen hält die SMS kürzer.',
    smsUnitCost: 'Kosten pro SMS-Teil (TRY)',
    whatsappUnitCost: 'Kosten pro WhatsApp-Nachricht (TRY)',
    costInvalid: 'Betrag konnte nicht gelesen werden; z. B. 0,25',
    frequencyCap: 'Frequenzbegrenzung',
    frequencyCapLead:
      'Eine Telefonnummer erhält innerhalb dieses Zeitraums höchstens eine SMS-/WhatsApp-Kampagnennachricht.',
    capNone: 'Keine Begrenzung',
    capHours: 'Höchstens eine Nachricht pro {{count}} Stunden',
    stagingPhones: 'Staging-Testnummern',
    stagingPhonesLead:
      'Auf dem Staging-Server erhalten nur diese Nummern Nachrichten (eine pro Zeile, max. 10). Im Live-Betrieb nicht verwendet.',
    saveSettings: 'Einstellungen speichern',
    settingsSaved: 'Einstellungen gespeichert.',
    saved: 'Kampagne gespeichert.',
    deleted: 'Kampagne gelöscht.',
    cancelled: 'Versand gestoppt.',
    resumed: 'Versand wird fortgesetzt.',
    save: 'Speichern',
    createConfirm: 'Entwurf erstellen',
    back: 'SMS- und WhatsApp-Kampagnen',
    unsaved: 'Ungespeicherte Änderungen',
    channelSetup: '{{channel}}: Einrichtung erforderlich',
    editor: 'Kampagnen-Editor',
    content: 'Inhalt',
    channel: 'Kanal',
    name: 'Kampagnenname',
    nameLead: 'Nur in der Verwaltung sichtbar.',
    smsTemplate: 'SMS-Vorlage',
    chooseTemplate: 'Vorlage auswählen',
    openTemplate: 'Vorlage öffnen',
    noTemplates: 'Noch keine SMS-Vorlagen.',
    audience: 'Zielgruppe',
    audienceLead:
      'Kunden in den ausgewählten Segmenten; jede Telefonnummer erhält nur eine Nachricht. Privatpersonen benötigen eine Einwilligung und eine İYS-Bestätigung; bei Gewerbetreibenden (Mitglieder einer Händlerfirma) genügt für SMS, dass kein Widerspruch in İYS vorliegt. WhatsApp erfordert von allen eine ausdrückliche Einwilligung.',
    estimate: 'Empfänger und Kosten berechnen',
    dangerZone: 'Löschen',
    deleteConfirm: 'Kampagne „{{name}}“ löschen?',
    updated: 'Letzte Änderung: {{date}}',
    whatsappNotConnected:
      'WhatsApp Business ist nicht verbunden (Einrichtung erforderlich): Die Liste der genehmigten Vorlagen ist nicht verfügbar. Sie können einen Entwurf erstellen, indem Sie Vorlagenname und Sprache wie in Meta eingeben; für den Versand ist die Verbindung erforderlich.',
    whatsappTemplate: 'WhatsApp-Vorlage',
    whatsappOption: '{{name}} ({{language}}) · {{status}}',
    waStatuses: {
      APPROVED: 'genehmigt',
      PENDING: 'in Prüfung bei Meta',
      REJECTED: 'abgelehnt',
      PAUSED: 'pausiert',
      DISABLED: 'deaktiviert',
      OTHER: 'nicht verfügbar',
    },
    whatsappName: 'Vorlagenname',
    whatsappNameLead: 'Vorlagenname in Meta (z. B. campaign_announcement).',
    whatsappLanguage: 'Sprachcode',
    whatsappParams: 'Vorlagenvariablen',
    noParams: 'Diese Vorlage hat keine Variablen.',
    paramLabel: 'Variable {{n}}',
    addParam: 'Variable hinzufügen',
    paramsLead:
      'Werden der Reihe nach für {{1}}, {{2}}… in der Vorlage eingesetzt. Für einen persönlichen Wert schreiben Sie {{firstName}}, {{name}} oder {{storeName}}.',
    estimateResult: '{{eligible}} von {{total}} Personen können angeschrieben werden.',
    skipReasons: {
      no_phone: 'Keine Telefonnummer: {{count}}',
      not_mobile: 'Keine türkische Mobilnummer: {{count}}',
      suppressed: 'Auf der Sperrliste: {{count}}',
      no_consent: 'Keine Einwilligung für diesen Kanal: {{count}}',
      iys_not_registered: 'Einwilligung nicht an İYS gemeldet: {{count}}',
      iys_refused: 'In İYS abgelehnt: {{count}}',
      duplicate_phone: 'Gleiche Nummer bei mehreren Kunden (einmal gesendet): {{count}}',
      frequency_cap: 'Frequenzbegrenzung (kürzlich eine andere Nachricht erhalten): {{count}}',
      staging_allowlist: 'Keine Staging-Testnummer (nicht gesendet): {{count}}',
      invalid_address: 'Ungültige Nummer: {{count}}',
    },
    partsPerMessage: '{{count}} SMS-Teil(e) pro Person',
    costEstimate: 'Geschätzte Kosten: {{cost}}',
    costUnknown: 'Geben Sie für eine Kostenschätzung die Stückkosten in den Einstellungen ein.',
    estimateNote:
      'Eine Schätzung: Einwilligung und Sperrliste werden beim Versand erneut geprüft; die SMS-Länge kann je nach Name variieren.',
    send: 'Senden…',
    templateNotApproved:
      'Die Vorlage wartet auf die Expertenfreigabe; vor der Freigabe kann sie nicht gesendet werden.',
    sendTitle: '{{channel}}-Kampagne senden',
    sendLead:
      'Kostenpflichtige Nachrichten gehen an echte Personen und können nicht rückgängig gemacht werden. Prüfen Sie Empfängerzahl und geschätzte Kosten; für den Versand ist eine Zwei-Faktor-Authentifizierung erforderlich.',
    scheduleConfirm: 'Planen',
    sendConfirm: 'An {{count}} Personen senden',
    sendSetupWarning:
      'Dieser Kanal ist nicht eingerichtet (Einrichtung erforderlich); der Versand wird abgelehnt.',
    scheduledToast: 'Kampagne geplant.',
    queuedToast: 'Kampagne zum Versand eingereiht.',
    statusTitle: 'Versandstatus',
    statusLabel: 'Status',
    progressLabel: 'Versandfortschritt',
    progress:
      '{{done}} / {{total}} verarbeitet: {{sent}} gesendet, {{delivered}} zugestellt, {{skipped}} übersprungen, {{failed}} fehlgeschlagen.',
    pauseReasons: {
      sms_template_required:
        'Pausiert: Die SMS-Vorlage wurde gelöscht. Stoppen Sie die Kampagne und erstellen Sie eine neue.',
      template_review_required:
        'Pausiert: Die Vorlage wurde geändert und wartet auf die Expertenfreigabe. Setzen Sie nach der Freigabe fort.',
      sms_footer_missing:
        'Pausiert: MERSİS-Nummer oder Abmeldetext fehlt. Ergänzen Sie die Angaben und setzen Sie fort.',
      sms_not_configured:
        'Pausiert: Kein SMS-Anbieter verbunden oder ausgewählt. Verbinden Sie ihn unter Integrationen und setzen Sie fort.',
      whatsapp_not_configured:
        'Pausiert: Keine WhatsApp-Business-Verbindung. Verbinden Sie sie unter Integrationen und setzen Sie fort.',
      provider_invalid_settings: 'Pausiert: Anbietereinstellungen fehlen oder sind falsch.',
      provider_auth_failed:
        'Pausiert: Der Anbieter hat die Zugangsdaten abgelehnt. Erneuern Sie sie unter Integrationen.',
      provider_sender_invalid: 'Pausiert: Der SMS-Absendername ist beim Anbieter nicht genehmigt.',
      provider_iys_not_configured: 'Pausiert: Im Anbieterkonto ist kein İYS-Markencode hinterlegt.',
      provider_insufficient_balance:
        'Pausiert: Nicht genügend Guthaben im Anbieterkonto. Laden Sie es auf und setzen Sie fort.',
      provider_template_invalid:
        'Pausiert: Die WhatsApp-Vorlage ist in Meta ungültig oder ihre Parameter stimmen nicht überein.',
    },
    pauseReasonOther: 'Pausiert ({{code}}).',
    resume: 'Fortsetzen',
    cancelConfirm: 'Versand stoppen? Empfänger, an die noch nicht gesendet wurde, erhalten keine Nachricht.',
    cancel: 'Stoppen',
    reportTitle: 'Bericht',
    reportLead:
      'Der SMS-Zustellstatus wird alle 10 Minuten vom Anbieter abgerufen; der WhatsApp-Zustellstatus kommt über Meta-Benachrichtigungen.',
    purged:
      'Empfängerdatensätze wurden nach Ablauf der Aufbewahrungsfrist (180 Tage) gelöscht; die Summen bleiben erhalten.',
    stats: {
      recipients: 'Empfänger',
      sent: 'Gesendet',
      delivered: 'Zugestellt',
      failed: 'Fehlgeschlagen',
      skipped: 'Übersprungen',
      parts: 'SMS-Teile',
      cost: 'Geschätzte Kosten',
    },
    skippedTitle: 'Übersprungen',
    errorsTitle: 'Fehlgeschlagen',
    sendErrors: {
      whatsapp_opted_out: 'Person hat WhatsApp-Marketingnachrichten deaktiviert: {{count}}',
      interrupted: 'Versand unterbrochen (nicht erneut gesendet): {{count}}',
      undelivered: 'Netzbetreiber konnte nicht zustellen: {{count}}',
      whatsapp_failed: 'WhatsApp konnte nicht zustellen: {{count}}',
      error: 'Versandfehler: {{count}}',
    },
    providerError: 'Anbieter-Fehlercode {{code}}: {{count}}',
    reportNote:
      'Die Kosten sind eine Schätzung auf Basis der Stückkosten in den Einstellungen; der genaue Betrag steht auf der Rechnung des Anbieters.',
  },
  smsTemplates: {
    create: 'Neue SMS-Vorlage',
    lead: 'SMS-Texte für Kampagnen. MERSİS-Nummer und Abmeldetext werden beim Versand angehängt, und die Länge wird inklusive dieser Angaben berechnet. Texte mit gesundheitsbezogenen Aussagen werden ohne Freigabe durch die tierärztliche Fachprüfung nicht gesendet.',
    emptyTitle: 'Noch keine SMS-Vorlagen',
    emptyLead: 'Beginnen Sie mit einem kurzen, klaren Text; persönliche Felder können hinzugefügt werden.',
    listLabel: 'SMS-Vorlagen',
    colName: 'Vorlage',
    colReview: 'Expertenfreigabe',
    colUpdated: 'Letzte Änderung',
    noReview: 'Nicht erforderlich',
    saved: 'Vorlage gespeichert.',
    deleted: 'Vorlage gelöscht.',
    save: 'Speichern',
    createConfirm: 'Vorlage erstellen',
    back: 'SMS-Vorlagen',
    unsaved: 'Ungespeicherte Änderungen',
    editor: 'SMS-Vorlagen-Editor',
    name: 'Vorlagenname',
    nameLead: 'Nur in der Verwaltung sichtbar.',
    body: 'Text',
    bodyLead:
      'Max. 900 Zeichen. MERSİS-Nummer und Abmeldetext werden automatisch angehängt; geben Sie sie hier nicht ein.',
    insertField: 'Feld einfügen:',
    fields: {
      firstName: 'Vorname',
      name: 'Vollständiger Name',
      storeName: 'Shopname',
    },
    preview: 'Vorschau',
    previewEmpty: 'Während Sie tippen, erscheint hier der zu sendende Text.',
    encoding: 'Zeichensatz',
    encodings: {
      gsm7: 'Standard (ohne türkische Zeichen)',
      turkish: 'Mit türkischen Zeichen',
      unicode: 'Unicode (Emojis oder Sonderzeichen)',
    },
    length: 'Zeichen',
    parts: 'Teile',
    multiPart: 'Der Text umfasst {{count}} SMS-Teile; jeder Teil wird berechnet.',
    unicodeWarning:
      'Emojis oder Sonderzeichen: Ein SMS-Teil sinkt auf 65 Zeichen, und die Kosten steigen. Entfernen Sie sie nach Möglichkeit.',
    tooLong: 'Der Text überschreitet 7 SMS-Teile; Anbieter können ihn nicht senden. Kürzen Sie ihn.',
    footerMissing:
      'Die Fußzeile für kommerzielle SMS ist unvollständig; Kampagnen können nicht gesendet werden:',
    footerParts: {
      mersis: 'MERSİS-Nummer (Unternehmensdaten)',
      optOut: 'Abmeldetext (SMS- und WhatsApp-Einstellungen)',
    },
    findingsNote:
      'Der Text enthält {{count}} mögliche gesundheitsbezogene Aussage(n): Nach dem Speichern ist eine Expertenfreigabe erforderlich. Aussagen zur Vorbeugung oder Behandlung von Krankheiten werden nicht verwendet.',
    previewNote:
      'Beispielperson: Ayşe Yılmaz. Die Länge ist eine Schätzung; der Betreibercode wird vom Anbieter hinzugefügt.',
    dangerZone: 'Löschen',
    deleteConfirm: 'Vorlage „{{name}}“ löschen?',
    updated: 'Letzte Änderung: {{date}}',
  },
  push: {
    create: 'Neue Benachrichtigungskampagne',
    lead: 'Senden Sie eine kurze Benachrichtigung an die Browser von Besuchern, die Benachrichtigungen im Storefront erlaubt haben. Besucher abonnieren nur, indem sie selbst auf die Schaltfläche klicken und die Browserberechtigung erteilen, und können dies jederzeit deaktivieren. Der Versand erreicht echte Personen; prüfen Sie zuerst die Zielgruppe.',
    emptyTitle: 'Keine Benachrichtigungskampagnen für diesen Shop',
    emptyLead:
      'Schließen Sie die Einrichtung ab und erstellen Sie dann mit „Neue Benachrichtigungskampagne“ einen Entwurf.',
    listLabel: 'Benachrichtigungskampagnen',
    colName: 'Kampagne',
    colStatus: 'Status',
    colSent: 'Gesendet',
    colWhen: 'Datum',
    subscriberCount: '{{count}} Browser haben Benachrichtigungen für diesen Shop aktiviert.',
    statuses: {
      draft: 'Entwurf',
      scheduled: 'Geplant',
      sending: 'Wird gesendet',
      sent: 'Gesendet',
      paused: 'Pausiert',
      cancelled: 'Gestoppt',
    },
    setupTitle: 'Einrichtung',
    setupLead:
      'Die Storefront-Schaltfläche benötigt einen Schlüssel, eine Kontaktadresse und einen veröffentlichten KVKK-Datenschutzhinweis. Benachrichtigungen der Android-Admin-App benötigen eine Firebase-Verbindung.',
    vapidKey: 'Benachrichtigungsschlüssel (VAPID)',
    keyReady: 'Bereit ({{date}})',
    createKey: 'Schlüssel erstellen',
    replaceKey: 'Schlüssel ersetzen',
    replaceConfirm:
      'Das Ersetzen des Schlüssels macht alle Browser-Abonnements ungültig; Besucher müssen Benachrichtigungen erneut aktivieren. Fortfahren?',
    keyCreated: 'Schlüssel erstellt.',
    privacyNotice: 'KVKK-Datenschutzhinweis',
    published: 'Veröffentlicht',
    missing: 'Fehlt',
    privacyLink: 'Unter Rechtstexte veröffentlichen',
    android: 'Android-App (Firebase)',
    connected: 'Verbunden',
    firebaseLink: 'Firebase unter Integrationen verbinden',
    settingsTitle: 'Storefront-Einstellungen',
    contact: 'Kontaktadresse',
    contactLead:
      'Push-Dienste (Google, Mozilla, Apple) nutzen diese Adresse bei Problemen. Geben Sie mailto: mit einer E-Mail-Adresse oder https: mit einer Website-Adresse ein.',
    enabled: 'Schaltfläche „Benachrichtigungen aktivieren“ im Storefront anzeigen',
    saveSettings: 'Speichern',
    settingsSaved: 'Einstellungen gespeichert.',
    saved: 'Kampagne gespeichert.',
    deleted: 'Kampagne gelöscht.',
    cancelled: 'Versand gestoppt.',
    resumed: 'Versand wird fortgesetzt.',
    save: 'Speichern',
    createConfirm: 'Entwurf erstellen',
    back: 'Push-Benachrichtigungen',
    unsaved: 'Ungespeicherte Änderungen',
    notReady:
      'Einrichtung erforderlich: Storefront-Benachrichtigungen sind deaktiviert oder es gibt keinen Schlüssel',
    editor: 'Benachrichtigungs-Editor',
    name: 'Kampagnenname',
    nameLead: 'Nur in der Verwaltung sichtbar.',
    title: 'Titel',
    body: 'Text',
    counter: '{{n}} / {{max}} Zeichen',
    url: 'Zu öffnende Seite',
    urlLead:
      'Ein Pfad im Shop (z. B. /kategori/kedi). Öffnet sich beim Klick auf die Benachrichtigung; für den Quellenbericht wird UTM hinzugefügt.',
    audience: 'Zielgruppe',
    audienceLead:
      'Ohne Segmente geht die Nachricht an alle Abonnenten des Shops. Mit Segmenten geht sie nur an die Browser von Mitgliedern in diesen Segmenten (die beim Abonnieren angemeldet waren).',
    estimate: 'Browser zählen',
    estimateResult: '{{eligible}} von {{total}} Abonnements erhalten sie.',
    anonymousExcluded: '{{count}} ohne Anmeldung abonnierte Browser gehören zu keiner Segment-Zielgruppe.',
    estimateNote: 'Eine Schätzung: Abgelaufene Abonnements fallen beim Versand weg.',
    preview: 'Vorschau',
    previewTitle: 'Titel',
    previewBody: 'Benachrichtigungstext',
    previewNote: 'Das Aussehen hängt von Browser und Betriebssystem ab; langer Text kann gekürzt werden.',
    findingsNote:
      'Der Text enthält {{count}} mögliche gesundheitsbezogene Aussage(n): Nach dem Speichern ist eine Expertenfreigabe erforderlich. Aussagen zur Vorbeugung oder Behandlung von Krankheiten werden nicht verwendet.',
    send: 'Senden…',
    reviewRequired:
      'Der Text wartet auf die Expertenfreigabe; vor der Freigabe kann er nicht gesendet werden.',
    sendTitle: 'Benachrichtigungskampagne senden',
    sendLead:
      'Die Benachrichtigung geht an die Browser echter Personen und kann nicht rückgängig gemacht werden. Für den Versand ist eine Zwei-Faktor-Authentifizierung erforderlich.',
    sendConfirm: 'An {{count}} Browser senden',
    scheduleConfirm: 'Planen',
    sendSetupWarning:
      'Storefront-Benachrichtigungen sind nicht eingerichtet (Einrichtung erforderlich); der Versand wird abgelehnt.',
    scheduledToast: 'Kampagne geplant.',
    queuedToast: 'Kampagne zum Versand eingereiht.',
    statusTitle: 'Versandstatus',
    statusLabel: 'Status',
    progressLabel: 'Versandfortschritt',
    progress:
      '{{done}} / {{total}} verarbeitet: {{sent}} gesendet, {{expired}} Abonnements abgelaufen, {{failed}} fehlgeschlagen.',
    pauseReasons: {
      template_review_required: 'Pausiert: Der Text wartet auf die Expertenfreigabe.',
      web_push_not_configured:
        'Pausiert: Storefront-Benachrichtigungen wurden deaktiviert oder der Schlüssel wurde entfernt.',
      push_auth_failed:
        'Pausiert: Der Push-Dienst hat den Schlüssel abgelehnt. Prüfen Sie die Kontaktadresse; möglicherweise muss der Schlüssel ersetzt werden.',
    },
    pauseReasonOther: 'Pausiert ({{code}}).',
    resume: 'Fortsetzen',
    cancelConfirm:
      'Versand stoppen? Browser, an die noch nicht gesendet wurde, erhalten keine Benachrichtigung.',
    cancel: 'Stoppen',
    reportTitle: 'Bericht',
    reportLead:
      'Ob die Benachrichtigung angezeigt wurde, wird nicht gemessen; gezählt werden nur vom Dienst angenommene Sendungen.',
    purged:
      'Empfängerdatensätze wurden nach Ablauf der Aufbewahrungsfrist (180 Tage) gelöscht; die Summen bleiben erhalten.',
    stats: {
      recipients: 'Empfänger',
      sent: 'Gesendet',
      expired: 'Abgelaufene Abonnements',
      failed: 'Fehlgeschlagen',
      skipped: 'Übersprungen',
    },
    errorsTitle: 'Gründe',
    sendErrors: {
      push_404: 'Abonnement nicht gefunden (entfernt): {{count}}',
      push_410: 'Abonnement abgelaufen (entfernt): {{count}}',
      push_403: 'Abonnement mit einem anderen Schlüssel erstellt (entfernt): {{count}}',
      push_too_large: 'Benachrichtigung zu groß: {{count}}',
      push_unavailable: 'Push-Dienst nach mehreren Versuchen nicht erreichbar: {{count}}',
      interrupted: 'Versand unterbrochen (nicht erneut gesendet): {{count}}',
    },
    serviceError: 'Antwort des Push-Dienstes {{code}}: {{count}}',
    ordersNote:
      'Bestellungen von Besuchern, die über den Benachrichtigungslink kamen und der Cookie-Nutzung zugestimmt haben (Last Touch).',
    dangerZone: 'Löschen',
    deleteConfirm: 'Kampagne „{{name}}“ löschen?',
    updated: 'Letzte Änderung: {{date}}',
  },
  notifications: {
    title: 'Mobile Benachrichtigungen (Android)',
    lead: 'Benachrichtigungen in der Android-Admin-App zu Ereignissen wie neuen Bestellungen und Rücksendeanfragen. Nur Ereignisse, für die Sie eine Berechtigung haben; Benachrichtigungen enthalten keine personenbezogenen Daten.',
    firebaseMissing:
      'Firebase ist für das Unternehmen nicht verbunden; bis dahin werden keine Benachrichtigungen gesendet (Integrationen → Firebase).',
    devices: 'Meine Geräte',
    noDevices:
      'Für dieses Konto sind keine Geräte registriert. Das Gerät erscheint hier, nachdem Sie Benachrichtigungen in der Android-Admin-App aktiviert haben.',
    unnamed: 'Unbenanntes Gerät',
    deviceLine: 'App-Version {{version}} · zuletzt gesehen {{seen}}',
    remove: 'Entfernen',
    removeConfirm: 'Dieses Gerät entfernen? Es kann sich beim erneuten Öffnen der App wieder registrieren.',
    removed: 'Gerät entfernt.',
    events: 'Ereignisse, über die ich benachrichtigt werde',
    eventNames: {
      order_created: 'Neue Bestellung',
      payment_review_required: 'Zahlung muss geprüft werden',
      return_requested: 'Neue Rücksendeanfrage',
      dealer_applied: 'Neue Händlerbewerbung',
      form_submitted: 'Neue Kontaktnachricht',
      dealer_balance_paid: 'Händlerzahlung eingegangen',
    },
    noPermission: '(keine Berechtigung)',
    quietHours: 'Ruhezeiten (in diesem Zeitraum keine Benachrichtigungen)',
    save: 'Einstellungen speichern',
    saved: 'Benachrichtigungseinstellungen gespeichert.',
    test: 'Testbenachrichtigung senden',
    testSent: 'Testbenachrichtigung an {{count}} Geräte gesendet.',
  },
  promotions: {
    create: 'Neue Aktion',
    lead: 'Rabatte ohne Gutscheincode: Produkt-/Kategorie-/Markenrabatt, Staffeln nach Warenkorbwert oder Stückzahl, Kaufe X, zahle Y, kostenloser Versand. Der Rabatt wird im Warenkorb angewendet; an Produkten wird kein durchgestrichener Preis angezeigt. Ein Produkt, dessen Preis in den 10 Tagen vor der Aktion erhöht wurde, erhält keinen Rabatt.',
    emptyTitle: 'Noch keine automatischen Aktionen',
    emptyLead:
      'Erstellen Sie mit „Neue Aktion“ einen Entwurf; Kunden sehen nichts, bis Sie ihn live schalten.',
    listLabel: 'Automatische Aktionen',
    colName: 'Aktion',
    colKind: 'Typ',
    colStatus: 'Status',
    colUsage: 'Nutzung',
    colDates: 'Zeitraum',
    kinds: {
      item_discount: 'Produktrabatt (Prozent)',
      cart_tiers: 'Warenkorbstaffeln',
      buy_x_pay_y: 'Kaufe X, zahle Y',
      free_shipping: 'Kostenloser Versand',
    },
    kindLeads: {
      item_discount:
        'Ein Prozentrabatt auf ausgewählte (oder alle) Produkte im Warenkorb. Auf ein Produkt wird höchstens ein Produktrabatt angewendet.',
      cart_tiers:
        'Ein Rabatt, sobald Warenkorbwert oder Artikelanzahl einen Schwellenwert überschreitet; es gilt die höchste zutreffende Staffel. Maßgeblich ist der Betrag nach Produktrabatten.',
      buy_x_pay_y:
        'Bei je X Artikeln sind die (X − Y) günstigsten kostenlos. Ausgewählte Produkte können kombiniert werden.',
      free_shipping:
        'Keine Versandkosten oberhalb des Schwellenwerts (die Nachnahmegebühr fällt weiterhin an). Maßgeblich ist der rabattierte Betrag.',
    },
    phases: {
      draft: 'Entwurf',
      scheduled: 'Wartet auf Start',
      running: 'Live',
      paused: 'Pausiert',
      ended: 'Beendet',
    },
    usageShort: '{{orders}} Bestellungen · {{discount}}',
    noDates: 'Unbefristet',
    saved: 'Aktion gespeichert.',
    activated: 'Aktion ist live.',
    paused: 'Aktion pausiert.',
    deleted: 'Entwurf gelöscht.',
    save: 'Speichern',
    createConfirm: 'Entwurf erstellen',
    activate: 'Live schalten',
    pause: 'Pausieren',
    back: 'Zurück zu automatischen Aktionen',
    unsaved: 'Ungespeicherte Änderungen',
    liveLocked: 'Eine Live-Aktion kann nicht geändert werden; pausieren Sie sie zuerst.',
    reviewRequired:
      'Der Aktionsname enthält möglicherweise eine gesundheitsbezogene Aussage: Ohne Freigabe durch die tierärztliche Fachprüfung kann die Aktion nicht live geschaltet werden.',
    editor: 'Aktionseinstellungen',
    name: 'Aktionsname',
    nameLead: 'Nur in der Verwaltung sichtbar.',
    label: 'Für Kunden sichtbarer Name',
    labelLead: 'Wird im Warenkorb, an der Kasse und auf Produktseiten angezeigt ({{n}}/{{max}}).',
    kind: 'Aktionstyp',
    percent: 'Rabatt in Prozent',
    buy: 'Kaufen (Stück)',
    pay: 'Zahlen (Stück)',
    minSubtotal: 'Mindestwarenkorbwert',
    minSubtotalLead: 'Leer lassen für kostenlosen Versand bei jeder Bestellung.',
    basis: 'Art des Schwellenwerts',
    bases: {
      subtotal: 'Warenkorbwert',
      quantity: 'Artikelanzahl',
    },
    tierType: 'Rabattart',
    tiers: 'Staffeln',
    tierMinAmount: 'Mindestbetrag',
    tierMinQty: 'Mindestanzahl Artikel',
    removeTier: 'Staffel {{n}} entfernen',
    addTier: 'Staffel hinzufügen',
    currency: 'Währung',
    targets: 'Zielprodukte',
    targetsLead:
      'Wenn nichts ausgewählt ist, gelten alle Produkte. Ein Produkt, das zu einer beliebigen Auswahl passt, ist enthalten; Unterkategorien sind eingeschlossen.',
    categories: 'Kategorien',
    brands: 'Marken',
    collections: 'Kollektionen',
    noCollections: 'Keine Kollektionen.',
    products: 'Produkte',
    audienceTitle: 'Zielgruppe',
    audience: 'Für wen',
    audiences: {
      all: 'Alle',
      retail: 'Nur Endkunden',
      dealers: 'Nur Händler',
    },
    groups: 'Kundengruppen (optional)',
    segments: 'Segmente (optional; nur angemeldete Mitglieder)',
    noSegments: 'Keine Segmente.',
    rulesTitle: 'Priorität, Kombinierbarkeit und Zeitraum',
    priority: 'Priorität',
    stacking: 'Kombinierbarkeit',
    stackings: {
      combinable: 'Mit anderen Aktionen kombinierbar',
      exclusive: 'Exklusiv (keine andere Aktion gilt)',
    },
    allowCoupon: 'Mit Gutscheincode kombinierbar',
    startsAt: 'Beginn',
    endsAt: 'Ende',
    preview: 'Was Kunden sehen',
    previewLabel: 'Für Kunden sichtbarer Name',
    previewNote:
      'Produktseiten zeigen Name, Bedingung und Enddatum; es wird kein durchgestrichener Preis angezeigt.',
    excludedTitle: 'Produkte ohne Rabatt (Preiserhöhung)',
    excludedLead:
      'Produkte, deren Preis innerhalb von {{days}} Tagen vor Beginn der Aktion oder währenddessen erhöht wurde, erhalten keinen Rabatt aus dieser Aktion und zeigen sie nicht auf ihrer Seite an (Regel für Rabattverkäufe). Bei einem Entwurf wird so gerechnet, als würde er jetzt live geschaltet.',
    excludedNone: 'Keine Preiserhöhungen; alle Zielprodukte sind enthalten.',
    excludedCount: '{{count}} Produktvarianten sind von der Aktion ausgeschlossen.',
    colProduct: 'Produkt',
    colPriceList: 'Preisliste',
    colCurrent: 'Aktueller Preis',
    colLowest: 'Niedrigster Preis im Zeitraum',
    usageTitle: 'Nutzung',
    usageNone: 'Noch keine Bestellungen mit dieser Aktion.',
    usageLine: '{{orders}} Bestellungen · Rabatt gesamt {{discount}} · Bestellsumme {{revenue}}',
    dangerZone: 'Entwurf löschen',
    deleteConfirm: 'Entwurf „{{name}}“ löschen?',
    updated: 'Zuletzt geändert: {{date}}',
  },
  giftCards: {
    lead: 'Eine Geschenkkarte ist eine Vorauszahlung, die durch Eingabe ihres Codes an der Kasse eingelöst wird. Der Code wird nur einmal bei der Erstellung angezeigt; gespeichert werden nur die letzten vier Zeichen. Bei einer teilweise genutzten Karte bleibt das Restguthaben für später erhalten.',
    create: 'Geschenkkarte erstellen',
    search: 'Letzte vier Zeichen',
    searchPlaceholder: 'z. B. 7KQ2',
    searchInvalid: 'Geben Sie bis zu vier Buchstaben oder Ziffern ein.',
    stateFilter: 'Status',
    states: {
      active: 'Einlösbar',
      disabled: 'Deaktiviert',
      expired: 'Abgelaufen',
      empty: 'Kein Guthaben',
    },
    emptyTitle: 'Noch keine Geschenkkarten',
    emptyLead:
      'Wählen Sie über „Geschenkkarte erstellen“ einen Betrag und optional ein Ablaufdatum; den Code geben Sie selbst an den Kunden weiter.',
    noMatch: 'Keine Karten entsprechen diesen Filtern',
    listLabel: 'Geschenkkarten',
    colCard: 'Karte',
    colState: 'Status',
    colBalance: 'Guthaben',
    colExpires: 'Gültig bis',
    colCreated: 'Erstellt',
    cardTitle: 'Karte ···· {{last4}}',
    ofInitial: 'Anfangsbetrag {{amount}}',
    noExpiry: 'Unbefristet',
    createTitle: 'Geschenkkarte erstellen',
    createLead:
      'Der Code wird nur einmal angezeigt. Sie geben ihn an den Kunden weiter; es wird keine E-Mail gesendet.',
    createForCustomer:
      'Die Karte wird für {{name}} erfasst. Der Code wird nur einmal angezeigt; Sie geben ihn weiter.',
    createButton: 'Erstellen',
    amount: 'Betrag',
    amountInvalid: 'Geben Sie den Betrag wie 250 oder 250,50 ein.',
    currency: 'Währung',
    expiresAt: 'Ablaufdatum',
    expiresHint: 'Gültig bis zum Ende des gewählten Tages. Leer lassen für unbefristete Gültigkeit.',
    note: 'Interne Notiz',
    noteHint: 'Nur in der Verwaltung sichtbar (z. B. „Geburtstagsgeschenk“).',
    createdTitle: 'Geschenkkarte erstellt',
    createdLead: 'Der Code der Karte über {{amount}} steht unten.',
    code: 'Code',
    copy: 'Code kopieren',
    copied: 'Code kopiert',
    copyFailed: 'Kopieren fehlgeschlagen; markieren Sie den Code und kopieren Sie ihn manuell.',
    codeOnce:
      'Dieser Code wird nicht noch einmal angezeigt. Kopieren Sie ihn vor dem Schließen und geben Sie ihn sicher an den Kunden weiter. Falls er verloren geht, deaktivieren Sie die Karte und erstellen Sie eine neue.',
    openCard: 'Karte öffnen',
    savedCode: 'Ich habe den Code gespeichert',
    backToList: 'Geschenkkarten',
    summary: 'Karte',
    balance: 'Guthaben',
    initial: 'Anfangsbetrag',
    customer: 'Kunde',
    created: 'Erstellt',
    adjust: 'Guthaben anpassen',
    disable: 'Karte deaktivieren',
    enable: 'Karte wieder aktivieren',
    disableConfirm:
      'Die Karte wird deaktiviert, und ihr Guthaben kann nicht mehr eingelöst werden. In früheren Bestellungen verwendete Beträge sind nicht betroffen. Fortfahren?',
    enableConfirm: 'Die Karte wird wieder einlösbar. Fortfahren?',
    settings: 'Ablaufdatum und Notiz',
    history: 'Buchungen',
    noHistory: 'Keine Buchungen.',
    colDate: 'Datum',
    colKind: 'Art',
    colAmount: 'Betrag',
    colAfter: 'Guthaben danach',
    kinds: {
      issue: 'Erstellt',
      redeem: 'In Bestellung verwendet',
      release: 'Bestellung storniert, wiederhergestellt',
      refund: 'Erstattung, wiederhergestellt',
      adjust: 'Manuelle Anpassung',
    },
    adjustTitle: 'Guthaben der Karte ···· {{last4}} anpassen',
    adjustLead:
      'Aktuelles Guthaben {{balance}}. Die Anpassung und ihr Grund werden in den Buchungen und im Prüfprotokoll erfasst.',
    direction: 'Aktion',
    directionAdd: 'Guthaben hinzufügen',
    directionSubtract: 'Guthaben abziehen',
    adjustAmount: 'Betrag ({{currency}})',
    adjustNote: 'Grund',
    adjustNoteHint: 'Mindestens 3 Zeichen, z. B. „Korrektur einer fehlerhaften Aufladung“.',
    adjustAdd: 'Hinzufügen',
    adjustSubtract: 'Abziehen',
    adjusted: 'Guthaben aktualisiert',
  },
  storeCredit: {
    title: 'Shop-Guthaben',
    lead: 'Guthaben im Kundenkonto wird an der Kasse mit „Mein Shop-Guthaben verwenden“ eingelöst. Es stammt aus Erstattungen (mit Zustimmung des Kunden) oder wird manuell hinzugefügt.',
    adjust: 'Guthaben hinzufügen / abziehen',
    issueGiftCard: 'Geschenkkarte ausstellen',
    none: 'Kein Guthaben.',
    history: 'Guthabenbuchungen',
    giftCards: 'An diesen Kunden ausgestellte Geschenkkarten',
    kinds: {
      grant: 'Hinzugefügt',
      refund: 'Erstattung',
      redeem: 'In Bestellung verwendet',
      release: 'Bestellung storniert, wiederhergestellt',
      adjust: 'Abgezogen',
    },
    adjustTitle: 'Shop-Guthaben hinzufügen / abziehen',
    adjustLead:
      'Der Grund wird in den Buchungen und im Prüfprotokoll erfasst; der Kunde sieht in seinem Konto nur Betrag und Art.',
  },
  loyalty: {
    lead: 'Mitglieder sammeln Punkte für zugestellte Bestellungen und zahlen an der Kasse mit Punkten; sie erhalten eine VIP-Stufe basierend auf ihren Ausgaben der letzten 12 Monate (Stufenrabatt und kostenloser Versand). Solange das Programm deaktiviert ist, gilt nichts für Kunden; Punkte bleiben erhalten.',
    summary: 'Programmübersicht',
    on: 'An',
    off: 'Aus',
    members: 'Mitglieder mit Punkten',
    outstanding: 'Nicht eingelöste Punkte (Wert)',
    earned30: 'Gesammelt, letzte 30 Tage',
    redeemed30: 'Eingelöst, letzte 30 Tage',
    expired30: 'Verfallen, letzte 30 Tage',
    tierCounts: 'Mitglieder nach Stufe: {{list}}',
    settings: 'Programmeinstellungen',
    settingsLead:
      'Änderungen gelten sofort nach dem Speichern für Warenkörbe und Kasse. Bestehende Bestellungen ändern sich nicht.',
    enabled: 'Treueprogramm aktiv',
    currency: 'Währung',
    earn: 'Punkte pro 1 Einheit',
    value: 'Benötigte Punkte für 1 Einheit Rabatt',
    preview:
      'Kunden erhalten {{earn}} Punkte pro {{one}}; {{value}} Punkte = {{one}}. Rückvergütungsquote: {{percent}}.',
    previewNoEarn: 'Punktesammeln ist deaktiviert: Es gelten nur die Stufen.',
    minRedeem: 'Mindestpunktzahl zum Einlösen',
    holdDays: 'Wartezeit nach Zustellung (Tage)',
    expiryMonths: 'Gültigkeit der Punkte (Monate)',
    expiryHint: '0 = Punkte verfallen nie.',
    tiers: 'VIP-Stufen',
    tiersLead:
      'Die Stufe wird bei jeder Bestellung anhand der Nettoausgaben des Kunden in den letzten 12 Monaten (abzüglich Erstattungen) neu berechnet. Bis zu 5 Stufen.',
    tierName: 'Stufenname',
    tierSpend: 'Letzte 12 Monate mindestens ({{currency}})',
    tierDiscount: 'Rabatt (%)',
    tierShipping: 'Kostenloser Versand',
    tierAdd: 'Stufe hinzufügen',
    tierRemove: 'Stufe {{name}} entfernen',
    fixErrors: 'Nicht gespeichert: Korrigieren Sie die markierten Felder.',
    save: 'Speichern',
    saved: 'Treueprogramm gespeichert',
    enableConfirm:
      'Wenn das Programm aktiv ist, gelten Stufenrabatte sofort in den Warenkörben der Mitglieder, und zugestellte Bestellungen bringen Punkte. Kunden erhalten keine Nachrichten. Fortfahren?',
    customerTitle: 'Treueprogramm',
    adjust: 'Punkte hinzufügen / abziehen',
    points: '{{points}} Punkte',
    expiringSoon: '{{points}} Punkte verfallen innerhalb von 30 Tagen.',
    customerTier: 'Stufe: {{tier}}',
    customerNoTier: 'Keine Stufe',
    spend12: 'letzte 12 Monate {{amount}}',
    nextTier: 'Noch {{amount}} bis {{tier}}',
    history: 'Punkteverlauf',
    colDate: 'Datum',
    colKind: 'Art',
    colPoints: 'Punkte',
    colExpires: 'Verfällt am',
    kinds: {
      earn: 'Gesammelt',
      redeem: 'In Bestellung verwendet',
      release: 'Wiederhergestellt',
      reverse: 'Zurückgebucht (Erstattung)',
      expire: 'Verfallen',
      adjust: 'Manuelle Anpassung',
    },
    adjustTitle: 'Punkte hinzufügen / abziehen',
    adjustLead:
      'Aktueller Stand {{points}} Punkte. Der Grund wird im Verlauf und im Prüfprotokoll erfasst; der Kunde sieht ihn nicht.',
    direction: 'Aktion',
    directionAdd: 'Punkte hinzufügen',
    directionSubtract: 'Punkte abziehen',
    pointsField: 'Punkte',
    pointsInvalid: 'Geben Sie eine positive ganze Zahl ein.',
    adjustAdd: 'Hinzufügen',
    adjustSubtract: 'Abziehen',
    adjusted: 'Punkte aktualisiert',
  },
  referrals: {
    lead: 'Mitglieder erhalten ihren Einladungscode unter Mein Konto und teilen ihn mit Freunden. Freunde erhalten einen Rabatt auf ihre erste Bestellung; sobald die Bestellung zugestellt und die Wartezeit abgelaufen ist, erhält die empfehlende Person einen einmalig nutzbaren Belohnungs-Gutscheincode. Der Shop schreibt niemanden an. Solange das Programm deaktiviert ist, funktionieren Einladungscodes nicht.',
    summary: 'Programmübersicht',
    on: 'An',
    off: 'Aus',
    codes: 'Mitglieder mit Einladungscode',
    pending: 'Offene Einladungen',
    rewarded: 'Belohnte Einladungen',
    cancelled: 'Ohne Belohnung abgeschlossen',
    rewardCoupons: 'Belohnungs-Gutscheincodes (ausgegeben / eingelöst)',
    rewardCouponsValue: '{{issued}} / {{used}}',
    settings: 'Programmeinstellungen',
    settingsLead:
      'Beim Speichern werden alle Einladungscodes mit dem neuen Rabatt aktualisiert. Bereits ausgegebene Belohnungs-Gutscheincodes ändern sich nicht.',
    enabled: 'Empfehlungsprogramm aktiv',
    currency: 'Währung',
    friend: 'Rabatt für Freunde (erste Bestellung)',
    referrer: 'Belohnung für Empfehlende (Gutscheincode)',
    rewardType: 'Rabattart',
    typePercent: 'Prozentsatz',
    typeFixed: 'Fester Betrag ({{currency}})',
    valuePercent: 'Rabatt (%)',
    valueFixed: 'Rabattbetrag ({{currency}})',
    minSubtotal: 'Mindestwarenkorbwert ({{currency}})',
    minSubtotalHint: 'Leer lassen für keinen Mindestwert.',
    holdDays: 'Wartezeit nach Zustellung (Tage)',
    rewardValidDays: 'Gültigkeit des Belohnungs-Gutscheincodes (Tage)',
    maxRewards: 'Maximale Belohnungen pro Mitglied',
    fixErrors: 'Nicht gespeichert: Korrigieren Sie die markierten Felder.',
    save: 'Speichern',
    saved: 'Empfehlungsprogramm gespeichert',
    enableConfirm:
      'Sobald das Programm aktiv ist, können Mitglieder unter Mein Konto einen Einladungscode erhalten, und Einladungscodes wirken im Warenkorb als Rabatt. Kunden erhalten keine Benachrichtigungen. Fortfahren?',
    recent: 'Letzte Einladungen',
    recentLead:
      'Mit einem Einladungscode aufgegebene Bestellungen. Belohnungen werden nach Ablauf der Wartezeit vom stündlichen Job vergeben.',
    emptyTitle: 'Noch keine Bestellungen über Einladungen',
    emptyLead:
      'Sobald ein Freund mit einem Einladungscode seine erste Bestellung aufgibt, erscheint sie hier.',
    colDate: 'Datum',
    colReferrer: 'Empfehlende Person',
    colOrder: 'Bestellung',
    colStatus: 'Status',
    colReward: 'Belohnungs-Gutscheincode',
    statuses: {
      pending: 'Wartet auf Zustellung',
      rewarded: 'Belohnt',
      cancelled: 'Storniert / zurückgesendet',
      limit: 'Belohnungslimit erreicht',
    },
  },
  affiliates: {
    lead: 'Bestellungen von Affiliates und Influencern werden über den Gutscheincode oder den utm_source-Wert im Link zugeordnet. Die Link-Zuordnung funktioniert nur, wenn der Besucher Mess-Cookies erlaubt hat. Die Provision wird auf den Produktbetrag ohne MwSt. und Versand berechnet und 14 Tage nach Zustellung freigegeben. Die Auszahlung nehmen Sie selbst vor: CSV herunterladen, zahlen und dann als bezahlt markieren.',
    create: 'Affiliate hinzufügen',
    emptyTitle: 'Noch keine Affiliates',
    emptyLead:
      'Fügen Sie einen Affiliate hinzu, um ihm einen eigenen Gutscheincode oder eine Link-Quelle zuzuweisen.',
    listLabel: 'Affiliates',
    colName: 'Affiliate',
    colMatch: 'Zuordnung',
    colRate: 'Satz',
    colPending: 'Ausstehend',
    colApproved: 'Freigegeben',
    colPaid: 'Bezahlt',
    colActions: 'Aktionen',
    kinds: {
      affiliate: 'Affiliate',
      influencer: 'Influencer',
    },
    paused: 'Pausiert',
    coupon: 'Gutscheincode: {{code}}',
    edit: 'Bearbeiten',
    editNamed: '{{name}} bearbeiten',
    createTitle: 'Affiliate hinzufügen',
    editTitle: 'Affiliate bearbeiten',
    dialogLead:
      'Änderungen von Satz und Status gelten nur für künftige Bestellungen; erfasste Provisionen ändern sich nicht.',
    name: 'Name',
    kind: 'Typ',
    email: 'E-Mail',
    emailMasked: 'E-Mail ausgeblendet. Geben Sie zum Ändern eine neue ein.',
    source: 'Link-Quelle (utm_source)',
    sourceHint: 'An das Ende des Links anhängen: ?utm_source={{source}}',
    rate: 'Provisionssatz (%)',
    discount: 'Gutscheincode',
    noDiscount: 'Kein Gutscheincode (nur Link)',
    status: 'Status',
    statuses: {
      active: 'Aktiv',
      paused: 'Pausiert',
    },
    note: 'Interne Notiz',
    save: 'Speichern',
    created: 'Affiliate hinzugefügt',
    updated: 'Affiliate aktualisiert',
    commissions: 'Provisionen',
    commissionsLead:
      'Ausstehende Provisionen werden 14 Tage nach Zustellung freigegeben; bei Stornierung oder vollständiger Erstattung werden sie storniert, bei Teilerstattungen verringert sich die Bemessungsgrundlage.',
    filterAffiliate: 'Affiliate',
    filterStatus: 'Status',
    export: 'CSV herunterladen',
    markPaid: 'Als bezahlt markieren ({{count}})',
    selectAll: 'Alle freigegebenen Provisionen auswählen',
    selectOne: 'Provision für {{order}} auswählen',
    noCommissions: 'Keine Provisionen',
    noCommissionsLead: 'Zugeordnete Bestellungen erscheinen hier.',
    colOrder: 'Bestellung',
    colAffiliate: 'Affiliate',
    colBase: 'Bemessungsgrundlage',
    colCommission: 'Provision',
    colStatus: 'Status',
    sources: {
      coupon: 'Über Gutscheincode',
      link: 'Über Link',
    },
    commissionStatuses: {
      pending: 'Ausstehend',
      approved: 'Freigegeben',
      paid: 'Bezahlt',
      cancelled: 'Storniert',
    },
    markPaidTitle: 'Provisionen als bezahlt markieren',
    markPaidLead:
      '{{count}} Provisionen, insgesamt {{total}}. Markieren Sie sie nur, wenn Sie außerhalb des Systems bezahlt haben; dies kann nicht rückgängig gemacht werden und wird im Prüfprotokoll erfasst.',
    paidNote: 'Zahlungsvermerk',
    paidNoteHint: 'z. B. Belegnummer und Zahlungsdatum.',
    markPaidConfirm: 'Als bezahlt markieren',
    markedPaid: '{{count}} Provisionen als bezahlt markiert',
  },
  support: {
    lead: 'Kunden eröffnen Tickets unter Mein Konto; auch Nachrichten aus dem Kontaktformular können in Tickets umgewandelt werden. Ihre Antwort an den Kunden wird auch per E-Mail gesendet; interne Notizen sind nur für das Team sichtbar. Kunden können gelöste Tickets mit 1 bis 5 bewerten.',
    countsLabel: 'Anzahl der Tickets',
    countOpen: 'Wartet auf Antwort: {{count}}',
    countWaiting: 'Wartet auf Kunden: {{count}}',
    countUnassigned: 'Nicht zugewiesen: {{count}}',
    listTitle: 'Tickets',
    filterStatus: 'Status',
    filterActive: 'Offen und wartend',
    filterAssigned: 'Zuständig',
    assignedMe: 'Mir zugewiesen',
    unassigned: 'Nicht zugewiesen',
    filterPriority: 'Priorität',
    search: 'Suchen',
    searchPlaceholder: 'Ticketnr., E-Mail oder Betreff',
    emptyTitle: 'Keine Tickets',
    emptyLead: 'Tickets, die Kunden unter Mein Konto → Support-Tickets eröffnen, erscheinen hier.',
    colTicket: 'Ticket',
    colCustomer: 'Kunde',
    colStatus: 'Status',
    colAssignee: 'Zuständig',
    colLast: 'Letzte Aktivität',
    pageOf: 'Seite {{page}} von {{pages}}',
    statuses: {
      open: 'Wartet auf Antwort',
      waiting: 'Wartet auf Kunden',
      resolved: 'Gelöst',
      closed: 'Geschlossen',
    },
    priorities: {
      low: 'Niedrig',
      normal: 'Normal',
      high: 'Hoch',
      urgent: 'Dringend',
    },
    categories: {
      order: 'Bestellung',
      shipping: 'Versand und Lieferung',
      return: 'Rücksendungen und Umtausch',
      payment: 'Zahlung und Rechnung',
      product: 'Produktinformationen',
      account: 'Konto',
      other: 'Sonstiges',
    },
    channels: {
      account: 'Mein Konto',
      contact_form: 'Kontaktformular',
      panel: 'Verwaltung',
      chat: 'Live-Chat',
    },
    kinds: {
      customer: 'Kunde',
      staff: 'Antwort',
      note: 'Interne Notiz',
    },
    durationDays: '{{d}} Tg. {{h}} Std.',
    durationHours: '{{h}} Std. {{m}} Min.',
    durationMinutes: '{{m}} Min.',
    report: 'Support- und Zufriedenheitsbericht',
    reportLead:
      'Im Zeitraum eröffnete und gelöste Tickets, Erstreaktionszeit (Median), Zufriedenheitswerte und Themen. Rücksendegründe werden angezeigt, wenn Sie Bestellungen einsehen dürfen.',
    period: 'Zeitraum',
    lastDays: 'Letzte {{days}} Tage',
    statCreated: 'Eröffnet',
    statResolved: 'Gelöst',
    statOpen: 'Derzeit offen',
    statFirstResponse: 'Erstreaktion (Median)',
    statSatisfaction: 'Zufriedenheit',
    satisfactionValue: '{{avg}} / 5 ({{count}} Bewertungen)',
    distribution: 'Bewertungsverteilung',
    score: '{{score}} Punkte',
    byCategory: 'Tickets nach Thema',
    noData: 'Keine Einträge in diesem Zeitraum.',
    returnReasons: 'Rücksendegründe',
    returnTotal: '{{count}} Rücksendeanfragen',
    colReason: 'Grund',
    colRequests: 'Anfragen',
    colApproved: 'Genehmigt',
    topReturned: 'Am häufigsten zurückgesendete Produkte',
    units: '{{count}} Stück',
    macros: 'Textbausteine',
    macrosLead:
      'Speichern Sie häufige Antworten; beim Antworten können Sie sie auswählen und bearbeiten. {{name}} wird durch den Kundennamen ersetzt.',
    macrosEmpty: 'Keine Textbausteine',
    macrosEmptyLead: 'Fügen Sie z. B. eine Antwort zu Versandverzögerungen oder zum Rücksendeprozess hinzu.',
    macroAdd: 'Textbaustein hinzufügen',
    macroEdit: 'Textbaustein bearbeiten',
    macroEditNamed: 'Textbaustein {{name}} bearbeiten',
    macroDeleteNamed: 'Textbaustein {{name}} löschen',
    macroDeleteConfirm: 'Textbaustein „{{name}}“ löschen?',
    macroDeleted: 'Textbaustein gelöscht',
    macroSaved: 'Textbaustein gespeichert',
    macroDialogLead: '{{name}} im Text wird beim Einfügen durch den Kundennamen ersetzt.',
    macroTitle: 'Name',
    macroBody: 'Antworttext',
    macroBodyHint:
      'Keine personenbezogenen Daten (Bestellung, Adresse) eintragen; fügen Sie diese jeweils in der Antwort hinzu.',
    ticketTitle: 'Ticket #{{number}}: {{subject}}',
    backToList: 'Zurück zu den Tickets',
    details: 'Ticketdetails',
    customer: 'Kunde',
    guest: 'Gast',
    order: 'Bestellung',
    channel: 'Quelle',
    opened: 'Eröffnet',
    firstResponse: 'Erstreaktionszeit',
    noResponseYet: 'Noch keine Antwort',
    satisfaction: 'Zufriedenheit',
    ratingValue: '{{rating}} / 5',
    status: 'Status',
    priority: 'Priorität',
    category: 'Thema',
    assignee: 'Zuständig',
    notifyResolved: 'Kunden per E-Mail informieren, dass das Ticket gelöst ist (mit Bewertungslink)',
    saveDetails: 'Änderungen speichern',
    savedEmailed: 'Gespeichert; der Kunde wurde per E-Mail informiert',
    savedNotEmailed:
      'Gespeichert; es wurde keine E-Mail gesendet, da der E-Mail-Versand nicht eingerichtet ist (Einrichtung erforderlich)',
    conversation: 'Verlauf',
    emailed: 'Per E-Mail gesendet',
    notEmailed: 'Nicht per E-Mail gesendet',
    closedHint:
      'Das Ticket ist geschlossen: Sie können dem Kunden nicht antworten, nur interne Notizen hinzufügen. Ändern Sie den Status, um wieder zu antworten.',
    insertMacro: 'Textbaustein einfügen',
    chooseMacro: 'Auswählen…',
    replyLabel: 'Antwort oder interne Notiz',
    noteLabel: 'Interne Notiz',
    replyHint:
      'Die Antwort wird auf der Ticketseite des Kunden angezeigt und auch per E-Mail gesendet. Interne Notizen bleiben im Team.',
    sendReply: 'Antwort senden',
    sendAndResolve: 'Senden und als gelöst markieren',
    addNote: 'Interne Notiz hinzufügen',
    noteSaved: 'Interne Notiz hinzugefügt',
    replySent: 'Antwort gesendet; der Kunde wurde per E-Mail informiert',
    replySavedNotEmailed:
      'Antwort gespeichert; der Kunde sieht sie auf der Ticketseite. Es wurde keine E-Mail gesendet, da der E-Mail-Versand nicht eingerichtet ist (Einrichtung erforderlich).',
    convertTitle: 'In Support-Ticket umwandeln',
    convertLead:
      'Die Nachricht wird zur ersten Kundennachricht des Tickets und als bearbeitet markiert. Der Ticketlink wird dem Kunden mit Ihrer ersten Antwort per E-Mail gesendet.',
    subject: 'Betreff des Tickets',
    convert: 'In Ticket umwandeln',
    converted: 'Ticket #{{number}} erstellt',
  },
  chat: {
    lead: 'Chats aus dem Fenster „Live-Support“ im Storefront. Besucher können nur dann einen Chat starten, wenn mindestens ein Mitarbeiter „Für Chats verfügbar“ ist; andernfalls wird stattdessen ein Nachrichtenformular (Support-Ticket) angezeigt. Die Ansicht wird alle 5 Sekunden aktualisiert.',
    disabledNotice:
      'Live-Chat ist deaktiviert: Das Fenster wird im Storefront nicht angezeigt. Aktivieren Sie ihn in den Einstellungen unten.',
    workspace: 'Chats',
    available: 'Für Chats verfügbar',
    onlineAgents: 'Derzeit verfügbare Mitarbeiter: {{count}}',
    waiting: 'Wartend',
    active: 'Laufend',
    closedRecent: 'In den letzten 24 Stunden geschlossen',
    noWaiting: 'Keine wartenden Chats.',
    noActive: 'Keine laufenden Chats.',
    noClosed: 'Keine geschlossenen Chats.',
    anonymous: 'Anonymer Besucher',
    visitor: 'Besucher',
    with: 'mit {{name}}',
    pickTitle: 'Chat auswählen',
    pickLead:
      'Wählen Sie einen Chat aus der Liste; einen wartenden Chat können Sie übernehmen und beantworten.',
    statuses: {
      waiting: 'Wartend',
      active: 'Laufend',
      closed: 'Geschlossen',
    },
    noEmail: 'Keine E-Mail angegeben',
    customerCard: 'Kundenkarte',
    messages: 'Chatnachrichten',
    events: {
      joined: 'Mitarbeiter ist dem Chat beigetreten',
      closed_visitor: 'Besucher hat den Chat beendet',
      closed_staff: 'Mitarbeiter hat den Chat geschlossen',
      closed_idle: 'Wegen Inaktivität geschlossen',
      ticket: 'In ein Support-Ticket umgewandelt',
    },
    openTicket: 'Support-Ticket öffnen',
    claim: 'Chat übernehmen',
    reply: 'Ihre Antwort',
    replyHint:
      'Enter sendet, Umschalt+Enter fügt eine Zeile hinzu. Der Besucher sieht „Support-Team“, nicht Ihren Namen.',
    send: 'Senden',
    close: 'Chat schließen',
    closeConfirm: 'Chat schließen? Der Besucher kann einen neuen Chat starten.',
    closedToast: 'Chat geschlossen',
    convert: 'In Ticket umwandeln',
    convertNeedsEmail: 'Umwandlung nicht möglich: Der Besucher hat keine E-Mail angegeben.',
    convertTitle: 'Chat in Support-Ticket umwandeln',
    convertLead:
      'Besuchernachrichten werden zu Kundennachrichten und Teamnachrichten zu Antworten; der Chat wird geschlossen. Antworten, die Sie im Ticket schreiben, werden dem Kunden per E-Mail gesendet.',
    settings: 'Chat-Einstellungen',
    settingsLead:
      'Der Chat ist standardmäßig deaktiviert. Zum Aktivieren muss der Datenschutzhinweis veröffentlicht sein.',
    enabled: 'Live-Support-Fenster im Storefront',
    needsNotice:
      'Der Chat kann erst aktiviert werden, wenn der Datenschutzhinweis veröffentlicht ist (Rechtstexte).',
    retentionDays: 'Aufbewahrung geschlossener Chats (Tage)',
    idleMinutes: 'Inaktiven Chat schließen nach (Minuten)',
    saveSettings: 'Einstellungen speichern',
    settingsSaved: 'Chat-Einstellungen gespeichert',
  },
  ads: {
    sourcesTitle: 'Werbekonten und Daten',
    sourcesLead:
      'Ausgabendaten werden jeden Morgen über die Meta- und TikTok-Verbindungen abgerufen, oder Sie laden den von der Plattform heruntergeladenen Bericht (CSV/XLSX) hoch. Der Umsatz wird immer aus den echten Bestellungen des Shops berechnet.',
    connections: 'Werbeverbindungen',
    connected: 'Verbunden',
    connectionError: 'Verbindungsfehler',
    setupRequired: 'Einrichtung erforderlich',
    manageConnections: 'Verbindungen verwalten',
    googleNote:
      'Damit die Google-Ads-Ausgaben jeden Morgen per API abgerufen werden, verbinden Sie auf der Seite der Google-Verbindungen das Google-Konto mit der Berechtigung „Google Ads“ und wählen das Kundenkonto für den Shop aus (kein Entwickler-Token nötig). Bis dahin können Sie den Google-Ads-Bericht als Datei hochladen.',
    googleNoteLink: 'Google-Verbindungen',
    syncNow: 'Jetzt synchronisieren',
    synced: 'Synchronisiert: {{rows}} Zeilen gelesen.',
    syncFailed: 'Synchronisierung konnte nicht abgeschlossen werden: {{error}}',
    addAccount: 'Konto hinzufügen',
    addAccountLead:
      'Ein Werbekonto, dessen Daten Sie als Datei hochladen. Meta- und TikTok-Konten werden nach dem Verbinden automatisch hinzugefügt.',
    editAccount: 'Konto bearbeiten',
    editAccountFor: 'Konto {{name}} bearbeiten',
    accountSaved: 'Konto gespeichert.',
    noAccounts: 'Noch keine Werbekonten',
    noAccountsLead:
      'Verbinden Sie Meta oder TikTok oder fügen Sie ein Konto hinzu, um Berichte von Google Ads und anderen Plattformen hochzuladen.',
    accountsTable: 'Werbekonten',
    account: 'Konto',
    accountName: 'Kontoname',
    platform: 'Plattform',
    externalId: 'Konto-ID auf der Plattform',
    currency: 'Währung',
    utmSources: 'Zugeordnete Quellen (utm_source)',
    utmDefault:
      'Wenn leer, werden die üblichen Werte der Plattform verwendet (z. B. facebook, instagram für Meta).',
    noUtm: 'Keine Quellen definiert',
    accountStatus: 'Status',
    active: 'Aktiv',
    archived: 'Archiviert',
    source: 'Datenquelle',
    sources: {
      api: 'API-Synchronisierung',
      file: 'Datei',
    },
    lastData: 'Letzte Synchronisierung',
    automatic: 'Automatisch',
    platforms: {
      google_ads: 'Google Ads',
      meta: 'Meta',
      tiktok: 'TikTok',
      other: 'Sonstige',
    },
    uploadReport: 'Bericht hochladen',
    uploadTitle: '{{name}} — Bericht hochladen',
    uploadLead:
      'Laden Sie den täglich aufgeschlüsselten Bericht der Plattform hoch (Datum, Kampagne, Ausgaben; optional Anzeigengruppe, Anzeige, Impressionen, Klicks). Beträge müssen in {{currency}} angegeben sein.',
    chooseFile: 'Datei auswählen',
    applyImport: 'Daten speichern',
    imported: 'Gespeichert: {{inserted}} neue, {{updated}} aktualisierte Zeilen.',
    previewFile: 'Datei',
    previewRows: 'Zeilen',
    previewRowsValue: '{{valid}} von {{rows}} Zeilen gültig, {{skipped}} übersprungen',
    previewPeriod: 'Zeitraum',
    previewSpend: 'Gesamtausgaben',
    previewCampaigns: 'Kampagnen',
    previewErrors: 'Übersprungene Zeilen (erste 20)',
    rowError: 'Zeile {{row}}: {{error}}',
    rowErrors: {
      ads_import_date: 'Datum nicht lesbar oder in der Zukunft',
      ads_import_campaign: 'kein Kampagnenname oder eine Summenzeile',
      ads_import_currency: 'Währung weicht vom Konto ab',
      ads_import_amount: 'Betrag oder Zahl nicht lesbar',
    },
    reportTitle: 'Kampagnenleistung',
    reportLead:
      'Plattformdaten zusammen mit Shop-Bestellungen. Der Umsatz stammt aus bezahlten Bestellungen, deren letzte Besuchsquelle zu den Quellen des Kontos gehört und deren Kampagne (utm_campaign) übereinstimmt.',
    period: 'Zeitraum',
    lastDays: 'Letzte {{n}} Tage',
    allPlatforms: 'Alle Plattformen',
    noData: 'Keine Werbedaten in diesem Zeitraum',
    noDataLead:
      'Warten Sie auf die Synchronisierung der Verbindungen oder laden Sie einen Bericht für ein Konto hoch.',
    totalsLabel: 'Summen ({{currency}})',
    campaignsTable: 'Kampagnen',
    campaign: 'Kampagne',
    unmatchedCampaign: 'Bestellungen ohne passende Kampagne',
    spend: 'Ausgaben',
    impressions: 'Impressionen',
    clicks: 'Klicks',
    ctr: 'CTR',
    cpc: 'CPC',
    cpm: 'CPM',
    platformConversions: 'Plattform-Conversions',
    orders: 'Bestellungen',
    revenue: 'Umsatz',
    cpa: 'Kosten pro Bestellung',
    newCustomers: 'Neukunden',
    cac: 'Kosten pro Neukunde (CAC)',
    roas: 'ROAS',
    profit: 'Gewinn nach Werbung',
    revenueNote:
      'Der Umsatz ist der Produktbetrag ohne MwSt. und Versand, abzüglich Erstattungen und Stornierungen. Plattform-Conversions dienen nur dem Vergleich.',
    profitNote:
      'Gewinn = Umsatz − Produktkosten − Werbeausgaben. Wenn für ein Produkt in einer Bestellung keine Kosten hinterlegt sind, wird kein Gewinn angezeigt (—).',
    profitHidden:
      'Zum Anzeigen des Gewinns nach Werbung ist die Berechtigung zum Einsehen der Kosten erforderlich.',
    currencyMismatch:
      '{{n}} Bestellungen wurden nicht berücksichtigt, da ihre Währung vom Werbekonto abweicht.',
    compare: 'Vergleichen',
    compareThis: 'Kampagne {{name}} zum Vergleich hinzufügen',
    compareHint: 'Wählen Sie bis zu {{n}} Kampagnen zum Vergleich aus.',
    compareTitle: 'Kampagnenvergleich',
    metric: 'Kennzahl',
    anomaliesTitle: 'Warnungen',
    noAnomalies: 'Keine Auffälligkeiten in den neuesten Daten.',
    anomalyKinds: {
      spend_spike: 'Ausgabenspitze',
      ctr_drop: 'CTR gesunken',
      no_clicks: 'Ausgaben ohne Klicks',
      sync_failed: 'Synchronisierungsfehler',
      sync_stale: 'Veraltete Daten',
    },
    anomalyText: {
      spend_spike:
        '{{account}} · {{campaign}}: Ausgaben am {{date}} betrugen {{value}}, Durchschnitt der vorherigen 7 Tage {{baseline}}.',
      ctr_drop:
        '{{account}} · {{campaign}}: Die CTR am {{date}} liegt unter der Hälfte der vorherigen 7 Tage.',
      no_clicks: '{{account}} · {{campaign}}: {{value}} am {{date}} ausgegeben, ohne Klicks.',
      sync_failed:
        '{{account}}: Die letzte Synchronisierung ist fehlgeschlagen. Prüfen Sie das Verbindungstoken.',
      sync_stale: '{{account}}: seit mehr als 2 Tagen keine neuen Daten.',
    },
    productsTitle: 'Produktleistung (Bestellungen aus Werbung)',
    product: 'Produkt',
    quantity: 'Menge',
    productRevenue: 'Nettoumsatz',
    productAdsTitle: 'Produkte in Shopping-Anzeigen (Google Ads)',
    productAdsNote:
      'Ausgaben und Klicks aus dem Produktbericht von Google; der Nettoumsatz ist dieses Produkt in bezahlten Bestellungen desselben Kontos (Zuordnung über die SKU).',
    requestChange: 'Änderung anfordern',
    changeTitle: 'Budget- oder Auslieferungsänderung anfordern',
    changeLead:
      '{{account}} · {{campaign}}. Nach der Genehmigung nehmen Sie die Änderung selbst auf der Werbeplattform vor.',
    changeKind: 'Änderung',
    kinds: {
      budget: 'Tagesbudget ändern',
      status: 'Auslieferungsstatus ändern',
    },
    dailyBudget: 'Neues Tagesbudget ({{currency}})',
    budgetInvalid: 'Geben Sie einen gültigen Betrag ein (z. B. 750 oder 750,50).',
    targetStatus: 'Neuer Status',
    targets: {
      paused: 'Auslieferung pausieren',
      active: 'Auslieferung fortsetzen',
    },
    changeNote: 'Grund',
    changeManualNote:
      'Das System ändert nie selbstständig etwas auf der Werbeplattform; wenden Sie die Änderung nach der Genehmigung auf der Plattform an und markieren Sie sie als „Angewendet“.',
    sendRequest: 'Zur Genehmigung senden',
    changeRequested: 'Anfrage zur Genehmigung gesendet.',
    changeUpdated: 'Anfrage aktualisiert.',
    historyTitle: 'Änderungsverlauf',
    historyLead: 'Budget- und Auslieferungsanfragen, Genehmigungen und Daten-Uploads.',
    changesTable: 'Änderungsanfragen',
    noChanges: 'Noch keine Änderungsanfragen.',
    when: 'Datum',
    request: 'Anfrage',
    status: 'Status',
    budgetTo: 'Tagesbudget: {{amount}}',
    requestedBy: 'Angefordert von: {{name}}',
    decidedBy: '{{name}}, {{at}}',
    appliedAt: 'Angewendet: {{at}}',
    changeStatuses: {
      pending: 'Wartet auf Genehmigung',
      approved: 'Genehmigt — anzuwenden',
      rejected: 'Abgelehnt',
      applied: 'Angewendet',
      cancelled: 'Storniert',
    },
    decide: 'Entscheiden',
    decideTitle: 'Änderungsanfrage',
    decideLead: '{{campaign}}: {{change}}',
    decisionNote: 'Entscheidungsnotiz',
    approve: 'Genehmigen',
    reject: 'Ablehnen',
    markApplied: 'Angewendet',
    markAppliedConfirm:
      'Haben Sie die Änderung auf der Werbeplattform angewendet? Sie wird als angewendet markiert.',
    cancelRequest: 'Stornieren',
    cancelConfirm: 'Offene Anfrage stornieren?',
    runsTitle: 'Daten-Uploads und Synchronisierungen',
    noRuns: 'Noch keine Daten hochgeladen.',
    runRows: 'Zeilen',
    runRowsValue: '{{inserted}} neu · {{updated}} aktualisiert · {{skipped}} übersprungen',
    gcTitle: 'Google-Ads-Conversion-Upload',
    gcLead:
      'Meldet bezahlte Bestellungen aus Werbung als Conversions an Google Ads, damit die Gebotsstrategie aus echten Verkäufen lernt. Standardmäßig deaktiviert.',
    gcPrivacy:
      'Wenn aktiviert, werden für Bestellungen von Besuchern, die Marketing-Cookies zugestimmt haben, die Google-Klick-ID (gclid), Bestellnummer, Betrag und Zeitpunkt an Google (ins Ausland) übermittelt. Klären Sie vor dem Aktivieren mit Ihrem Anwalt, ob Ihre Datenschutzerklärung dies abdeckt. Name, E-Mail-Adresse und Telefonnummer werden nicht übermittelt.',
    gcEnabled: 'Bezahlte Bestellungen als Conversions in Google Ads hochladen',
    gcEnabledHint: 'Jeden Morgen nach der Synchronisierung; letzte 60 Tage, einmal pro Bestellung.',
    gcAction: 'Conversion-Aktion',
    gcActionHint:
      'Eine Conversion-Aktion vom Typ „Klick-Import“ unter Google Ads → Ziele → Conversions; Ressourcenname customers/…/conversionActions/….',
    gcSaved: 'Einstellung für den Conversion-Upload gespeichert.',
    gcNoUploads: 'Noch keine Conversions hochgeladen.',
    gcUploaded: '{{count}} Bestellungen hochgeladen ({{value}})',
    gcFailed: '{{count}} Bestellungen von Google abgelehnt',
    runStatuses: {
      ok: 'OK',
      partial: 'Teilweise',
      failed: 'Fehlgeschlagen',
    },
  },
  googleReports: {
    ga4Title: 'Analytics-Bericht (GA4)',
    ga4Lead:
      'Verknüpfte Property: {{property}}. Bis einschließlich gestern; Google-Analytics-Daten stammen von Besuchern, die der Messung zugestimmt haben.',
    ga4LeadEmpty: 'Kanal- und Tagesbericht der mit dem Shop verknüpften GA4-Property.',
    period: 'Zeitraum',
    lastDays: 'Letzte {{n}} Tage',
    totals: 'Summen des Zeitraums',
    sessions: 'Sitzungen',
    users: 'Nutzer',
    keyEvents: 'Schlüsselereignisse',
    revenue: 'Kaufumsatz',
    byChannel: 'Nach Kanal',
    byDay: 'Nach Tag',
    channel: 'Kanal',
    day: 'Tag',
    noData: 'Keine GA4-Daten in diesem Zeitraum.',
    ga4Note:
      'Der GA4-Umsatz umfasst nur Besucher, die der Messung zugestimmt haben, und enthält keine Erstattungen/Stornierungen; genaue Verkaufszahlen finden Sie in den Berichten „Umsatz“ sowie „Kampagnen und Quellen“. Nutzer werden nicht zeilenübergreifend summiert (eine Person kann über mehrere Kanäle kommen).',
    gbpTitle: 'Google Business Profile',
    gbpLead:
      'Standortdaten und die neuesten 50 Google-Rezensionen (nur Lesezugriff). Rezensionen werden bei Google beantwortet.',
    location: 'Standort',
    address: 'Adresse',
    phone: 'Telefon',
    website: 'Website',
    rating: 'Durchschnittliche Bewertung',
    ratingValue: '{{avg}} / 5 ({{count}} Rezensionen)',
    replyOnGoogle: 'In Google Maps öffnen und Rezensionen beantworten',
    reviews: 'Google-Rezensionen',
    noReviews: 'Noch keine Rezensionen.',
    anonymous: 'Google-Nutzer',
    stars: '{{n}} Sterne',
    replied: 'Ihre Antwort: {{reply}}',
    noReply: 'Noch nicht beantwortet.',
    problem_google_not_linked: 'Mit diesem Shop ist keine Google-Ressource verknüpft',
    problem_google_scope_missing: 'Das Google-Konto hat die Berechtigung für diesen Dienst nicht erteilt',
    problem_google_not_connected: 'Kein Google-Konto verbunden',
    problemLead:
      'Verbinden Sie auf der Seite „Google-Verbindungen“ das Konto mit der erforderlichen Berechtigung und wählen Sie eine Property oder einen Standort für den Shop.',
    openConnections: 'Zu den Google-Verbindungen',
  },
  trackingEvents: {
    title: 'Event-Manager',
    lead: 'Welche E-Commerce-Ereignisse des Storefronts an welchen Messdienst gesendet werden, sowie von Ihnen definierte benutzerdefinierte Ereignisse.',
    standardTitle: 'Standardereignisse',
    event: 'Ereignis',
    sendTo: '{{event}}: an {{provider}} senden',
    notApplicable: 'Keine Entsprechung in diesem Dienst',
    events: {
      view_item_list: 'Ansicht der Produktliste',
      select_item: 'Produkt aus Liste auswählen',
      view_item: 'Produktansicht',
      add_to_cart: 'In den Warenkorb legen',
      remove_from_cart: 'Aus dem Warenkorb entfernen',
      view_cart: 'Warenkorb ansehen',
      begin_checkout: 'Zur Kasse gehen',
      add_shipping_info: 'Versandinformationen',
      add_payment_info: 'Zahlungsinformationen',
      purchase: 'Kauf',
      search: 'Suche',
      sign_up: 'Registrierung',
      login: 'Anmeldung',
      generate_lead: 'Formularübermittlung (Händler, Kontakt)',
      quiz_start: 'Bedarfsfinder gestartet',
      quiz_step: 'Bedarfsfinder-Schritt',
      quiz_complete: 'Bedarfsfinder-Ergebnis',
    },
    customTitle: 'Benutzerdefinierte Ereignisse',
    customLead:
      'Messen Sie Aufrufe einer bestimmten Seite oder Klicks auf Telefon-, E-Mail-, WhatsApp- und externe Links. Es werden keine personenbezogenen Daten gesendet; bei externen Links nur die Domain.',
    noCustom: 'Keine benutzerdefinierten Ereignisse.',
    name: 'Ereignisname',
    nameHint: 'Kleinbuchstaben, Ziffern und Unterstrich; z. B. campaign_viewed',
    trigger: 'Wann',
    triggers: {
      page_view: 'Beim Aufruf der Seite',
      click_phone: 'Beim Klick auf einen Telefonlink',
      click_email: 'Beim Klick auf einen E-Mail-Link',
      click_whatsapp: 'Beim Klick auf einen WhatsApp-Link',
      click_outbound: 'Beim Klick auf einen Link zu einer anderen Website',
    },
    path: 'Seitenpfad',
    pathHint: 'Exakter Pfad (/campaign/october) oder * anhängen, um den Anfang abzugleichen (/campaign/*)',
    destinations: 'Senden an',
    addTitle: 'Benutzerdefiniertes Ereignis hinzufügen',
    add: 'Zur Liste hinzufügen',
    remove: '{{name}} entfernen',
    consentNote:
      'Ereignisse werden nur gesendet, solange die Cookie-Richtlinie veröffentlicht ist und der Besucher der jeweiligen Cookie-Art zugestimmt hat (GA4: Analyse; Meta und TikTok: Marketing). Die Kauf-Conversion für Google Ads wird in den Tag-Einstellungen verwaltet.',
    save: 'Ereigniseinstellungen speichern',
    saved: 'Ereigniseinstellungen gespeichert. Sie werden innerhalb weniger Minuten im Storefront wirksam.',
  },
  credit: {
    available: 'Verbleibender Kreditrahmen: {{amount}}',
    overdue: 'Überfällige Forderung: {{amount}}',
    overrideLead:
      'Sie dürfen Händlerkonten verwalten: Geben Sie eine Begründung ein und speichern Sie erneut, um die Bestellung über dem Limit anzulegen (Zwei-Faktor-Authentifizierung; wird im Prüfprotokoll erfasst).',
    overrideReason: 'Begründung für die Limitüberschreitung',
    summary: 'Kreditlimit {{limit}} · verbleibend {{available}}',
    blocked: {
      overdue: 'Das offene Konto ist wegen überfälliger Forderungen gesperrt.',
      currency: 'Das Limit ist in einer anderen Währung: In dieser Währung ist das offene Konto geschlossen.',
    },
    limit: 'Kreditlimit',
    limitHint: 'Leer lassen für kein Limit.',
    currency: 'Währung des Limits',
    blockWhenOverdue: 'Offenes Konto bei Überfälligkeit sperren',
    limitColumn: 'Limit / verbleibend',
  },
  compliance: {
    title: 'Länderzulässigkeit',
    lead: 'Ob das Produkt in den einzelnen Ländern verkauft werden darf, seine Registrierungs-/Zulassungsnummer und der Prüfstatus. In Ländern ohne Eintrag ist der Verkauf erlaubt.',
    add: 'Land hinzufügen',
    editTitle: 'Ländereintrag bearbeiten',
    dialogLead:
      'Ein gesperrtes Produkt wird im Markt dieses Landes nicht gelistet, erscheint nicht in der Suche oder im Feed und kann nicht in den Warenkorb gelegt werden. Grund und Notiz werden Besuchern nicht angezeigt.',
    empty: 'Keine Ländereinträge',
    emptyLead:
      'Das Produkt darf in allen Ländern verkauft werden. Fügen Sie ein Land hinzu, wenn es dort nicht verkauft werden darf oder um eine Registrierungsnummer einzutragen.',
    country: 'Land',
    saleStatus: 'Verkaufsstatus',
    status: {
      allowed: 'Zum Verkauf freigegeben',
      blocked: 'Nicht zum Verkauf',
    },
    allowedLead: 'Zum Verkauf freigegeben',
    reason: 'Grund',
    reasons: {
      registration_missing: 'Registrierung/Zulassung fehlt oder ausstehend',
      legal_restriction: 'Gesetzliche Beschränkung',
      shipping_restriction: 'Versand-/Zollbeschränkung',
      business_decision: 'Geschäftsentscheidung',
      other: 'Sonstiges',
    },
    registrationNo: 'Registrierungs-/Zulassungsnummer',
    registrationHint:
      'Z. B. die Registrierungsnummer des Ministeriums oder eine EU-Zulassung als Futtermittelzusatzstoff. Im Shop werden nur verifizierte Nummern angezeigt.',
    registrationShort: 'Reg.-Nr. {{no}}',
    verificationLabel: 'Verifizierung',
    verification: {
      unverified: 'Nicht verifiziert',
      verified: 'Verifiziert',
      not_required: 'Nicht erforderlich',
    },
    verifiedAt: 'Verifiziert: {{date}}',
    note: 'Interne Notiz',
    confirmDelete:
      'Eintrag für {{country}} löschen? Das Produkt ist dort dann wieder zum Verkauf freigegeben.',
  },
  fx: {
    statusTitle: 'Kursquelle',
    sourceLead:
      'Die Zentralbank der Republik Türkei (TCMB) veröffentlicht ihr Kursbulletin an Werktagen gegen 15:30 Uhr; die Kurse werden nach 15:40 Uhr automatisch abgerufen. Kurse werden nie erfunden: Schlägt der Abruf fehl, werden der letzte gültige Kurs und sein Datum verwendet.',
    source: 'Quelle',
    sourceName: 'Indikative Wechselkurse der TCMB',
    bulletinLabel: 'Neuestes Bulletin',
    bulletin: 'Bulletin vom {{date}}',
    bulletinNo: 'Nr. {{no}}',
    noBulletin: 'Noch keine Kurse abgerufen',
    lastSuccess: 'Letzter erfolgreicher Abruf',
    nextAttempt: 'Nächster Versuch',
    nextAttemptNone: 'Nicht geplant (beginnt, sobald eine Fremdwährung verwendet wird)',
    lastError: 'Letzter Fehler',
    refresh: 'Kurse jetzt aktualisieren',
    refreshResult: {
      updated: 'Neues Bulletin abgerufen ({{date}}); {{count}} Listen neu berechnet.',
      unchanged: 'Die Kurse sind aktuell (Bulletin vom {{date}}).',
      throttled: 'Gerade erst versucht; bitte in einer Minute erneut versuchen.',
      not_needed:
        'Kein Markt und keine Preisliste verwendet eine andere Währung als TRY; es wurden keine Kurse abgerufen.',
      not_due: 'Noch nicht fällig.',
      failed: 'TCMB nicht erreichbar: {{error}}',
    },
    stale: {
      no_data: 'Noch keine Kurse; kursbasierte Listen können nicht berechnet werden.',
      old_bulletin:
        'Die Kurse sind veraltet: Das neueste Bulletin ist vom {{date}}. Preise und Bestellungen verwenden es weiterhin.',
      fetch_failing:
        'Kurse können nicht abgerufen werden ({{count}} Versuche fehlgeschlagen). Der letzte gültige Kurs ({{date}}) wird verwendet.',
    },
    ratesTitle: 'Kurse',
    ratesLead:
      'Wert in TRY; ist die Einheit nicht 1 (z. B. JPY 100), ist es der Wert dieser Anzahl Einheiten.',
    currency: 'Währung',
    unit: 'Einheit',
    rateTypes: {
      forex_buying: 'Devisenankauf',
      forex_selling: 'Devisenverkauf',
      banknote_buying: 'Sortenankauf',
      banknote_selling: 'Sortenverkauf',
    },
    notPublished: 'nicht veröffentlicht',
    inUse: 'In Verwendung',
    noRates: 'Noch keine Kurse',
    noRatesLead:
      'Kurse werden abgerufen, sobald ein Markt oder eine Preisliste eine andere Währung als TRY verwendet; mit „Kurse jetzt aktualisieren“ rufen Sie sie sofort ab.',
    derivedTitle: 'Kursbasierte Preislisten',
    derivedLead:
      'Die Preise werden aus der Basisliste mit dem gewählten Kurs berechnet; sie können nicht manuell eingegeben werden.',
    toPricing: 'Zu den Preislisten',
    noDerived: 'Keine kursbasierten Listen',
    noDerivedLead: 'Verwenden Sie auf der Seite „Preise“ bei einer Liste „Aus Kurs ableiten“.',
    derivedFrom: 'aus {{base}} ({{currency}})',
    rule: '{{rateType}} · Aufschlag {{markup}} · Preisendung {{ending}}',
    auto: 'Wird automatisch aktualisiert',
    manualOnly: 'Wird manuell neu berechnet',
    applied: 'Bulletin vom {{date}}: {{pair}} · {{count}} Preise',
    notApplied: 'Noch nicht berechnet (kein Kurs)',
    behind: 'Nicht mit dem neuesten Bulletin berechnet',
    recompute: 'Jetzt neu berechnen',
    recomputed: 'Liste mit dem neuesten Kurs neu berechnet; {{count}} Preise geändert.',
    pair: '{{unit}} {{currency}} = {{rate}} TRY',
    deriveButton: 'Aus Kurs ableiten',
    deriveTitle: '{{name}} — aus Kurs ableiten',
    deriveLead:
      'Die Preise dieser Liste ({{currency}}) werden aus der Basisliste mit dem TCMB-Kurs berechnet. Berechnete Preise ersetzen die aktuellen (Erfassung in der Preishistorie); manuelle Preise können nicht eingegeben werden.',
    lastApplied: 'Letzte Berechnung: Bulletin vom {{date}}, {{pair}} ({{rateType}}).',
    baseList: 'Basisliste',
    baseListHint:
      'Eine manuell bepreiste Liste in einer anderen Währung. Staffelpreise werden ebenfalls umgerechnet.',
    rateType: 'Kursart',
    markup: 'Aufschlag (%)',
    markupHint:
      'Wird nach der Umrechnung angewendet; für eine Senkung ein Minuszeichen verwenden (z. B. -5).',
    markupInvalid: 'Geben Sie den Satz wie 5 oder -2,5 ein.',
    autoLabel: 'Bei neuem Bulletin und bei Änderung der Basispreise automatisch aktualisieren',
    saved: 'Kurseinstellungen gespeichert; {{count}} Preise aktualisiert.',
    savedNoRate: 'Kurseinstellungen gespeichert, aber die Liste konnte nicht berechnet werden: {{reason}}',
    clear: 'Auf manuelle Preise umstellen',
    confirmClear:
      'Die Liste wird manuell bepreist; die aktuellen Preise bleiben erhalten und werden nicht mehr per Kurs aktualisiert. Fortfahren?',
    cleared: 'Die Liste wird jetzt manuell bepreist.',
    badge: 'Kurs · {{base}}',
    noBaseOptions:
      'Keine manuell bepreiste Liste in einer anderen Währung. Legen Sie zuerst die Basisliste an (z. B. TRY-Einzelhandel).',
    orderRate: 'Wechselkurs',
    orderRateLine: '{{pair}} · TCMB-Devisenankauf · Bulletin vom {{date}} ({{no}})',
    orderRateNone: 'Bei der Bestellung war kein Kurs verfügbar (es wurde keiner erfunden).',
    orderTryEquivalent: 'Gegenwert in TRY (zum Kurs bei Bestellung, zur Information): {{amount}}',
    orderRateStale: 'Der Kurs war bei der Bestellung veraltet.',
    orderListRate: 'Preise von {{name}}: {{pair}} ({{rateType}}, Bulletin vom {{date}})',
  },
  internationalReport: {
    csv: 'CSV herunterladen',
    from: 'Von',
    to: 'Bis',
    store: 'Shop',
    allStores: 'Alle Shops',
    note: 'Land ist das Land der Lieferadresse. Beträge stehen in der Bestellwährung; verschiedene Währungen werden nicht addiert. Brutto enthält MwSt., abzüglich stornierter Artikel; Netto = Brutto − Erstattungen. Export: von der MwSt. befreite (Export-)Bestellungen. Der TRY-Gegenwert nutzt den auf der Bestellung gespeicherten TCMB-Kurs.',
    empty: 'Keine Bestellungen in diesem Zeitraum',
    emptyLead:
      'Entwürfe und stornierte Bestellungen werden nicht gezählt. Ändern Sie den Zeitraum oder den Shop.',
    totalOrders: 'Bestellungen',
    tryNet: 'Netto (TRY-Gegenwert)',
    exportOrders: 'Exportbestellungen',
    exportTryNet: 'Export netto (TRY-Gegenwert)',
    withoutRate:
      '{{count}} Fremdwährungsbestellungen haben keinen gespeicherten Kurs und fehlen im TRY-Gegenwert.',
    caption: 'Umsatz nach Land und Währung',
    country: 'Land',
    currency: 'Währung',
    orders: 'Bestellungen',
    gross: 'Brutto',
    tax: 'MwSt.',
    shipping: 'Versand',
    refunded: 'Erstattungen',
    net: 'Netto',
    unknown: 'Keine Adresse',
    rowWithoutRate: '{{count}} ohne Kurs',
    currencyTotal: 'Summe',
  },
  dealerReports: {
    csv: 'CSV herunterladen',
    report: 'Bericht',
    reports: {
      sales: 'Umsatz',
      products: 'Produkte',
      categories: 'Kategorien',
      aging: 'Fälligkeitsanalyse',
      collections: 'Zahlungseingänge',
    },
    from: 'Von',
    to: 'Bis',
    groupBy: 'Gruppieren nach',
    groups: {
      company: 'Händler',
      rep: 'Außendienstmitarbeiter',
      region: 'Region',
    },
    none: {
      company: 'Keine Firma',
      rep: 'Kein Außendienstmitarbeiter',
      region: 'Keine Region',
    },
    rep: 'Außendienstmitarbeiter',
    region: 'Region',
    all: 'Alle',
    noRep: 'Kein Außendienstmitarbeiter',
    noRegion: 'Keine Region',
    notes: {
      sales:
        'Im Zeitraum aufgegebene Händlerbestellungen (ohne Entwürfe und Stornierungen). Brutto: Bestellsumme − stornierte Artikel (inkl. MwSt.). Netto: Brutto − Erstattungen. Der Produktumsatz versteht sich ohne MwSt. und Versand. Außendienstmitarbeiter ist der in der Bestellung hinterlegte; Region ist die aktuelle Region des Händlers.',
      products:
        'Menge und Umsatz ohne MwSt. je Produkt in den Händlerbestellungen des Zeitraums (ohne stornierte Mengen).',
      categories:
        'Jede Kategorie eines Produkts wird gezählt: Ein Produkt in mehreren Kategorien erscheint in jeder davon; die unterste Zeile ist die Summe des Produktumsatzes.',
      aging:
        'Offene Posten zum heutigen Tag nach Tagen der Überfälligkeit (Händlerkonto dieses Systems; Zahlungen werden mit der ältesten fälligen Forderung verrechnet). Der BizimHesap-Saldo dient nur zur Information. Außendienstmitarbeiter und Region entsprechen der aktuellen Zuordnung des Händlers.',
      collections:
        'Im Zeitraum auf Händlerkonten erfasste Zahlungen (ohne stornierte Buchungen); „Bestellzahlung“ wird über „Zahlung erhalten“ in der Bestellung erfasst.',
    },
    orders: 'Bestellungen',
    dealers: 'Händler',
    gross: 'Brutto (inkl. MwSt.)',
    refunded: 'Erstattungen',
    net: 'Netto (inkl. MwSt.)',
    netExTax: 'Produktumsatz (ohne MwSt.)',
    average: 'Durchschnittliche Bestellung',
    lastOrder: 'Letzte Bestellung',
    total: 'Gesamt',
    product: 'Produkt',
    quantity: 'Menge',
    category: 'Kategorie',
    noCategory: 'Ohne Kategorie',
    productTotal: 'Summe Produktumsatz',
    balance: 'Saldo',
    buckets: {
      notDue: 'Nicht fällig',
      d1_30: '1–30 Tage',
      d31_60: '31–60 Tage',
      d61_90: '61–90 Tage',
      d90plus: '90+ Tage',
    },
    bizimhesap: 'BizimHesap-Saldo',
    oldest: 'Älteste Überfälligkeit',
    days: '{{days}} Tage',
    count: 'Zahlungen',
    collected: 'Summe der Zahlungseingänge',
    methods: {
      bank_transfer: 'Banküberweisung',
      cash: 'Bar',
      card: 'Karte',
      cheque: 'Scheck',
      note: 'Solawechsel',
      other: 'Sonstiges',
      order: 'Bestellzahlung',
    },
    emptySales: 'Keine Händlerbestellungen in diesem Zeitraum.',
    emptyAging: 'Kein Händler hat einen offenen Saldo.',
    emptyCollections: 'Keine Zahlungen in diesem Zeitraum.',
    emptyLead: 'Ändern Sie den Zeitraum oder die Filter.',
  },
  dealerCampaigns: {
    companies: 'Händlerfirmen',
    search: 'Nach Name, Händlercode oder Steuernummer suchen',
    companiesNote:
      'Firmen ausgewählt: Die Aktion gilt nur für Nutzer dieser Händler (Zielgruppe: Händler). Gruppen- und Segmentauswahl gelten zusätzlich.',
    forCompanies: 'Für {{count}} Händler',
    couponFor: 'Nur: {{names}}',
  },
  balancePayments: {
    recent: {
      title: 'Letzte Händlerzahlungen',
      lead: 'Zahlungen, die Händler unter Mein Konto → Mein Händlerkonto per Karte geleistet haben (letzte 30 Tage). Jede Zahlung wird automatisch im Händlerkonto gebucht; das Geld geht an Ihr Konto beim Zahlungsanbieter.',
      all: 'Händlerkonten',
      empty: 'Keine Kartenzahlungen von Händlern in den letzten {{days}} Tagen.',
      email: 'E-Mail bei Händlerzahlung',
      emailOn: 'Alarmempfänger erhalten bei einer Händlerzahlung eine E-Mail.',
      emailOff: 'E-Mail bei Händlerzahlung ist aus.',
    },
    title: 'Saldozahlungen per Karte',
    lead: 'Zahlungen, die der Händler unter Mein Konto → Mein Händlerkonto per Karte geleistet hat. Eingegangene Zahlungen werden automatisch als Kartenzahlungseingang im Kontobuch gebucht.',
    reference: 'Zahlungsschlüssel',
    status: 'Status',
    card: 'Karte',
    sandbox: 'Test',
    installments: '{{count}} Raten',
    modes: {
      balance: 'Gesamter Saldo',
      items: 'Ausgewählte Posten',
      custom: 'Betrag',
    },
    providers: {
      iyzico: 'iyzico',
      paytr: 'PayTR',
    },
    statuses: {
      pending: 'Ausstehend',
      captured: 'Eingegangen',
      failed: 'Fehlgeschlagen',
      expired: 'Abgelaufen',
      requires_action: 'In Prüfung',
    },
    reviewHint:
      '{{reason}} Nicht gebucht: Prüfen Sie das Portal des Zahlungsanbieters; wenn das Geld eingegangen ist, erfassen Sie über „Zahlung erfassen“ einen Kartenzahlungseingang.',
    reasons: {
      amount_mismatch: 'Der Anbieter hat einen abweichenden Betrag gemeldet.',
      amount_unverified: 'Der Betrag konnte nicht verifiziert werden.',
      currency_mismatch: 'Abweichende Währung.',
      provider_review: 'Der Anbieter prüft die Zahlung.',
      provider_review_stale: 'Die Prüfung durch den Anbieter hat zu lange gedauert.',
      provider_unreachable: 'Der Anbieter war nicht erreichbar.',
      test_mode_payment: 'Testtransaktion in der Live-Umgebung.',
      other: 'Das Ergebnis ist nicht endgültig.',
    },
  },
  bankImport: {
    open: 'Banktransaktionen hochladen',
    back: 'Zurück zu den Händlerkonten',
    columns:
      'Laden Sie Ihre Kontoumsätze als CSV oder Excel (XLSX) hoch. Pflichtspalten: Datum und Betrag (oder getrennt Haben/Soll). Beschreibung, Absender und Referenz werden, sofern vorhanden, für die Zuordnung verwendet. Es werden nur eingehende Transaktionen übernommen.',
    file: 'Kontoauszug',
    summary:
      '{{incoming}} eingehende Transaktionen: {{matched}} einem Händler zugeordnet, {{ambiguous}} mit mehreren Kandidaten, {{unmatched}} nicht zugeordnet, {{blocked}} nicht buchbar. {{outgoing}} ausgehende Transaktionen übersprungen.',
    validUntil: 'Die Vorschau ist gültig bis {{time}}.',
    tableCaption: 'Banktransaktionen und vorgeschlagene Händler',
    pick: 'Auswählen',
    pickRow: 'Zeile {{line}} buchen',
    date: 'Datum',
    description: 'Beschreibung',
    amount: 'Betrag',
    dealer: 'Händler',
    dealerFor: 'Händler für Zeile {{line}}',
    matchColumn: 'Zuordnung',
    reference: 'Referenz {{ref}}',
    line: 'Dateizeile {{line}}',
    chooseDealer: 'Händler auswählen',
    candidates: 'Kandidaten',
    allDealers: 'Alle Händler',
    match: {
      order: 'Bestellung {{number}}',
      code: 'Händlercode',
      bizimhesap: 'BizimHesap-Code',
      tax: 'Steuernummer',
      name: 'Ähnlicher Name — bitte prüfen',
      ambiguous: 'Mehrere Kandidaten',
      none: 'Keine Zuordnung',
    },
    issues: {
      amount_invalid: 'Betrag nicht lesbar',
      date_invalid: 'Datum nicht lesbar',
      date_in_future: 'Datum in der Zukunft',
      duplicate: 'Bereits gebucht',
    },
    apply: 'Ausgewählte buchen ({{count}} Transaktionen · {{total}})',
    missingDealer: 'Wählen Sie für jede ausgewählte Zeile einen Händler.',
    applied: '{{count}} Zahlungen im Kontobuch gebucht.',
    appliedWithBh:
      '{{count}} Zahlungen gebucht; {{queued}} wurden in die BizimHesap-Zahlungswarteschlange aufgenommen.',
    alreadyApplied: 'Dieser Auszug wurde gebucht. Laden Sie den Auszug für neue Transaktionen erneut hoch.',
  },
  ledger: {
    import: 'Eröffnungssalden importieren',
    importLead:
      'Importieren Sie Händlersalden aus Ihrer bisherigen Buchhaltung per Datei. Zuerst wird eine Vorschau angezeigt; gebucht wird erst nach Ihrer Bestätigung.',
    importColumns:
      'Spalten: Händlercode oder Steuernummer, Betrag (Soll positiv, Haben negativ), optional Währung (TRY, wenn leer), Datum, Fälligkeitsdatum und Beschreibung. CSV (Semikolon) oder Excel.',
    importFile: 'Datei',
    importSummary:
      '{{valid}} Zeilen werden importiert, {{invalid}} Zeilen sind fehlerhaft (werden übersprungen). Summe: {{totals}}',
    importAlready:
      '{{count}} Händler in dieser Datei haben bereits einen Eröffnungssaldo. Achten Sie darauf, nicht doppelt zu importieren.',
    importApply: '{{count}} Zeilen buchen',
    importApplied: '{{count}} Eröffnungssalden gebucht.',
    importPreview: 'Vorschau der Eröffnungssalden',
    importLine: 'Zeile',
    importStatus: 'Status',
    importOk: 'Wird importiert',
    importErrors: {
      dealer_key_required: 'Kein Händlercode und keine Steuernummer.',
      dealer_not_found: 'Händler nicht gefunden.',
      currency_invalid: 'Ungültige Währung (z. B. TRY, EUR).',
      amount_invalid: 'Betrag konnte nicht gelesen werden.',
      amount_zero: 'Der Betrag ist null.',
      date_invalid: 'Datum konnte nicht gelesen werden.',
      date_in_future: 'Das Datum liegt in der Zukunft.',
      due_date_invalid: 'Fälligkeitsdatum konnte nicht gelesen werden.',
    },
    totals: 'Summen',
    totalBalance: 'Gesamtsaldo ({{currency}})',
    totalOverdue: 'Überfällig: {{amount}}',
    search: 'Händler suchen',
    onlyOverdue: 'Nur überfällige',
    empty: 'Keine Kontobewegungen bei Händlern',
    emptyLead:
      'Bestellungen auf offenes Konto werden automatisch gebucht. Verwenden Sie „Eröffnungssalden importieren“ für frühere Salden.',
    listCaption: 'Händlerkonten',
    dealer: 'Händler',
    balance: 'Saldo',
    overdue: 'Überfällig',
    notDue: 'Noch nicht fällig',
    oldestOverdue: 'Ältestes Fälligkeitsdatum',
    daysOverdue: '{{date}} ({{days}} Tage überfällig)',
    lastEntry: 'Letzte Buchung',
    companyTitle: '{{name}} — Konto',
    toDealer: 'Händlerkarte',
    term: 'Zahlungsziel: {{days}} Tage nach der Bestellung. Ein positiver Saldo bedeutet, dass der Händler Ihnen etwas schuldet.',
    noEntries: 'Noch keine Kontobewegungen',
    noEntriesLead: 'Bestellungen auf offenes Konto, Zahlungen und Eröffnungssalden erscheinen hier.',
    statement: 'Kontoauszug',
    csv: 'Kontoauszug herunterladen (CSV)',
    print: 'Drucken',
    currency: 'Währung',
    from: 'Von',
    to: 'Bis',
    date: 'Datum',
    kind: 'Art',
    description: 'Beschreibung',
    dueDate: 'Fälligkeitsdatum',
    debit: 'Soll',
    credit: 'Haben',
    actions: 'Aktionen',
    broughtForward: 'Übertrag',
    periodTotal: 'Periodensumme / Schlusssaldo',
    reversedBadge: 'Storniert',
    kinds: {
      order: 'Bestellung',
      order_change: 'Bestelländerung',
      order_payment: 'Bestellzahlung',
      payment: 'Zahlung',
      opening: 'Eröffnungssaldo',
      adjustment: 'Korrektur',
      reversal: 'Stornobuchung',
    },
    reasons: {
      placed: 'Bestellung aufgegeben',
      cancelled: 'Storniert',
      partial_cancel: 'Teilstornierung',
      edited: 'Bestellung bearbeitet',
      refunded: 'Erstattung',
      paid: 'Zahlung erhalten',
      refund_paid: 'Erstattung ausgezahlt',
      changed: 'Betrag geändert',
      card_balance: 'Kartenzahlung über Mein Konto',
    },
    methods: {
      bank_transfer: 'Banküberweisung',
      cash: 'Bar',
      cheque: 'Scheck',
      note: 'Solawechsel',
      card: 'Karte',
      other: 'Sonstiges',
    },
    payment: 'Zahlung erfassen',
    paymentLead:
      'Vom Händler erhaltenes Geld wird im Haben gebucht und mit der ältesten fälligen Forderung verrechnet. Ist der Händler mit BizimHesap verknüpft, werden Banküberweisungen, Bar- und Kartenzahlungen auch in die BizimHesap-Zahlungswarteschlange aufgenommen (sofortiger Versand, wenn das Schreiben nach BizimHesap aktiviert ist).',
    paymentSaved: 'Zahlung erfasst.',
    adjustment: 'Korrektur erfassen',
    adjustmentLead:
      'Eine manuelle Buchung, die die Forderung gegenüber dem Händler erhöht oder verringert. Eine Beschreibung ist erforderlich.',
    adjustmentSaved: 'Korrektur erfasst.',
    direction: 'Richtung',
    directions: {
      debit: 'Soll (Händler schuldet mehr)',
      credit: 'Haben (Händler schuldet weniger)',
    },
    amount: 'Betrag',
    amountIn: 'Betrag ({{currency}})',
    amountInvalid: 'Betrag konnte nicht gelesen werden (z. B. 1.250,50).',
    entryDate: 'Buchungsdatum',
    method: 'Zahlungsart',
    reference: 'Belegnr.',
    reverse: 'Stornieren',
    reverseTitle: 'Buchung stornieren',
    reverseLead:
      'Die Buchung {{kind}} ({{amount}}) wird durch eine Gegenbuchung aufgehoben. Es wird nichts gelöscht.',
    reverseReason: 'Grund',
    reversed: 'Buchung storniert.',
    openItems: 'Offene Posten',
    openItemsLead:
      'Unbezahlte Beträge, älteste Fälligkeit zuerst. Zahlungen werden mit der ältesten fälligen Forderung verrechnet.',
    openItem: 'Bestellung / Buchung',
    original: 'Betrag',
    open: 'Restbetrag',
    reminders: {
      title: 'Zahlungserinnerungen',
      lead: 'Eine morgendliche E-Mail an Händler zu bald fälligen oder überfälligen Beträgen. Standardmäßig deaktiviert.',
      noMail:
        'Der E-Mail-Versand ist nicht eingerichtet (Einrichtung erforderlich): Auch bei aktivierten Erinnerungen werden keine E-Mails gesendet. Verbinden Sie auf der Seite „Integrationen“ einen E-Mail-Anbieter (SMTP, Amazon SES, SendGrid oder Postmark).',
      enabled: 'Zahlungserinnerungen an Händler senden',
      daysBefore: 'Tage vor dem Fälligkeitsdatum',
      daysInvalid: 'Geben Sie eine Anzahl von Tagen zwischen 0 und 30 ein.',
      confirm:
        'Ich bestätige, dass Händler mit offenen Posten (Firmen-E-Mail und verantwortliche Personen der Firma) jeden Morgen echte E-Mails erhalten.',
      saved: 'Einstellung für Zahlungserinnerungen gespeichert.',
    },
  },
  sales: {
    sectionTitle: 'Außendienstmitarbeiter und Region',
    sectionLead:
      'Beim Umfang „nur zugewiesene Händler“ sehen der Außendienstmitarbeiter und der Regionalleiter diesen Händler, seine Nutzer, Bestellungen und Angebote.',
    rep: 'Außendienstmitarbeiter',
    region: 'Vertriebsregion',
    noRep: 'Kein Außendienstmitarbeiter',
    noRegion: 'Keine Region',
    saveAssignment: 'Zuordnung speichern',
    repLabel: 'Außendienst: {{name}}',
    regionLabel: 'Region: {{name}}',
    newRegion: 'Region hinzufügen',
    editRegion: 'Region {{name}} bearbeiten',
    saveRegion: 'Region speichern',
    regionSaved: 'Region gespeichert.',
    regionDeleted: 'Region gelöscht.',
    emptyRegions: 'Noch keine Vertriebsregionen',
    emptyRegionsLead:
      'Erstellen Sie Regionen aus Provinzen/Bezirken, weisen Sie einen Verantwortlichen zu und gruppieren Sie Händler nach Standort.',
    regionsTable: 'Vertriebsregionen',
    regionName: 'Name der Region',
    places: 'Provinzen und Bezirke',
    manager: 'Regionalleiter',
    noManager: 'Kein Regionalleiter',
    dealerCount: 'Händler',
    morePlaces: 'und {{count}} weitere',
    confirmDelete:
      'Region {{name}} löschen? {{count}} Händler verlieren ihre Region; Händler und Bestellungen sind nicht betroffen.',
    city: 'Provinz',
    district: 'Bezirk',
    wholeCity: 'Gesamte Provinz',
    addPlace: 'Hinzufügen',
    chosenPlaces: 'Provinzen und Bezirke der Region',
    removePlace: '{{place}} aus der Region entfernen',
    noPlaces: 'Noch keine Provinzen oder Bezirke.',
    autoAssign: 'Nach Provinz/Bezirk zuordnen',
    autoAssignLead:
      'Provinz/Bezirk der Händler wird den Regionen zugeordnet: zuerst der Bezirk, sonst die gesamte Provinz. Zuerst erscheint eine Vorschau; es wird nichts gespeichert.',
    reassignAll: 'Auch Händler mit bestehender Region neu zuordnen',
    previewAssign: 'Vorschau',
    previewSummary: '{{assigned}} Händler werden zugeordnet; {{unmatched}} Händler passen zu keiner Region.',
    applyAssign: '{{count}} Händler zuordnen',
    autoAssigned: '{{count}} Händler Regionen zugeordnet.',
  },
  bizimhesap: {
    reversedFixAtBh: 'Im Kontobuch storniert; korrigieren Sie die Zahlung in BizimHesap manuell.',
    ledgerEntry: 'BizimHesap-Zahlung {{number}}: {{status}}',
    statement: {
      title: 'BizimHesap-Kontoauszug',
      lead: 'BizimHesap ist das führende System: Der Saldo ist der letzte laufende Saldo des Kontoauszugs. Das Kreditlimit wird gegen diesen Saldo zuzüglich der noch nicht an BizimHesap übertragenen Bestellungen auf offenes Konto geprüft. Der Auszug wird alle 30 Minuten abgerufen (bei inaktiven Händlern alle 6 Stunden).',
      notLinked: 'Der Händler ist mit keinem BizimHesap-Konto verknüpft. So verknüpfen Sie ihn:',
      balance: 'BizimHesap-Saldo',
      pending: 'Noch nicht übertragene Bestellungen',
      effective: 'Für das Kreditlimit verwendet',
      fetchedAt: 'Zuletzt aktualisiert {{date}}',
      neverFetched: 'Noch nicht abgerufen',
      lastError: 'Letzter Versuch fehlgeschlagen: {{error}}',
      refreshOne: 'Diesen Händler aktualisieren',
      refreshed: 'Kontoauszug aus BizimHesap aktualisiert.',
      pendingOrders: 'Noch nicht in BizimHesap übertragene Bestellungen auf offenes Konto: {{orders}}',
      rows: 'BizimHesap-Auszugszeilen',
      date: 'Datum',
      type: 'Art',
      note: 'Beschreibung',
      debit: 'Soll',
      credit: 'Haben',
      running: 'Saldo',
      sources: {
        field: 'Saldo aus dem Kopfbereich des Auszugs gelesen (kein laufender Saldo in den Zeilen)',
        sums: 'Saldo aus Soll − Haben berechnet',
        rows: 'Saldo aus den Zeilen berechnet',
      },
      creditSource:
        'Das Kreditlimit wird gegen den BizimHesap-Saldo zuzüglich noch nicht übertragener Bestellungen geprüft.',
    },
    diff: {
      title: 'BizimHesap-Salden und Differenzbericht',
      lead: 'Für jeden mit BizimHesap verknüpften Händler: der BizimHesap-Saldo, noch nicht übertragene Bestellungen auf offenes Konto und der Kontobuchsaldo dieses Systems. Differenz = BizimHesap + nicht übertragen − Kontobuch (größte zuerst).',
      refreshAll: 'Jetzt aktualisieren',
      queued:
        'Kontoauszüge von {{count}} Händlern in die Warteschlange gestellt; sie werden innerhalb weniger Minuten aktualisiert.',
      bizimhesap: 'BizimHesap',
      pending: 'Nicht übertragen',
      ledger: 'Kontobuch',
      diff: 'Differenz',
      updated: 'Zuletzt aktualisiert',
    },
    dealerTitle: 'BizimHesap-Konto',
    dealerLead:
      'Rechnungen und Zahlungen dieses Händlers werden auf diese BizimHesap-Kontonummer gebucht; BizimHesap ist das führende System. Der Code wird mit der BizimHesap-Kontenliste abgeglichen.',
    notLinked: 'Nicht verknüpft — Rechnungen werden nicht gesendet',
    linkedAt: 'Verknüpft am',
    link: 'Verknüpfen',
    unlink: 'Verknüpfung aufheben',
    notConnected:
      'BizimHesap ist nicht verbunden oder nicht getestet (Einrichtung erforderlich). Geben Sie die Firmen-ID ein und führen Sie „Verbindung testen“ aus:',
    cashTitle: 'Kassenkonten',
    cashLead:
      'Die Rechnung einer bezahlten Bestellung wird mit dem Kassenkonto ihrer Zahlungsart gesendet; BizimHesap bucht die Zahlung dort. Bestellungen auf offenes Konto senden kein Kassenkonto und bleiben als Forderung bestehen.',
    cashiersRefreshed: 'Liste der Kassenkonten aktualisiert.',
    cashiersAt: '{{count}} Kassenkonten aus BizimHesap · {{date}}',
    cashiersNever: 'Die Liste der Kassenkonten wurde noch nicht abgerufen.',
    refreshCashiers: 'Kassenkonten abrufen',
    cashKeys: {
      card: 'Kartenzahlung',
      bank_transfer: 'Banküberweisung',
      cash_on_delivery: 'Nachnahme',
      manual: 'Manuelle Zahlung (Verwaltung)',
      cash: 'Barzahlungseingang (Konto)',
    },
    noCash: 'Kein Kassenkonto',
    cashRule:
      'Rechnungen von Bestellungen, die mit einer Zahlungsart ohne Kassenkonto bezahlt wurden, werden nicht gesendet (ohne Kassenkonto zeigt BizimHesap keinen Zahlungseingang).',
    saveCash: 'Kassenkonten speichern',
    linksTitle: 'Händler ↔ BizimHesap-Konto',
    linksLead:
      'Rechnungen und Zahlungen von Händlern werden auf deren BizimHesap-Kontonummer gebucht. Die Zuordnung erfolgt über die Kontenliste: zuerst Händlercode = Kontonummer, dann Steuernummer. Rechnungen nicht verknüpfter Händler werden nicht gesendet.',
    dealers: 'Händler',
    linked: 'Mit BizimHesap verknüpft',
    customersCheck: 'Nächtliche Prüfung der Kontenliste',
    customersCheckResult: 'Händler, deren verknüpfter Code in der Liste fehlt: {{missing}}',
    importCustomers: 'Konten importieren',
    linkedDone: '{{count}} Händler mit BizimHesap-Konten verknüpft.',
    previewSummary:
      'Zugeordnet {{matched}} · mehrdeutig {{ambiguous}} · nicht in BizimHesap {{unmatched}} · bereits verknüpft {{linked}}. {{other}} BizimHesap-Konten ohne passenden Händler (evtl. Einzelhandel) bleiben unverändert.',
    applyLinks: '{{count}} Zuordnungen speichern',
    groupMatched: 'Zugeordnet (zum Speichern markiert)',
    byCode: 'Händlercode',
    byTax: 'Steuernr.',
    groupAmbiguous: 'Mehrdeutig: mehrere Kandidaten',
    leaveUnlinked: 'Nicht verknüpfen',
    groupUnmatched: 'In BizimHesap nicht gefunden',
    unmatchedLead:
      'Diese Händler benötigen ein Konto in BizimHesap. Das Anlegen von Konten (AddCustomer) schreibt in BizimHesap und ist standardmäßig deaktiviert; legen Sie bis dahin das Konto in BizimHesap an und importieren Sie erneut.',
    linkMissing: 'verknüpfter Code ({{code}}) nicht in der Liste',
    alreadyLinked: '{{count}} Händler bereits verknüpft.',
    writesTitle: 'Schreiben nach BizimHesap',
    writesLead:
      'Diese Schritte schreiben Datensätze in Ihr echtes BizimHesap-Konto und sind standardmäßig deaktiviert. Solange sie deaktiviert sind, warten die Datensätze hier; nach dem Aktivieren werden sie manuell gesendet.',
    writeKeys: {
      collections: 'Zahlungen senden (AddCollection)',
      customers: 'Konten anlegen (AddCustomer)',
      cancel: 'Rechnungen stornieren (CancelInvoice)',
    },
    writesConfirm:
      'Ich bestätige, dass die von mir aktivierten Schritte Datensätze in mein echtes BizimHesap-Konto schreiben.',
    saveWrites: 'Schreibeinstellungen speichern',
    writesOwnerOnly: 'Diese Einstellung ändert der Inhaber oder ein Administrator.',
    correctionsTitle: 'Ohne Kassenkonto gesendete bezahlte Bestellungen',
    correctionsLead:
      'Bezahlte Bestellungen, die früher ohne Kassenkonto in Rechnung gestellt wurden: BizimHesap zeigt für sie keinen Zahlungseingang. Markieren Sie sie, um Zahlungsdatensätze anzulegen; der Versand hängt von der mit Zustimmung des Inhabers aktivierten Schreibeinstellung ab.',
    queued: '{{count}} Zahlungsdatensätze angelegt.',
    noCorrections: 'Keine zu korrigierenden Rechnungen.',
    method: 'Zahlungsart',
    customerCode: 'Kontonummer',
    sentAt: 'Rechnung gesendet',
    amount: 'Betrag',
    collection: 'Zahlungseingang',
    pickCorrection: 'Bestellung {{number}} auswählen',
    cashMissing: 'Kein Kassenkonto',
    statuses: {
      pending: 'Ausstehend',
      sending: 'Wird gesendet',
      sent: 'Gesendet',
      failed: 'Fehlgeschlagen',
      uncertain: 'Unklar',
      cancelled: 'Storniert',
    },
    queueCorrections: 'Zahlungsdatensätze für Auswahl anlegen ({{count}})',
    writesOffNote:
      'Das Schreiben von Zahlungen nach BizimHesap ist deaktiviert: Datensätze warten ungesendet.',
    collectionsTitle: 'Zahlungswarteschlange',
    collectionsLead:
      'Zahlungen, die an BizimHesap gesendet werden sollen bzw. gesendet wurden. Die Zahlungsnummer (ZT-TAH-…) wird in die BizimHesap-Notiz geschrieben; bleibt eine Antwort aus, wird der Status „unklar“ und durch Suche nach dieser Nummer im Kontoauszug geprüft — keine blinden Wiederholungen.',
    sent: 'Zahlung an BizimHesap gesendet.',
    sendResult: {
      uncertain:
        'BizimHesap hat nicht geantwortet: Die Zahlung könnte bereits existieren. Prüfen Sie den Kontoauszug.',
      failed: 'BizimHesap hat die Zahlung abgelehnt; der Fehler steht in der Zeile.',
    },
    checkFound: 'Zahlungsnummer im Kontoauszug gefunden: als gesendet markiert.',
    checkNotFound: 'Nicht im Kontoauszug gefunden: Sie können sie erneut senden.',
    noCollections: 'Keine Zahlungsdatensätze.',
    collectionNumber: 'Zahlungsnr.',
    account: 'Konto',
    paymentType: 'Art',
    status: 'Status',
    sources: {
      order_correction: 'Rechnungskorrektur',
      ledger_payment: 'Zahlung aus der Verwaltung',
      balance_payment: 'Saldozahlung per Karte',
    },
    paymentTypes: {
      '1': 'Bar',
      '2': 'Kreditkarte',
      '3': 'Banküberweisung',
    },
    send: 'Senden',
    cancelCollection: 'Datensatz stornieren',
    checkStatement: 'Kontoauszug prüfen',
    collectionActionsNote:
      '„Senden“, „Kontoauszug prüfen“ und „Datensatz stornieren“ werden im Prüfprotokoll erfasst.',
    cancelled: 'Zahlungsdatensatz storniert.',
    cancelTitle: 'Datensatz {{number}} stornieren',
    cancelLead:
      'Der Datensatz wird nicht an BizimHesap gesendet. Notieren Sie dies, falls Sie die Zahlung manuell in BizimHesap erfasst haben.',
    cancelNote: 'Grund',
    sampleReset: 'Beispiel gelöscht; die nächste echte Antwort wird erneut gespeichert.',
    samplesTitle: 'BizimHesap-Antwortbeispiele',
    samplesLead:
      'Die BizimHesap-Dokumentation beschreibt die Felder der Antworten für Kontenliste, Kontoauszug und Kassenkonten nicht. Die erste echte Antwort wird hier mit maskierten personenbezogenen Daten gespeichert; die Feldzuordnung wird damit geprüft.',
    endpoints: {
      customers: 'Kontenliste (customers)',
      abstract: 'Kontoauszug (abstract)',
      cashiers: 'Kassenkonten (cashiers)',
    },
    sampleAt: 'erfasst am {{date}}',
    sampleNone: 'noch keine',
    copySample: 'Kopieren',
    copied: 'Kopiert.',
    resetSample: 'Beispiel löschen',
  },
  commissions: {
    rules: 'Provisionsregeln',
    rulesLead:
      'Der Satz gilt für den Nettobetrag der Bestellung ohne MwSt. und Versand. Für jede Zeile gilt die spezifischste Regel: mitarbeiterspezifisch vor allgemein, Produkt vor Kategorie, Kategorie vor allen Produkten.',
    newRule: 'Regel hinzufügen',
    editRule: 'Regel {{name}} bearbeiten',
    saveRule: 'Regel speichern',
    ruleSaved: 'Provisionsregel gespeichert.',
    ruleDeleted: 'Provisionsregel gelöscht.',
    confirmDeleteRule:
      'Regel {{name}} löschen? Bereits für Bestellungen berechnete Sätze ändern sich nicht; neue Bestellungen verwenden sie nicht.',
    noRules: 'Noch keine Provisionsregeln',
    noRulesLead:
      'Beginnen Sie mit einem allgemeinen Satz für alle Außendienstmitarbeiter; fügen Sie bei Bedarf mitarbeiter- oder produktspezifische Regeln hinzu.',
    ruleName: 'Regelname',
    rep: 'Außendienstmitarbeiter',
    allReps: 'Alle Außendienstmitarbeiter',
    scope: 'Geltungsbereich',
    allProducts: 'Alle Produkte',
    categoryCount: '{{count}} Kategorien',
    productCount: '{{count}} Produkte',
    rate: 'Satz',
    rateHint: 'In Prozent, z. B. 5 oder 2,5. Höchstens 50 %.',
    rateInvalid: 'Geben Sie einen Prozentsatz zwischen 0 und 50 ein (z. B. 2,5).',
    validity: 'Gültigkeit',
    always: 'Unbefristet',
    validFrom: 'Erster Tag',
    validTo: 'Letzter Tag',
    categories: 'Kategorien',
    products: 'Produkte',
    activeLabel: 'Regel ist aktiv',
    inactive: 'Aus',
    statements: 'Monatsabrechnungen',
    statementsLead:
      'Beim Berechnen eines Zeitraums wird für jeden Außendienstmitarbeiter eine Entwurfsabrechnung erstellt. Die Provision folgt dem eingezogenen Betrag; Erstattungen, Stornierungen und verspätete Zahlungen erscheinen in späteren Monaten als Korrekturen.',
    period: 'Zeitraum (Monat)',
    calculate: 'Zeitraum berechnen',
    calculated:
      'Abrechnungen für {{count}} Außendienstmitarbeiter erstellt; {{locked}} genehmigte Abrechnungen beibehalten.',
    downloadCsv: 'CSV herunterladen',
    noStatements: 'Keine Abrechnungen für diesen Zeitraum. Berechnen Sie den Zeitraum.',
    orders: 'Bestellungen',
    base: 'Basis (ohne MwSt.)',
    commission: 'Provision',
    status: 'Status',
    statuses: {
      draft: 'Entwurf',
      approved: 'Genehmigt',
      paid: 'Bezahlt',
    },
    details: 'Details',
    approve: 'Genehmigen',
    approved: 'Abrechnung genehmigt.',
    markPaid: 'Als bezahlt markieren',
    markPaidTitle: '{{name}} — als bezahlt markieren',
    markPaidLead:
      'Die Zahlung erfolgt außerhalb des Systems (Überweisung, Lohnabrechnung); hier wird nur der Nachweis geführt. Eine bezahlte Abrechnung kann nicht mehr geändert werden.',
    paidNote: 'Zahlungsnotiz',
    paidDone: 'Abrechnung als bezahlt markiert.',
    detailTitle: '{{name}} — {{period}}',
    calculatedAt: 'Berechnet: {{date}}',
    entries: 'Abrechnungszeilen',
    kind: 'Art',
    kinds: {
      accrual: 'Abgrenzung',
      adjustment: 'Korrektur',
    },
    collected: 'Eingezogen',
    ownOnly: 'Sie sehen nur Ihre eigenen Abrechnungen.',
  },
  quotes: {
    new: 'Neues Angebot',
    newLead:
      'Wählen Sie den Händler. Das Angebot wird im aktuell bearbeiteten Shop geöffnet; die Preise richten sich nach der Händlergruppe.',
    create: 'Angebot erstellen',
    changeDealer: 'Händler ändern',
    status: 'Status',
    search: 'Angebotsnr. oder Händler',
    empty: 'Keine Angebote',
    emptyLead:
      'Händler können im Warenkorb ein Angebot anfordern; Sie können auch eines über „Neues Angebot“ erstellen.',
    listCaption: 'Angebote',
    number: 'Angebotsnr.',
    dealer: 'Händler',
    total: 'Gesamt',
    validUntil: 'Gültig bis',
    validUntilShort: 'bis {{date}}',
    createdAt: 'Erstellt',
    expired: 'Abgelaufen',
    statuses: {
      requested: 'Angefordert',
      draft: 'Entwurf',
      sent: 'Gesendet',
      ordered: 'Bestellt',
      rejected: 'Abgelehnt',
      cancelled: 'Storniert',
    },
    title: 'Angebot {{number}}',
    backToList: 'Angebotsliste',
    print: 'Drucken',
    send: 'Senden',
    resend: 'Neue Version senden',
    cancel: 'Angebot stornieren',
    saved: 'Angebot gespeichert.',
    sentEmailed: 'Angebot gesendet; der Händler wurde per E-Mail benachrichtigt.',
    sentNoEmail:
      'Angebot gesendet; der Händler sieht es unter Mein Konto. Es wurde keine E-Mail gesendet, da der E-Mail-Versand nicht eingerichtet ist (Einrichtung erforderlich).',
    summary: 'Zusammenfassung',
    requester: 'Angefordert von',
    requestNote: 'Notiz des Händlers',
    version: 'Gesendete Version',
    versionValue: 'Version {{version}}',
    rejectReason: 'Ablehnungsgrund',
    cancelReason: 'Stornierungsgrund',
    order: 'Bestellung',
    openOrder: 'Bestellung öffnen',
    editResetsLead:
      'Wenn Sie Änderungen an einem gesendeten Angebot speichern, wird es wieder zum Entwurf; der Händler kann es erst annehmen, wenn Sie die neue Version senden.',
    lines: 'Produkte',
    linesLead:
      'Geben Sie Stückpreise wie in der Händlerpreisliste ein (inkl./ohne MwSt.); leer bedeutet Listenpreis des Händlers.',
    product: 'Produkt',
    qty: 'Menge',
    listPrice: 'Listenpreis',
    unitPrice: 'Angebotspreis',
    lineTotal: 'Betrag (inkl. MwSt.)',
    taxIncluded: 'MwSt.: {{tax}}',
    saving: 'Rabatt gegenüber Listenpreis: {{amount}}',
    saveToRecalc: 'Beträge geänderter Zeilen werden beim Speichern neu berechnet.',
    terms: 'Bedingungen',
    note: 'Notiz an den Händler',
    noteHint: 'Wird im Angebot angezeigt',
    internalNote: 'Interne Notiz',
    internalNoteHint: 'Nur in der Verwaltung',
    versions: 'Gesendete Versionen',
    cancelTitle: 'Angebot stornieren',
    cancelLead: 'Ein storniertes Angebot kann nicht angenommen werden. Der Grund bleibt in der Verwaltung.',
    cancelled: 'Angebot storniert.',
  },
  locations: {
    title: 'Standorte',
    lead: 'Filial-, Liefer- und Rechnungsadressen des Händlers. Händlernutzer wählen eine davon an der Kasse aus; die verantwortliche Person der Firma kann sie auch im Storefront hinzufügen.',
    add: 'Standort hinzufügen',
    edit: 'Standort bearbeiten',
    empty: 'Keine Standorte',
    emptyLead: 'Fügen Sie Standorte für Händler mit Filialen oder separaten Liefer-/Rechnungsadressen hinzu.',
    label: 'Standortname',
    contact: 'Empfänger',
    postalCode: 'Postleitzahl',
    defaultShipping: 'Standard-Lieferadresse',
    defaultBilling: 'Standard-Rechnungsadresse',
    makeDefaultShipping: 'Als Standard-Lieferadresse festlegen',
    makeDefaultBilling: 'Als Standard-Rechnungsadresse festlegen',
    saved: 'Standort gespeichert.',
    deleted: 'Standort gelöscht.',
    confirmDelete: 'Standort „{{name}}“ löschen? Adressen in früheren Bestellungen ändern sich nicht.',
    fill: 'Aus Firmenstandort übernehmen',
    choose: 'Standort auswählen',
  },
  retention: {
    rulesTitle: 'Regeln zur automatischen Löschung',
    rulesLead:
      'Aktivierte Regeln laufen jede Nacht um 03:40 Uhr und löschen Datensätze, deren Aufbewahrungsfrist abgelaufen ist, endgültig. Alle sind standardmäßig deaktiviert. Die Fristen sind Vorschläge; klären Sie sie mit Ihrem Anwalt.',
    colData: 'Daten',
    colDays: 'Aufbewahrungsfrist (Tage)',
    colDue: 'Heute fällig',
    colEnabled: 'Automatische Löschung',
    daysLabel: '{{name}}: Aufbewahrungsfrist (Tage)',
    daysRange: '{{min}}–{{max}} Tage; empfohlen {{def}}',
    dueValue: '{{n}} Datensätze',
    enabledLabel: '{{name}}: automatische Löschung',
    on: 'An',
    off: 'Aus',
    saved: 'Aufbewahrungsregeln gespeichert.',
    lastRun: 'Letzte Löschung: {{day}}',
    noRunYet: 'Noch keine Löschung.',
    confirmTitle: 'Automatische Löschung aktivieren',
    confirmLead:
      'Aktivierte Regeln laufen jede Nacht. Datensätze mit abgelaufener Aufbewahrungsfrist werden endgültig gelöscht und im Löschprotokoll erfasst.',
    confirmRow: '{{days}} Tage: Beim ersten Lauf werden {{n}} Datensätze gelöscht',
    confirmRowUnknown: '{{days}} Tage: Anzahl der zu löschenden Datensätze konnte nicht ermittelt werden',
    confirmAck: 'Mir ist bewusst, dass abgelaufene Datensätze jede Nacht endgültig gelöscht werden.',
    confirmButton: 'Aktivieren und speichern',
    fixedTitle: 'Feste Aufbewahrungsfristen',
    fixedLead:
      'Diese Datensätze werden nach Ablauf der Frist der jeweiligen Funktion gelöscht und im Löschprotokoll erfasst. Die Frist für den Live-Chat ändern Sie in den Live-Chat-Einstellungen.',
    colRetention: 'Aufbewahrungsfrist',
    days: '{{n}} Tage',
    logTitle: 'Löschprotokoll',
    logLead:
      'Gelöschte oder anonymisierte personenbezogene Daten: Tag, Datenart, Methode und Anzahl der Datensätze. Das Protokoll enthält keine personenbezogenen Daten und wird nie gelöscht.',
    period: 'Zeitraum',
    lastDays: 'Letzte {{n}} Tage',
    colDay: 'Tag',
    colRule: 'Datenart',
    colMethod: 'Methode',
    colCount: 'Datensätze',
    methods: {
      delete: 'Löschung',
      anonymize: 'Anonymisierung',
    },
    byRequest: 'Auf Antrag',
    logEmpty: 'Keine Löschung in diesem Zeitraum',
    logEmptyLead:
      'Erscheint hier, wenn abgelaufene Datensätze gelöscht oder Daten auf Antrag anonymisiert werden.',
    rules: {
      carts: 'Warenkörbe',
      pending_subscribers: 'Unbestätigte Newsletter-Anmeldungen',
      unsubscribed_subscribers: 'Beendete Newsletter-Abonnements',
      integration_logs: 'Integrationsprotokolle',
      support_tickets: 'Gelöste Support-Tickets',
      form_submissions: 'Nachrichten aus dem Kontaktformular',
      chat_conversations: 'Geschlossene Live-Chats',
      email_campaign_recipients: 'Empfängerdatensätze von E-Mail-Kampagnen',
      automation_runs: 'Abgeschlossene Automatisierungsdatensätze',
      stock_alerts: 'Geschlossene Anfragen „Benachrichtigen, wenn verfügbar“',
      price_drop_notices: 'Preissenkungsbenachrichtigungen',
      message_recipients: 'Empfängerdatensätze von SMS-/WhatsApp-Kampagnen',
      push_deliveries: 'Zustellungsdatensätze von Browser-Benachrichtigungen',
      push_subscriptions: 'Abgelaufene Abonnements für Browser-Benachrichtigungen',
      staff_notifications: 'Mitarbeiterbenachrichtigungen',
      staff_devices: 'Nicht genutzte Mitarbeitergeräte',
      server_events: 'Serverseitige Messereignisse',
      privacy_request: 'KVKK-Antrag (Daten der betroffenen Person)',
    },
    ruleLeads: {
      carts:
        'Warenkörbe, die zu Bestellungen wurden oder abgebrochen wurden; gerechnet ab der letzten Änderung.',
      pending_subscribers:
        'Anmeldungen, deren Bestätigungslink nie geöffnet wurde (keine Einwilligung); gerechnet ab der Anmeldung.',
      unsubscribed_subscribers:
        'Datensätze von Personen, die den Newsletter abbestellt haben; gerechnet ab der Abmeldung. Einwilligungsnachweise werden 3 Jahre nach Ende der Einwilligung aufbewahrt; die Adresse bleibt auf der Sperrliste.',
      integration_logs: 'Protokolle von Verbindungen zu externen Diensten (maskierte Zusammenfassung).',
    },
  },
  questions: {
    filter: 'Status',
    statuses: {
      pending: 'Wartet auf Antwort',
      published: 'Veröffentlicht',
      rejected: 'Abgelehnt',
    },
    empty: {
      pending: 'Keine Fragen, die auf eine Antwort warten',
      published: 'Keine veröffentlichten Fragen',
      rejected: 'Keine abgelehnten Fragen',
    },
    answered: 'Antwort verfasst',
    unanswered: 'Keine Antwort',
    detailTitle: 'Produktfrage',
    back: 'Alle Fragen',
    question: 'Frage',
    meta: '{{author}} · {{date}}',
    answer: 'Antwort',
    answerLead: 'Die Antwort wird auf der Produktseite unter dem Shopnamen angezeigt.',
    answerLabel: 'Ihre Antwort',
    answeredBy: 'Zuletzt beantwortet von {{name}}, {{date}}',
    save: 'Antwort speichern',
    saved: 'Antwort gespeichert',
    saveFirst: 'Speichern Sie die Antwort vor dem Veröffentlichen.',
    publish: 'Veröffentlichen',
    publishedToast: 'Frage veröffentlicht',
    notified: 'Antwort-E-Mail an den Kunden gesendet: {{date}}',
    rejectTitle: 'Ablehnen',
    rejectLead: 'Die Frage wird im Storefront nicht angezeigt; der Kunde wird nicht benachrichtigt.',
    rejectNote: 'Grund (nur in der Verwaltung)',
    reject: 'Ablehnen',
    unpublish: 'Veröffentlichung aufheben',
    rejectConfirm: 'Die Frage wird im Storefront nicht angezeigt. Fortfahren?',
    rejectedToast: 'Frage abgelehnt',
    rejectedNote: 'Ablehnungsgrund: {{note}}',
  },
  productTools: {
    copy: 'Kopieren',
    copyConfirm:
      'Es wird eine Entwurfskopie erstellt: Inhalt, Varianten (neue SKU, ohne Barcode), Kategorien, Merkmale, Bilder und Preise. Shop-Veröffentlichung und Bestand werden nicht kopiert. Fortfahren?',
    copied: 'Entwurfskopie erstellt. Neue SKU: {{skus}}',
    saveTemplate: 'Als Vorlage speichern',
    saveTemplateLead:
      'Marke, Kategorien, Tierarten, Optionen, Merkmale, Tags und Beschreibungstexte werden gespeichert. Name, SKU, Preis und Bilder nicht.',
    templateName: 'Vorlagenname',
    templateSaved: 'Vorlage gespeichert',
    startFrom: 'Mit einer Vorlage beginnen',
    startFromLead:
      'Wenden Sie eine gespeicherte Vorlage an, um das Formular auszufüllen, und bearbeiten Sie es dann.',
    template: 'Vorlage',
    chooseTemplate: 'Vorlage auswählen',
    applyTemplate: 'Vorlage anwenden',
    templateApplied: 'Vorlage „{{name}}“ angewendet',
    noTemplates:
      'Keine gespeicherten Vorlagen. Verwenden Sie bei einem Produkt „Als Vorlage speichern“, um eine zu erstellen.',
    deleteTemplate: 'Vorlage löschen',
    deleteTemplateConfirm: 'Vorlage „{{name}}“ löschen? Daraus erstellte Produkte sind nicht betroffen.',
    templateDeleted: 'Vorlage gelöscht',
    suggestSkus: 'SKUs vorschlagen',
    skusSuggested: 'Leere SKU-Felder ausgefüllt (Muster: {{pattern}}). Vergessen Sie nicht zu speichern.',
    skuPattern: 'SKU-Muster',
    skuPatternLead: 'SKU-Vorschläge folgen diesem Muster und sind im Unternehmen stets eindeutig.',
    skuPatternLabel: 'Muster',
    skuPatternHint:
      'Platzhalter: {marka} (Marke), {kategori} (Kategorie), {urun} (erste drei Wörter des Namens), {secenek} (Optionswerte), {sira} (laufende Nummer). Trennzeichen: - _ . /',
    skuPatternSaved: 'SKU-Muster gespeichert',
    schedule: 'Veröffentlichung planen',
    scheduleLead:
      'Das Produkt wird zum gewählten Zeitpunkt in diesem Shop veröffentlicht. Die Veröffentlichungsbedingungen werden dann erneut geprüft; sind sie nicht erfüllt, wird es nicht veröffentlicht und der Grund wird hier angezeigt.',
    publishAt: 'Veröffentlichen am',
    publishAtHint: 'In der Zeit Ihres Browsers; mindestens 1 Minute im Voraus, innerhalb eines Jahres.',
    scheduleSave: 'Planen',
    scheduled: 'Veröffentlichung geplant',
    scheduledFor: 'Geplant: {{date}}',
    unschedule: 'Planung aufheben',
    unscheduled: 'Planung aufgehoben',
    scheduleFailed: 'Geplante Veröffentlichung fehlgeschlagen:',
  },
  productBulk: {
    selectAllPage: 'Alle Produkte auf dieser Seite auswählen',
    selectRow: '{{title}} auswählen',
    selected: '{{count}} Produkte ausgewählt',
    allMatching: 'Alle Produkte, die dem Filter entsprechen, sind ausgewählt',
    selectAllMatching: 'Alle Produkte auswählen, die dem Filter entsprechen',
    clear: 'Auswahl aufheben',
    open: 'Massenaktion',
    history: 'Verlauf der Massenaktionen',
    lead: 'Wählen Sie eine Aktion und sehen Sie sich die Vorschau an. In der Vorschau ändert sich nichts; „Anwenden“ führt die Änderung aus, die im Verlauf der Massenaktionen rückgängig gemacht werden kann.',
    kind: 'Aktion',
    kinds: {
      status: 'Status ändern',
      categories_add: 'Zu Kategorie hinzufügen',
      categories_remove: 'Aus Kategorie entfernen',
      tags_add: 'Tags hinzufügen',
      tags_remove: 'Tags entfernen',
      collection_add: 'Zu Kollektion hinzufügen',
      collection_remove: 'Aus Kollektion entfernen',
      stock_set: 'Bestand auf Zählmenge setzen',
      stock_adjust: 'Bestand erhöhen oder verringern',
      seo: 'SEO-Titel und -Beschreibung',
      merchant: 'Google Shopping',
      cells: 'Tabellenbearbeitung',
      store_publish: 'Im Shop veröffentlichen',
      store_unpublish: 'Veröffentlichung im Shop aufheben',
    },
    newStatus: 'Neuer Status',
    categories: 'Kategorien',
    tags: 'Tags',
    tagsHint: 'Durch Kommas getrennt (z. B. Kätzchen, getreidefrei).',
    collection: 'Kollektion',
    chooseCollection: 'Kollektion auswählen',
    noManualCollections:
      'Keine manuell zusammengestellten Kollektionen. Produkte werden regelbasierten Kollektionen automatisch zugeordnet.',
    warehouse: 'Lager',
    chooseWarehouse: 'Lager auswählen',
    quantitySet: 'Neuer Bestand (Stück)',
    quantityAdjust: 'Hinzuzufügende oder abzuziehende Stückzahl',
    stockHint:
      'Ändert den Bestand jeder aktiven Variante in diesem Lager. Für eine Verringerung ein Minuszeichen verwenden (z. B. -5). Varianten, die unter die reservierte Menge fallen würden, werden übersprungen; Varianten mit Chargen-/MHD-Verfolgung werden in der Bestandsansicht erfasst.',
    seoTitle: 'Muster für SEO-Titel',
    seoDescription: 'Muster für SEO-Beschreibung',
    seoHint:
      'Platzhalter: {urun}, {marka}, {kategori} (z. B. {urun} | {marka}). Leere Felder bleiben unverändert. Titel werden bei 70, Beschreibungen bei 170 Zeichen gekürzt.',
    onlyEmpty: 'Nur leere Felder ausfüllen',
    merchantChoice: 'Im Google-Shopping-Produktfeed',
    store: 'Shop',
    storeHint:
      'Produkte, die nicht aktiv sind, auf tierärztliche Freigabe warten oder in diesem Shop keinen Preis haben, werden nicht veröffentlicht; die Vorschau überspringt sie mit Angabe des Grundes.',
    merchantOptions: {
      include: 'Einschließen',
      exclude: 'Ausschließen',
    },
    preview: 'Vorschau',
    back: 'Zurück',
    apply: 'Anwenden',
    summary: '{{products}} Produkte geprüft: {{total}} Änderungen, {{skipped}} übersprungen.',
    nothing: 'Es würde sich nichts ändern. Sehen Sie sich die Gründe für übersprungene Zeilen an.',
    expires: 'Die Vorschau ist gültig bis {{time}}.',
    item: 'Produkt',
    before: 'Jetzt',
    after: 'Danach',
    sampleNote: 'Die ersten 200 Änderungen werden angezeigt.',
    skippedTitle: 'Übersprungen ({{count}})',
    queued: 'Wird im Hintergrund angewendet: {{processed}} / {{total}}',
    queuedLead:
      'Sie können dieses Fenster schließen; der Fortschritt wird im Verlauf der Massenaktionen angezeigt.',
    done: 'Massenaktion ausgeführt: {{applied}} Änderungen, {{skipped}} Zeilen übersprungen.',
    notes: {
      unchanged: 'Wert bereits gesetzt',
      product_requires_active_variant: 'Keine aktive Variante',
      too_many_categories: 'Kategorienlimit (20) überschritten',
      too_many_tags: 'Tag-Limit (30) überschritten',
      lot_tracked: 'Mit Charge/MHD geführt; bitte über die Bestandsansicht erfassen',
      insufficient_stock: 'Bestand würde unter null oder unter die reservierte Menge fallen',
      changed_since_preview: 'Nach der Vorschau geändert; unverändert gelassen',
      error: 'Konnte nicht geändert werden ({{code}})',
    },
    values: {
      inCollection: 'In Kollektion',
      notInCollection: 'Nicht in Kollektion',
      included: 'Enthalten',
      excluded: 'Ausgeschlossen',
      published: 'Veröffentlicht',
      notPublished: 'Nicht veröffentlicht',
    },
    date: 'Datum',
    status: 'Status',
    rows: 'Zeilen',
    statuses: {
      preview: 'Nicht ausgeführt',
      queued: 'In Warteschlange',
      running: 'Wird ausgeführt',
      applied: 'Ausgeführt',
      failed: 'Fehlgeschlagen',
      reverted: 'Rückgängig gemacht',
      expired: 'Abgelaufen',
    },
    states: {
      pending: 'Ausstehend',
      applied: 'Ausgeführt',
      skipped: 'Übersprungen',
      reverted: 'Rückgängig gemacht',
      revert_skipped: 'Nicht rückgängig gemacht (später geändert)',
    },
    progress: '{{processed}} / {{total}}',
    skippedCount: '{{count}} übersprungen',
    empty: 'Noch keine Massenaktionen',
    emptyLead: 'Wählen Sie in der Produktübersicht Produkte aus und klicken Sie auf „Massenaktion“.',
    details: 'Details',
    revert: 'Rückgängig machen',
    revertConfirm:
      'Durch diese Aktion geänderte Werte werden auf ihren vorherigen Stand zurückgesetzt. Seitdem manuell geänderte Zeilen bleiben unberührt; der Bestand wird durch eine Gegenbuchung korrigiert. Fortfahren?',
    reverted: '{{reverted}} Zeilen rückgängig gemacht. Übersprungen, da später geändert: {{skipped}}.',
    itemsNote: 'Die ersten 200 Zeilen werden angezeigt.',
    note: 'Hinweis',
  },
  productGrid: {
    open: 'In Tabelle bearbeiten',
    tableLabel: 'Produkttabelle',
    priceList: 'Preisliste',
    noPriceList: 'Preise ausblenden',
    warehouse: 'Lager',
    noWarehouse: 'Bestand ausblenden',
    lockedWhileDirty:
      'Speichern oder verwerfen Sie Ihre Änderungen, bevor Sie Preisliste oder Lager wechseln.',
    keyboard:
      'Mit den Pfeiltasten wechseln Sie zwischen den Zellen. Zum Bearbeiten Enter drücken, doppelklicken oder einfach lostippen; Enter speichert und springt nach unten, Tab nach rechts, Esc bricht ab.',
    changesRegion: 'Nicht gespeicherte Änderungen',
    cols: {
      product: 'Produkt',
      sku: 'SKU',
      barcode: 'Barcode',
      status: 'Status',
      price: 'Preis',
      priceIn: 'Preis ({{currency}})',
      onHand: 'Bestand',
    },
    statuses: {
      active: 'Aktiv',
      archived: 'Archiviert',
    },
    changes: '{{count}} nicht gespeicherte Änderungen',
    noChanges: 'Keine nicht gespeicherten Änderungen',
    discard: 'Verwerfen',
    discardConfirm: '{{count}} nicht gespeicherte Änderungen verwerfen?',
    review: 'Änderungen speichern',
    previously: 'Vorher: {{value}}',
    edited: 'geändert, nicht gespeichert',
    invalidPrice: 'Geben Sie den Betrag im Format 129,90 ein.',
    invalidStock: 'Geben Sie null oder eine positive ganze Zahl ein.',
    lotTracked: 'Mit Charge/MHD geführt; bitte über die Bestandsansicht erfassen',
    prevPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
    empty: 'Keine Produkte zu dieser Suche',
    previewTitle: 'Änderungen speichern',
    previewLead:
      'Prüfen Sie vor dem Speichern. Zellen, die während Ihrer Bearbeitung von jemand anderem geändert wurden, werden nicht gespeichert.',
    summary: 'Änderungen werden in {{total}} Zeilen gespeichert.',
    nothing: 'Es gibt keine gültigen Änderungen zum Speichern.',
    field: 'Feld',
    conflictsTitle: 'Während Ihrer Bearbeitung geändert ({{count}})',
    conflictsLead:
      'Diese Zellen werden nicht gespeichert und aus der Tabelle entfernt. Bearbeiten Sie sie nach dem Neuladen der Tabelle erneut auf Basis des aktuellen Werts.',
    conflict: 'Sie sahen {{yours}}, jetzt {{current}}',
    problemsTitle: 'Nicht speicherbare Zellen ({{count}})',
    save: 'Speichern',
    saved: '{{count}} Zeilen gespeichert.',
    queued:
      'Die Änderungen werden im Hintergrund gespeichert; den Fortschritt sehen Sie im Verlauf der Massenaktionen.',
  },
  priceTiers: {
    title: 'Staffelpreise',
    lead: 'Ein Preis, der ab einer bestimmten Menge gilt (z. B. ab 6 Stück). Im Warenkorb gilt die höchste passende Staffel.',
    row: '{{list}} · {{sku}} · ab {{qty}} Stück: {{price}}',
    empty: 'Keine Staffelpreise.',
    list: 'Liste',
    variant: 'Variante',
    minQuantity: 'Mindestmenge',
    price: 'Stückpreis ({{currency}})',
    add: 'Hinzufügen',
    remove: 'Entfernen',
    removeConfirm: 'Preis ab {{qty}} Stück entfernen?',
  },
  reviews: {
    enabled: 'Bewertungen im Storefront angezeigt',
    filter: 'Status',
    statuses: {
      pending: 'Freigabe ausstehend',
      published: 'Live',
      rejected: 'Abgelehnt',
    },
    empty: {
      pending: 'Keine Bewertungen warten auf Freigabe',
      published: 'Keine Live-Bewertungen',
      rejected: 'Keine abgelehnten Bewertungen',
    },
    ratingFilter: 'Sterne',
    allRatings: 'Alle Sterne',
    ratingN: '{{n}} Sterne',
    listLabel: 'Bewertungen',
    itemLabel: '{{rating}}/5 — {{title}}',
    verified: 'Verifizierter Kauf',
    replied: 'Beantwortet',
    detailTitle: 'Produktbewertung',
    back: 'Alle Bewertungen',
    verifiedOrder: 'Verifizierter Kauf: Bestellung {{number}}',
    review: 'Bewertung',
    ratingOutOf: '{{n}} von 5',
    meta: '{{author}} · {{date}}',
    reply: 'Antwort des Shops',
    replyLead: 'Die Antwort erscheint auf der Produktseite unter der Bewertung mit dem Namen des Shops.',
    replyLabel: 'Ihre Antwort',
    repliedBy: 'Zuletzt beantwortet von {{name}}, {{date}}',
    saveReply: 'Antwort speichern',
    replySaved: 'Antwort gespeichert',
    saveFirst: 'Speichern Sie die Antwort vor der Veröffentlichung.',
    publish: 'Freigeben und veröffentlichen',
    publishedToast: 'Bewertung veröffentlicht',
    rejectTitle: 'Ablehnen',
    rejectLead:
      'Die Bewertung wird ausgeblendet und nicht in den Durchschnitt einbezogen; der Kunde wird nicht benachrichtigt.',
    rejectNote: 'Begründung (nur in der Verwaltung)',
    reject: 'Ablehnen',
    unpublish: 'Veröffentlichung zurückziehen',
    rejectConfirm: 'Die Bewertung wird im Storefront ausgeblendet. Fortfahren?',
    rejectedToast: 'Bewertung abgelehnt',
    rejectedNote: 'Ablehnungsgrund: {{note}}',
  },
  translations: {
    locale: 'Inhaltssprache',
    current: 'Sprache: {{lang}}',
    others: 'Weitere Sprachen:',
    add: 'Übersetzung hinzufügen',
    lead: 'Der Inhalt wird als Entwurf in die gewählte Sprache kopiert. Übersetzen Sie die Texte und speichern Sie; bis zur Veröffentlichung erscheint er nicht im Storefront. Gesundheitsbezogene Inhalte benötigen in der Übersetzung erneut die Freigabe durch die Fachprüfung.',
    target: 'Zielsprache',
    create: 'Übersetzung erstellen',
    created: 'Übersetzungsentwurf erstellt',
    categoryName: 'Kategoriename ({{lang}})',
  },
  // F7-19: düzenli sipariş (abonelik)
  subscriptions: {
    lead: 'Kunden starten auf der Produktseite eine regelmäßige Lieferung („alle N Wochen“). In jedem Zeitraum wird eine Bestellung zum aktuellen Preis mit Abo-Rabatt angelegt, der Bestand reserviert und ein Zahlungslink für die Kartenzahlung gesendet. Es wird keine Karte gespeichert und nichts automatisch abgebucht; eine nicht rechtzeitig bezahlte Bestellung wird storniert und der Bestand freigegeben.',
    store: 'Shop',
    settingsTitle: 'Einstellungen',
    settingsLead: 'Die regelmäßige Lieferung wird pro Shop eingeschaltet; standardmäßig ist sie aus.',
    readiness: 'Bereitschaft',
    ok: 'Bereit',
    missing: 'Fehlt',
    readyCard: 'Kartenzahlungsanbieter verbunden (für Zahlungslinks)',
    readyLegal: 'Vorabinformation und Fernabsatzvertrag veröffentlicht',
    readyEmail: 'E-Mail-Versand aktiv (sonst sehen Kunden den Zahlungslink nur unter „Mein Konto“)',
    readyProducts: 'Für regelmäßige Lieferung verfügbare Produkte: {{count}}',
    enabled: 'Regelmäßige Lieferung einschalten',
    enabledLead:
      'Wenn aktiv, zeigen geeignete Produktseiten das Feld „Regelmäßig liefern“. Wenn aus, werden keine neuen Bestellungen angelegt; Abos warten.',
    intervals: 'Wählbare Intervalle',
    everyWeek: 'Jede Woche',
    everyWeeks: 'Alle {{n}} Wochen',
    discount: 'Abo-Rabatt (%)',
    discountHint: '0 bis 30. Der Satz beim Start eines Abos bleibt für dieses Abo unverändert.',
    discountShort: '{{pct}} % Rabatt',
    linkHours: 'Gültigkeit des Zahlungslinks',
    hoursOption: '{{n}} Stunden',
    save: 'Einstellungen speichern',
    saved: 'Einstellungen für wiederkehrende Bestellungen gespeichert.',
    enableConfirm:
      'Regelmäßige Lieferung einschalten? Geeignete Produktseiten zeigen das Feld „Regelmäßig liefern“ und Kunden können Abos starten.',
    listTitle: 'Abos',
    listLead: 'Kunde, Produkt, Intervall, nächster Bestelltag und die Bestellung, die auf Zahlung wartet.',
    statusFilter: 'Status',
    all: 'Alle',
    statuses: {
      active: 'Aktiv',
      paused: 'Pausiert',
      cancelled: 'Gekündigt',
    },
    reasons: {
      customer: 'Auf Wunsch des Kunden',
      unpaid: 'Zwei Bestellungen in Folge nicht bezahlt',
      unavailable: 'Produkt oder Kunde nicht mehr geeignet',
      panel: 'Im Panel gekündigt',
      payment_unavailable: 'Zahlungslink konnte nicht erstellt werden (ist die Kartenzahlung verbunden?)',
    },
    emptyTitle: 'Noch keine wiederkehrenden Bestellungen',
    emptyLead:
      'Schalten Sie die Einstellung ein und markieren Sie Produkte als für regelmäßige Lieferung verfügbar; Kunden können dann auf der Produktseite starten.',
    colCustomer: 'Kunde',
    colProduct: 'Produkt',
    colQuantity: 'Menge',
    colInterval: 'Intervall',
    colNext: 'Nächste Bestellung',
    colStatus: 'Status',
    colPending: 'Wartet auf Zahlung',
    colActions: 'Aktionen',
    runs: 'Zeiträume',
    runsFor: 'Zeitraumprotokoll für {{product}}',
    runsTitle: 'Zeitraumprotokoll',
    noRuns: 'Noch keine Einträge.',
    runStatuses: {
      order_created: 'Bestellung angelegt (wartet auf Zahlung)',
      paid: 'Bezahlt',
      skipped: 'Übersprungen',
      out_of_stock: 'Nicht auf Lager',
      unpaid: 'Nicht bezahlt (Bestellung storniert)',
      failed: 'Bestellung konnte nicht angelegt werden',
    },
    cancel: 'Kündigen',
    cancelFor: 'Abo für {{product}} kündigen',
    cancelTitle: 'Abo kündigen',
    cancelLead:
      'Es werden keine neuen Bestellungen angelegt. Eine Bestellung, die auf Zahlung wartet, wird nach Ablauf des Links automatisch storniert. Der Kunde erhält keine E-Mail; unter „Mein Konto“ steht „Gekündigt“.',
    cancelReason: 'Grund (wird im Audit-Protokoll gespeichert)',
    cancelSubmit: 'Abo kündigen',
    cancelled: 'Abo gekündigt.',
  },
  gads: {
    textReviewStatus: {
      not_required: 'Keine Expertenprüfung nötig',
      pending:
        'Der Text enthält {{count}} Gesundheitsaussagen: Freigabe durch die tierärztliche Prüfung steht aus; vorher kann diese Anfrage nicht freigegeben werden.',
      approved: 'Der Text wurde von der Expertin bzw. dem Experten freigegeben ({{count}} Befunde geprüft).',
      rejected: 'Der Text wurde abgelehnt; bearbeiten Sie ihn und stellen Sie die Anfrage erneut.',
    },
    keywordChanges: {
      added: 'Hinzufügen ({{count}})',
      removed: 'Entfernen ({{count}})',
    },
    accessLevel: 'Google Ads API-Zugriffsstufe',
    accessLevelHint:
      'Die Stufe, die Google Ihrem Cloud-Projekt gewährt hat. Mit Explorer sind Keyword-Vorschläge gesperrt; ändern Sie sie nach der Basic-Freigabe.',
    accessLevels: {
      explorer: 'Explorer (Standard)',
      basic: 'Basic',
      standard: 'Standard',
    },
    searchOnlyReady: 'Nur eine Suchkampagne ist möglich: Für Performance Max und Shopping fehlt',
    search: {
      source: 'Entwurf aus Daten erstellen',
      sourceKinds: {
        product: 'Produkt',
        category: 'Kategorie',
      },
      sourceCategory: 'Kategorie',
      sourceSearch: 'Produkte suchen',
      sourceProduct: 'Produkt',
      suggest: 'Entwurf erstellen',
      preview: 'Anzeigenvorschau',
      previewCaption:
        'Beispielansicht: Google wählt Reihenfolge und Kombination der Titel und Beschreibungen.',
      sponsored: 'Gesponsert',
      previewEmpty: 'Titel eingeben',
      findings: '{{count}} Gesundheitsaussagen',
      findingsLead:
        'Dieser Text geht ohne Freigabe der tierärztlichen Prüfung nicht an Google. Keine Aussagen zur Vorbeugung oder Behandlung von Krankheiten.',
      shortOf:
        'Zu wenig Text in den Daten: Schreiben Sie {{headlines}} weitere Titel und {{descriptions}} weitere Beschreibungen.',
      finalUrl: 'Finale URL',
      finalUrlHint:
        'Eine Seite in Ihrem Shop (https://…). Beim Entwurf wird die Produkt- oder Kategorieseite eingetragen.',
      path1: 'Anzeigepfad 1',
      path2: 'Anzeigepfad 2',
      headlines: 'Titel (3–15, bis zu 30 Zeichen)',
      headlinesHint: 'Schreiben Sie Titel mit unterschiedlicher Aussage; fixieren Sie nur bei Bedarf.',
      headlineN: 'Titel {{n}}',
      pinN: 'Fixierung Titel {{n}}',
      pinNone: 'Nicht fixiert',
      pins: {
        h1: 'Titelposition 1',
        h2: 'Titelposition 2',
        h3: 'Titelposition 3',
        d1: 'Beschreibungsposition 1',
        d2: 'Beschreibungsposition 2',
      },
      removeHeadline: 'Titel {{n}} entfernen',
      addHeadline: 'Titel hinzufügen',
      descriptions: 'Beschreibungen (2–4, bis zu 90 Zeichen)',
      descriptionN: 'Beschreibung {{n}}',
      pinDescN: 'Fixierung Beschreibung {{n}}',
      removeDescription: 'Beschreibung {{n}} entfernen',
      addDescription: 'Beschreibung hinzufügen',
      keywordN: '{{label}} {{n}}',
      matchTypeN: '{{label}} {{n}} Option',
      matchTypes: {
        broad: 'Weitgehend passend',
        phrase: 'Passende Wortgruppe',
        exact: 'Genau passend',
      },
      removeKeyword: '„{{text}}“ entfernen',
      addKeywords: '{{label}} hinzufügen',
      addKeywordsHint: 'Eine pro Zeile (oder mit ; trennen). Als passende Wortgruppe hinzugefügt.',
      add: 'Hinzufügen',
      keywordCount: '{{count}} / {{max}}',
      ideas: 'Keywords vorschlagen',
      basicRequired: 'Basic-Zugriff erforderlich',
      basicRequiredLead:
        'Mit Explorer-Zugriff sperrt Google die Planungsdienste (Keyword-Vorschläge). Ändern Sie nach der Basic-Freigabe die Zugriffsstufe unter Budgetobergrenze und Einstellungen.',
      noIdeas: 'Google lieferte für diese Begriffe keine Vorschläge.',
      monthlySearches: '≈ {{n}} Suchanfragen/Monat',
      competition: {
        LOW: 'geringer Wettbewerb',
        MEDIUM: 'mittlerer Wettbewerb',
        HIGH: 'hoher Wettbewerb',
        UNSPECIFIED: 'Wettbewerb unbekannt',
        UNKNOWN: 'Wettbewerb unbekannt',
      },
      addIdea: '„{{text}}“ hinzufügen',
      approvalStatuses: {
        APPROVED: 'Genehmigt',
        APPROVED_LIMITED: 'Eingeschränkt genehmigt',
        AREA_OF_INTEREST_ONLY: 'Nur Interessengebiet',
        DISAPPROVED: 'Abgelehnt',
        UNKNOWN: 'Unbekannt',
      },
      googleReviewStatuses: {
        REVIEW_IN_PROGRESS: 'Wird geprüft',
        REVIEWED: 'Geprüft',
        UNDER_APPEAL: 'Einspruch läuft',
        ELIGIBLE_MAY_SERVE: 'Berechtigt, kann ausgeliefert werden',
      },
      adStrengths: {
        EXCELLENT: 'Sehr gut',
        GOOD: 'Gut',
        AVERAGE: 'Durchschnittlich',
        POOR: 'Schwach',
        PENDING: 'Ausstehend',
        NO_ADS: 'Keine Anzeigen',
      },
      notSent: 'Nicht an Google gesendet',
      reviewSaved: 'Prüfentscheidung gespeichert.',
      reviewTitle: 'Expertenprüfung',
      reviewStatuses: {
        not_required: 'Nicht nötig',
        pending: 'Ausstehend',
        approved: 'Freigegeben',
        rejected: 'Abgelehnt',
      },
      reviewedBy: 'Entscheidung: {{name}}',
      reviewNote: 'Prüfnotiz',
      reviewNoteHint: 'Für eine Ablehnung ist eine Begründung nötig.',
      reviewApprove: 'Text freigeben',
      reviewReject: 'Text ablehnen',
      reviewWaiting: 'Die Entscheidung der tierärztlichen Prüfung steht aus.',
      adTitle: 'Anzeigentext',
      adLead: 'Responsive Suchanzeige: Google kombiniert Titel und Beschreibungen.',
      requestedDiffers:
        'Der angeforderte neue Text ist noch nicht bei Google (wartet auf Freigabe oder Anwendung).',
      googleState: 'Status bei Google',
      approvalStatus: 'Richtlinienstatus',
      googleReview: 'Google-Prüfung',
      adStrength: 'Anzeigeneffektivität',
      keywords: 'Keywords',
      keywordsLead:
        'Suchanfragen, bei denen die Anzeige erscheinen kann. Hinzufügen braucht Freigabe; nur Entfernen nicht.',
      negatives: 'Ausschließende Keywords',
      negativesLead:
        'Suchanfragen, bei denen die Anzeige nicht erscheint. Hinzufügen ohne Freigabe; Entfernen mit Freigabe.',
      noKeywords: 'Keine Keywords.',
      noNegatives: 'Keine ausschließenden Keywords.',
      edit: {
        ad: 'Anzeigentext bearbeiten',
        keywords: 'Keywords bearbeiten',
        negatives: 'Ausschlüsse bearbeiten',
      },
      draftSaved: 'Entwurf gespeichert.',
      draftEditLead: 'Die Kampagne ist ein Entwurf: Änderungen werden gespeichert, ohne an Google zu gehen.',
      adChangeLead:
        'Der neue Text geht zur Freigabe; danach wird die Anzeige bei Google aktualisiert. Gesundheitsaussagen brauchen zuerst die Expertenfreigabe.',
      changeSummary: '{{added}} hinzufügen, {{removed}} entfernen.',
      summaryAd: 'Anzeige',
      summaryAdValue:
        '{{headlines}} Titel, {{descriptions}} Beschreibungen, {{keywords}} Keywords, {{negatives}} Ausschlüsse',
      summaryReviewNote:
        'Enthält der Text Gesundheitsaussagen, kann die Kampagne ohne tierärztliche Freigabe nicht erstellt werden.',
    },
    backToAds: 'Werbezentrale',
    backToList: 'Kampagnen',
    settings: 'Budgetobergrenze und Einstellungen',
    newCampaign: 'Neue Kampagne',
    stopAll: 'Alle Google-Kampagnen stoppen',
    stopConfirm:
      'Alle aktiven Google-Ads-Kampagnen werden pausiert und ausstehende ausgabenwirksame Anfragen abgebrochen. Fortfahren?',
    stopDone: '{{pausing}} Kampagnen werden pausiert; {{cancelled}} Anfragen abgebrochen.',
    monthTitle: 'Dieser Monat',
    monthSpent: 'Ausgaben diesen Monat',
    monthlyCap: 'Monatliche Werbebudget-Obergrenze',
    capMissing: 'Nicht festgelegt',
    capExceeded: 'Überschreitet die Obergrenze ({{cap}})',
    projected: 'Geschätztes monatliches Maximum',
    projectedAll: 'Monatliches Maximum mit allen aktiven Kampagnen',
    projectedNote:
      'Das geschätzte monatliche Maximum ist die Summe der Tagesbudgets der aktiven Kampagnen × 30,4. Google kann an einem Tag bis zum Doppelten des Tagesbudgets ausgeben; die Monatssumme überschreitet Tagesbudget × 30,4 nicht.',
    apiUsage: 'Google-Ads-API-Vorgänge heute',
    apiUsageValue: '{{used}} / {{limit}}',
    campaignsTitle: 'Kampagnen',
    empty: 'Noch keine Google-Ads-Kampagnen',
    emptyLead:
      'Erstellen Sie mit „Neue Kampagne“ eine Performance-Max- oder Shopping-Kampagne aus Ihren Produkten. Die Kampagne wird in Google pausiert angelegt; der Start braucht eine eigene Freigabe.',
    campaign: 'Kampagne',
    status: 'Status',
    dailyBudget: 'Tagesbudget',
    dailyMax: 'Maximal an einem Tag',
    monthlyMax: 'Monatliches Maximum',
    productsCount: 'Produkte',
    notes: 'Hinweise',
    driftBadge: 'In Google Ads geändert',
    pendingBadge: '{{count}} warten auf Freigabe',
    kinds: {
      search: 'Suche',
      pmax: 'Performance Max',
      shopping: 'Shopping',
    },
    kindHints: {
      search:
        'Textanzeigen in den Google-Suchergebnissen (responsive Suchanzeige) mit Titeln, Beschreibungen und Keywords. Kein Merchant Center nötig. Gebote: Conversion-Wert, Conversions oder Klicks.',
      pmax: 'Automatische Anzeigen aus dem Produktfeed in allen Google-Kanälen (Suche, Shopping, YouTube, Display, Gmail). Gebote: Conversion-Wert oder Conversions.',
      shopping: 'Produktanzeigen nur in Google-Shopping-Ergebnissen. Gebote: Conversion-Wert oder Klicks.',
    },
    statuses: {
      draft: 'Entwurf',
      paused: 'Pausiert',
      enabled: 'Aktiv',
      removed: 'Entfernt',
    },
    biddings: {
      max_conv_value: 'Conversion-Wert maximieren',
      max_conversions: 'Conversions maximieren',
      max_clicks: 'Klicks maximieren',
    },
    alerts: {
      month_80: 'Diesen Monat {{spent}} ausgegeben: 80 % der Monatsobergrenze ({{cap}}) erreicht.',
      month_cap_reached: 'Diesen Monat {{spent}} ausgegeben: Monatsobergrenze ({{cap}}) erreicht.',
      daily_overspend:
        'Die Ausgaben am letzten Tag ({{spent}}) überstiegen das 1,5-Fache des Tagesbudgets ({{budget}}).',
      no_conversions_2d:
        'In den letzten zwei Tagen {{spent}} ausgegeben, aber Google meldete keine Conversions.',
    },
    approvalsTitle: 'Warten auf Freigabe',
    approvalsLead:
      'Ausgabenwirksame Änderungen gehen erst nach Freigabe an Google. Die Freigabe erfordert Zwei-Faktor-Bestätigung; eigene Anfragen kann nur der Inhaber freigeben.',
    noApprovals: 'Nichts wartet auf Freigabe.',
    requestedBy: 'Angefordert von: {{name}}',
    system: 'System',
    approve: 'Freigeben',
    reject: 'Ablehnen',
    approveTitle: 'Änderung freigeben',
    rejectTitle: 'Änderung ablehnen',
    approveSubmit: 'Freigeben und an Google senden',
    rejectSubmit: 'Ablehnen',
    approved: 'Freigegeben; die Änderung ist in der Warteschlange.',
    rejected: 'Abgelehnt.',
    approveStepUp: 'Die Freigabe erfordert Zwei-Faktor-Bestätigung; ggf. wird ein Code abgefragt.',
    decisionNote: 'Notiz',
    moneyLine: 'Tagesbudget: {{daily}}.',
    moneyRule:
      'Google kann an einem Tag bis zum Doppelten ausgeben ({{dailyMax}}); monatliches Maximum ≈ Tagesbudget × 30,4 ({{monthlyMax}}).',
    moneyProjected:
      'Mit dieser Freigabe beträgt das geschätzte monatliche Maximum aller aktiven Kampagnen: {{value}}.',
    loosensWarning:
      'Diese Änderung lockert das Gebotsziel oder ändert die Strategie: Die Ausgaben können steigen.',
    removeWarning:
      'Entfernen kann nicht rückgängig gemacht werden: Die Kampagne wird in Google Ads entfernt und kann nicht wieder aktiviert werden.',
    settingsTitle: 'Budgetobergrenze und Einstellungen',
    settingsLead:
      'Die Monatsobergrenze wird bei der Freigabe ausgabenwirksamer Änderungen geprüft. Ändern erfordert Freigaberecht und Zwei-Faktor-Bestätigung.',
    monthlyCapLabel: 'Monatliche Werbebudget-Obergrenze ({{currency}})',
    monthlyCapHint: 'Leer: Start und Budgeterhöhungen können nicht freigegeben werden.',
    autoStop: 'Bei Erreichen der Obergrenze automatisch stoppen',
    autoStopHint:
      'Standardmäßig aus. Wenn aktiv, werden aktive Kampagnen ohne Freigabe pausiert, sobald die Google-Ads-Ausgaben des Monats die Obergrenze erreichen.',
    dailyLimitHint:
      'Tägliches Google-Ads-API-Vorgangslimit: {{limit}}. Ist es erreicht, werden Änderungen am nächsten Morgen angewendet.',
    settingsReadOnly: 'Nur Personen mit Freigaberecht können diese Einstellungen ändern.',
    settingsSaved: 'Einstellungen gespeichert.',
    wizardTitle: 'Neue Google-Ads-Kampagne',
    wizardStep: 'Schritt {{n}} von {{total}}: {{name}}',
    stepsLabel: 'Schritte des Assistenten',
    steps: {
      ad: 'Anzeige und Keywords',
      store: 'Shop',
      campaign: 'Typ und Name',
      products: 'Produkte',
      budget: 'Budget und Gebote',
      targeting: 'Regionen, Sprachen, Daten',
      summary: 'Zusammenfassung',
    },
    back: 'Zurück',
    next: 'Weiter',
    store: 'Shop',
    checking: 'Google-Verbindungen werden geprüft…',
    ready: 'Bereit',
    readyLead:
      'Google-Ads-Konto {{customer}}, Merchant Center {{merchant}}; Kauf-Conversion: {{conversion}}.',
    locked: 'Bevor Sie eine Kampagne erstellen, erledigen Sie Folgendes:',
    kind: 'Kampagnentyp',
    name: 'Kampagnenname',
    productSearch: 'Produkte suchen',
    productsHint:
      'Die gewählten Produkte kommen in den Produktfilter der Kampagne. Produkte, die nicht in den Google-Feed dürfen (z. B. ohne tierärztliche Freigabe, Gesundheitsversprechen), werden nicht hinzugefügt; die Gründe werden angezeigt.',
    selectedCount: '{{count}} Produkte ausgewählt',
    dailyBudgetLabel: 'Tagesbudget ({{currency}})',
    budgetInvalid: 'Geben Sie einen gültigen Betrag ein.',
    bidding: 'Gebotsstrategie',
    targetRoas: 'Ziel-ROAS (%)',
    targetRoasHint:
      'Optional. Beispiel: 400 = 4 Einheiten Conversion-Wert je 1 ausgegebene Einheit anstreben.',
    targetCpa: 'Ziel-Kosten pro Conversion ({{currency}})',
    targetCpaHint: 'Optional. Leer: Google sucht im Budget die meisten Conversions.',
    roasValue: '{{value}} % ROAS',
    noTarget: 'ohne Ziel',
    countries: 'Länder',
    languagesLabel: 'Sprachen',
    languages: {
      tr: 'Türkisch',
      en: 'Englisch',
      de: 'Deutsch',
      ar: 'Arabisch',
    },
    countryNames: {
      TR: 'Türkei',
      DE: 'Deutschland',
      GB: 'Vereinigtes Königreich',
      AE: 'VAE',
      US: 'USA',
      NL: 'Niederlande',
      FR: 'Frankreich',
      AT: 'Österreich',
      BE: 'Belgien',
      CH: 'Schweiz',
      AZ: 'Aserbaidschan',
      SA: 'Saudi-Arabien',
      QA: 'Katar',
      KW: 'Kuwait',
      BG: 'Bulgarien',
      GR: 'Griechenland',
      IT: 'Italien',
      ES: 'Spanien',
      SE: 'Schweden',
      DK: 'Dänemark',
    },
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    startHint: 'Leer: Start nach Freigabe und Aktivierung.',
    endHint: 'Leer: unbefristet.',
    dates: 'Daten',
    startNow: 'Bei Aktivierung',
    noEnd: 'unbefristet',
    assetsNote:
      'Assets: Google erstellt Anzeigentexte und Bilder aus dem Produktfeed und Ihrer Website (diese Version fügt keine Anzeigentitel oder Bilder hinzu; laut Google kann die Reichweite eingeschränkt sein).',
    pausedNote:
      'Die Kampagne wird in Google Ads PAUSIERT angelegt und bietet nur auf die Conversion „Kauf“. Der Start braucht eine eigene Freigabe.',
    requestNote: 'Notiz (für die freigebende Person)',
    saveDraft: 'Entwurf speichern',
    submitForApproval: 'Zur Freigabe senden',
    wizardSaved: 'Entwurf gespeichert',
    wizardSavedLead:
      'Der Entwurf wurde nicht an Google gesendet. Sie können ihn auf der Kampagnenseite bearbeiten und zur Freigabe senden.',
    wizardSubmitted: 'Zur Freigabe gesendet',
    wizardSubmittedLead: 'Nach der Freigabe wird die Kampagne in Google Ads pausiert angelegt.',
    openCampaign: 'Kampagne öffnen',
    rejectedTitle: 'Nicht hinzugefügte Produkte',
    reasons: {
      product_not_active: 'Das Produkt ist nicht veröffentlicht.',
      product_not_found: 'Produkt nicht gefunden.',
      in_other_campaign:
        'Das Produkt ist in einer anderen Kampagne (ein Produkt kann nur in einer Kampagne sein).',
      feed_not_listed:
        'Das Produkt ist nicht im Google-Feed dieses Shops (im Shop veröffentlicht und für Endkunden sichtbar?).',
      feed_excluded_by_user: 'Das Produkt ist vom Google-Feed ausgeschlossen.',
      feed_health_not_approved: 'Gesundheitsinhalte warten auf tierärztliche Freigabe.',
      feed_health_claim:
        'Der Text enthält ein Krankheits-/Heilversprechen (Google-Gesundheitsrichtlinie und Vorschriften).',
      feed_image_missing: 'Kein Bild.',
      feed_image_too_small: 'Das Bild ist kleiner als Googles Mindestgröße.',
      feed_image_too_large: 'Das Bild ist zu groß.',
      feed_price_missing: 'Kein Preis.',
      feed_price_not_tax_inclusive: 'Der Preis enthält keine MwSt.',
      feed_no_variants: 'Keine aktiven Varianten.',
      feed_country_blocked: 'Das Produkt darf in diesem Land nicht verkauft werden.',
      feed_translation_missing: 'Keine Übersetzung in der Sprache des Markts.',
      feed_tax_rate_missing: 'Kein MwSt.-Satz festgelegt.',
      out_of_stock: 'Nicht vorrätig: Google zeigt keine nicht vorrätigen Produkte.',
    },
    productStates: {
      queued: 'In Warteschlange',
      sent: 'An Google gesendet — wird verarbeitet',
      eligible: 'Zulässig',
      limited: 'Eingeschränkt',
      not_eligible: 'Nicht zulässig',
    },
    googleId: 'Google-ID {{id}}',
    labelValue: 'Produktlabel {{label}}',
    primaryStatus: 'Status in Google: {{status}}',
    primaryStatuses: {
      ELIGIBLE: 'Zulässig',
      PAUSED: 'Pausiert',
      REMOVED: 'Entfernt',
      ENDED: 'Beendet',
      PENDING: 'Start ausstehend',
      MISCONFIGURED: 'Fehlkonfiguriert',
      LIMITED: 'Eingeschränkt',
      LEARNING: 'Lernphase',
      NOT_ELIGIBLE: 'Nicht zulässig',
    },
    readAt: 'gelesen {{at}}',
    driftTitle: 'In Google Ads geändert',
    driftLead:
      'Die Werte in Google Ads weichen vom System ab. Das System überschreibt Googles Werte nicht selbstständig: Übernehmen Sie Googles Werte oder stellen Sie eine neue Anfrage.',
    driftFields: {
      ad_text: 'Anzeigentext (erster Titel)',
      keywords: 'Anzahl der Keywords',
      negatives: 'Anzahl ausschließender Keywords',
      status: 'Status',
      name: 'Name',
      budget: 'Tagesbudget (Mikros)',
      bidding: 'Gebotsstrategie',
      target_roas: 'Ziel-ROAS (%)',
      target_cpa: 'Ziel-CPA (Mikros)',
      end_date: 'Enddatum',
    },
    driftValues: 'im System {{expected}}, in Google {{google}}',
    acceptGoogle: 'Googles Werte übernehmen',
    driftAccepted: 'Der Systemeintrag entspricht jetzt Google Ads.',
    goal: 'Conversion-Ziel',
    goalApplied: 'Nur Käufe',
    goalPending: 'Wird angewendet',
    accounts: 'Google Ads / Merchant',
    actions: 'Kampagnenaktionen',
    ops: {
      adTextText: 'Erster Titel: {{headline}}',
      keywordsText: '{{add}} hinzufügen, {{remove}} entfernen',
      actions: {
        ad_text: 'Anzeigentext',
        keywords: 'Keywords',
        negatives: 'Ausschließende Keywords',
        create: 'Zur Freigabe senden (anlegen)',
        enable: 'Aktivieren',
        pause: 'Pausieren',
        budget: 'Budget ändern',
        bidding: 'Gebotsstrategie',
        targeting: 'Regionen, Sprachen und Daten',
        rename: 'Umbenennen',
        remove: 'Entfernen',
        apply_recommendation: 'Google-Empfehlung',
        conversion_goal: 'Conversion-Ziel',
      },
      kinds: {
        ad_text: 'Anzeigentext',
        keywords: 'Keywords',
        negatives: 'Ausschließende Keywords',
        create: 'Anlegen',
        enable: 'Aktivierung',
        pause: 'Pausierung',
        budget: 'Budget',
        bidding: 'Gebote',
        targeting: 'Ausrichtung',
        rename: 'Name',
        remove: 'Entfernung',
        apply_recommendation: 'Google-Empfehlung',
        conversion_goal: 'Kauf-Ziel',
      },
      budgetText: 'Tagesbudget {{from}} → {{to}}',
      biddingText: '{{bidding}} ({{target}})',
      targetingText: '{{countries}} · {{languages}} · {{start}} — {{end}}',
      renameText: 'Neuer Name: {{name}}',
      recommendationText: 'Empfehlung: {{type}}',
    },
    opStatuses: {
      pending_approval: 'Wartet auf Freigabe',
      queued: 'In Warteschlange',
      applying: 'Wird angewendet',
      applied: 'Angewendet',
      failed: 'Fehlgeschlagen',
      rejected: 'Abgelehnt',
      cancelled: 'Abgebrochen',
    },
    origins: {
      user: 'Benutzer',
      system: 'System',
      emergency: 'Notstopp',
      auto_stop: 'Automatischer Stopp (Obergrenze)',
    },
    deleteDraft: 'Entwurf löschen',
    deleteDraftConfirm:
      'Der Entwurf wird gelöscht. In Google Ads ändert sich nichts, da er nie gesendet wurde.',
    draftDeleted: 'Entwurf gelöscht.',
    openNote: 'Eine Änderung steht aus; außer Pausieren können keine neuen Änderungen angefordert werden.',
    productsTitle: 'Produkte',
    productsLead:
      'Produkte gehen mit dem Kampagnenlabel (custom_label_0) und dem Margenband (custom_label_1) an das Merchant Center; nach der Verarbeitung durch Google wird der Status jedes Produkts in der Kampagne angezeigt.',
    addProducts: 'Produkte hinzufügen',
    addProductsLead:
      'Hinzugefügt werden nur Produkte, die in den Google-Feed dürfen und in keiner anderen Kampagne sind.',
    addSelected: '{{count}} Produkte hinzufügen',
    noProducts: 'Die Kampagne enthält keine Produkte.',
    removeProduct: 'Entfernen',
    productRemoved: 'Produkt aus der Kampagne entfernt.',
    productsAdded: '{{count}} Produkte hinzugefügt.',
    productsRemoved: '{{count}} Produkte entfernt.',
    operationsTitle: 'Änderungen',
    noOperations: 'Noch keine Änderungen.',
    operation: 'Änderung',
    who: 'Angefordert von → entschieden von',
    when: 'Zeit',
    cancel: 'Abbrechen',
    cancelled: 'Änderung abgebrochen.',
    nextAttempt: 'Nächster Versuch: {{at}}',
    recommendationsTitle: 'Google-Empfehlungen',
    recommendationsLead:
      'Werden bei Bedarf von Google gelesen. Das Anwenden einer Empfehlung erfordert immer eine Freigabe.',
    loadRecommendations: 'Empfehlungen laden',
    noRecommendations: 'Google hat keine Empfehlungen für diese Kampagne.',
    recommendationTypes: {
      CAMPAIGN_BUDGET: 'Budgetempfehlung',
      TARGET_ROAS_OPT_IN: 'Ziel-ROAS-Empfehlung',
      MAXIMIZE_CONVERSION_VALUE_OPT_IN: 'Empfehlung: Gebote auf Conversion-Wert',
    },
    recommendedBudget: 'Empfohlenes Tagesbudget {{daily}} (monatliches Maximum {{monthly}})',
    requestRecommendation: 'Anwendung anfordern',
    recommendationRequested: 'Empfehlung zur Freigabe gesendet.',
    historyTitle: 'Google-Ads-Änderungsverlauf',
    historyLead: 'Letzte 14 Tage; bei Bedarf von Google gelesen und nicht gespeichert.',
    loadHistory: 'Verlauf laden',
    noHistory: 'Keine Änderungen in diesem Zeitraum.',
    historyBy: 'Quelle: {{client}} · {{user}}',
    historyNote: 'Gelesen um: {{at}}',
    noApprovalLead:
      'Diese Änderung braucht keine Freigabe; nach dem Häkchen wird sie eingereiht und auf Google angewendet.',
    approvalLead: 'Diese Änderung kann die Ausgaben erhöhen: Sie geht erst nach Freigabe an Google.',
    applyNow: 'Auf Google Ads anwenden',
    sendForApproval: 'Zur Freigabe senden',
    queued: 'Änderung eingereiht.',
    sentForApproval: 'Zur Freigabe gesendet.',
    enableLead: 'Mit dem Start beginnen die Ausgaben: {{daily}} pro Tag, höchstens {{monthly}} pro Monat.',
    confirmApply: 'Ich bestätige, diese Änderung auf Google Ads anzuwenden.',
    productBox: 'Google-Anzeigen',
    productBoxTitle: 'Google-Anzeigen',
    inCampaign: 'Kampagne:',
    notInCampaign: 'Dieses Produkt ist in keiner Google-Ads-Kampagne.',
    checkedAt: 'Von Google gelesen: {{at}}',
    labelsNote:
      'Für dieses Produkt werden custom_label_0 = {{label}} und custom_label_1 = Margenband an Merchant gesendet (anstelle der eigenen 1. und 2. Labels des Produkts).',
    removeFromCampaign: 'Aus Kampagne entfernen',
    notEligible: 'Dieses Produkt kann derzeit keiner Kampagne hinzugefügt werden:',
    chooseCampaign: 'Kampagne',
    chooseCampaignPlaceholder: 'Kampagne wählen',
    addToCampaign: 'Zur Kampagne hinzufügen',
    productAdded: 'Produkt zur Kampagne hinzugefügt.',
    productNotAdded: 'Das Produkt konnte nicht hinzugefügt werden; Gründe siehe unten.',
    noCampaignsYet: 'Noch keine Kampagnen. Erstellen Sie eine unter Marketing → Google-Ads-Kampagnen.',
    bulkCampaign: 'Google-Ads-Kampagne',
    bulkAdd: '{{count}} ausgewählte Produkte hinzufügen',
    bulkRemove: 'Ausgewählte aus Kampagne entfernen',
    filterLabel: 'Google-Anzeigen',
    filterAny: 'In einer Kampagne',
    filterNone: 'In keiner Kampagne',
    filterNotEligible: 'Laut Google nicht zulässig',
  },
};
